(function () {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
// Standard
//import "bootstrap"; // nicht so! nur importieren, was wir brauchen
//so:
//import Alert from 'bootstrap/js/dist/alert'
// or, specify which plugins you need:
/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ function $ccc23a021f1e6bc0$export$71511d61b312f219(o) {
    $ccc23a021f1e6bc0$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ccc23a021f1e6bc0$export$71511d61b312f219(o);
}


function $0616b26550fb407b$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($0616b26550fb407b$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $7663be19a9d89647$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $17c6da0aa640e82f$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $5f8faa38aa7bcc75$export$71511d61b312f219(self, call) {
    if (call && ((0, $17c6da0aa640e82f$export$71511d61b312f219)(call) === "object" || typeof call === "function")) return call;
    return (0, $7663be19a9d89647$export$71511d61b312f219)(self);
}


function $ba9b3af6d173df65$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $ccc23a021f1e6bc0$export$71511d61b312f219)(derived);
    return (0, $5f8faa38aa7bcc75$export$71511d61b312f219)(_this, (0, $0616b26550fb407b$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $ccc23a021f1e6bc0$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}


function $aa63010954ffd74c$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $5a9423d6bdf9478a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5a9423d6bdf9478a$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $5a9423d6bdf9478a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5a9423d6bdf9478a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $71081ebd7d211bed$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



function $1a31f82b87f62ce4$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $ccc23a021f1e6bc0$export$71511d61b312f219)(object);
        if (object === null) break;
    }
    return object;
}


function $3eca773514dd6a70$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $3eca773514dd6a70$export$71511d61b312f219 = Reflect.get;
    else $3eca773514dd6a70$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $1a31f82b87f62ce4$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $3eca773514dd6a70$export$71511d61b312f219(target, property, receiver || target);
}



function $964fb531acf43ca5$export$71511d61b312f219(o, p) {
    $964fb531acf43ca5$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $964fb531acf43ca5$export$71511d61b312f219(o, p);
}


function $429fca99a37ce120$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $964fb531acf43ca5$export$71511d61b312f219)(subClass, superClass);
}



function $34448b2f636abc71$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $71081ebd7d211bed$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $82dbc585330cff66$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $82dbc585330cff66$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $82dbc585330cff66$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



function $15fa35b92343d82d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $ae2ee4b241bf08f3$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $22743732e33643c8$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $197b31e54e99ed29$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $bdb768849265fd3d$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $197b31e54e99ed29$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $197b31e54e99ed29$export$71511d61b312f219)(o, minLen);
}


function $d98b89efad01a571$export$71511d61b312f219(arr, i) {
    return (0, $15fa35b92343d82d$export$71511d61b312f219)(arr) || (0, $ae2ee4b241bf08f3$export$71511d61b312f219)(arr, i) || (0, $bdb768849265fd3d$export$71511d61b312f219)(arr, i) || (0, $22743732e33643c8$export$71511d61b312f219)();
}



function $e83e5e97102e2c54$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $197b31e54e99ed29$export$71511d61b312f219)(arr);
}


function $af28950850a78917$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $1a5151a9158d4e3a$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $1961f7bca441a4c6$export$71511d61b312f219(arr) {
    return (0, $e83e5e97102e2c54$export$71511d61b312f219)(arr) || (0, $af28950850a78917$export$71511d61b312f219)(arr) || (0, $bdb768849265fd3d$export$71511d61b312f219)(arr) || (0, $1a5151a9158d4e3a$export$71511d61b312f219)();
}



var $22226631ba3d4356$exports = {};

$parcel$export($22226631ba3d4356$exports, "popperGenerator", function () { return $ada4301381eadd7f$export$ed5e13716264f202; });
$parcel$export($22226631ba3d4356$exports, "detectOverflow", function () { return $5c75910e995426af$export$2e2bcd8739ae039; });
$parcel$export($22226631ba3d4356$exports, "createPopperBase", function () { return $ada4301381eadd7f$export$8f7491d57c8f97a9; });
$parcel$export($22226631ba3d4356$exports, "createPopper", function () { return $bdeead69b159d288$export$8f7491d57c8f97a9; });
$parcel$export($22226631ba3d4356$exports, "createPopperLite", function () { return $91bd71f001b9e709$export$8f7491d57c8f97a9; });
var $cefd77a409472d8d$exports = {};

$parcel$export($cefd77a409472d8d$exports, "top", function () { return $cefd77a409472d8d$export$1e95b668f3b82d; });
$parcel$export($cefd77a409472d8d$exports, "bottom", function () { return $cefd77a409472d8d$export$40e543e69a8b3fbb; });
$parcel$export($cefd77a409472d8d$exports, "right", function () { return $cefd77a409472d8d$export$79ffe56a765070d2; });
$parcel$export($cefd77a409472d8d$exports, "left", function () { return $cefd77a409472d8d$export$eabcd2c8791e7bf4; });
$parcel$export($cefd77a409472d8d$exports, "auto", function () { return $cefd77a409472d8d$export$dfb5619354ba860; });
$parcel$export($cefd77a409472d8d$exports, "basePlacements", function () { return $cefd77a409472d8d$export$aec2ce47c367b8c3; });
$parcel$export($cefd77a409472d8d$exports, "start", function () { return $cefd77a409472d8d$export$b3571188c770cc5a; });
$parcel$export($cefd77a409472d8d$exports, "end", function () { return $cefd77a409472d8d$export$bd5df0f255a350f8; });
$parcel$export($cefd77a409472d8d$exports, "clippingParents", function () { return $cefd77a409472d8d$export$390fd549c5303b4d; });
$parcel$export($cefd77a409472d8d$exports, "viewport", function () { return $cefd77a409472d8d$export$d7b7311ec04a3e8f; });
$parcel$export($cefd77a409472d8d$exports, "popper", function () { return $cefd77a409472d8d$export$ae5ab1c730825774; });
$parcel$export($cefd77a409472d8d$exports, "reference", function () { return $cefd77a409472d8d$export$ca50aac9f3ba507f; });
$parcel$export($cefd77a409472d8d$exports, "variationPlacements", function () { return $cefd77a409472d8d$export$368f9a87e87fa4e1; });
$parcel$export($cefd77a409472d8d$exports, "placements", function () { return $cefd77a409472d8d$export$803cd8101b6c182b; });
$parcel$export($cefd77a409472d8d$exports, "beforeRead", function () { return $cefd77a409472d8d$export$421679a7c3d56e; });
$parcel$export($cefd77a409472d8d$exports, "read", function () { return $cefd77a409472d8d$export$aafa59e2e03f2942; });
$parcel$export($cefd77a409472d8d$exports, "afterRead", function () { return $cefd77a409472d8d$export$6964f6c886723980; });
$parcel$export($cefd77a409472d8d$exports, "beforeMain", function () { return $cefd77a409472d8d$export$c65e99957a05207c; });
$parcel$export($cefd77a409472d8d$exports, "main", function () { return $cefd77a409472d8d$export$f22da7240b7add18; });
$parcel$export($cefd77a409472d8d$exports, "afterMain", function () { return $cefd77a409472d8d$export$bab79516f2d662fe; });
$parcel$export($cefd77a409472d8d$exports, "beforeWrite", function () { return $cefd77a409472d8d$export$8d4d2d70e7d46032; });
$parcel$export($cefd77a409472d8d$exports, "write", function () { return $cefd77a409472d8d$export$68d8715fc104d294; });
$parcel$export($cefd77a409472d8d$exports, "afterWrite", function () { return $cefd77a409472d8d$export$70a6e5159acce2e6; });
$parcel$export($cefd77a409472d8d$exports, "modifierPhases", function () { return $cefd77a409472d8d$export$d087d3878fdf71d5; });
var $cefd77a409472d8d$export$1e95b668f3b82d = 'top';
var $cefd77a409472d8d$export$40e543e69a8b3fbb = 'bottom';
var $cefd77a409472d8d$export$79ffe56a765070d2 = 'right';
var $cefd77a409472d8d$export$eabcd2c8791e7bf4 = 'left';
var $cefd77a409472d8d$export$dfb5619354ba860 = 'auto';
var $cefd77a409472d8d$export$aec2ce47c367b8c3 = [
    $cefd77a409472d8d$export$1e95b668f3b82d,
    $cefd77a409472d8d$export$40e543e69a8b3fbb,
    $cefd77a409472d8d$export$79ffe56a765070d2,
    $cefd77a409472d8d$export$eabcd2c8791e7bf4
];
var $cefd77a409472d8d$export$b3571188c770cc5a = 'start';
var $cefd77a409472d8d$export$bd5df0f255a350f8 = 'end';
var $cefd77a409472d8d$export$390fd549c5303b4d = 'clippingParents';
var $cefd77a409472d8d$export$d7b7311ec04a3e8f = 'viewport';
var $cefd77a409472d8d$export$ae5ab1c730825774 = 'popper';
var $cefd77a409472d8d$export$ca50aac9f3ba507f = 'reference';
var $cefd77a409472d8d$export$368f9a87e87fa4e1 = /*#__PURE__*/ $cefd77a409472d8d$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $cefd77a409472d8d$export$b3571188c770cc5a,
        placement + "-" + $cefd77a409472d8d$export$bd5df0f255a350f8
    ]);
}, []);
var $cefd77a409472d8d$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($cefd77a409472d8d$export$aec2ce47c367b8c3, [
    $cefd77a409472d8d$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $cefd77a409472d8d$export$b3571188c770cc5a,
        placement + "-" + $cefd77a409472d8d$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $cefd77a409472d8d$export$421679a7c3d56e = 'beforeRead';
var $cefd77a409472d8d$export$aafa59e2e03f2942 = 'read';
var $cefd77a409472d8d$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $cefd77a409472d8d$export$c65e99957a05207c = 'beforeMain';
var $cefd77a409472d8d$export$f22da7240b7add18 = 'main';
var $cefd77a409472d8d$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $cefd77a409472d8d$export$8d4d2d70e7d46032 = 'beforeWrite';
var $cefd77a409472d8d$export$68d8715fc104d294 = 'write';
var $cefd77a409472d8d$export$70a6e5159acce2e6 = 'afterWrite';
var $cefd77a409472d8d$export$d087d3878fdf71d5 = [
    $cefd77a409472d8d$export$421679a7c3d56e,
    $cefd77a409472d8d$export$aafa59e2e03f2942,
    $cefd77a409472d8d$export$6964f6c886723980,
    $cefd77a409472d8d$export$c65e99957a05207c,
    $cefd77a409472d8d$export$f22da7240b7add18,
    $cefd77a409472d8d$export$bab79516f2d662fe,
    $cefd77a409472d8d$export$8d4d2d70e7d46032,
    $cefd77a409472d8d$export$68d8715fc104d294,
    $cefd77a409472d8d$export$70a6e5159acce2e6
];


var $30fb6fc8419c2434$exports = {};

$parcel$export($30fb6fc8419c2434$exports, "applyStyles", function () { return $74054666164da556$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "arrow", function () { return $83dc86f42fc279ac$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "computeStyles", function () { return $3fb07310bceb7864$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "eventListeners", function () { return $e4433c3268ceda30$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "flip", function () { return $bed9f5a8c2893a90$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "hide", function () { return $222ad0d139efc5fd$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "offset", function () { return $07171abb3b970e38$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "popperOffsets", function () { return $f7ba4eded364f4f7$export$2e2bcd8739ae039; });
$parcel$export($30fb6fc8419c2434$exports, "preventOverflow", function () { return $19834a509ede1e0f$export$2e2bcd8739ae039; });
function $335c1d630991db9d$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $52a68dbbf79b0696$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $02e3a7a40389e518$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $02e3a7a40389e518$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $02e3a7a40389e518$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $74054666164da556$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element) || !(0, $335c1d630991db9d$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $74054666164da556$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element) || !(0, $335c1d630991db9d$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $74054666164da556$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $74054666164da556$var$applyStyles,
    effect: $74054666164da556$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $41b6b608ffa08ca1$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $cfac5f0503fa0c0c$export$8960430cfd85939f = Math.max;
var $cfac5f0503fa0c0c$export$96ec731ed4dcb222 = Math.min;
var $cfac5f0503fa0c0c$export$2077e0241d6afd3c = Math.round;



function $0496b7e7c66765a6$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b496e8e32f6ce209$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $0496b7e7c66765a6$export$2e2bcd8739ae039)());
}


function $8e6bc95b10844cc4$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(element) ? (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b496e8e32f6ce209$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $0af463a2f2f36779$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $78c67adc35462806$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $02e3a7a40389e518$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $aa613a05ba685ccb$export$2e2bcd8739ae039(element) {
    return (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $061cc7497f9f99cf$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $335c1d630991db9d$export$2e2bcd8739ae039)(element)) >= 0;
}




function $562fcd476b3355d2$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $a13476024d635e41$export$2e2bcd8739ae039(element) {
    if ((0, $335c1d630991db9d$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $02e3a7a40389e518$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $44d2dcfa9b6528d5$var$getTrueOffsetParent(element) {
    if (!(0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $44d2dcfa9b6528d5$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $0496b7e7c66765a6$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $0496b7e7c66765a6$export$2e2bcd8739ae039)());
    if (isIE && (0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $a13476024d635e41$export$2e2bcd8739ae039)(element);
    if ((0, $02e3a7a40389e518$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $335c1d630991db9d$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $44d2dcfa9b6528d5$export$2e2bcd8739ae039(element) {
    var window = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(element);
    var offsetParent = $44d2dcfa9b6528d5$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $061cc7497f9f99cf$export$2e2bcd8739ae039)(offsetParent) && (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $44d2dcfa9b6528d5$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $335c1d630991db9d$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $335c1d630991db9d$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $44d2dcfa9b6528d5$var$getContainingBlock(element) || window;
}


function $367fb99255482738$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $af737c27d799169c$export$f28d906d67a997f3(min, value, max) {
    return (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(min, (0, $cfac5f0503fa0c0c$export$96ec731ed4dcb222)(value, max));
}
function $af737c27d799169c$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $af737c27d799169c$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $a5ee4ff71e95e5f9$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $96514a6e68cf3ac6$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $a5ee4ff71e95e5f9$export$2e2bcd8739ae039)(), paddingObject);
}


function $30de99b1366d30c9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $83dc86f42fc279ac$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $96514a6e68cf3ac6$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $30de99b1366d30c9$export$2e2bcd8739ae039)(padding, (0, $cefd77a409472d8d$export$aec2ce47c367b8c3)));
};
function $83dc86f42fc279ac$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $367fb99255482738$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4),
        (0, $cefd77a409472d8d$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $83dc86f42fc279ac$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $0af463a2f2f36779$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $cefd77a409472d8d$export$1e95b668f3b82d) : (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $cefd77a409472d8d$export$40e543e69a8b3fbb) : (0, $cefd77a409472d8d$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $44d2dcfa9b6528d5$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $af737c27d799169c$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $83dc86f42fc279ac$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $78c67adc35462806$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $83dc86f42fc279ac$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $83dc86f42fc279ac$var$arrow,
    effect: $83dc86f42fc279ac$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $963149affb10e1b3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $3fb07310bceb7864$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3fb07310bceb7864$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $3fb07310bceb7864$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4);
    var sideY = (0, $cefd77a409472d8d$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $44d2dcfa9b6528d5$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(popper);
            if ((0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cefd77a409472d8d$export$1e95b668f3b82d) || (placement === (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4) || placement === (0, $cefd77a409472d8d$export$79ffe56a765070d2)) && variation === (0, $cefd77a409472d8d$export$bd5df0f255a350f8)) {
            sideY = (0, $cefd77a409472d8d$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4) || (placement === (0, $cefd77a409472d8d$export$1e95b668f3b82d) || placement === (0, $cefd77a409472d8d$export$40e543e69a8b3fbb)) && variation === (0, $cefd77a409472d8d$export$bd5df0f255a350f8)) {
            sideX = (0, $cefd77a409472d8d$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3fb07310bceb7864$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3fb07310bceb7864$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $3fb07310bceb7864$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $963149affb10e1b3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3fb07310bceb7864$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3fb07310bceb7864$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3fb07310bceb7864$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $3fb07310bceb7864$var$computeStyles,
    data: {}
};



var $e4433c3268ceda30$var$passive = {
    passive: true
};
function $e4433c3268ceda30$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e4433c3268ceda30$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e4433c3268ceda30$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e4433c3268ceda30$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e4433c3268ceda30$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e4433c3268ceda30$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e4433c3268ceda30$var$effect,
    data: {}
};


var $f1842893058158ff$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $f1842893058158ff$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $f1842893058158ff$var$hash[matched];
    });
}



var $52285ff45efd9816$var$hash = {
    start: 'end',
    end: 'start'
};
function $52285ff45efd9816$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $52285ff45efd9816$var$hash[matched];
    });
}








function $c4e0cf975615cf4c$export$2e2bcd8739ae039(node) {
    var win = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $30c541c7d797b61f$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)((0, $562fcd476b3355d2$export$2e2bcd8739ae039)(element)).left + (0, $c4e0cf975615cf4c$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $616485e4a91e3db8$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(element);
    var html = (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b496e8e32f6ce209$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $30c541c7d797b61f$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $c9bc4bd93d03c0dd$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $c4e0cf975615cf4c$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $30c541c7d797b61f$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $555c06a00f1841ba$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $4cb396b5b9e812c5$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $335c1d630991db9d$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(node) && (0, $555c06a00f1841ba$export$2e2bcd8739ae039)(node)) return node;
    return $4cb396b5b9e812c5$export$2e2bcd8739ae039((0, $a13476024d635e41$export$2e2bcd8739ae039)(node));
}





function $2faa903c271e9c84$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $4cb396b5b9e812c5$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $555c06a00f1841ba$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($2faa903c271e9c84$export$2e2bcd8739ae039((0, $a13476024d635e41$export$2e2bcd8739ae039)(target)));
}










function $58ad4cd3a98c7161$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $33bb425c939e76c7$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $33bb425c939e76c7$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cefd77a409472d8d$export$d7b7311ec04a3e8f) ? (0, $58ad4cd3a98c7161$export$2e2bcd8739ae039)((0, $616485e4a91e3db8$export$2e2bcd8739ae039)(element, strategy)) : (0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(clippingParent) ? $33bb425c939e76c7$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $58ad4cd3a98c7161$export$2e2bcd8739ae039)((0, $c9bc4bd93d03c0dd$export$2e2bcd8739ae039)((0, $562fcd476b3355d2$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $33bb425c939e76c7$var$getClippingParents(element) {
    var clippingParents = (0, $2faa903c271e9c84$export$2e2bcd8739ae039)((0, $a13476024d635e41$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $aa613a05ba685ccb$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(element) ? (0, $44d2dcfa9b6528d5$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(clippingParent) && (0, $78c67adc35462806$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $335c1d630991db9d$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $33bb425c939e76c7$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $33bb425c939e76c7$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $33bb425c939e76c7$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $cfac5f0503fa0c0c$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $cfac5f0503fa0c0c$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $33bb425c939e76c7$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $ef298a14a6d7c348$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $963149affb10e1b3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cefd77a409472d8d$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cefd77a409472d8d$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cefd77a409472d8d$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cefd77a409472d8d$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $367fb99255482738$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cefd77a409472d8d$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cefd77a409472d8d$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $5c75910e995426af$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cefd77a409472d8d$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cefd77a409472d8d$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cefd77a409472d8d$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $96514a6e68cf3ac6$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $30de99b1366d30c9$export$2e2bcd8739ae039)(padding, (0, $cefd77a409472d8d$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $cefd77a409472d8d$export$ae5ab1c730825774) ? (0, $cefd77a409472d8d$export$ca50aac9f3ba507f) : (0, $cefd77a409472d8d$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $33bb425c939e76c7$export$2e2bcd8739ae039)((0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $ef298a14a6d7c348$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $58ad4cd3a98c7161$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cefd77a409472d8d$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cefd77a409472d8d$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cefd77a409472d8d$export$79ffe56a765070d2),
                (0, $cefd77a409472d8d$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cefd77a409472d8d$export$1e95b668f3b82d),
                (0, $cefd77a409472d8d$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $99991629c512342a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cefd77a409472d8d$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $963149affb10e1b3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $cefd77a409472d8d$export$368f9a87e87fa4e1) : (0, $cefd77a409472d8d$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $963149affb10e1b3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $cefd77a409472d8d$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $5c75910e995426af$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $bed9f5a8c2893a90$var$getExpandedFallbackPlacements(placement) {
    if ((0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement) === (0, $cefd77a409472d8d$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $f1842893058158ff$export$2e2bcd8739ae039)(placement);
    return [
        (0, $52285ff45efd9816$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $52285ff45efd9816$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $bed9f5a8c2893a90$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $f1842893058158ff$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $bed9f5a8c2893a90$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement) === (0, $cefd77a409472d8d$export$dfb5619354ba860) ? (0, $99991629c512342a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $963149affb10e1b3$export$2e2bcd8739ae039)(placement) === (0, $cefd77a409472d8d$export$b3571188c770cc5a);
        var isVertical = [
            (0, $cefd77a409472d8d$export$1e95b668f3b82d),
            (0, $cefd77a409472d8d$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $5c75910e995426af$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cefd77a409472d8d$export$79ffe56a765070d2) : (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $cefd77a409472d8d$export$40e543e69a8b3fbb) : (0, $cefd77a409472d8d$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $f1842893058158ff$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $f1842893058158ff$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $bed9f5a8c2893a90$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $bed9f5a8c2893a90$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $222ad0d139efc5fd$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $222ad0d139efc5fd$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cefd77a409472d8d$export$1e95b668f3b82d),
        (0, $cefd77a409472d8d$export$79ffe56a765070d2),
        (0, $cefd77a409472d8d$export$40e543e69a8b3fbb),
        (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $222ad0d139efc5fd$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $5c75910e995426af$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $5c75910e995426af$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $222ad0d139efc5fd$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $222ad0d139efc5fd$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $222ad0d139efc5fd$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $222ad0d139efc5fd$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $222ad0d139efc5fd$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $222ad0d139efc5fd$var$hide
};




function $07171abb3b970e38$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4),
        (0, $cefd77a409472d8d$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4),
        (0, $cefd77a409472d8d$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $07171abb3b970e38$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cefd77a409472d8d$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $07171abb3b970e38$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $07171abb3b970e38$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $07171abb3b970e38$var$offset
};



function $f7ba4eded364f4f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $ef298a14a6d7c348$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f7ba4eded364f4f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $f7ba4eded364f4f7$var$popperOffsets,
    data: {}
};





function $27d0d9b036ab2393$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $19834a509ede1e0f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $5c75910e995426af$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $41b6b608ffa08ca1$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $963149affb10e1b3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $367fb99255482738$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $27d0d9b036ab2393$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cefd77a409472d8d$export$1e95b668f3b82d) : (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $cefd77a409472d8d$export$40e543e69a8b3fbb) : (0, $cefd77a409472d8d$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cefd77a409472d8d$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cefd77a409472d8d$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $0af463a2f2f36779$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $a5ee4ff71e95e5f9$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $af737c27d799169c$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $44d2dcfa9b6528d5$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $af737c27d799169c$export$f28d906d67a997f3)(tether ? (0, $cfac5f0503fa0c0c$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $cfac5f0503fa0c0c$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cefd77a409472d8d$export$1e95b668f3b82d) : (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $cefd77a409472d8d$export$40e543e69a8b3fbb) : (0, $cefd77a409472d8d$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cefd77a409472d8d$export$1e95b668f3b82d),
            (0, $cefd77a409472d8d$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $af737c27d799169c$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $af737c27d799169c$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $19834a509ede1e0f$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $19834a509ede1e0f$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $1522d2d0b08b8e74$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $6958779f792d73b3$export$2e2bcd8739ae039(node) {
    if (node === (0, $52a68dbbf79b0696$export$2e2bcd8739ae039)(node) || !(0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(node)) return (0, $c4e0cf975615cf4c$export$2e2bcd8739ae039)(node);
    else return (0, $1522d2d0b08b8e74$export$2e2bcd8739ae039)(node);
}








function $ba496b91dbb50203$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cfac5f0503fa0c0c$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $ba496b91dbb50203$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(offsetParent) && $ba496b91dbb50203$var$isElementScaled(offsetParent);
    var documentElement = (0, $562fcd476b3355d2$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $335c1d630991db9d$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $555c06a00f1841ba$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $6958779f792d73b3$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $02e3a7a40389e518$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $8e6bc95b10844cc4$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $30c541c7d797b61f$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $55372a8a1c1b1368$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $55372a8a1c1b1368$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $55372a8a1c1b1368$var$order(modifiers); // order based on phase
    return (0, $cefd77a409472d8d$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $894c4f4cf7ffd620$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $05d485493b85a587$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $ada4301381eadd7f$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $ada4301381eadd7f$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $ada4301381eadd7f$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $ada4301381eadd7f$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $ada4301381eadd7f$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $02e3a7a40389e518$export$45a5e7f76e0caa8d)(reference) ? (0, $2faa903c271e9c84$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $2faa903c271e9c84$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $2faa903c271e9c84$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $55372a8a1c1b1368$export$2e2bcd8739ae039)((0, $05d485493b85a587$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$ada4301381eadd7f$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $ba496b91dbb50203$export$2e2bcd8739ae039)(_$reference, (0, $44d2dcfa9b6528d5$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $0af463a2f2f36779$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $894c4f4cf7ffd620$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$ada4301381eadd7f$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $ada4301381eadd7f$export$8f7491d57c8f97a9 = /*#__PURE__*/ $ada4301381eadd7f$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $bdeead69b159d288$export$d34966752335dd47 = [
    (0, $e4433c3268ceda30$export$2e2bcd8739ae039),
    (0, $f7ba4eded364f4f7$export$2e2bcd8739ae039),
    (0, $3fb07310bceb7864$export$2e2bcd8739ae039),
    (0, $74054666164da556$export$2e2bcd8739ae039),
    (0, $07171abb3b970e38$export$2e2bcd8739ae039),
    (0, $bed9f5a8c2893a90$export$2e2bcd8739ae039),
    (0, $19834a509ede1e0f$export$2e2bcd8739ae039),
    (0, $83dc86f42fc279ac$export$2e2bcd8739ae039),
    (0, $222ad0d139efc5fd$export$2e2bcd8739ae039)
];
var $bdeead69b159d288$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $ada4301381eadd7f$export$ed5e13716264f202)({
    defaultModifiers: $bdeead69b159d288$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $91bd71f001b9e709$export$d34966752335dd47 = [
    (0, $e4433c3268ceda30$export$2e2bcd8739ae039),
    (0, $f7ba4eded364f4f7$export$2e2bcd8739ae039),
    (0, $3fb07310bceb7864$export$2e2bcd8739ae039),
    (0, $74054666164da556$export$2e2bcd8739ae039)
];
var $91bd71f001b9e709$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $ada4301381eadd7f$export$ed5e13716264f202)({
    defaultModifiers: $91bd71f001b9e709$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($22226631ba3d4356$exports, $cefd77a409472d8d$exports);
$parcel$exportWildcard($22226631ba3d4356$exports, $30fb6fc8419c2434$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$elementMap = new Map();
var $a3e6c60bea301201$var$Data = {
    set: function(element, key, instance) {
        if (!$a3e6c60bea301201$var$elementMap.has(element)) $a3e6c60bea301201$var$elementMap.set(element, new Map());
        var instanceMap = $a3e6c60bea301201$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0], "."));
            return;
        }
        instanceMap.set(key, instance);
    },
    get: function(element, key) {
        if ($a3e6c60bea301201$var$elementMap.has(element)) return $a3e6c60bea301201$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove: function(element, key) {
        if (!$a3e6c60bea301201$var$elementMap.has(element)) return;
        var instanceMap = $a3e6c60bea301201$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $a3e6c60bea301201$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $a3e6c60bea301201$var$MAX_UID = 1000000;
var $a3e6c60bea301201$var$MILLISECONDS_MULTIPLIER = 1000;
var $a3e6c60bea301201$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ var $a3e6c60bea301201$var$parseSelector = function(selector) {
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, function(match, id) {
        return "#".concat(CSS.escape(id));
    });
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
var $a3e6c60bea301201$var$toType = function(object) {
    if (object === null || object === undefined) return "".concat(object);
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ var $a3e6c60bea301201$var$getUID = function(prefix) {
    do prefix += Math.floor(Math.random() * $a3e6c60bea301201$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
var $a3e6c60bea301201$var$getTransitionDurationFromElement = function(element) {
    if (!element) return 0;
    // Get transition-duration of the element
    var _window_getComputedStyle = window.getComputedStyle(element), transitionDuration = _window_getComputedStyle.transitionDuration, transitionDelay = _window_getComputedStyle.transitionDelay;
    var floatTransitionDuration = Number.parseFloat(transitionDuration);
    var floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $a3e6c60bea301201$var$MILLISECONDS_MULTIPLIER;
};
var $a3e6c60bea301201$var$triggerTransitionEnd = function(element) {
    element.dispatchEvent(new Event($a3e6c60bea301201$var$TRANSITION_END));
};
var $a3e6c60bea301201$var$isElement = function(object) {
    if (!object || (typeof object === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(object)) !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
var $a3e6c60bea301201$var$getElement = function(object) {
    // it's a jQuery object or a node element
    if ($a3e6c60bea301201$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($a3e6c60bea301201$var$parseSelector(object));
    return null;
};
var $a3e6c60bea301201$var$isVisible = function(element) {
    if (!$a3e6c60bea301201$var$isElement(element) || element.getClientRects().length === 0) return false;
    var elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    var closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        var summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
var $a3e6c60bea301201$var$isDisabled = function(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
var $a3e6c60bea301201$var$findShadowRoot = function(element) {
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $a3e6c60bea301201$var$findShadowRoot(element.parentNode);
};
var $a3e6c60bea301201$var$noop = function() {};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ var $a3e6c60bea301201$var$reflow = function(element) {
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
var $a3e6c60bea301201$var$getjQuery = function() {
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
var $a3e6c60bea301201$var$DOMContentLoadedCallbacks = [];
var $a3e6c60bea301201$var$onDOMContentLoaded = function(callback) {
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$a3e6c60bea301201$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = $a3e6c60bea301201$var$DOMContentLoadedCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$callback = _step.value;
                    _$callback();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        $a3e6c60bea301201$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
var $a3e6c60bea301201$var$isRTL = function() {
    return document.documentElement.dir === 'rtl';
};
var $a3e6c60bea301201$var$defineJQueryPlugin = function(plugin) {
    $a3e6c60bea301201$var$onDOMContentLoaded(function() {
        var $ = $a3e6c60bea301201$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            var name = plugin.NAME;
            var JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = function() {
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
var $a3e6c60bea301201$var$execute = function(possibleCallback) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : possibleCallback;
    return typeof possibleCallback === 'function' ? possibleCallback.apply(void 0, (0, $1961f7bca441a4c6$export$71511d61b312f219)(args)) : defaultValue;
};
var $a3e6c60bea301201$var$executeAfterTransition = function(callback, transitionElement) {
    var waitForTransition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!waitForTransition) {
        $a3e6c60bea301201$var$execute(callback);
        return;
    }
    var durationPadding = 5;
    var emulatedDuration = $a3e6c60bea301201$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    var called = false;
    var handler = function(param) {
        var target = param.target;
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($a3e6c60bea301201$var$TRANSITION_END, handler);
        $a3e6c60bea301201$var$execute(callback);
    };
    transitionElement.addEventListener($a3e6c60bea301201$var$TRANSITION_END, handler);
    setTimeout(function() {
        if (!called) $a3e6c60bea301201$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ var $a3e6c60bea301201$var$getNextActiveElement = function(list, activeElement, shouldGetNext, isCycleAllowed) {
    var listLength = list.length;
    var index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
var $a3e6c60bea301201$var$stripNameRegex = /\..*/;
var $a3e6c60bea301201$var$stripUidRegex = /::\d+$/;
var $a3e6c60bea301201$var$eventRegistry = {}; // Events storage
var $a3e6c60bea301201$var$uidEvent = 1;
var $a3e6c60bea301201$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
var $a3e6c60bea301201$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $a3e6c60bea301201$var$makeEventUid(element, uid) {
    return uid && "".concat(uid, "::").concat($a3e6c60bea301201$var$uidEvent++) || element.uidEvent || $a3e6c60bea301201$var$uidEvent++;
}
function $a3e6c60bea301201$var$getElementEvents(element) {
    var uid = $a3e6c60bea301201$var$makeEventUid(element);
    element.uidEvent = uid;
    $a3e6c60bea301201$var$eventRegistry[uid] = $a3e6c60bea301201$var$eventRegistry[uid] || {};
    return $a3e6c60bea301201$var$eventRegistry[uid];
}
function $a3e6c60bea301201$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $a3e6c60bea301201$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $a3e6c60bea301201$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $a3e6c60bea301201$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        var domElements = element.querySelectorAll(selector);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        for(var target = event.target; target && target !== this; target = target.parentNode)try {
            for(var _iterator = domElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var domElement = _step.value;
                if (domElement !== target) continue;
                $a3e6c60bea301201$var$hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) $a3e6c60bea301201$var$EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
function $a3e6c60bea301201$var$findHandler(events, callable) {
    var delegationSelector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return Object.values(events).find(function(event) {
        return event.callable === callable && event.delegationSelector === delegationSelector;
    });
}
function $a3e6c60bea301201$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    var isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    var callable = isDelegated ? delegationFunction : handler || delegationFunction;
    var typeEvent = $a3e6c60bea301201$var$getTypeEvent(originalTypeEvent);
    if (!$a3e6c60bea301201$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $a3e6c60bea301201$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    var _normalizeParameters = (0, $d98b89efad01a571$export$71511d61b312f219)($a3e6c60bea301201$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $a3e6c60bea301201$var$customEvents) {
        var wrapFunction = function(fn) {
            return function wrapFunction(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    var events = $a3e6c60bea301201$var$getElementEvents(element);
    var handlers = events[typeEvent] || (events[typeEvent] = {});
    var previousFunction = $a3e6c60bea301201$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    var uid = $a3e6c60bea301201$var$makeEventUid(callable, originalTypeEvent.replace($a3e6c60bea301201$var$namespaceRegex, ''));
    var fn = isDelegated ? $a3e6c60bea301201$var$bootstrapDelegationHandler(element, handler, callable) : $a3e6c60bea301201$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    var fn = $a3e6c60bea301201$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $a3e6c60bea301201$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    var storeElementEvent = events[typeEvent] || {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(storeElementEvent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $d98b89efad01a571$export$71511d61b312f219)(_step.value, 2), handlerKey = _step_value[0], event = _step_value[1];
            if (handlerKey.includes(namespace)) $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $a3e6c60bea301201$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($a3e6c60bea301201$var$stripNameRegex, '');
    return $a3e6c60bea301201$var$customEvents[event] || event;
}
var $a3e6c60bea301201$var$EventHandler = {
    on: function(element, event, handler, delegationFunction) {
        $a3e6c60bea301201$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one: function(element, event, handler, delegationFunction) {
        $a3e6c60bea301201$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off: function(element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        var _normalizeParameters = (0, $d98b89efad01a571$export$71511d61b312f219)($a3e6c60bea301201$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
        var inNamespace = typeEvent !== originalTypeEvent;
        var events = $a3e6c60bea301201$var$getElementEvents(element);
        var storeElementEvent = events[typeEvent] || {};
        var isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (isNamespace) try {
            for(var _iterator = Object.keys(events)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elementEvent = _step.value;
                $a3e6c60bea301201$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.entries(storeElementEvent)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $d98b89efad01a571$export$71511d61b312f219)(_step1.value, 2), keyHandlers = _step_value[0], event = _step_value[1];
                var handlerKey = keyHandlers.replace($a3e6c60bea301201$var$stripUidRegex, '');
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) $a3e6c60bea301201$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    },
    trigger: function(element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        var $ = $a3e6c60bea301201$var$getjQuery();
        var typeEvent = $a3e6c60bea301201$var$getTypeEvent(event);
        var inNamespace = event !== typeEvent;
        var jQueryEvent = null;
        var bubbles = true;
        var nativeDispatch = true;
        var defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        var evt = $a3e6c60bea301201$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $a3e6c60bea301201$var$hydrateObj(obj) {
    var meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $d98b89efad01a571$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            try {
                obj[key] = value;
            } catch (_unused) {
                Object.defineProperty(obj, key, {
                    configurable: true,
                    get: function() {
                        return value;
                    }
                });
            }
        };
        for(var _iterator = Object.entries(meta)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $a3e6c60bea301201$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $a3e6c60bea301201$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, function(chr) {
        return "-".concat(chr.toLowerCase());
    });
}
var $a3e6c60bea301201$var$Manipulator = {
    setDataAttribute: function(element, key, value) {
        element.setAttribute("data-bs-".concat($a3e6c60bea301201$var$normalizeDataKey(key)), value);
    },
    removeDataAttribute: function(element, key) {
        element.removeAttribute("data-bs-".concat($a3e6c60bea301201$var$normalizeDataKey(key)));
    },
    getDataAttributes: function(element) {
        if (!element) return {};
        var attributes = {};
        var bsKeys = Object.keys(element.dataset).filter(function(key) {
            return key.startsWith('bs') && !key.startsWith('bsConfig');
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = bsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var pureKey = key.replace(/^bs/, '');
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
                attributes[pureKey] = $a3e6c60bea301201$var$normalizeData(element.dataset[key]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return attributes;
    },
    getDataAttribute: function(element, key) {
        return $a3e6c60bea301201$var$normalizeData(element.getAttribute("data-bs-".concat($a3e6c60bea301201$var$normalizeDataKey(key))));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ var $a3e6c60bea301201$var$Config = /*#__PURE__*/ function() {
    "use strict";
    function Config() {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Config);
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Config, [
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                return config;
            }
        },
        {
            key: "_mergeConfigObj",
            value: function _mergeConfigObj(config, element) {
                var jsonConfig = $a3e6c60bea301201$var$isElement(element) ? $a3e6c60bea301201$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
                return (0, $34448b2f636abc71$export$71511d61b312f219)({}, this.constructor.Default, (typeof jsonConfig === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(jsonConfig)) === 'object' ? jsonConfig : {}, $a3e6c60bea301201$var$isElement(element) ? $a3e6c60bea301201$var$Manipulator.getDataAttributes(element) : {}, (typeof config === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(config)) === 'object' ? config : {});
            }
        },
        {
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                var configTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.constructor.DefaultType;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(configTypes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $d98b89efad01a571$export$71511d61b312f219)(_step.value, 2), property = _step_value[0], expectedTypes = _step_value[1];
                        var value = config[property];
                        var valueType = $a3e6c60bea301201$var$isElement(value) ? 'element' : $a3e6c60bea301201$var$toType(value);
                        if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError("".concat(this.constructor.NAME.toUpperCase(), ': Option "').concat(property, '" provided type "').concat(valueType, '" but expected type "').concat(expectedTypes, '".'));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return {};
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return {};
            }
        },
        {
            key: "NAME",
            get: function get() {
                throw new Error('You have to implement the static method "NAME", for each component!');
            }
        }
    ]);
    return Config;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$VERSION = '5.3.3';
/**
 * Class definition
 */ var $a3e6c60bea301201$var$BaseComponent = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(BaseComponent, Config);
    function BaseComponent(element, config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, BaseComponent);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, BaseComponent);
        element = $a3e6c60bea301201$var$getElement(element);
        if (!element) return (0, $5f8faa38aa7bcc75$export$71511d61b312f219)(_this);
        _this._element = element;
        _this._config = _this._getConfig(config);
        $a3e6c60bea301201$var$Data.set(_this._element, _this.constructor.DATA_KEY, _this);
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(BaseComponent, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $a3e6c60bea301201$var$Data.remove(this._element, this.constructor.DATA_KEY);
                $a3e6c60bea301201$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.getOwnPropertyNames(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var propertyName = _step.value;
                        this[propertyName] = null;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_queueCallback",
            value: function _queueCallback(callback, element) {
                var isAnimated = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                $a3e6c60bea301201$var$executeAfterTransition(callback, element, isAnimated);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config, this._element);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        }
    ], [
        {
            key: "getInstance",
            value: // Static
            function getInstance(element) {
                return $a3e6c60bea301201$var$Data.get($a3e6c60bea301201$var$getElement(element), this.DATA_KEY);
            }
        },
        {
            key: "getOrCreateInstance",
            value: function getOrCreateInstance(element) {
                var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return this.getInstance(element) || new this(element, (typeof config === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(config)) === 'object' ? config : null);
            }
        },
        {
            key: "VERSION",
            get: function get() {
                return $a3e6c60bea301201$var$VERSION;
            }
        },
        {
            key: "DATA_KEY",
            get: function get() {
                return "bs.".concat(this.NAME);
            }
        },
        {
            key: "EVENT_KEY",
            get: function get() {
                return ".".concat(this.DATA_KEY);
            }
        },
        {
            key: "eventName",
            value: function eventName(name) {
                return "".concat(name).concat(this.EVENT_KEY);
            }
        }
    ]);
    return BaseComponent;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $a3e6c60bea301201$var$getSelector = function(element) {
    var selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        var hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = "#".concat(hrefAttribute.split('#')[1]);
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map(function(sel) {
        return $a3e6c60bea301201$var$parseSelector(sel);
    }).join(',') : null;
};
var $a3e6c60bea301201$var$SelectorEngine = {
    find: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $1961f7bca441a4c6$export$71511d61b312f219)(Element.prototype.querySelectorAll.call(element, selector)));
    },
    findOne: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        return Element.prototype.querySelector.call(element, selector);
    },
    children: function(element, selector) {
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $1961f7bca441a4c6$export$71511d61b312f219)(element.children)).filter(function(child) {
            return child.matches(selector);
        });
    },
    parents: function(element, selector) {
        var parents = [];
        var ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev: function(element, selector) {
        var previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next: function(element, selector) {
        var next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren: function(element) {
        var focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map(function(selector) {
            return "".concat(selector, ':not([tabindex^="-"])');
        }).join(',');
        return this.find(focusables, element).filter(function(el) {
            return !$a3e6c60bea301201$var$isDisabled(el) && $a3e6c60bea301201$var$isVisible(el);
        });
    },
    getSelectorFromElement: function(element) {
        var selector = $a3e6c60bea301201$var$getSelector(element);
        if (selector) return $a3e6c60bea301201$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector: function(element) {
        var selector = $a3e6c60bea301201$var$getSelector(element);
        return selector ? $a3e6c60bea301201$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector: function(element) {
        var selector = $a3e6c60bea301201$var$getSelector(element);
        return selector ? $a3e6c60bea301201$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $a3e6c60bea301201$var$enableDismissTrigger = function(component) {
    var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'hide';
    var clickEvent = "click.dismiss".concat(component.EVENT_KEY);
    var name = component.NAME;
    $a3e6c60bea301201$var$EventHandler.on(document, clickEvent, '[data-bs-dismiss="'.concat(name, '"]'), function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($a3e6c60bea301201$var$isDisabled(this)) return;
        var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this) || this.closest(".".concat(name));
        var instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$f = 'alert';
var $a3e6c60bea301201$var$DATA_KEY$a = 'bs.alert';
var $a3e6c60bea301201$var$EVENT_KEY$b = ".".concat($a3e6c60bea301201$var$DATA_KEY$a);
var $a3e6c60bea301201$var$EVENT_CLOSE = "close".concat($a3e6c60bea301201$var$EVENT_KEY$b);
var $a3e6c60bea301201$var$EVENT_CLOSED = "closed".concat($a3e6c60bea301201$var$EVENT_KEY$b);
var $a3e6c60bea301201$var$CLASS_NAME_FADE$5 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ var $a3e6c60bea301201$export$caec2af78bcc877f = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Alert, BaseComponent);
    function Alert() {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Alert);
        return (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Alert, arguments);
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Alert, [
        {
            // Public
            key: "close",
            value: function close() {
                var _this = this;
                var closeEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_CLOSE);
                if (closeEvent.defaultPrevented) return;
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$8);
                var isAnimated = this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$5);
                this._queueCallback(function() {
                    return _this._destroyElement();
                }, this._element, isAnimated);
            }
        },
        {
            // Private
            key: "_destroyElement",
            value: function _destroyElement() {
                this._element.remove();
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_CLOSED);
                this.dispose();
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$NAME$f;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Alert.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Alert;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$e = 'button';
var $a3e6c60bea301201$var$DATA_KEY$9 = 'bs.button';
var $a3e6c60bea301201$var$EVENT_KEY$a = ".".concat($a3e6c60bea301201$var$DATA_KEY$9);
var $a3e6c60bea301201$var$DATA_API_KEY$6 = '.data-api';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE$3 = 'active';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$6 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$a).concat($a3e6c60bea301201$var$DATA_API_KEY$6);
/**
 * Class definition
 */ var $a3e6c60bea301201$export$353f5b6fc5456de1 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Button, BaseComponent);
    function Button() {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Button);
        return (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Button, arguments);
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Button, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
                this._element.setAttribute('aria-pressed', this._element.classList.toggle($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$3));
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$NAME$e;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Button.getOrCreateInstance(this);
                    if (config === 'toggle') data[config]();
                });
            }
        }
    ]);
    return Button;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$6, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$5, function(event) {
    event.preventDefault();
    var button = event.target.closest($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$5);
    var data = $a3e6c60bea301201$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$d = 'swipe';
var $a3e6c60bea301201$var$EVENT_KEY$9 = '.bs.swipe';
var $a3e6c60bea301201$var$EVENT_TOUCHSTART = "touchstart".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_TOUCHMOVE = "touchmove".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_TOUCHEND = "touchend".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_POINTERDOWN = "pointerdown".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$EVENT_POINTERUP = "pointerup".concat($a3e6c60bea301201$var$EVENT_KEY$9);
var $a3e6c60bea301201$var$POINTER_TYPE_TOUCH = 'touch';
var $a3e6c60bea301201$var$POINTER_TYPE_PEN = 'pen';
var $a3e6c60bea301201$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
var $a3e6c60bea301201$var$SWIPE_THRESHOLD = 40;
var $a3e6c60bea301201$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
var $a3e6c60bea301201$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$Swipe = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Swipe, Config);
    function Swipe(element, config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Swipe);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Swipe);
        _this._element = element;
        if (!element || !Swipe.isSupported()) return (0, $5f8faa38aa7bcc75$export$71511d61b312f219)(_this);
        _this._config = _this._getConfig(config);
        _this._deltaX = 0;
        _this._supportPointerEvents = Boolean(window.PointerEvent);
        _this._initEvents();
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Swipe, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $a3e6c60bea301201$var$EventHandler.off(this._element, $a3e6c60bea301201$var$EVENT_KEY$9);
            }
        },
        {
            // Private
            key: "_start",
            value: function _start(event) {
                if (!this._supportPointerEvents) {
                    this._deltaX = event.touches[0].clientX;
                    return;
                }
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
            }
        },
        {
            key: "_end",
            value: function _end(event) {
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
                this._handleSwipe();
                $a3e6c60bea301201$var$execute(this._config.endCallback);
            }
        },
        {
            key: "_move",
            value: function _move(event) {
                this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
            }
        },
        {
            key: "_handleSwipe",
            value: function _handleSwipe() {
                var absDeltaX = Math.abs(this._deltaX);
                if (absDeltaX <= $a3e6c60bea301201$var$SWIPE_THRESHOLD) return;
                var direction = absDeltaX / this._deltaX;
                this._deltaX = 0;
                if (!direction) return;
                $a3e6c60bea301201$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
            }
        },
        {
            key: "_initEvents",
            value: function _initEvents() {
                var _this = this;
                if (this._supportPointerEvents) {
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_POINTERDOWN, function(event) {
                        return _this._start(event);
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_POINTERUP, function(event) {
                        return _this._end(event);
                    });
                    this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_POINTER_EVENT);
                } else {
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_TOUCHSTART, function(event) {
                        return _this._start(event);
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_TOUCHMOVE, function(event) {
                        return _this._move(event);
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_TOUCHEND, function(event) {
                        return _this._end(event);
                    });
                }
            }
        },
        {
            key: "_eventIsPointerPenTouch",
            value: function _eventIsPointerPenTouch(event) {
                return this._supportPointerEvents && (event.pointerType === $a3e6c60bea301201$var$POINTER_TYPE_PEN || event.pointerType === $a3e6c60bea301201$var$POINTER_TYPE_TOUCH);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$c;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$c;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$d;
            }
        },
        {
            key: "isSupported",
            value: // Static
            function isSupported() {
                return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
            }
        }
    ]);
    return Swipe;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$c = 'carousel';
var $a3e6c60bea301201$var$DATA_KEY$8 = 'bs.carousel';
var $a3e6c60bea301201$var$EVENT_KEY$8 = ".".concat($a3e6c60bea301201$var$DATA_KEY$8);
var $a3e6c60bea301201$var$DATA_API_KEY$5 = '.data-api';
var $a3e6c60bea301201$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
var $a3e6c60bea301201$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
var $a3e6c60bea301201$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
var $a3e6c60bea301201$var$ORDER_NEXT = 'next';
var $a3e6c60bea301201$var$ORDER_PREV = 'prev';
var $a3e6c60bea301201$var$DIRECTION_LEFT = 'left';
var $a3e6c60bea301201$var$DIRECTION_RIGHT = 'right';
var $a3e6c60bea301201$var$EVENT_SLIDE = "slide".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_SLID = "slid".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_KEYDOWN$1 = "keydown".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_MOUSEENTER$1 = "mouseenter".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_MOUSELEAVE$1 = "mouseleave".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_DRAG_START = "dragstart".concat($a3e6c60bea301201$var$EVENT_KEY$8);
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$3 = "load".concat($a3e6c60bea301201$var$EVENT_KEY$8).concat($a3e6c60bea301201$var$DATA_API_KEY$5);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$5 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$8).concat($a3e6c60bea301201$var$DATA_API_KEY$5);
var $a3e6c60bea301201$var$CLASS_NAME_CAROUSEL = 'carousel';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2 = 'active';
var $a3e6c60bea301201$var$CLASS_NAME_SLIDE = 'slide';
var $a3e6c60bea301201$var$CLASS_NAME_END = 'carousel-item-end';
var $a3e6c60bea301201$var$CLASS_NAME_START = 'carousel-item-start';
var $a3e6c60bea301201$var$CLASS_NAME_NEXT = 'carousel-item-next';
var $a3e6c60bea301201$var$CLASS_NAME_PREV = 'carousel-item-prev';
var $a3e6c60bea301201$var$SELECTOR_ACTIVE = '.active';
var $a3e6c60bea301201$var$SELECTOR_ITEM = '.carousel-item';
var $a3e6c60bea301201$var$SELECTOR_ACTIVE_ITEM = $a3e6c60bea301201$var$SELECTOR_ACTIVE + $a3e6c60bea301201$var$SELECTOR_ITEM;
var $a3e6c60bea301201$var$SELECTOR_ITEM_IMG = '.carousel-item img';
var $a3e6c60bea301201$var$SELECTOR_INDICATORS = '.carousel-indicators';
var $a3e6c60bea301201$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
var $a3e6c60bea301201$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
var $a3e6c60bea301201$var$_obj;
var $a3e6c60bea301201$var$KEY_TO_DIRECTION = ($a3e6c60bea301201$var$_obj = {}, (0, $71081ebd7d211bed$export$71511d61b312f219)($a3e6c60bea301201$var$_obj, $a3e6c60bea301201$var$ARROW_LEFT_KEY$1, $a3e6c60bea301201$var$DIRECTION_RIGHT), (0, $71081ebd7d211bed$export$71511d61b312f219)($a3e6c60bea301201$var$_obj, $a3e6c60bea301201$var$ARROW_RIGHT_KEY$1, $a3e6c60bea301201$var$DIRECTION_LEFT), $a3e6c60bea301201$var$_obj);
var $a3e6c60bea301201$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
var $a3e6c60bea301201$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$144901db2ea8e967 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Carousel, BaseComponent);
    function Carousel(element, config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Carousel);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Carousel, [
            element,
            config
        ]);
        _this._interval = null;
        _this._activeElement = null;
        _this._isSliding = false;
        _this.touchTimeout = null;
        _this._swipeHelper = null;
        _this._indicatorsElement = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_INDICATORS, _this._element);
        _this._addEventListeners();
        if (_this._config.ride === $a3e6c60bea301201$var$CLASS_NAME_CAROUSEL) _this.cycle();
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Carousel, [
        {
            // Public
            key: "next",
            value: function next() {
                this._slide($a3e6c60bea301201$var$ORDER_NEXT);
            }
        },
        {
            key: "nextWhenVisible",
            value: function nextWhenVisible() {
                // FIXME TODO use `document.visibilityState`
                // Don't call next when the page isn't visible
                // or the carousel or its parent isn't visible
                if (!document.hidden && $a3e6c60bea301201$var$isVisible(this._element)) this.next();
            }
        },
        {
            key: "prev",
            value: function prev() {
                this._slide($a3e6c60bea301201$var$ORDER_PREV);
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this._isSliding) $a3e6c60bea301201$var$triggerTransitionEnd(this._element);
                this._clearInterval();
            }
        },
        {
            key: "cycle",
            value: function cycle() {
                var _this = this;
                this._clearInterval();
                this._updateInterval();
                this._interval = setInterval(function() {
                    return _this.nextWhenVisible();
                }, this._config.interval);
            }
        },
        {
            key: "_maybeEnableCycle",
            value: function _maybeEnableCycle() {
                var _this = this;
                if (!this._config.ride) return;
                if (this._isSliding) {
                    $a3e6c60bea301201$var$EventHandler.one(this._element, $a3e6c60bea301201$var$EVENT_SLID, function() {
                        return _this.cycle();
                    });
                    return;
                }
                this.cycle();
            }
        },
        {
            key: "to",
            value: function to(index) {
                var _this = this;
                var items = this._getItems();
                if (index > items.length - 1 || index < 0) return;
                if (this._isSliding) {
                    $a3e6c60bea301201$var$EventHandler.one(this._element, $a3e6c60bea301201$var$EVENT_SLID, function() {
                        return _this.to(index);
                    });
                    return;
                }
                var activeIndex = this._getItemIndex(this._getActive());
                if (activeIndex === index) return;
                var order = index > activeIndex ? $a3e6c60bea301201$var$ORDER_NEXT : $a3e6c60bea301201$var$ORDER_PREV;
                this._slide(order, items[index]);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._swipeHelper) this._swipeHelper.dispose();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $ccc23a021f1e6bc0$export$71511d61b312f219)(Carousel.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.defaultInterval = config.interval;
                return config;
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                if (this._config.keyboard) $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN$1, function(event) {
                    return _this._keydown(event);
                });
                if (this._config.pause === 'hover') {
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEENTER$1, function() {
                        return _this.pause();
                    });
                    $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSELEAVE$1, function() {
                        return _this._maybeEnableCycle();
                    });
                }
                if (this._config.touch && $a3e6c60bea301201$var$Swipe.isSupported()) this._addTouchEventListeners();
            }
        },
        {
            key: "_addTouchEventListeners",
            value: function _addTouchEventListeners() {
                var _this = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_ITEM_IMG, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var img = _step.value;
                        $a3e6c60bea301201$var$EventHandler.on(img, $a3e6c60bea301201$var$EVENT_DRAG_START, function(event) {
                            return event.preventDefault();
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var endCallBack = function() {
                    if (_this._config.pause !== 'hover') return;
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this.pause();
                    if (_this.touchTimeout) clearTimeout(_this.touchTimeout);
                    _this.touchTimeout = setTimeout(function() {
                        return _this._maybeEnableCycle();
                    }, $a3e6c60bea301201$var$TOUCHEVENT_COMPAT_WAIT + _this._config.interval);
                };
                var swipeConfig = {
                    leftCallback: function() {
                        return _this._slide(_this._directionToOrder($a3e6c60bea301201$var$DIRECTION_LEFT));
                    },
                    rightCallback: function() {
                        return _this._slide(_this._directionToOrder($a3e6c60bea301201$var$DIRECTION_RIGHT));
                    },
                    endCallback: endCallBack
                };
                this._swipeHelper = new $a3e6c60bea301201$var$Swipe(this._element, swipeConfig);
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (/input|textarea/i.test(event.target.tagName)) return;
                var direction = $a3e6c60bea301201$var$KEY_TO_DIRECTION[event.key];
                if (direction) {
                    event.preventDefault();
                    this._slide(this._directionToOrder(direction));
                }
            }
        },
        {
            key: "_getItemIndex",
            value: function _getItemIndex(element) {
                return this._getItems().indexOf(element);
            }
        },
        {
            key: "_setActiveIndicatorElement",
            value: function _setActiveIndicatorElement(index) {
                if (!this._indicatorsElement) return;
                var activeIndicator = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_ACTIVE, this._indicatorsElement);
                activeIndicator.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2);
                activeIndicator.removeAttribute('aria-current');
                var newActiveIndicator = $a3e6c60bea301201$var$SelectorEngine.findOne('[data-bs-slide-to="'.concat(index, '"]'), this._indicatorsElement);
                if (newActiveIndicator) {
                    newActiveIndicator.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2);
                    newActiveIndicator.setAttribute('aria-current', 'true');
                }
            }
        },
        {
            key: "_updateInterval",
            value: function _updateInterval() {
                var element = this._activeElement || this._getActive();
                if (!element) return;
                var elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
                this._config.interval = elementInterval || this._config.defaultInterval;
            }
        },
        {
            key: "_slide",
            value: function _slide(order) {
                var _this = this;
                var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (this._isSliding) return;
                var activeElement = this._getActive();
                var isNext = order === $a3e6c60bea301201$var$ORDER_NEXT;
                var nextElement = element || $a3e6c60bea301201$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
                if (nextElement === activeElement) return;
                var nextElementIndex = this._getItemIndex(nextElement);
                var triggerEvent = function(eventName) {
                    return $a3e6c60bea301201$var$EventHandler.trigger(_this._element, eventName, {
                        relatedTarget: nextElement,
                        direction: _this._orderToDirection(order),
                        from: _this._getItemIndex(activeElement),
                        to: nextElementIndex
                    });
                };
                var slideEvent = triggerEvent($a3e6c60bea301201$var$EVENT_SLIDE);
                if (slideEvent.defaultPrevented) return;
                if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
                // TODO: change tests that use empty divs to avoid this check
                return;
                var isCycling = Boolean(this._interval);
                this.pause();
                this._isSliding = true;
                this._setActiveIndicatorElement(nextElementIndex);
                this._activeElement = nextElement;
                var directionalClassName = isNext ? $a3e6c60bea301201$var$CLASS_NAME_START : $a3e6c60bea301201$var$CLASS_NAME_END;
                var orderClassName = isNext ? $a3e6c60bea301201$var$CLASS_NAME_NEXT : $a3e6c60bea301201$var$CLASS_NAME_PREV;
                nextElement.classList.add(orderClassName);
                $a3e6c60bea301201$var$reflow(nextElement);
                activeElement.classList.add(directionalClassName);
                nextElement.classList.add(directionalClassName);
                var completeCallBack = function() {
                    nextElement.classList.remove(directionalClassName, orderClassName);
                    nextElement.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2);
                    activeElement.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                    _this._isSliding = false;
                    triggerEvent($a3e6c60bea301201$var$EVENT_SLID);
                };
                this._queueCallback(completeCallBack, activeElement, this._isAnimated());
                if (isCycling) this.cycle();
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SLIDE);
            }
        },
        {
            key: "_getActive",
            value: function _getActive() {
                return $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_ACTIVE_ITEM, this._element);
            }
        },
        {
            key: "_getItems",
            value: function _getItems() {
                return $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_ITEM, this._element);
            }
        },
        {
            key: "_clearInterval",
            value: function _clearInterval() {
                if (this._interval) {
                    clearInterval(this._interval);
                    this._interval = null;
                }
            }
        },
        {
            key: "_directionToOrder",
            value: function _directionToOrder(direction) {
                if ($a3e6c60bea301201$var$isRTL()) return direction === $a3e6c60bea301201$var$DIRECTION_LEFT ? $a3e6c60bea301201$var$ORDER_PREV : $a3e6c60bea301201$var$ORDER_NEXT;
                return direction === $a3e6c60bea301201$var$DIRECTION_LEFT ? $a3e6c60bea301201$var$ORDER_NEXT : $a3e6c60bea301201$var$ORDER_PREV;
            }
        },
        {
            key: "_orderToDirection",
            value: function _orderToDirection(order) {
                if ($a3e6c60bea301201$var$isRTL()) return order === $a3e6c60bea301201$var$ORDER_PREV ? $a3e6c60bea301201$var$DIRECTION_LEFT : $a3e6c60bea301201$var$DIRECTION_RIGHT;
                return order === $a3e6c60bea301201$var$ORDER_PREV ? $a3e6c60bea301201$var$DIRECTION_RIGHT : $a3e6c60bea301201$var$DIRECTION_LEFT;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$b;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$b;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$c;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Carousel.getOrCreateInstance(this, config);
                    if (typeof config === 'number') {
                        data.to(config);
                        return;
                    }
                    if (typeof config === 'string') {
                        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Carousel;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$5, $a3e6c60bea301201$var$SELECTOR_DATA_SLIDE, function(event) {
    var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($a3e6c60bea301201$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    var carousel = $a3e6c60bea301201$export$144901db2ea8e967.getOrCreateInstance(target);
    var slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($a3e6c60bea301201$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$3, function() {
    var carousels = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_RIDE);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = carousels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var carousel = _step.value;
            $a3e6c60bea301201$export$144901db2ea8e967.getOrCreateInstance(carousel);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$b = 'collapse';
var $a3e6c60bea301201$var$DATA_KEY$7 = 'bs.collapse';
var $a3e6c60bea301201$var$EVENT_KEY$7 = ".".concat($a3e6c60bea301201$var$DATA_KEY$7);
var $a3e6c60bea301201$var$DATA_API_KEY$4 = '.data-api';
var $a3e6c60bea301201$var$EVENT_SHOW$6 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_SHOWN$6 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_HIDE$6 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_HIDDEN$6 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$7);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$4 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$7).concat($a3e6c60bea301201$var$DATA_API_KEY$4);
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$7 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_COLLAPSE = 'collapse';
var $a3e6c60bea301201$var$CLASS_NAME_COLLAPSING = 'collapsing';
var $a3e6c60bea301201$var$CLASS_NAME_COLLAPSED = 'collapsed';
var $a3e6c60bea301201$var$CLASS_NAME_DEEPER_CHILDREN = ":scope .".concat($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE, " .").concat($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE);
var $a3e6c60bea301201$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
var $a3e6c60bea301201$var$WIDTH = 'width';
var $a3e6c60bea301201$var$HEIGHT = 'height';
var $a3e6c60bea301201$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
var $a3e6c60bea301201$var$Default$a = {
    parent: null,
    toggle: true
};
var $a3e6c60bea301201$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$78768a9af065a7b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Collapse, BaseComponent);
    function Collapse(element, config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Collapse);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Collapse, [
            element,
            config
        ]);
        _this._isTransitioning = false;
        _this._triggerArray = [];
        var toggleList = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = toggleList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elem = _step.value;
                var selector = $a3e6c60bea301201$var$SelectorEngine.getSelectorFromElement(elem);
                var filterElement = $a3e6c60bea301201$var$SelectorEngine.find(selector).filter(function(foundElement) {
                    return foundElement === _this._element;
                });
                if (selector !== null && filterElement.length) _this._triggerArray.push(elem);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _this._initializeChildren();
        if (!_this._config.parent) _this._addAriaAndCollapsedClass(_this._triggerArray, _this._isShown());
        if (_this._config.toggle) _this.toggle();
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Collapse, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                if (this._isShown()) this.hide();
                else this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                if (this._isTransitioning || this._isShown()) return;
                var activeChildren = [];
                // find active children
                if (this._config.parent) activeChildren = this._getFirstLevelChildren($a3e6c60bea301201$var$SELECTOR_ACTIVES).filter(function(element) {
                    return element !== _this._element;
                }).map(function(element) {
                    return Collapse.getOrCreateInstance(element, {
                        toggle: false
                    });
                });
                if (activeChildren.length && activeChildren[0]._isTransitioning) return;
                var startEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$6);
                if (startEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var activeInstance = _step.value;
                        activeInstance.hide();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var dimension = this._getDimension();
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                this._element.style[dimension] = 0;
                this._addAriaAndCollapsedClass(this._triggerArray, true);
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE, $a3e6c60bea301201$var$CLASS_NAME_SHOW$7);
                    _this._element.style[dimension] = '';
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN$6);
                };
                var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                var scrollSize = "scroll".concat(capitalizedDimension);
                this._queueCallback(complete, this._element, true);
                this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (this._isTransitioning || !this._isShown()) return;
                var startEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$6);
                if (startEvent.defaultPrevented) return;
                var dimension = this._getDimension();
                this._element.style[dimension] = "".concat(this._element.getBoundingClientRect()[dimension], "px");
                $a3e6c60bea301201$var$reflow(this._element);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE, $a3e6c60bea301201$var$CLASS_NAME_SHOW$7);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        var element = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(trigger);
                        if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                            trigger
                        ], false);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_COLLAPSE);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$6);
                };
                this._element.style[dimension] = '';
                this._queueCallback(complete, this._element, true);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._element;
                return element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW$7);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.toggle = Boolean(config.toggle); // Coerce string values
                config.parent = $a3e6c60bea301201$var$getElement(config.parent);
                return config;
            }
        },
        {
            key: "_getDimension",
            value: function _getDimension() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_HORIZONTAL) ? $a3e6c60bea301201$var$WIDTH : $a3e6c60bea301201$var$HEIGHT;
            }
        },
        {
            key: "_initializeChildren",
            value: function _initializeChildren() {
                if (!this._config.parent) return;
                var children = this._getFirstLevelChildren($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        var selected = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(element);
                        if (selected) this._addAriaAndCollapsedClass([
                            element
                        ], this._isShown(selected));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_getFirstLevelChildren",
            value: function _getFirstLevelChildren(selector) {
                var children = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
                // remove children if greater depth
                return $a3e6c60bea301201$var$SelectorEngine.find(selector, this._config.parent).filter(function(element) {
                    return !children.includes(element);
                });
            }
        },
        {
            key: "_addAriaAndCollapsedClass",
            value: function _addAriaAndCollapsedClass(triggerArray, isOpen) {
                if (!triggerArray.length) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        element.classList.toggle($a3e6c60bea301201$var$CLASS_NAME_COLLAPSED, !isOpen);
                        element.setAttribute('aria-expanded', isOpen);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$a;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$a;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$b;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                var _config = {};
                if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
                return this.each(function() {
                    var data = Collapse.getOrCreateInstance(this, _config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Collapse;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$4, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.getMultipleElementsFromSelector(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $a3e6c60bea301201$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }).toggle();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$a = 'dropdown';
var $a3e6c60bea301201$var$DATA_KEY$6 = 'bs.dropdown';
var $a3e6c60bea301201$var$EVENT_KEY$6 = ".".concat($a3e6c60bea301201$var$DATA_KEY$6);
var $a3e6c60bea301201$var$DATA_API_KEY$3 = '.data-api';
var $a3e6c60bea301201$var$ESCAPE_KEY$2 = 'Escape';
var $a3e6c60bea301201$var$TAB_KEY$1 = 'Tab';
var $a3e6c60bea301201$var$ARROW_UP_KEY$1 = 'ArrowUp';
var $a3e6c60bea301201$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
var $a3e6c60bea301201$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
var $a3e6c60bea301201$var$EVENT_HIDE$5 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_HIDDEN$5 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_SHOW$5 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_SHOWN$5 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$6);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$3 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$6).concat($a3e6c60bea301201$var$DATA_API_KEY$3);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_DATA_API = "keydown".concat($a3e6c60bea301201$var$EVENT_KEY$6).concat($a3e6c60bea301201$var$DATA_API_KEY$3);
var $a3e6c60bea301201$var$EVENT_KEYUP_DATA_API = "keyup".concat($a3e6c60bea301201$var$EVENT_KEY$6).concat($a3e6c60bea301201$var$DATA_API_KEY$3);
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$6 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_DROPUP = 'dropup';
var $a3e6c60bea301201$var$CLASS_NAME_DROPEND = 'dropend';
var $a3e6c60bea301201$var$CLASS_NAME_DROPSTART = 'dropstart';
var $a3e6c60bea301201$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
var $a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_SHOWN = "".concat($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, ".").concat($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
var $a3e6c60bea301201$var$SELECTOR_MENU = '.dropdown-menu';
var $a3e6c60bea301201$var$SELECTOR_NAVBAR = '.navbar';
var $a3e6c60bea301201$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
var $a3e6c60bea301201$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
var $a3e6c60bea301201$var$PLACEMENT_TOP = $a3e6c60bea301201$var$isRTL() ? 'top-end' : 'top-start';
var $a3e6c60bea301201$var$PLACEMENT_TOPEND = $a3e6c60bea301201$var$isRTL() ? 'top-start' : 'top-end';
var $a3e6c60bea301201$var$PLACEMENT_BOTTOM = $a3e6c60bea301201$var$isRTL() ? 'bottom-end' : 'bottom-start';
var $a3e6c60bea301201$var$PLACEMENT_BOTTOMEND = $a3e6c60bea301201$var$isRTL() ? 'bottom-start' : 'bottom-end';
var $a3e6c60bea301201$var$PLACEMENT_RIGHT = $a3e6c60bea301201$var$isRTL() ? 'left-start' : 'right-start';
var $a3e6c60bea301201$var$PLACEMENT_LEFT = $a3e6c60bea301201$var$isRTL() ? 'right-start' : 'left-start';
var $a3e6c60bea301201$var$PLACEMENT_TOPCENTER = 'top';
var $a3e6c60bea301201$var$PLACEMENT_BOTTOMCENTER = 'bottom';
var $a3e6c60bea301201$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
var $a3e6c60bea301201$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$931cbfb6bfb85fc = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Dropdown, BaseComponent);
    function Dropdown(element, config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Dropdown);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Dropdown, [
            element,
            config
        ]);
        _this._popper = null;
        _this._parent = _this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        _this._menu = $a3e6c60bea301201$var$SelectorEngine.next(_this._element, $a3e6c60bea301201$var$SELECTOR_MENU)[0] || $a3e6c60bea301201$var$SelectorEngine.prev(_this._element, $a3e6c60bea301201$var$SELECTOR_MENU)[0] || $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_MENU, _this._parent);
        _this._inNavbar = _this._detectNavbar();
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Dropdown, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                return this._isShown() ? this.hide() : this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _instance;
                if ($a3e6c60bea301201$var$isDisabled(this._element) || this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$5, relatedTarget);
                if (showEvent.defaultPrevented) return;
                this._createPopper();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement && !this._parent.closest($a3e6c60bea301201$var$SELECTOR_NAVBAR_NAV)) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $1961f7bca441a4c6$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.on(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._element.focus();
                this._element.setAttribute('aria-expanded', true);
                this._menu.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOWN$5, relatedTarget);
            }
        },
        {
            key: "hide",
            value: function hide() {
                if ($a3e6c60bea301201$var$isDisabled(this._element) || !this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                this._completeHide(relatedTarget);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._popper) this._popper.destroy();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $ccc23a021f1e6bc0$export$71511d61b312f219)(Dropdown.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "update",
            value: function update() {
                this._inNavbar = this._detectNavbar();
                if (this._popper) this._popper.update();
            }
        },
        {
            // Private
            key: "_completeHide",
            value: function _completeHide(relatedTarget) {
                var _instance;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$5, relatedTarget);
                if (hideEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $1961f7bca441a4c6$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.off(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._popper) this._popper.destroy();
                this._menu.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
                this._element.setAttribute('aria-expanded', 'false');
                $a3e6c60bea301201$var$Manipulator.removeDataAttribute(this._menu, 'popper');
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$5, relatedTarget);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $ccc23a021f1e6bc0$export$71511d61b312f219)(Dropdown.prototype), "_getConfig", this).call(this, config);
                if ((0, $17c6da0aa640e82f$export$71511d61b312f219)(config.reference) === 'object' && !$a3e6c60bea301201$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
                throw new TypeError("".concat($a3e6c60bea301201$var$NAME$a.toUpperCase(), ': Option "reference" provided type "object" without a required "getBoundingClientRect" method.'));
                return config;
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper() {
                if (typeof $22226631ba3d4356$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
                var referenceElement = this._element;
                if (this._config.reference === 'parent') referenceElement = this._parent;
                else if ($a3e6c60bea301201$var$isElement(this._config.reference)) referenceElement = $a3e6c60bea301201$var$getElement(this._config.reference);
                else if ((0, $17c6da0aa640e82f$export$71511d61b312f219)(this._config.reference) === 'object') referenceElement = this._config.reference;
                var popperConfig = this._getPopperConfig();
                this._popper = $22226631ba3d4356$exports.createPopper(referenceElement, this._menu, popperConfig);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this._menu.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW$6);
            }
        },
        {
            key: "_getPlacement",
            value: function _getPlacement() {
                var parentDropdown = this._parent;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPEND)) return $a3e6c60bea301201$var$PLACEMENT_RIGHT;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPSTART)) return $a3e6c60bea301201$var$PLACEMENT_LEFT;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPUP_CENTER)) return $a3e6c60bea301201$var$PLACEMENT_TOPCENTER;
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_CENTER)) return $a3e6c60bea301201$var$PLACEMENT_BOTTOMCENTER;
                // We need to trim the value because custom properties can also include spaces
                var isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
                if (parentDropdown.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPUP)) return isEnd ? $a3e6c60bea301201$var$PLACEMENT_TOPEND : $a3e6c60bea301201$var$PLACEMENT_TOP;
                return isEnd ? $a3e6c60bea301201$var$PLACEMENT_BOTTOMEND : $a3e6c60bea301201$var$PLACEMENT_BOTTOM;
            }
        },
        {
            key: "_detectNavbar",
            value: function _detectNavbar() {
                return this._element.closest($a3e6c60bea301201$var$SELECTOR_NAVBAR) !== null;
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig() {
                var defaultBsPopperConfig = {
                    placement: this._getPlacement(),
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        }
                    ]
                };
                // Disable Popper if we have a static display or Dropdown is in Navbar
                if (this._inNavbar || this._config.display === 'static') {
                    $a3e6c60bea301201$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
                    defaultBsPopperConfig.modifiers = [
                        {
                            name: 'applyStyles',
                            enabled: false
                        }
                    ];
                }
                return (0, $34448b2f636abc71$export$71511d61b312f219)({}, defaultBsPopperConfig, $a3e6c60bea301201$var$execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_selectMenuItem",
            value: function _selectMenuItem(param) {
                var key = param.key, target = param.target;
                var items = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter(function(element) {
                    return $a3e6c60bea301201$var$isVisible(element);
                });
                if (!items.length) return;
                // if target isn't included in items (e.g. when expanding the dropdown)
                // allow cycling to get the last item in case key equals ARROW_UP_KEY
                $a3e6c60bea301201$var$getNextActiveElement(items, target, key === $a3e6c60bea301201$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$9;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$9;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$a;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Dropdown.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        },
        {
            key: "clearMenus",
            value: function clearMenus(event) {
                if (event.button === $a3e6c60bea301201$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $a3e6c60bea301201$var$TAB_KEY$1) return;
                var openToggles = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_SHOWN);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = openToggles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var toggle = _step.value;
                        var context = Dropdown.getInstance(toggle);
                        if (!context || context._config.autoClose === false) continue;
                        var composedPath = event.composedPath();
                        var isMenuTarget = composedPath.includes(context._menu);
                        if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
                        // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                        if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $a3e6c60bea301201$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                        var relatedTarget = {
                            relatedTarget: context._element
                        };
                        if (event.type === 'click') relatedTarget.clickEvent = event;
                        context._completeHide(relatedTarget);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dataApiKeydownHandler",
            value: function dataApiKeydownHandler(event) {
                // If not an UP | DOWN | ESCAPE key => not a dropdown command
                // If input/textarea && if key is other than ESCAPE => not a dropdown command
                var isInput = /input|textarea/i.test(event.target.tagName);
                var isEscapeEvent = event.key === $a3e6c60bea301201$var$ESCAPE_KEY$2;
                var isUpOrDownEvent = [
                    $a3e6c60bea301201$var$ARROW_UP_KEY$1,
                    $a3e6c60bea301201$var$ARROW_DOWN_KEY$1
                ].includes(event.key);
                if (!isUpOrDownEvent && !isEscapeEvent) return;
                if (isInput && !isEscapeEvent) return;
                event.preventDefault();
                // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
                var getToggleButton = this.matches($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3) ? this : $a3e6c60bea301201$var$SelectorEngine.prev(this, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3)[0] || $a3e6c60bea301201$var$SelectorEngine.next(this, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3)[0] || $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
                var instance = Dropdown.getOrCreateInstance(getToggleButton);
                if (isUpOrDownEvent) {
                    event.stopPropagation();
                    instance.show();
                    instance._selectMenuItem(event);
                    return;
                }
                if (instance._isShown()) {
                    // else is escape and we check if it is shown
                    event.stopPropagation();
                    instance.hide();
                    getToggleButton.focus();
                }
            }
        }
    ]);
    return Dropdown;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYDOWN_DATA_API, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, $a3e6c60bea301201$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYDOWN_DATA_API, $a3e6c60bea301201$var$SELECTOR_MENU, $a3e6c60bea301201$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$3, $a3e6c60bea301201$export$931cbfb6bfb85fc.clearMenus);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYUP_DATA_API, $a3e6c60bea301201$export$931cbfb6bfb85fc.clearMenus);
$a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$3, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $a3e6c60bea301201$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$9 = 'backdrop';
var $a3e6c60bea301201$var$CLASS_NAME_FADE$4 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$5 = 'show';
var $a3e6c60bea301201$var$EVENT_MOUSEDOWN = "mousedown.bs.".concat($a3e6c60bea301201$var$NAME$9);
var $a3e6c60bea301201$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
var $a3e6c60bea301201$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$Backdrop = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Backdrop, Config);
    function Backdrop(config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Backdrop);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Backdrop);
        _this._config = _this._getConfig(config);
        _this._isAppended = false;
        _this._element = null;
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Backdrop, [
        {
            // Public
            key: "show",
            value: function show(callback) {
                if (!this._config.isVisible) {
                    $a3e6c60bea301201$var$execute(callback);
                    return;
                }
                this._append();
                var element = this._getElement();
                if (this._config.isAnimated) $a3e6c60bea301201$var$reflow(element);
                element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    $a3e6c60bea301201$var$execute(callback);
                });
            }
        },
        {
            key: "hide",
            value: function hide(callback) {
                var _this = this;
                if (!this._config.isVisible) {
                    $a3e6c60bea301201$var$execute(callback);
                    return;
                }
                this._getElement().classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    _this.dispose();
                    $a3e6c60bea301201$var$execute(callback);
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (!this._isAppended) return;
                $a3e6c60bea301201$var$EventHandler.off(this._element, $a3e6c60bea301201$var$EVENT_MOUSEDOWN);
                this._element.remove();
                this._isAppended = false;
            }
        },
        {
            // Private
            key: "_getElement",
            value: function _getElement() {
                if (!this._element) {
                    var backdrop = document.createElement('div');
                    backdrop.className = this._config.className;
                    if (this._config.isAnimated) backdrop.classList.add($a3e6c60bea301201$var$CLASS_NAME_FADE$4);
                    this._element = backdrop;
                }
                return this._element;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // use getElement() with the default "body" to get a fresh Element on each instantiation
                config.rootElement = $a3e6c60bea301201$var$getElement(config.rootElement);
                return config;
            }
        },
        {
            key: "_append",
            value: function _append() {
                var _this = this;
                if (this._isAppended) return;
                var element = this._getElement();
                this._config.rootElement.append(element);
                $a3e6c60bea301201$var$EventHandler.on(element, $a3e6c60bea301201$var$EVENT_MOUSEDOWN, function() {
                    $a3e6c60bea301201$var$execute(_this._config.clickCallback);
                });
                this._isAppended = true;
            }
        },
        {
            key: "_emulateAnimation",
            value: function _emulateAnimation(callback) {
                $a3e6c60bea301201$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$8;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$8;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$9;
            }
        }
    ]);
    return Backdrop;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$8 = 'focustrap';
var $a3e6c60bea301201$var$DATA_KEY$5 = 'bs.focustrap';
var $a3e6c60bea301201$var$EVENT_KEY$5 = ".".concat($a3e6c60bea301201$var$DATA_KEY$5);
var $a3e6c60bea301201$var$EVENT_FOCUSIN$2 = "focusin".concat($a3e6c60bea301201$var$EVENT_KEY$5);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_TAB = "keydown.tab".concat($a3e6c60bea301201$var$EVENT_KEY$5);
var $a3e6c60bea301201$var$TAB_KEY = 'Tab';
var $a3e6c60bea301201$var$TAB_NAV_FORWARD = 'forward';
var $a3e6c60bea301201$var$TAB_NAV_BACKWARD = 'backward';
var $a3e6c60bea301201$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
var $a3e6c60bea301201$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$FocusTrap = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(FocusTrap, Config);
    function FocusTrap(config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, FocusTrap);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, FocusTrap);
        _this._config = _this._getConfig(config);
        _this._isActive = false;
        _this._lastTabNavDirection = null;
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(FocusTrap, [
        {
            // Public
            key: "activate",
            value: function activate() {
                var _this = this;
                if (this._isActive) return;
                if (this._config.autofocus) this._config.trapElement.focus();
                $a3e6c60bea301201$var$EventHandler.off(document, $a3e6c60bea301201$var$EVENT_KEY$5); // guard against infinite focus loop
                $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_FOCUSIN$2, function(event) {
                    return _this._handleFocusin(event);
                });
                $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_KEYDOWN_TAB, function(event) {
                    return _this._handleKeydown(event);
                });
                this._isActive = true;
            }
        },
        {
            key: "deactivate",
            value: function deactivate() {
                if (!this._isActive) return;
                this._isActive = false;
                $a3e6c60bea301201$var$EventHandler.off(document, $a3e6c60bea301201$var$EVENT_KEY$5);
            }
        },
        {
            // Private
            key: "_handleFocusin",
            value: function _handleFocusin(event) {
                var trapElement = this._config.trapElement;
                if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
                var elements = $a3e6c60bea301201$var$SelectorEngine.focusableChildren(trapElement);
                if (elements.length === 0) trapElement.focus();
                else if (this._lastTabNavDirection === $a3e6c60bea301201$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
                else elements[0].focus();
            }
        },
        {
            key: "_handleKeydown",
            value: function _handleKeydown(event) {
                if (event.key !== $a3e6c60bea301201$var$TAB_KEY) return;
                this._lastTabNavDirection = event.shiftKey ? $a3e6c60bea301201$var$TAB_NAV_BACKWARD : $a3e6c60bea301201$var$TAB_NAV_FORWARD;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$7;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$7;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$8;
            }
        }
    ]);
    return FocusTrap;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
var $a3e6c60bea301201$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
var $a3e6c60bea301201$var$PROPERTY_PADDING = 'padding-right';
var $a3e6c60bea301201$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ var $a3e6c60bea301201$var$ScrollBarHelper = /*#__PURE__*/ function() {
    "use strict";
    function ScrollBarHelper() {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, ScrollBarHelper);
        this._element = document.body;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(ScrollBarHelper, [
        {
            // Public
            key: "getWidth",
            value: function getWidth() {
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
                var documentWidth = document.documentElement.clientWidth;
                return Math.abs(window.innerWidth - documentWidth);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var width = this.getWidth();
                this._disableOverFlow();
                // give padding to element to balance the hidden scrollbar width
                this._setElementAttributes(this._element, $a3e6c60bea301201$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
                this._setElementAttributes($a3e6c60bea301201$var$SELECTOR_FIXED_CONTENT, $a3e6c60bea301201$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                this._setElementAttributes($a3e6c60bea301201$var$SELECTOR_STICKY_CONTENT, $a3e6c60bea301201$var$PROPERTY_MARGIN, function(calculatedValue) {
                    return calculatedValue - width;
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._resetElementAttributes(this._element, 'overflow');
                this._resetElementAttributes(this._element, $a3e6c60bea301201$var$PROPERTY_PADDING);
                this._resetElementAttributes($a3e6c60bea301201$var$SELECTOR_FIXED_CONTENT, $a3e6c60bea301201$var$PROPERTY_PADDING);
                this._resetElementAttributes($a3e6c60bea301201$var$SELECTOR_STICKY_CONTENT, $a3e6c60bea301201$var$PROPERTY_MARGIN);
            }
        },
        {
            key: "isOverflowing",
            value: function isOverflowing() {
                return this.getWidth() > 0;
            }
        },
        {
            // Private
            key: "_disableOverFlow",
            value: function _disableOverFlow() {
                this._saveInitialAttribute(this._element, 'overflow');
                this._element.style.overflow = 'hidden';
            }
        },
        {
            key: "_setElementAttributes",
            value: function _setElementAttributes(selector, styleProperty, callback) {
                var _this = this;
                var scrollbarWidth = this.getWidth();
                var manipulationCallBack = function(element) {
                    if (element !== _this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                    _this._saveInitialAttribute(element, styleProperty);
                    var calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                    element.style.setProperty(styleProperty, "".concat(callback(Number.parseFloat(calculatedValue)), "px"));
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_saveInitialAttribute",
            value: function _saveInitialAttribute(element, styleProperty) {
                var actualValue = element.style.getPropertyValue(styleProperty);
                if (actualValue) $a3e6c60bea301201$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
            }
        },
        {
            key: "_resetElementAttributes",
            value: function _resetElementAttributes(selector, styleProperty) {
                var manipulationCallBack = function(element) {
                    var value = $a3e6c60bea301201$var$Manipulator.getDataAttribute(element, styleProperty);
                    // We only want to remove the property if the value is `null`; the value can also be zero
                    if (value === null) {
                        element.style.removeProperty(styleProperty);
                        return;
                    }
                    $a3e6c60bea301201$var$Manipulator.removeDataAttribute(element, styleProperty);
                    element.style.setProperty(styleProperty, value);
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_applyManipulationCallback",
            value: function _applyManipulationCallback(selector, callBack) {
                if ($a3e6c60bea301201$var$isElement(selector)) {
                    callBack(selector);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find(selector, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sel = _step.value;
                        callBack(sel);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return ScrollBarHelper;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$7 = 'modal';
var $a3e6c60bea301201$var$DATA_KEY$4 = 'bs.modal';
var $a3e6c60bea301201$var$EVENT_KEY$4 = ".".concat($a3e6c60bea301201$var$DATA_KEY$4);
var $a3e6c60bea301201$var$DATA_API_KEY$2 = '.data-api';
var $a3e6c60bea301201$var$ESCAPE_KEY$1 = 'Escape';
var $a3e6c60bea301201$var$EVENT_HIDE$4 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED$1 = "hidePrevented".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_HIDDEN$4 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_SHOW$4 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_SHOWN$4 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_RESIZE$1 = "resize".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_CLICK_DISMISS = "click.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS$1 = "keydown.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$4);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$2 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$4).concat($a3e6c60bea301201$var$DATA_API_KEY$2);
var $a3e6c60bea301201$var$CLASS_NAME_OPEN = 'modal-open';
var $a3e6c60bea301201$var$CLASS_NAME_FADE$3 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$4 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_STATIC = 'modal-static';
var $a3e6c60bea301201$var$OPEN_SELECTOR$1 = '.modal.show';
var $a3e6c60bea301201$var$SELECTOR_DIALOG = '.modal-dialog';
var $a3e6c60bea301201$var$SELECTOR_MODAL_BODY = '.modal-body';
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
var $a3e6c60bea301201$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
var $a3e6c60bea301201$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$2b77a92f1a5ad772 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Modal, BaseComponent);
    function Modal(element, config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Modal);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Modal, [
            element,
            config
        ]);
        _this._dialog = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_DIALOG, _this._element);
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._isShown = false;
        _this._isTransitioning = false;
        _this._scrollBar = new $a3e6c60bea301201$var$ScrollBarHelper();
        _this._addEventListeners();
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Modal, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown || this._isTransitioning) return;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$4, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._isTransitioning = true;
                this._scrollBar.hide();
                document.body.classList.add($a3e6c60bea301201$var$CLASS_NAME_OPEN);
                this._adjustDialog();
                this._backdrop.show(function() {
                    return _this._showElement(relatedTarget);
                });
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown || this._isTransitioning) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$4);
                if (hideEvent.defaultPrevented) return;
                this._isShown = false;
                this._isTransitioning = true;
                this._focustrap.deactivate();
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$4);
                this._queueCallback(function() {
                    return _this._hideModal();
                }, this._element, this._isAnimated());
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                $a3e6c60bea301201$var$EventHandler.off(window, $a3e6c60bea301201$var$EVENT_KEY$4);
                $a3e6c60bea301201$var$EventHandler.off(this._dialog, $a3e6c60bea301201$var$EVENT_KEY$4);
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $ccc23a021f1e6bc0$export$71511d61b312f219)(Modal.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "handleUpdate",
            value: function handleUpdate() {
                this._adjustDialog();
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                return new $a3e6c60bea301201$var$Backdrop({
                    isVisible: Boolean(this._config.backdrop),
                    // 'static' option will be translated to true, and booleans will keep their value,
                    isAnimated: this._isAnimated()
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $a3e6c60bea301201$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_showElement",
            value: function _showElement(relatedTarget) {
                var _this = this;
                // try to append dynamic modal
                if (!document.body.contains(this._element)) document.body.append(this._element);
                this._element.style.display = 'block';
                this._element.removeAttribute('aria-hidden');
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.scrollTop = 0;
                var modalBody = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_MODAL_BODY, this._dialog);
                if (modalBody) modalBody.scrollTop = 0;
                $a3e6c60bea301201$var$reflow(this._element);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$4);
                var transitionComplete = function() {
                    if (_this._config.focus) _this._focustrap.activate();
                    _this._isTransitioning = false;
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN$4, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS$1, function(event) {
                    if (event.key !== $a3e6c60bea301201$var$ESCAPE_KEY$1) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    _this._triggerBackdropTransition();
                });
                $a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_RESIZE$1, function() {
                    if (_this._isShown && !_this._isTransitioning) _this._adjustDialog();
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEDOWN_DISMISS, function(event) {
                    // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                    $a3e6c60bea301201$var$EventHandler.one(_this._element, $a3e6c60bea301201$var$EVENT_CLICK_DISMISS, function(event2) {
                        if (_this._element !== event.target || _this._element !== event2.target) return;
                        if (_this._config.backdrop === 'static') {
                            _this._triggerBackdropTransition();
                            return;
                        }
                        if (_this._config.backdrop) _this.hide();
                    });
                });
            }
        },
        {
            key: "_hideModal",
            value: function _hideModal() {
                var _this = this;
                this._element.style.display = 'none';
                this._element.setAttribute('aria-hidden', true);
                this._element.removeAttribute('aria-modal');
                this._element.removeAttribute('role');
                this._isTransitioning = false;
                this._backdrop.hide(function() {
                    document.body.classList.remove($a3e6c60bea301201$var$CLASS_NAME_OPEN);
                    _this._resetAdjustments();
                    _this._scrollBar.reset();
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$4);
                });
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$3);
            }
        },
        {
            key: "_triggerBackdropTransition",
            value: function _triggerBackdropTransition() {
                var _this = this;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED$1);
                if (hideEvent.defaultPrevented) return;
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var initialOverflowY = this._element.style.overflowY;
                // return if the following background transition hasn't yet completed
                if (initialOverflowY === 'hidden' || this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_STATIC)) return;
                if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_STATIC);
                this._queueCallback(function() {
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_STATIC);
                    _this._queueCallback(function() {
                        _this._element.style.overflowY = initialOverflowY;
                    }, _this._dialog);
                }, this._dialog);
                this._element.focus();
            }
        },
        {
            /**
   * The following methods are used to handle overflowing modals
   */ key: "_adjustDialog",
            value: function _adjustDialog() {
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var scrollbarWidth = this._scrollBar.getWidth();
                var isBodyOverflowing = scrollbarWidth > 0;
                if (isBodyOverflowing && !isModalOverflowing) {
                    var property = $a3e6c60bea301201$var$isRTL() ? 'paddingLeft' : 'paddingRight';
                    this._element.style[property] = "".concat(scrollbarWidth, "px");
                }
                if (!isBodyOverflowing && isModalOverflowing) {
                    var property1 = $a3e6c60bea301201$var$isRTL() ? 'paddingRight' : 'paddingLeft';
                    this._element.style[property1] = "".concat(scrollbarWidth, "px");
                }
            }
        },
        {
            key: "_resetAdjustments",
            value: function _resetAdjustments() {
                this._element.style.paddingLeft = '';
                this._element.style.paddingRight = '';
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$6;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$6;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$7;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config, relatedTarget) {
                return this.each(function() {
                    var data = Modal.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](relatedTarget);
                });
            }
        }
    ]);
    return Modal;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$2, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    var _this = this;
    var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $a3e6c60bea301201$var$EventHandler.one(target, $a3e6c60bea301201$var$EVENT_SHOW$4, function(showEvent) {
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $a3e6c60bea301201$var$EventHandler.one(target, $a3e6c60bea301201$var$EVENT_HIDDEN$4, function() {
            if ($a3e6c60bea301201$var$isVisible(_this)) _this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    var alreadyOpen = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $a3e6c60bea301201$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    var data = $a3e6c60bea301201$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$6 = 'offcanvas';
var $a3e6c60bea301201$var$DATA_KEY$3 = 'bs.offcanvas';
var $a3e6c60bea301201$var$EVENT_KEY$3 = ".".concat($a3e6c60bea301201$var$DATA_KEY$3);
var $a3e6c60bea301201$var$DATA_API_KEY$1 = '.data-api';
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$2 = "load".concat($a3e6c60bea301201$var$EVENT_KEY$3).concat($a3e6c60bea301201$var$DATA_API_KEY$1);
var $a3e6c60bea301201$var$ESCAPE_KEY = 'Escape';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$3 = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_SHOWING$1 = 'showing';
var $a3e6c60bea301201$var$CLASS_NAME_HIDING = 'hiding';
var $a3e6c60bea301201$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
var $a3e6c60bea301201$var$OPEN_SELECTOR = '.offcanvas.show';
var $a3e6c60bea301201$var$EVENT_SHOW$3 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_SHOWN$3 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_HIDE$3 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED = "hidePrevented".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_HIDDEN$3 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_RESIZE = "resize".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$1 = "click".concat($a3e6c60bea301201$var$EVENT_KEY$3).concat($a3e6c60bea301201$var$DATA_API_KEY$1);
var $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS = "keydown.dismiss".concat($a3e6c60bea301201$var$EVENT_KEY$3);
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
var $a3e6c60bea301201$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
var $a3e6c60bea301201$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$591ca0244c9dfcd4 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Offcanvas, BaseComponent);
    function Offcanvas(element, config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Offcanvas);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Offcanvas, [
            element,
            config
        ]);
        _this._isShown = false;
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._addEventListeners();
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Offcanvas, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown) return;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW$3, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._backdrop.show();
                if (!this._config.scroll) new $a3e6c60bea301201$var$ScrollBarHelper().hide();
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOWING$1);
                var completeCallBack = function() {
                    if (!_this._config.scroll || _this._config.backdrop) _this._focustrap.activate();
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$3);
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOWING$1);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN$3, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(completeCallBack, this._element, true);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE$3);
                if (hideEvent.defaultPrevented) return;
                this._focustrap.deactivate();
                this._element.blur();
                this._isShown = false;
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_HIDING);
                this._backdrop.hide();
                var completeCallback = function() {
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$3, $a3e6c60bea301201$var$CLASS_NAME_HIDING);
                    _this._element.removeAttribute('aria-modal');
                    _this._element.removeAttribute('role');
                    if (!_this._config.scroll) new $a3e6c60bea301201$var$ScrollBarHelper().reset();
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN$3);
                };
                this._queueCallback(completeCallback, this._element, true);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $ccc23a021f1e6bc0$export$71511d61b312f219)(Offcanvas.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                var _this = this;
                var clickCallback = function() {
                    if (_this._config.backdrop === 'static') {
                        $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED);
                        return;
                    }
                    _this.hide();
                };
                // 'static' option will be translated to true, and booleans will keep their value
                var isVisible = Boolean(this._config.backdrop);
                return new $a3e6c60bea301201$var$Backdrop({
                    className: $a3e6c60bea301201$var$CLASS_NAME_BACKDROP,
                    isVisible: isVisible,
                    isAnimated: true,
                    rootElement: this._element.parentNode,
                    clickCallback: isVisible ? clickCallback : null
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $a3e6c60bea301201$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN_DISMISS, function(event) {
                    if (event.key !== $a3e6c60bea301201$var$ESCAPE_KEY) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDE_PREVENTED);
                });
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$5;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$5;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$6;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Offcanvas.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Offcanvas;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API$1, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    var _this = this;
    var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($a3e6c60bea301201$var$isDisabled(this)) return;
    $a3e6c60bea301201$var$EventHandler.one(target, $a3e6c60bea301201$var$EVENT_HIDDEN$3, function() {
        // focus on trigger when it is closed
        if ($a3e6c60bea301201$var$isVisible(_this)) _this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    var alreadyOpen = $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $a3e6c60bea301201$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    var data = $a3e6c60bea301201$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$2, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$OPEN_SELECTOR)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var selector = _step.value;
            $a3e6c60bea301201$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_RESIZE, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (getComputedStyle(element).position !== 'fixed') $a3e6c60bea301201$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
var $a3e6c60bea301201$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
var $a3e6c60bea301201$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $a3e6c60bea301201$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
var $a3e6c60bea301201$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
var $a3e6c60bea301201$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
var $a3e6c60bea301201$var$allowedAttribute = function(attribute, allowedAttributeList) {
    var attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($a3e6c60bea301201$var$uriAttributes.has(attributeName)) return Boolean($a3e6c60bea301201$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter(function(attributeRegex) {
        return attributeRegex instanceof RegExp;
    }).some(function(regex) {
        return regex.test(attributeName);
    });
};
function $a3e6c60bea301201$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    var _instance;
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    var domParser = new window.DOMParser();
    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    var elements = (_instance = []).concat.apply(_instance, (0, $1961f7bca441a4c6$export$71511d61b312f219)(createdDocument.body.querySelectorAll('*')));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            var _instance1;
            var elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            var attributeList = (_instance1 = []).concat.apply(_instance1, (0, $1961f7bca441a4c6$export$71511d61b312f219)(element.attributes));
            var allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = attributeList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var attribute = _step1.value;
                    if (!$a3e6c60bea301201$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$5 = 'TemplateFactory';
var $a3e6c60bea301201$var$Default$4 = {
    allowList: $a3e6c60bea301201$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
var $a3e6c60bea301201$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
var $a3e6c60bea301201$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$var$TemplateFactory = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(TemplateFactory, Config);
    function TemplateFactory(config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, TemplateFactory);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, TemplateFactory);
        _this._config = _this._getConfig(config);
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(TemplateFactory, [
        {
            // Public
            key: "getContent",
            value: function getContent() {
                var _this = this;
                return Object.values(this._config.content).map(function(config) {
                    return _this._resolvePossibleFunction(config);
                }).filter(Boolean);
            }
        },
        {
            key: "hasContent",
            value: function hasContent() {
                return this.getContent().length > 0;
            }
        },
        {
            key: "changeContent",
            value: function changeContent(content) {
                this._checkContent(content);
                this._config.content = (0, $34448b2f636abc71$export$71511d61b312f219)({}, this._config.content, content);
                return this;
            }
        },
        {
            key: "toHtml",
            value: function toHtml() {
                var _template_classList;
                var templateWrapper = document.createElement('div');
                templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config.content)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $d98b89efad01a571$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], text = _step_value[1];
                        this._setContent(templateWrapper, text, selector);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var template = templateWrapper.children[0];
                var extraClass = this._resolvePossibleFunction(this._config.extraClass);
                if (extraClass) (_template_classList = template.classList).add.apply(_template_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(extraClass.split(' ')));
                return template;
            }
        },
        {
            // Private
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $ccc23a021f1e6bc0$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, config);
                this._checkContent(config.content);
            }
        },
        {
            key: "_checkContent",
            value: function _checkContent(arg) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(arg)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $d98b89efad01a571$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], content = _step_value[1];
                        (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $ccc23a021f1e6bc0$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, {
                            selector: selector,
                            entry: content
                        }, $a3e6c60bea301201$var$DefaultContentType);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setContent",
            value: function _setContent(template, content, selector) {
                var templateElement = $a3e6c60bea301201$var$SelectorEngine.findOne(selector, template);
                if (!templateElement) return;
                content = this._resolvePossibleFunction(content);
                if (!content) {
                    templateElement.remove();
                    return;
                }
                if ($a3e6c60bea301201$var$isElement(content)) {
                    this._putElementInTemplate($a3e6c60bea301201$var$getElement(content), templateElement);
                    return;
                }
                if (this._config.html) {
                    templateElement.innerHTML = this._maybeSanitize(content);
                    return;
                }
                templateElement.textContent = content;
            }
        },
        {
            key: "_maybeSanitize",
            value: function _maybeSanitize(arg) {
                return this._config.sanitize ? $a3e6c60bea301201$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $a3e6c60bea301201$var$execute(arg, [
                    this
                ]);
            }
        },
        {
            key: "_putElementInTemplate",
            value: function _putElementInTemplate(element, templateElement) {
                if (this._config.html) {
                    templateElement.innerHTML = '';
                    templateElement.append(element);
                    return;
                }
                templateElement.textContent = element.textContent;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$4;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$4;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$5;
            }
        }
    ]);
    return TemplateFactory;
}($a3e6c60bea301201$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$4 = 'tooltip';
var $a3e6c60bea301201$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
var $a3e6c60bea301201$var$CLASS_NAME_FADE$2 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_MODAL = 'modal';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$2 = 'show';
var $a3e6c60bea301201$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
var $a3e6c60bea301201$var$SELECTOR_MODAL = ".".concat($a3e6c60bea301201$var$CLASS_NAME_MODAL);
var $a3e6c60bea301201$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
var $a3e6c60bea301201$var$TRIGGER_HOVER = 'hover';
var $a3e6c60bea301201$var$TRIGGER_FOCUS = 'focus';
var $a3e6c60bea301201$var$TRIGGER_CLICK = 'click';
var $a3e6c60bea301201$var$TRIGGER_MANUAL = 'manual';
var $a3e6c60bea301201$var$EVENT_HIDE$2 = 'hide';
var $a3e6c60bea301201$var$EVENT_HIDDEN$2 = 'hidden';
var $a3e6c60bea301201$var$EVENT_SHOW$2 = 'show';
var $a3e6c60bea301201$var$EVENT_SHOWN$2 = 'shown';
var $a3e6c60bea301201$var$EVENT_INSERTED = 'inserted';
var $a3e6c60bea301201$var$EVENT_CLICK$1 = 'click';
var $a3e6c60bea301201$var$EVENT_FOCUSIN$1 = 'focusin';
var $a3e6c60bea301201$var$EVENT_FOCUSOUT$1 = 'focusout';
var $a3e6c60bea301201$var$EVENT_MOUSEENTER = 'mouseenter';
var $a3e6c60bea301201$var$EVENT_MOUSELEAVE = 'mouseleave';
var $a3e6c60bea301201$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $a3e6c60bea301201$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $a3e6c60bea301201$var$isRTL() ? 'right' : 'left'
};
var $a3e6c60bea301201$var$Default$3 = {
    allowList: $a3e6c60bea301201$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
var $a3e6c60bea301201$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$28c660c63b792dea = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Tooltip, BaseComponent);
    function Tooltip(element, config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Tooltip);
        var _this;
        if (typeof $22226631ba3d4356$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Tooltip, [
            element,
            config
        ]);
        // Private
        _this._isEnabled = true;
        _this._timeout = 0;
        _this._isHovered = null;
        _this._activeTrigger = {};
        _this._popper = null;
        _this._templateFactory = null;
        _this._newContent = null;
        // Protected
        _this.tip = null;
        _this._setListeners();
        if (!_this._config.selector) _this._fixTitle();
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Tooltip, [
        {
            // Public
            key: "enable",
            value: function enable() {
                this._isEnabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._isEnabled = false;
            }
        },
        {
            key: "toggleEnabled",
            value: function toggleEnabled() {
                this._isEnabled = !this._isEnabled;
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (!this._isEnabled) return;
                this._activeTrigger.click = !this._activeTrigger.click;
                if (this._isShown()) {
                    this._leave();
                    return;
                }
                this._enter();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                clearTimeout(this._timeout);
                $a3e6c60bea301201$var$EventHandler.off(this._element.closest($a3e6c60bea301201$var$SELECTOR_MODAL), $a3e6c60bea301201$var$EVENT_MODAL_HIDE, this._hideModalHandler);
                if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
                this._disposePopper();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $ccc23a021f1e6bc0$export$71511d61b312f219)(Tooltip.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                var _instance;
                if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
                if (!(this._isWithContent() && this._isEnabled)) return;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_SHOW$2));
                var shadowRoot = $a3e6c60bea301201$var$findShadowRoot(this._element);
                var isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
                if (showEvent.defaultPrevented || !isInTheDom) return;
                // TODO: v6 remove this or make it optional
                this._disposePopper();
                var tip = this._getTipElement();
                this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
                var container = this._config.container;
                if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                    container.append(tip);
                    $a3e6c60bea301201$var$EventHandler.trigger(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_INSERTED));
                }
                this._popper = this._createPopper(tip);
                tip.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $1961f7bca441a4c6$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.on(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var complete = function() {
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, _this.constructor.eventName($a3e6c60bea301201$var$EVENT_SHOWN$2));
                    if (_this._isHovered === false) _this._leave();
                    _this._isHovered = false;
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                var _instance;
                if (!this._isShown()) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_HIDE$2));
                if (hideEvent.defaultPrevented) return;
                var tip = this._getTipElement();
                tip.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $1961f7bca441a4c6$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $a3e6c60bea301201$var$EventHandler.off(element, 'mouseover', $a3e6c60bea301201$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._activeTrigger[$a3e6c60bea301201$var$TRIGGER_CLICK] = false;
                this._activeTrigger[$a3e6c60bea301201$var$TRIGGER_FOCUS] = false;
                this._activeTrigger[$a3e6c60bea301201$var$TRIGGER_HOVER] = false;
                this._isHovered = null; // it is a trick to support manual triggering
                var complete = function() {
                    if (_this._isWithActiveTrigger()) return;
                    if (!_this._isHovered) _this._disposePopper();
                    _this._element.removeAttribute('aria-describedby');
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, _this.constructor.eventName($a3e6c60bea301201$var$EVENT_HIDDEN$2));
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "update",
            value: function update() {
                if (this._popper) this._popper.update();
            }
        },
        {
            // Protected
            key: "_isWithContent",
            value: function _isWithContent() {
                return Boolean(this._getTitle());
            }
        },
        {
            key: "_getTipElement",
            value: function _getTipElement() {
                if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
                return this.tip;
            }
        },
        {
            key: "_createTipElement",
            value: function _createTipElement(content) {
                var tip = this._getTemplateFactory(content).toHtml();
                // TODO: remove this check in v6
                if (!tip) return null;
                tip.classList.remove($a3e6c60bea301201$var$CLASS_NAME_FADE$2, $a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
                // TODO: v6 the following can be achieved with CSS only
                tip.classList.add("bs-".concat(this.constructor.NAME, "-auto"));
                var tipId = $a3e6c60bea301201$var$getUID(this.constructor.NAME).toString();
                tip.setAttribute('id', tipId);
                if (this._isAnimated()) tip.classList.add($a3e6c60bea301201$var$CLASS_NAME_FADE$2);
                return tip;
            }
        },
        {
            key: "setContent",
            value: function setContent(content) {
                this._newContent = content;
                if (this._isShown()) {
                    this._disposePopper();
                    this.show();
                }
            }
        },
        {
            key: "_getTemplateFactory",
            value: function _getTemplateFactory(content) {
                if (this._templateFactory) this._templateFactory.changeContent(content);
                else this._templateFactory = new $a3e6c60bea301201$var$TemplateFactory((0, $82dbc585330cff66$export$71511d61b312f219)((0, $34448b2f636abc71$export$71511d61b312f219)({}, this._config), {
                    // the `content` var has to be after `this._config`
                    // to override config.content in case of popover
                    content: content,
                    extraClass: this._resolvePossibleFunction(this._config.customClass)
                }));
                return this._templateFactory;
            }
        },
        {
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                return (0, $71081ebd7d211bed$export$71511d61b312f219)({}, $a3e6c60bea301201$var$SELECTOR_TOOLTIP_INNER, this._getTitle());
            }
        },
        {
            key: "_getTitle",
            value: function _getTitle() {
                return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
            }
        },
        {
            // Private
            key: "_initializeOnDelegatedTarget",
            value: function _initializeOnDelegatedTarget(event) {
                return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._config.animation || this.tip && this.tip.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$2);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this.tip && this.tip.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW$2);
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper(tip) {
                var placement = $a3e6c60bea301201$var$execute(this._config.placement, [
                    this,
                    tip,
                    this._element
                ]);
                var attachment = $a3e6c60bea301201$var$AttachmentMap[placement.toUpperCase()];
                return $22226631ba3d4356$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $a3e6c60bea301201$var$execute(arg, [
                    this._element
                ]);
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig(attachment) {
                var _this = this;
                var defaultBsPopperConfig = {
                    placement: attachment,
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: this._config.fallbackPlacements
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'arrow',
                            options: {
                                element: ".".concat(this.constructor.NAME, "-arrow")
                            }
                        },
                        {
                            name: 'preSetPlacement',
                            enabled: true,
                            phase: 'beforeMain',
                            fn: function(data) {
                                // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                                // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                                _this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                            }
                        }
                    ]
                };
                return (0, $34448b2f636abc71$export$71511d61b312f219)({}, defaultBsPopperConfig, $a3e6c60bea301201$var$execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                var triggers = this._config.trigger.split(' ');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        if (trigger === 'click') $a3e6c60bea301201$var$EventHandler.on(this._element, this.constructor.eventName($a3e6c60bea301201$var$EVENT_CLICK$1), this._config.selector, function(event) {
                            var context = _this._initializeOnDelegatedTarget(event);
                            context.toggle();
                        });
                        else if (trigger !== $a3e6c60bea301201$var$TRIGGER_MANUAL) {
                            var eventIn = trigger === $a3e6c60bea301201$var$TRIGGER_HOVER ? this.constructor.eventName($a3e6c60bea301201$var$EVENT_MOUSEENTER) : this.constructor.eventName($a3e6c60bea301201$var$EVENT_FOCUSIN$1);
                            var eventOut = trigger === $a3e6c60bea301201$var$TRIGGER_HOVER ? this.constructor.eventName($a3e6c60bea301201$var$EVENT_MOUSELEAVE) : this.constructor.eventName($a3e6c60bea301201$var$EVENT_FOCUSOUT$1);
                            $a3e6c60bea301201$var$EventHandler.on(this._element, eventIn, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusin' ? $a3e6c60bea301201$var$TRIGGER_FOCUS : $a3e6c60bea301201$var$TRIGGER_HOVER] = true;
                                context._enter();
                            });
                            $a3e6c60bea301201$var$EventHandler.on(this._element, eventOut, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusout' ? $a3e6c60bea301201$var$TRIGGER_FOCUS : $a3e6c60bea301201$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                                context._leave();
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._hideModalHandler = function() {
                    if (_this._element) _this.hide();
                };
                $a3e6c60bea301201$var$EventHandler.on(this._element.closest($a3e6c60bea301201$var$SELECTOR_MODAL), $a3e6c60bea301201$var$EVENT_MODAL_HIDE, this._hideModalHandler);
            }
        },
        {
            key: "_fixTitle",
            value: function _fixTitle() {
                var title = this._element.getAttribute('title');
                if (!title) return;
                if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
                this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
                this._element.removeAttribute('title');
            }
        },
        {
            key: "_enter",
            value: function _enter() {
                var _this = this;
                if (this._isShown() || this._isHovered) {
                    this._isHovered = true;
                    return;
                }
                this._isHovered = true;
                this._setTimeout(function() {
                    if (_this._isHovered) _this.show();
                }, this._config.delay.show);
            }
        },
        {
            key: "_leave",
            value: function _leave() {
                var _this = this;
                if (this._isWithActiveTrigger()) return;
                this._isHovered = false;
                this._setTimeout(function() {
                    if (!_this._isHovered) _this.hide();
                }, this._config.delay.hide);
            }
        },
        {
            key: "_setTimeout",
            value: function _setTimeout(handler, timeout) {
                clearTimeout(this._timeout);
                this._timeout = setTimeout(handler, timeout);
            }
        },
        {
            key: "_isWithActiveTrigger",
            value: function _isWithActiveTrigger() {
                return Object.values(this._activeTrigger).includes(true);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                var dataAttributes = $a3e6c60bea301201$var$Manipulator.getDataAttributes(this._element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(dataAttributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dataAttribute = _step.value;
                        if ($a3e6c60bea301201$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config = (0, $34448b2f636abc71$export$71511d61b312f219)({}, dataAttributes, (typeof config === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(config)) === 'object' && config ? config : {});
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.container = config.container === false ? document.body : $a3e6c60bea301201$var$getElement(config.container);
                if (typeof config.delay === 'number') config.delay = {
                    show: config.delay,
                    hide: config.delay
                };
                if (typeof config.title === 'number') config.title = config.title.toString();
                if (typeof config.content === 'number') config.content = config.content.toString();
                return config;
            }
        },
        {
            key: "_getDelegateConfig",
            value: function _getDelegateConfig() {
                var config = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $d98b89efad01a571$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (this.constructor.Default[key] !== value) config[key] = value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config.selector = false;
                config.trigger = 'manual';
                // In the future can be replaced with:
                // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
                // `Object.fromEntries(keysWithDifferentValues)`
                return config;
            }
        },
        {
            key: "_disposePopper",
            value: function _disposePopper() {
                if (this._popper) {
                    this._popper.destroy();
                    this._popper = null;
                }
                if (this.tip) {
                    this.tip.remove();
                    this.tip = null;
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$3;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$3;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$4;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tooltip.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tooltip;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$3 = 'popover';
var $a3e6c60bea301201$var$SELECTOR_TITLE = '.popover-header';
var $a3e6c60bea301201$var$SELECTOR_CONTENT = '.popover-body';
var $a3e6c60bea301201$var$Default$2 = (0, $82dbc585330cff66$export$71511d61b312f219)((0, $34448b2f636abc71$export$71511d61b312f219)({}, $a3e6c60bea301201$export$28c660c63b792dea.Default), {
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
});
var $a3e6c60bea301201$var$DefaultType$2 = (0, $82dbc585330cff66$export$71511d61b312f219)((0, $34448b2f636abc71$export$71511d61b312f219)({}, $a3e6c60bea301201$export$28c660c63b792dea.DefaultType), {
    content: '(null|string|element|function)'
});
/**
 * Class definition
 */ var $a3e6c60bea301201$export$5b6b19405a83ff9d = /*#__PURE__*/ function(Tooltip) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Popover, Tooltip);
    function Popover() {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Popover);
        return (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Popover, arguments);
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Popover, [
        {
            // Overrides
            key: "_isWithContent",
            value: function _isWithContent() {
                return this._getTitle() || this._getContent();
            }
        },
        {
            // Private
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                var _obj;
                return _obj = {}, (0, $71081ebd7d211bed$export$71511d61b312f219)(_obj, $a3e6c60bea301201$var$SELECTOR_TITLE, this._getTitle()), (0, $71081ebd7d211bed$export$71511d61b312f219)(_obj, $a3e6c60bea301201$var$SELECTOR_CONTENT, this._getContent()), _obj;
            }
        },
        {
            key: "_getContent",
            value: function _getContent() {
                return this._resolvePossibleFunction(this._config.content);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$2;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$2;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$3;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Popover.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Popover;
}($a3e6c60bea301201$export$28c660c63b792dea);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$2 = 'scrollspy';
var $a3e6c60bea301201$var$DATA_KEY$2 = 'bs.scrollspy';
var $a3e6c60bea301201$var$EVENT_KEY$2 = ".".concat($a3e6c60bea301201$var$DATA_KEY$2);
var $a3e6c60bea301201$var$DATA_API_KEY = '.data-api';
var $a3e6c60bea301201$var$EVENT_ACTIVATE = "activate".concat($a3e6c60bea301201$var$EVENT_KEY$2);
var $a3e6c60bea301201$var$EVENT_CLICK = "click".concat($a3e6c60bea301201$var$EVENT_KEY$2);
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$1 = "load".concat($a3e6c60bea301201$var$EVENT_KEY$2).concat($a3e6c60bea301201$var$DATA_API_KEY);
var $a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1 = 'active';
var $a3e6c60bea301201$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
var $a3e6c60bea301201$var$SELECTOR_TARGET_LINKS = '[href]';
var $a3e6c60bea301201$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
var $a3e6c60bea301201$var$SELECTOR_NAV_LINKS = '.nav-link';
var $a3e6c60bea301201$var$SELECTOR_NAV_ITEMS = '.nav-item';
var $a3e6c60bea301201$var$SELECTOR_LIST_ITEMS = '.list-group-item';
var $a3e6c60bea301201$var$SELECTOR_LINK_ITEMS = "".concat($a3e6c60bea301201$var$SELECTOR_NAV_LINKS, ", ").concat($a3e6c60bea301201$var$SELECTOR_NAV_ITEMS, " > ").concat($a3e6c60bea301201$var$SELECTOR_NAV_LINKS, ", ").concat($a3e6c60bea301201$var$SELECTOR_LIST_ITEMS);
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN = '.dropdown';
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
var $a3e6c60bea301201$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
var $a3e6c60bea301201$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$a6472a5298a374be = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(ScrollSpy, BaseComponent);
    function ScrollSpy(element, config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, ScrollSpy);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, ScrollSpy, [
            element,
            config
        ]);
        // this._element is the observablesContainer and config.target the menu links wrapper
        _this._targetLinks = new Map();
        _this._observableSections = new Map();
        _this._rootElement = getComputedStyle(_this._element).overflowY === 'visible' ? null : _this._element;
        _this._activeTarget = null;
        _this._observer = null;
        _this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        _this.refresh(); // initialize
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(ScrollSpy, [
        {
            // Public
            key: "refresh",
            value: function refresh() {
                this._initializeTargetsAndObservables();
                this._maybeEnableSmoothScroll();
                if (this._observer) this._observer.disconnect();
                else this._observer = this._getNewObserver();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._observableSections.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var section = _step.value;
                        this._observer.observe(section);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._observer.disconnect();
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $ccc23a021f1e6bc0$export$71511d61b312f219)(ScrollSpy.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
                config.target = $a3e6c60bea301201$var$getElement(config.target) || document.body;
                // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
                config.rootMargin = config.offset ? "".concat(config.offset, "px 0px -30%") : config.rootMargin;
                if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map(function(value) {
                    return Number.parseFloat(value);
                });
                return config;
            }
        },
        {
            key: "_maybeEnableSmoothScroll",
            value: function _maybeEnableSmoothScroll() {
                var _this = this;
                if (!this._config.smoothScroll) return;
                // unregister any previous listeners
                $a3e6c60bea301201$var$EventHandler.off(this._config.target, $a3e6c60bea301201$var$EVENT_CLICK);
                $a3e6c60bea301201$var$EventHandler.on(this._config.target, $a3e6c60bea301201$var$EVENT_CLICK, $a3e6c60bea301201$var$SELECTOR_TARGET_LINKS, function(event) {
                    var observableSection = _this._observableSections.get(event.target.hash);
                    if (observableSection) {
                        event.preventDefault();
                        var root = _this._rootElement || window;
                        var height = observableSection.offsetTop - _this._element.offsetTop;
                        if (root.scrollTo) {
                            root.scrollTo({
                                top: height,
                                behavior: 'smooth'
                            });
                            return;
                        }
                        // Chrome 60 doesn't support `scrollTo`
                        root.scrollTop = height;
                    }
                });
            }
        },
        {
            key: "_getNewObserver",
            value: function _getNewObserver() {
                var _this = this;
                var options = {
                    root: this._rootElement,
                    threshold: this._config.threshold,
                    rootMargin: this._config.rootMargin
                };
                return new IntersectionObserver(function(entries) {
                    return _this._observerCallback(entries);
                }, options);
            }
        },
        {
            // The logic of selection
            key: "_observerCallback",
            value: function _observerCallback(entries) {
                var _this = this;
                var targetElement = function(entry) {
                    return _this._targetLinks.get("#".concat(entry.target.id));
                };
                var activate = function(entry) {
                    _this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                    _this._process(targetElement(entry));
                };
                var parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
                var userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
                this._previousScrollData.parentScrollTop = parentScrollTop;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        if (!entry.isIntersecting) {
                            this._activeTarget = null;
                            this._clearActiveClass(targetElement(entry));
                            continue;
                        }
                        var entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                        // if we are scrolling down, pick the bigger offsetTop
                        if (userScrollsDown && entryIsLowerThanPrevious) {
                            activate(entry);
                            // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                            if (!parentScrollTop) return;
                            continue;
                        }
                        // if we are scrolling up, pick the smallest offsetTop
                        if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_initializeTargetsAndObservables",
            value: function _initializeTargetsAndObservables() {
                this._targetLinks = new Map();
                this._observableSections = new Map();
                var targetLinks = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_TARGET_LINKS, this._config.target);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = targetLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var anchor = _step.value;
                        // ensure that the anchor has an id and is not disabled
                        if (!anchor.hash || $a3e6c60bea301201$var$isDisabled(anchor)) continue;
                        var observableSection = $a3e6c60bea301201$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                        // ensure that the observableSection exists & is visible
                        if ($a3e6c60bea301201$var$isVisible(observableSection)) {
                            this._targetLinks.set(decodeURI(anchor.hash), anchor);
                            this._observableSections.set(anchor.hash, observableSection);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_process",
            value: function _process(target) {
                if (this._activeTarget === target) return;
                this._clearActiveClass(this._config.target);
                this._activeTarget = target;
                target.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                this._activateParents(target);
                $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_ACTIVATE, {
                    relatedTarget: target
                });
            }
        },
        {
            key: "_activateParents",
            value: function _activateParents(target) {
                // Activate dropdown parents
                if (target.classList.contains($a3e6c60bea301201$var$CLASS_NAME_DROPDOWN_ITEM)) {
                    $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($a3e6c60bea301201$var$SELECTOR_DROPDOWN)).classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.parents(target, $a3e6c60bea301201$var$SELECTOR_NAV_LIST_GROUP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var listGroup = _step.value;
                        try {
                            // Set triggered links parents as active
                            // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                            for(var _iterator1 = $a3e6c60bea301201$var$SelectorEngine.prev(listGroup, $a3e6c60bea301201$var$SELECTOR_LINK_ITEMS)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var item = _step1.value;
                                item.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_clearActiveClass",
            value: function _clearActiveClass(parent) {
                parent.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                var activeNodes = $a3e6c60bea301201$var$SelectorEngine.find("".concat($a3e6c60bea301201$var$SELECTOR_TARGET_LINKS, ".").concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1), parent);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        node.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE$1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default$1;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType$1;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME$2;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = ScrollSpy.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return ScrollSpy;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API$1, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_SPY)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var spy = _step.value;
            $a3e6c60bea301201$export$a6472a5298a374be.getOrCreateInstance(spy);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME$1 = 'tab';
var $a3e6c60bea301201$var$DATA_KEY$1 = 'bs.tab';
var $a3e6c60bea301201$var$EVENT_KEY$1 = ".".concat($a3e6c60bea301201$var$DATA_KEY$1);
var $a3e6c60bea301201$var$EVENT_HIDE$1 = "hide".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_HIDDEN$1 = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_SHOW$1 = "show".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_SHOWN$1 = "shown".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_CLICK_DATA_API = "click".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_KEYDOWN = "keydown".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$EVENT_LOAD_DATA_API = "load".concat($a3e6c60bea301201$var$EVENT_KEY$1);
var $a3e6c60bea301201$var$ARROW_LEFT_KEY = 'ArrowLeft';
var $a3e6c60bea301201$var$ARROW_RIGHT_KEY = 'ArrowRight';
var $a3e6c60bea301201$var$ARROW_UP_KEY = 'ArrowUp';
var $a3e6c60bea301201$var$ARROW_DOWN_KEY = 'ArrowDown';
var $a3e6c60bea301201$var$HOME_KEY = 'Home';
var $a3e6c60bea301201$var$END_KEY = 'End';
var $a3e6c60bea301201$var$CLASS_NAME_ACTIVE = 'active';
var $a3e6c60bea301201$var$CLASS_NAME_FADE$1 = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_SHOW$1 = 'show';
var $a3e6c60bea301201$var$CLASS_DROPDOWN = 'dropdown';
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
var $a3e6c60bea301201$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
var $a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(".concat($a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE, ")");
var $a3e6c60bea301201$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
var $a3e6c60bea301201$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
var $a3e6c60bea301201$var$SELECTOR_INNER = ".nav-link".concat($a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ", .list-group-item").concat($a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ', [role="tab"]').concat($a3e6c60bea301201$var$NOT_SELECTOR_DROPDOWN_TOGGLE);
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
var $a3e6c60bea301201$var$SELECTOR_INNER_ELEM = "".concat($a3e6c60bea301201$var$SELECTOR_INNER, ", ").concat($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE);
var $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_ACTIVE = ".".concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="tab"], .').concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="pill"], .').concat($a3e6c60bea301201$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="list"]');
/**
 * Class definition
 */ var $a3e6c60bea301201$export$3e41faf802a29e71 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Tab, BaseComponent);
    function Tab(element) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Tab);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Tab, [
            element
        ]);
        _this._parent = _this._element.closest($a3e6c60bea301201$var$SELECTOR_TAB_PANEL);
        if (!_this._parent) return (0, $5f8faa38aa7bcc75$export$71511d61b312f219)(_this);
        // Set up initial aria attributes
        _this._setInitialAttributes(_this._parent, _this._getChildren());
        $a3e6c60bea301201$var$EventHandler.on(_this._element, $a3e6c60bea301201$var$EVENT_KEYDOWN, function(event) {
            return _this._keydown(event);
        });
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Tab, [
        {
            // Public
            key: "show",
            value: function show() {
                // Shows this elem and deactivate the active sibling if exists
                var innerElem = this._element;
                if (this._elemIsActive(innerElem)) return;
                // Search for active tab on same parent to deactivate it
                var active = this._getActiveElem();
                var hideEvent = active ? $a3e6c60bea301201$var$EventHandler.trigger(active, $a3e6c60bea301201$var$EVENT_HIDE$1, {
                    relatedTarget: innerElem
                }) : null;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(innerElem, $a3e6c60bea301201$var$EVENT_SHOW$1, {
                    relatedTarget: active
                });
                if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
                this._deactivate(active, innerElem);
                this._activate(innerElem, active);
            }
        },
        {
            // Private
            key: "_activate",
            value: function _activate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.add($a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
                this._activate($a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.removeAttribute('tabindex');
                    element.setAttribute('aria-selected', true);
                    _this._toggleDropDown(element, true);
                    $a3e6c60bea301201$var$EventHandler.trigger(element, $a3e6c60bea301201$var$EVENT_SHOWN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_deactivate",
            value: function _deactivate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
                element.blur();
                this._deactivate($a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.setAttribute('aria-selected', false);
                    element.setAttribute('tabindex', '-1');
                    _this._toggleDropDown(element, false);
                    $a3e6c60bea301201$var$EventHandler.trigger(element, $a3e6c60bea301201$var$EVENT_HIDDEN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (![
                    $a3e6c60bea301201$var$ARROW_LEFT_KEY,
                    $a3e6c60bea301201$var$ARROW_RIGHT_KEY,
                    $a3e6c60bea301201$var$ARROW_UP_KEY,
                    $a3e6c60bea301201$var$ARROW_DOWN_KEY,
                    $a3e6c60bea301201$var$HOME_KEY,
                    $a3e6c60bea301201$var$END_KEY
                ].includes(event.key)) return;
                event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
                event.preventDefault();
                var children = this._getChildren().filter(function(element) {
                    return !$a3e6c60bea301201$var$isDisabled(element);
                });
                var nextActiveElement;
                if ([
                    $a3e6c60bea301201$var$HOME_KEY,
                    $a3e6c60bea301201$var$END_KEY
                ].includes(event.key)) nextActiveElement = children[event.key === $a3e6c60bea301201$var$HOME_KEY ? 0 : children.length - 1];
                else {
                    var isNext = [
                        $a3e6c60bea301201$var$ARROW_RIGHT_KEY,
                        $a3e6c60bea301201$var$ARROW_DOWN_KEY
                    ].includes(event.key);
                    nextActiveElement = $a3e6c60bea301201$var$getNextActiveElement(children, event.target, isNext, true);
                }
                if (nextActiveElement) {
                    nextActiveElement.focus({
                        preventScroll: true
                    });
                    Tab.getOrCreateInstance(nextActiveElement).show();
                }
            }
        },
        {
            key: "_getChildren",
            value: function _getChildren() {
                // collection of inner elements
                return $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_INNER_ELEM, this._parent);
            }
        },
        {
            key: "_getActiveElem",
            value: function _getActiveElem() {
                var _this = this;
                return this._getChildren().find(function(child) {
                    return _this._elemIsActive(child);
                }) || null;
            }
        },
        {
            key: "_setInitialAttributes",
            value: function _setInitialAttributes(parent, children) {
                this._setAttributeIfNotExists(parent, 'role', 'tablist');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this._setInitialAttributesOnChild(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setInitialAttributesOnChild",
            value: function _setInitialAttributesOnChild(child) {
                child = this._getInnerElement(child);
                var isActive = this._elemIsActive(child);
                var outerElem = this._getOuterElement(child);
                child.setAttribute('aria-selected', isActive);
                if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
                if (!isActive) child.setAttribute('tabindex', '-1');
                this._setAttributeIfNotExists(child, 'role', 'tab');
                // set attributes to the related panel too
                this._setInitialAttributesOnTargetPanel(child);
            }
        },
        {
            key: "_setInitialAttributesOnTargetPanel",
            value: function _setInitialAttributesOnTargetPanel(child) {
                var target = $a3e6c60bea301201$var$SelectorEngine.getElementFromSelector(child);
                if (!target) return;
                this._setAttributeIfNotExists(target, 'role', 'tabpanel');
                if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', "".concat(child.id));
            }
        },
        {
            key: "_toggleDropDown",
            value: function _toggleDropDown(element, open) {
                var outerElem = this._getOuterElement(element);
                if (!outerElem.classList.contains($a3e6c60bea301201$var$CLASS_DROPDOWN)) return;
                var toggle = function(selector, className) {
                    var _$element = $a3e6c60bea301201$var$SelectorEngine.findOne(selector, outerElem);
                    if (_$element) _$element.classList.toggle(className, open);
                };
                toggle($a3e6c60bea301201$var$SELECTOR_DROPDOWN_TOGGLE, $a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
                toggle($a3e6c60bea301201$var$SELECTOR_DROPDOWN_MENU, $a3e6c60bea301201$var$CLASS_NAME_SHOW$1);
                outerElem.setAttribute('aria-expanded', open);
            }
        },
        {
            key: "_setAttributeIfNotExists",
            value: function _setAttributeIfNotExists(element, attribute, value) {
                if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
            }
        },
        {
            key: "_elemIsActive",
            value: function _elemIsActive(elem) {
                return elem.classList.contains($a3e6c60bea301201$var$CLASS_NAME_ACTIVE);
            }
        },
        {
            // Try to get the inner element (usually the .nav-link)
            key: "_getInnerElement",
            value: function _getInnerElement(elem) {
                return elem.matches($a3e6c60bea301201$var$SELECTOR_INNER_ELEM) ? elem : $a3e6c60bea301201$var$SelectorEngine.findOne($a3e6c60bea301201$var$SELECTOR_INNER_ELEM, elem);
            }
        },
        {
            // Try to get the outer element (usually the .nav-item)
            key: "_getOuterElement",
            value: function _getOuterElement(elem) {
                return elem.closest($a3e6c60bea301201$var$SELECTOR_OUTER) || elem;
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$NAME$1;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tab.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tab;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$EventHandler.on(document, $a3e6c60bea301201$var$EVENT_CLICK_DATA_API, $a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($a3e6c60bea301201$var$isDisabled(this)) return;
    $a3e6c60bea301201$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $a3e6c60bea301201$var$EventHandler.on(window, $a3e6c60bea301201$var$EVENT_LOAD_DATA_API, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a3e6c60bea301201$var$SelectorEngine.find($a3e6c60bea301201$var$SELECTOR_DATA_TOGGLE_ACTIVE)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $a3e6c60bea301201$export$3e41faf802a29e71.getOrCreateInstance(element);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $a3e6c60bea301201$var$NAME = 'toast';
var $a3e6c60bea301201$var$DATA_KEY = 'bs.toast';
var $a3e6c60bea301201$var$EVENT_KEY = ".".concat($a3e6c60bea301201$var$DATA_KEY);
var $a3e6c60bea301201$var$EVENT_MOUSEOVER = "mouseover".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_MOUSEOUT = "mouseout".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_FOCUSIN = "focusin".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_FOCUSOUT = "focusout".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_HIDE = "hide".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_HIDDEN = "hidden".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_SHOW = "show".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$EVENT_SHOWN = "shown".concat($a3e6c60bea301201$var$EVENT_KEY);
var $a3e6c60bea301201$var$CLASS_NAME_FADE = 'fade';
var $a3e6c60bea301201$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
var $a3e6c60bea301201$var$CLASS_NAME_SHOW = 'show';
var $a3e6c60bea301201$var$CLASS_NAME_SHOWING = 'showing';
var $a3e6c60bea301201$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
var $a3e6c60bea301201$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ var $a3e6c60bea301201$export$8d8dc7d5f743331b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $429fca99a37ce120$export$71511d61b312f219)(Toast, BaseComponent);
    function Toast(element, config) {
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Toast);
        var _this;
        _this = (0, $ba9b3af6d173df65$export$71511d61b312f219)(this, Toast, [
            element,
            config
        ]);
        _this._timeout = null;
        _this._hasMouseInteraction = false;
        _this._hasKeyboardInteraction = false;
        _this._setListeners();
        return _this;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Toast, [
        {
            // Public
            key: "show",
            value: function show() {
                var _this = this;
                var showEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_SHOW);
                if (showEvent.defaultPrevented) return;
                this._clearTimeout();
                if (this._config.animation) this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_FADE);
                var complete = function() {
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOWING);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_SHOWN);
                    _this._maybeScheduleHide();
                };
                this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_HIDE); // @deprecated
                $a3e6c60bea301201$var$reflow(this._element);
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOW, $a3e6c60bea301201$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this.isShown()) return;
                var hideEvent = $a3e6c60bea301201$var$EventHandler.trigger(this._element, $a3e6c60bea301201$var$EVENT_HIDE);
                if (hideEvent.defaultPrevented) return;
                var complete = function() {
                    _this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_HIDE); // @deprecated
                    _this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOWING, $a3e6c60bea301201$var$CLASS_NAME_SHOW);
                    $a3e6c60bea301201$var$EventHandler.trigger(_this._element, $a3e6c60bea301201$var$EVENT_HIDDEN);
                };
                this._element.classList.add($a3e6c60bea301201$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._clearTimeout();
                if (this.isShown()) this._element.classList.remove($a3e6c60bea301201$var$CLASS_NAME_SHOW);
                (0, $3eca773514dd6a70$export$71511d61b312f219)((0, $ccc23a021f1e6bc0$export$71511d61b312f219)(Toast.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "isShown",
            value: function isShown() {
                return this._element.classList.contains($a3e6c60bea301201$var$CLASS_NAME_SHOW);
            }
        },
        {
            // Private
            key: "_maybeScheduleHide",
            value: function _maybeScheduleHide() {
                var _this = this;
                if (!this._config.autohide) return;
                if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
                this._timeout = setTimeout(function() {
                    _this.hide();
                }, this._config.delay);
            }
        },
        {
            key: "_onInteraction",
            value: function _onInteraction(event, isInteracting) {
                switch(event.type){
                    case 'mouseover':
                    case 'mouseout':
                        this._hasMouseInteraction = isInteracting;
                        break;
                    case 'focusin':
                    case 'focusout':
                        this._hasKeyboardInteraction = isInteracting;
                        break;
                }
                if (isInteracting) {
                    this._clearTimeout();
                    return;
                }
                var nextElement = event.relatedTarget;
                if (this._element === nextElement || this._element.contains(nextElement)) return;
                this._maybeScheduleHide();
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEOVER, function(event) {
                    return _this._onInteraction(event, true);
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_MOUSEOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_FOCUSIN, function(event) {
                    return _this._onInteraction(event, true);
                });
                $a3e6c60bea301201$var$EventHandler.on(this._element, $a3e6c60bea301201$var$EVENT_FOCUSOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
            }
        },
        {
            key: "_clearTimeout",
            value: function _clearTimeout() {
                clearTimeout(this._timeout);
                this._timeout = null;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $a3e6c60bea301201$var$Default;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $a3e6c60bea301201$var$DefaultType;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $a3e6c60bea301201$var$NAME;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Toast.getOrCreateInstance(this, config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config](this);
                    }
                });
            }
        }
    ]);
    return Toast;
}($a3e6c60bea301201$var$BaseComponent);
/**
 * Data API implementation
 */ $a3e6c60bea301201$var$enableDismissTrigger($a3e6c60bea301201$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $a3e6c60bea301201$var$defineJQueryPlugin($a3e6c60bea301201$export$8d8dc7d5f743331b);


// Video Size
/* ####################################################################################

UO-Accessibility

Author: Sarah Becker [UO True Digital Partners]
unternehmen online GmbH & Co. KG

#################################################################################### */ 

var $b52a5343ffee21e0$var$UoAccessability = /*#__PURE__*/ function() {
    "use strict";
    function UoAccessability(argumentObject) {
        var _this = this;
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, UoAccessability);
        console.log("UO-Accessibility: Loaded");
        //All access helpers:
        this.helper = argumentObject.helper;
        //Setting hidden class for html-anchors
        this.hiddenClass = argumentObject.hiddenClass;
        //Setting focus visible styles
        this.overwriteFocusVisibleStyles = argumentObject.overwriteFocusVisibleStyles;
        // Get the current language from the HTML head
        this.language = document.documentElement.lang || 'de';
        console.log("UO-Accessibility: Language set to ".concat(this.language));
        this.helper.forEach(function(element) {
            console.log("UO-Accessibility: Element ".concat(element.helperName[_this.language] || element.helperName['de-DE'], " added"));
        });
        if (!this.checkDom()) return false;
        this.addAnchors();
        console.log("UO-Accessibility: Anchors added");
        this.addAccessibilityNav();
        console.log("UO-Accessibility: Accessibility nav added");
        this.doOverwriteFocusVisibleStyles();
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(UoAccessability, [
        {
            //Add html-anchors for all access helpers (each anchor is also an screenreader-only introductory heading)
            key: "addAnchors",
            value: function addAnchors() {
                var _this = this;
                this.helper.forEach(function(element) {
                    document.querySelector(element.targetSelector).insertAdjacentHTML("beforebegin", '<span tabindex="-1" class="'.concat(_this.hiddenClass, '" id="').concat(element.anchorID, '">').concat(element.helperName[_this.language] || element.helperName['de-DE'], "</span>"));
                });
            }
        },
        {
            //Add buttons at top of page as quick-access to all the anchors
            key: "addAccessibilityNav",
            value: function addAccessibilityNav() {
                var _this = this;
                //Create new div as container
                var accessibilityNav = document.createElement("div");
                //Add content and class to new div
                accessibilityNav.innerHTML = this.helper.map(function(element) {
                    return '<a href="#'.concat(element.anchorID, '" data-target="').concat(element.anchorID, '">').concat(element.linkText[_this.language] || element.linkText['de-DE'], "</a>");
                }).join("<br />");
                accessibilityNav.classList.add("uo-accessibility-buttons");
                var allLinks = accessibilityNav.querySelectorAll('a');
                console.log("allLinks: " + allLinks);
                allLinks.forEach(function(element) {
                    console.log("element: " + element);
                    // console.log("index: "+index);
                    element.addEventListener("click", function(event) {
                        // event.preventDefault();
                        var linkTarget = element.getAttribute("data-target");
                        //console.log(linkTarget);
                        document.getElementById(linkTarget).focus();
                    });
                });
                //Insert new div at beginning of page
                var body = document.body;
                body.insertBefore(accessibilityNav, body.firstChild);
            }
        },
        {
            //Add body-class to overwrite focus-visible-styles
            key: "doOverwriteFocusVisibleStyles",
            value: function doOverwriteFocusVisibleStyles() {
                if (this.overwriteFocusVisibleStyles) {
                    document.body.classList.add("uo-accessibility-focus");
                    console.log("UO-Accessibility: Overwrite focus styles TRUE");
                } else console.log("UO-Accessibility: Overwrite focus styles FALSE");
            }
        },
        {
            /**
	 * Checks the given helpers for the existance in the dom
	 * @returns boolean depending on if all targetSelectors are found
	 */ key: "checkDom",
            value: function checkDom() {
                var checkResult = true;
                this.helper.forEach(function(element) {
                    if (!document.querySelector(element.targetSelector)) {
                        checkResult = false;
                        console.log("UO-Accessibility: targetSelector ".concat(element.targetSelector, " does not exist!"));
                    }
                });
                return checkResult;
            }
        }
    ]);
    return UoAccessability;
}();
var $b52a5343ffee21e0$export$2e2bcd8739ae039 = $b52a5343ffee21e0$var$UoAccessability;


function $e77e57f2abfd97c1$var$enableRatioChecker() {
    function check16by9() {
        var videoElements = document.querySelectorAll('.swiper-slide video');
        if (videoElements.length === 0) return;
        videoElements.forEach(function(video) {
            if (video.offsetWidth / video.offsetHeight >= 16 / 9) video.classList.add('ratio16by9');
            else video.classList.remove('ratio16by9');
        });
    }
    window.addEventListener('resize', function() {
        check16by9();
    });
    check16by9();
}
document.addEventListener('DOMContentLoaded', function() {
    $e77e57f2abfd97c1$var$enableRatioChecker();
});
document.addEventListener('DOMContentLoaded', function() {
    var uoAccessability = new (0, $b52a5343ffee21e0$export$2e2bcd8739ae039)({
        overwriteFocusVisibleStyles: true,
        hiddenClass: 'visually-hidden',
        helper: [
            {
                helperName: {
                    'de-DE': 'Hauptnavigation',
                    'en-EN': 'Main menu'
                },
                targetSelector: 'header .navbar-toggler',
                anchorID: 'uo-target-nav',
                linkText: {
                    'de-DE': 'Direkt zur Hauptnavigation',
                    'en-EN': 'Skip to main menu'
                }
            },
            {
                helperName: {
                    'de-DE': 'Inhalt',
                    'en-EN': 'Content'
                },
                targetSelector: 'main',
                anchorID: 'uo-target-content',
                linkText: {
                    'de-DE': 'Direkt zum Inhalt',
                    'en-EN': 'Skip to content'
                }
            },
            {
                helperName: {
                    'de-DE': 'Footer',
                    'en-EN': 'Footer'
                },
                targetSelector: 'footer',
                anchorID: 'uo-target-footer',
                linkText: {
                    'de-DE': 'Direkt zum Footer',
                    'en-EN': 'Skip to footer'
                }
            }
        ]
    });
});
// Sticky Navbar
function $e77e57f2abfd97c1$var$initStickyNavbar() {
    var nav = document.querySelector('nav');
    var header = document.querySelector('header');
    if (!nav || !header) return;
    var isSticky = window.getComputedStyle(nav).position === 'sticky';
    var headerHeight = header.offsetHeight;
    var latestKnownScrollY = 0, ticking = false, isDone = false;
    var update = function update() {
        var cls = nav.classList;
        if (latestKnownScrollY >= headerHeight && !isDone) {
            if (!isSticky) cls.add('is-fixed') // IE11 and Edge 15
            ;
            cls.add('is-scrolled');
            isDone = true;
        } else if (latestKnownScrollY < headerHeight && isDone) {
            if (!isSticky) cls.remove('is-fixed');
            cls.remove('is-scrolled');
            isDone = false;
        }
        ticking = false;
    };
    var onScroll = function onScroll() {
        if (window.innerWidth >= 1200) {
            latestKnownScrollY = window.pageYOffset;
            if (!ticking) {
                requestAnimationFrame(update);
                ticking = true;
            }
        }
    };
    if (window.innerWidth >= 1200) window.addEventListener('scroll', onScroll, false);
}
document.addEventListener('DOMContentLoaded', $e77e57f2abfd97c1$var$initStickyNavbar, false);
// // Datepicker
// import $ from 'jquery'
// window.$ = $
// !(function (a) {
//   a.fn.datepicker.dates.de = {
//     days: [
//       'Sonntag',
//       'Montag',
//       'Dienstag',
//       'Mittwoch',
//       'Donnerstag',
//       'Freitag',
//       'Samstag'
//     ],
//     daysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
//     daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
//     months: [
//       'Januar',
//       'Februar',
//       'März',
//       'April',
//       'Mai',
//       'Juni',
//       'Juli',
//       'August',
//       'September',
//       'Oktober',
//       'November',
//       'Dezember'
//     ],
//     monthsShort: [
//       'Jan',
//       'Feb',
//       'Mär',
//       'Apr',
//       'Mai',
//       'Jun',
//       'Jul',
//       'Aug',
//       'Sep',
//       'Okt',
//       'Nov',
//       'Dez'
//     ],
//     today: 'Heute',
//     monthsTitle: 'Monate',
//     clear: 'Löschen',
//     weekStart: 1,
//     format: 'dd.mm.yyyy'
//   }
// })($)
// document.addEventListener('DOMContentLoaded', () => {
//   const datepickers = $('.datepicker')
//   if (datepickers.length > 0) {
//     datepickers.datepicker({
//       language: 'de-DE',
//       autoclose: true,
//       todayHighlight: true
//     })
//   }
// })
// IBAN
document.querySelectorAll('.iban').forEach(function(ibanInput) {
    ibanInput.addEventListener('input', function(e) {
        e.target.value = e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
    });
});
// Slider Buttons Position START
function $e77e57f2abfd97c1$var$adjustSliderButtons() {
    var firstImage = document.querySelector('.event-swiper .swiper-slide img');
    if (window.innerWidth <= 992 && firstImage) {
        var imageHeight = firstImage.clientHeight;
        var prevButton = document.querySelector('.event-swiper .swiper-button-prev');
        var nextButton = document.querySelector('.event-swiper .swiper-button-next');
        if (prevButton && nextButton) {
            var buttonTop = imageHeight / 2;
            prevButton.style.top = "".concat(buttonTop, "px");
            nextButton.style.top = "".concat(buttonTop, "px");
        }
    } else {
        var prevButton1 = document.querySelector('.event-swiper .swiper-button-prev');
        var nextButton1 = document.querySelector('.event-swiper .swiper-button-next');
        if (prevButton1 && nextButton1) {
            prevButton1.style.top = '';
            nextButton1.style.top = '';
        }
    }
}
window.addEventListener('load', $e77e57f2abfd97c1$var$adjustSliderButtons);
window.addEventListener('resize', $e77e57f2abfd97c1$var$adjustSliderButtons);
// Slider Buttons Position END
// matchHeight START
function $e77e57f2abfd97c1$var$matchIt(element) {
    var matches = document.querySelectorAll(element);
    var rows = [];
    matches.forEach(function(match) {
        match.style.height = 'auto' // Zurücksetzen der Höhe vor der Neuberechnung
        ;
        match.dataset.offset = 'offset-' + parseInt(match.getBoundingClientRect().top);
        var batch = document.querySelectorAll("[data-offset='offset-" + parseInt(match.getBoundingClientRect().top) + "']");
        if (batch.length) {
            var maxH = 0;
            batch.forEach(function(item) {
                if (maxH < item.clientHeight) maxH = item.clientHeight;
            });
            batch.forEach(function(item) {
                item.style.height = maxH + 'px' // Maximale Höhe für jedes Element setzen
                ;
            });
        }
    });
    matches.forEach(function(match) {
        match.removeAttribute('data-offset') // Entfernen des data-Offsets nach der Berechnung
        ;
    });
}
function $e77e57f2abfd97c1$var$matchItAll(element) {
    // Initiale Berechnung nur wenn der Bildschirm kleiner als 992px ist
    if (window.innerWidth < 992) $e77e57f2abfd97c1$var$matchIt(element);
    var previousWidth = window.innerWidth;
    window.addEventListener('resize', function() {
        var currentWidth = window.innerWidth;
        // Wenn von > 992px auf < 992px gewechselt wird, Höhen neu berechnen
        if (previousWidth >= 992 && currentWidth < 992) $e77e57f2abfd97c1$var$matchIt(element);
        else if (previousWidth < 992 && currentWidth >= 992) {
            // Wenn von < 992px auf > 992px gewechselt wird, zurücksetzen
            var matches = document.querySelectorAll(element);
            matches.forEach(function(match) {
                match.style.height = '100%' // Höhe zurücksetzen
                ;
            });
        }
        // Überprüfen, ob der Bildschirm wirklich eine Schwelle überschreitet (genauere Berechnung)
        if (previousWidth !== currentWidth) // requestAnimationFrame wird verwendet, um das Layout nach der Resize-Änderung zu aktualisieren
        requestAnimationFrame(function() {
            if (currentWidth < 992) $e77e57f2abfd97c1$var$matchIt(element) // Berechnung erneut durchführen
            ;
        });
        previousWidth = currentWidth // Speichern der aktuellen Fenstergröße
        ;
    });
}
// Überprüfen, ob .project-swiper vorhanden ist, und dann die matchItAll-Funktion aufrufen
var $e77e57f2abfd97c1$var$projectSwipers = document.querySelectorAll('.project-swiper');
if ($e77e57f2abfd97c1$var$projectSwipers.length > 0) $e77e57f2abfd97c1$var$projectSwipers.forEach(function(swiper) {
    $e77e57f2abfd97c1$var$matchItAll('.project-swiper .match-height');
});
// matchHeight END
// Header Height Start
function $e77e57f2abfd97c1$var$adjustHeroHeight() {
    var header = document.querySelector('header');
    var heroSwiper = document.querySelector('.event-swiper');
    if (!heroSwiper) return;
    if (window.innerWidth >= 1200) {
        if (header && heroSwiper) {
            var headerHeight = header.offsetHeight;
            var viewportHeight = window.innerHeight;
            var swiperHeight = viewportHeight - headerHeight;
            heroSwiper.style.height = "".concat(swiperHeight, "px");
        }
    } else heroSwiper.style.height = "100%";
}
window.addEventListener('load', $e77e57f2abfd97c1$var$adjustHeroHeight);
window.addEventListener('resize', $e77e57f2abfd97c1$var$adjustHeroHeight);
// Header Height END
// Toggle Form Previous Funding with Radio Buttons START
document.addEventListener('DOMContentLoaded', function() {
    // Alle Container mit der Klasse 'toggleRadioButtons' auswählen
    var toggleGroups = document.querySelectorAll('.toggleRadioButtons');
    toggleGroups.forEach(function(group) {
        var toggleFieldsetVisibility = // Funktion, um das Fieldset basierend auf dem Radiobutton-Zustand ein-/auszublenden
        function toggleFieldsetVisibility() {
            if (radioYes && radioYes.checked) toggleFieldset.style.display = 'block';
            else toggleFieldset.style.display = 'none';
        };
        // Radiobuttons und das abhängige Fieldset innerhalb des Containers finden
        var radioYes = group.querySelector('input[type="radio"][value="ja"]');
        var radioNo = group.querySelector('input[type="radio"][value="nein"]');
        var toggleFieldset = group.querySelector('.toggleFieldset');
        // Event-Listener für die Radiobuttons hinzufügen
        if (radioYes) radioYes.addEventListener('change', toggleFieldsetVisibility);
        if (radioNo) radioNo.addEventListener('change', toggleFieldsetVisibility);
        // Initialer Zustand überprüfen
        toggleFieldsetVisibility();
    });
});
// Toggle Form Previous Funding with Radio Buttons END
var $e77e57f2abfd97c1$var$rechtsformSelect = document.getElementById('rechtsformSelect');
if ($e77e57f2abfd97c1$var$rechtsformSelect) $e77e57f2abfd97c1$var$rechtsformSelect.addEventListener('change', function() {
    var wrapper = document.getElementById('zuschussStiftungWrapper');
    if (wrapper) {
        if (this.value === '4') wrapper.classList.remove('d-none');
        else wrapper.classList.add('d-none');
    }
});


/**
 * Swiper 11.1.15
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: November 18, 2024
 */ 








function $650091777930d0d5$var$isObject(e) {
    return null !== e && "object" == (typeof e === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(e)) && "constructor" in e && e.constructor === Object;
}
function $650091777930d0d5$var$extend(e, t) {
    void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach(function(n) {
        void 0 === e[n] ? e[n] = t[n] : $650091777930d0d5$var$isObject(t[n]) && $650091777930d0d5$var$isObject(e[n]) && Object.keys(t[n]).length > 0 && $650091777930d0d5$var$extend(e[n], t[n]);
    });
}
var $650091777930d0d5$var$ssrDocument = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ""
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $650091777930d0d5$export$39b482c5e57630a8() {
    var e = "undefined" != typeof document ? document : {};
    return $650091777930d0d5$var$extend(e, $650091777930d0d5$var$ssrDocument), e;
}
var $650091777930d0d5$var$ssrWindow = {
    document: $650091777930d0d5$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return "";
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(e) {
        return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
    },
    cancelAnimationFrame: function(e) {
        "undefined" != typeof setTimeout && clearTimeout(e);
    }
};
function $650091777930d0d5$export$407448d2b89b1813() {
    var e = "undefined" != typeof window ? window : {};
    return $650091777930d0d5$var$extend(e, $650091777930d0d5$var$ssrWindow), e;
}






function $3d818fcc5f3623ef$export$23f2a1d2818174ef(e) {
    return void 0 === e && (e = ""), e.trim().split(" ").filter(function(e) {
        return !!e.trim();
    });
}
function $3d818fcc5f3623ef$export$d141bba7fdc215a3(e) {
    var t = e;
    Object.keys(t).forEach(function(e) {
        try {
            t[e] = null;
        } catch (e) {}
        try {
            delete t[e];
        } catch (e) {}
    });
}
function $3d818fcc5f3623ef$export$7ccc53e8f1e7dfc5(e, t) {
    return void 0 === t && (t = 0), setTimeout(e, t);
}
function $3d818fcc5f3623ef$export$4368d992c4eafac0() {
    return Date.now();
}
function $3d818fcc5f3623ef$var$getComputedStyle(e) {
    var t = (0, $650091777930d0d5$export$407448d2b89b1813)();
    var n;
    return t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n || (n = e.style), n;
}
function $3d818fcc5f3623ef$export$35e795649ee09318(e, t) {
    void 0 === t && (t = "x");
    var n = (0, $650091777930d0d5$export$407448d2b89b1813)();
    var r, o, s;
    var l = $3d818fcc5f3623ef$var$getComputedStyle(e);
    return n.WebKitCSSMatrix ? (o = l.transform || l.webkitTransform, o.split(",").length > 6 && (o = o.split(", ").map(function(e) {
        return e.replace(",", ".");
    }).join(", ")), s = new n.WebKitCSSMatrix("none" === o ? "" : o)) : (s = l.MozTransform || l.OTransform || l.MsTransform || l.msTransform || l.transform || l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = s.toString().split(",")), "x" === t && (o = n.WebKitCSSMatrix ? s.m41 : 16 === r.length ? parseFloat(r[12]) : parseFloat(r[4])), "y" === t && (o = n.WebKitCSSMatrix ? s.m42 : 16 === r.length ? parseFloat(r[13]) : parseFloat(r[5])), o || 0;
}
function $3d818fcc5f3623ef$export$882b5998b3b9117c(e) {
    return "object" == (typeof e === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(e)) && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
}
function $3d818fcc5f3623ef$var$isNode(e) {
    return "undefined" != typeof window && void 0 !== window.HTMLElement ? e instanceof HTMLElement : e && (1 === e.nodeType || 11 === e.nodeType);
}
function $3d818fcc5f3623ef$export$efccba1c4a2ef57b() {
    var e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(var n = 1; n < arguments.length; n += 1){
        var r = n < 0 || arguments.length <= n ? void 0 : arguments[n];
        if (null != r && !$3d818fcc5f3623ef$var$isNode(r)) {
            var n1 = Object.keys(Object(r)).filter(function(e) {
                return t.indexOf(e) < 0;
            });
            for(var t1 = 0, o = n1.length; t1 < o; t1 += 1){
                var o1 = n1[t1], s = Object.getOwnPropertyDescriptor(r, o1);
                void 0 !== s && s.enumerable && ($3d818fcc5f3623ef$export$882b5998b3b9117c(e[o1]) && $3d818fcc5f3623ef$export$882b5998b3b9117c(r[o1]) ? r[o1].__swiper__ ? e[o1] = r[o1] : $3d818fcc5f3623ef$export$efccba1c4a2ef57b(e[o1], r[o1]) : !$3d818fcc5f3623ef$export$882b5998b3b9117c(e[o1]) && $3d818fcc5f3623ef$export$882b5998b3b9117c(r[o1]) ? (e[o1] = {}, r[o1].__swiper__ ? e[o1] = r[o1] : $3d818fcc5f3623ef$export$efccba1c4a2ef57b(e[o1], r[o1])) : e[o1] = r[o1]);
            }
        }
    }
    return e;
}
function $3d818fcc5f3623ef$export$2408f22a0fab9ae5(e, t, n) {
    e.style.setProperty(t, n);
}
function $3d818fcc5f3623ef$export$625550452a3fa3ec(e) {
    var t = e.swiper, n = e.targetPosition, r = e.side;
    var o = (0, $650091777930d0d5$export$407448d2b89b1813)(), s = -t.translate;
    var l, i = null;
    var a = t.params.speed;
    t.wrapperEl.style.scrollSnapType = "none", o.cancelAnimationFrame(t.cssModeFrameID);
    var c = n > s ? "next" : "prev", m = function(e, t) {
        return "next" === c && e >= t || "prev" === c && e <= t;
    }, u = function() {
        l = (new Date).getTime(), null === i && (i = l);
        var _$e = Math.max(Math.min((l - i) / a, 1), 0), c = .5 - Math.cos(_$e * Math.PI) / 2;
        var d = s + c * (n - s);
        if (m(d, n) && (d = n), t.wrapperEl.scrollTo((0, $71081ebd7d211bed$export$71511d61b312f219)({}, r, d)), m(d, n)) return t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(function() {
            t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo((0, $71081ebd7d211bed$export$71511d61b312f219)({}, r, d));
        }), void o.cancelAnimationFrame(t.cssModeFrameID);
        t.cssModeFrameID = o.requestAnimationFrame(u);
    };
    u();
}
function $3d818fcc5f3623ef$export$39b482c5e57630a8(e) {
    return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e;
}
function $3d818fcc5f3623ef$export$f1e1789686576879(e, t) {
    var _n;
    void 0 === t && (t = "");
    var n = (0, $1961f7bca441a4c6$export$71511d61b312f219)(e.children);
    return e instanceof HTMLSlotElement && (_n = n).push.apply(_n, (0, $1961f7bca441a4c6$export$71511d61b312f219)(e.assignedElements())), t ? n.filter(function(e) {
        return e.matches(t);
    }) : n;
}
function $3d818fcc5f3623ef$export$90a7f3efeed30595(e, t) {
    var n = t.contains(e);
    if (!n && t instanceof HTMLSlotElement) return (0, $1961f7bca441a4c6$export$71511d61b312f219)(t.assignedElements()).includes(e);
    return n;
}
function $3d818fcc5f3623ef$export$3b14a55fb2447963(e) {
    try {
        return void console.warn(e);
    } catch (e) {}
}
function $3d818fcc5f3623ef$export$db3b6bfb95261072(e, t) {
    var _n_classList;
    void 0 === t && (t = []);
    var n = document.createElement(e);
    return (_n_classList = n.classList).add.apply(_n_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(Array.isArray(t) ? t : $3d818fcc5f3623ef$export$23f2a1d2818174ef(t))), n;
}
function $3d818fcc5f3623ef$export$8b22cf2602fb60ce(e) {
    var t = (0, $650091777930d0d5$export$407448d2b89b1813)(), n = (0, $650091777930d0d5$export$39b482c5e57630a8)(), r = e.getBoundingClientRect(), o = n.body, s = e.clientTop || o.clientTop || 0, l = e.clientLeft || o.clientLeft || 0, i = e === t ? t.scrollY : e.scrollTop, a = e === t ? t.scrollX : e.scrollLeft;
    return {
        top: r.top + i - s,
        left: r.left + a - l
    };
}
function $3d818fcc5f3623ef$export$43caf9889c228507(e, t) {
    var n = [];
    for(; e.previousElementSibling;){
        var r = e.previousElementSibling;
        t ? r.matches(t) && n.push(r) : n.push(r), e = r;
    }
    return n;
}
function $3d818fcc5f3623ef$export$9e5f44173e64f162(e, t) {
    var n = [];
    for(; e.nextElementSibling;){
        var r = e.nextElementSibling;
        t ? r.matches(t) && n.push(r) : n.push(r), e = r;
    }
    return n;
}
function $3d818fcc5f3623ef$export$ffb5f4729a158638(e, t) {
    return (0, $650091777930d0d5$export$407448d2b89b1813)().getComputedStyle(e, null).getPropertyValue(t);
}
function $3d818fcc5f3623ef$export$dda1d9f60106f0e9(e) {
    var t, n = e;
    if (n) {
        for(t = 0; null !== (n = n.previousSibling);)1 === n.nodeType && (t += 1);
        return t;
    }
}
function $3d818fcc5f3623ef$export$407448d2b89b1813(e, t) {
    var n = [];
    var r = e.parentElement;
    for(; r;)t ? r.matches(t) && n.push(r) : n.push(r), r = r.parentElement;
    return n;
}
function $3d818fcc5f3623ef$export$342063e11d6c3cad(e, t) {
    t && e.addEventListener("transitionend", function n(r) {
        r.target === e && (t.call(e, r), e.removeEventListener("transitionend", n));
    });
}
function $3d818fcc5f3623ef$export$2d1720544b23b823(e, t, n) {
    var r = (0, $650091777930d0d5$export$407448d2b89b1813)();
    return n ? e["width" === t ? "offsetWidth" : "offsetHeight"] + parseFloat(r.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) + parseFloat(r.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom")) : e.offsetWidth;
}
function $3d818fcc5f3623ef$export$953cecd6e717a553(e) {
    return (Array.isArray(e) ? e : [
        e
    ]).filter(function(e) {
        return !!e;
    });
}
function $3d818fcc5f3623ef$export$ae1af26003f05816(e) {
    return function(t) {
        return Math.abs(t) > 0 && e.browser && e.browser.need3dFix && Math.abs(t) % 90 == 0 ? t + .001 : t;
    };
}


var $7704c8facc3d92c9$var$support, $7704c8facc3d92c9$var$deviceCached, $7704c8facc3d92c9$var$browser;
function $7704c8facc3d92c9$var$calcSupport() {
    var e = (0, $650091777930d0d5$export$407448d2b89b1813)(), t = (0, $650091777930d0d5$export$39b482c5e57630a8)();
    return {
        smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
        touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
    };
}
function $7704c8facc3d92c9$var$getSupport() {
    return $7704c8facc3d92c9$var$support || ($7704c8facc3d92c9$var$support = $7704c8facc3d92c9$var$calcSupport()), $7704c8facc3d92c9$var$support;
}
function $7704c8facc3d92c9$var$calcDevice(e) {
    var _ref = void 0 === e ? {} : e, t = _ref.userAgent;
    var s = $7704c8facc3d92c9$var$getSupport(), i = (0, $650091777930d0d5$export$407448d2b89b1813)(), r = i.navigator.platform, n = t || i.navigator.userAgent, a = {
        ios: !1,
        android: !1
    }, l = i.screen.width, o = i.screen.height, d = n.match(/(Android);?[\s\/]+([\d.]+)?/);
    var c = n.match(/(iPad).*OS\s([\d_]+)/);
    var p = n.match(/(iPod)(.*OS\s([\d_]+))?/), u = !c && n.match(/(iPhone\sOS|iOS)\s([\d_]+)/), h = "Win32" === r;
    var m = "MacIntel" === r;
    return !c && m && s.touch && [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ].indexOf("".concat(l, "x").concat(o)) >= 0 && (c = n.match(/(Version)\/([\d.]+)/), c || (c = [
        0,
        1,
        "13_0_0"
    ]), m = !1), d && !h && (a.os = "android", a.android = !0), (c || u || p) && (a.os = "ios", a.ios = !0), a;
}
function $7704c8facc3d92c9$var$getDevice(e) {
    return void 0 === e && (e = {}), $7704c8facc3d92c9$var$deviceCached || ($7704c8facc3d92c9$var$deviceCached = $7704c8facc3d92c9$var$calcDevice(e)), $7704c8facc3d92c9$var$deviceCached;
}
function $7704c8facc3d92c9$var$calcBrowser() {
    var e = (0, $650091777930d0d5$export$407448d2b89b1813)(), t = $7704c8facc3d92c9$var$getDevice();
    var s = !1;
    function i() {
        var t = e.navigator.userAgent.toLowerCase();
        return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
    }
    if (i()) {
        var t1 = String(e.navigator.userAgent);
        if (t1.includes("Version/")) {
            var _t_split__split__split_map = (0, $d98b89efad01a571$export$71511d61b312f219)(t1.split("Version/")[1].split(" ")[0].split(".").map(function(e) {
                return Number(e);
            }), 2), e1 = _t_split__split__split_map[0], _$i = _t_split__split__split_map[1];
            s = e1 < 16 || 16 === e1 && _$i < 2;
        }
    }
    var r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), n = i();
    return {
        isSafari: s || n,
        needPerspectiveFix: s,
        need3dFix: n || r && t.ios,
        isWebView: r
    };
}
function $7704c8facc3d92c9$var$getBrowser() {
    return $7704c8facc3d92c9$var$browser || ($7704c8facc3d92c9$var$browser = $7704c8facc3d92c9$var$calcBrowser()), $7704c8facc3d92c9$var$browser;
}
function $7704c8facc3d92c9$var$Resize(e) {
    var t = e.swiper, s = e.on, i = e.emit;
    var r = (0, $650091777930d0d5$export$407448d2b89b1813)();
    var n = null, a = null;
    var l = function() {
        t && !t.destroyed && t.initialized && (i("beforeResize"), i("resize"));
    }, o = function() {
        t && !t.destroyed && t.initialized && i("orientationchange");
    };
    s("init", function() {
        t.params.resizeObserver && void 0 !== r.ResizeObserver ? t && !t.destroyed && t.initialized && (n = new ResizeObserver(function(e) {
            a = r.requestAnimationFrame(function() {
                var s = t.width, i = t.height;
                var r = s, n = i;
                e.forEach(function(e) {
                    var s = e.contentBoxSize, i = e.contentRect, a = e.target;
                    a && a !== t.el || (r = i ? i.width : (s[0] || s).inlineSize, n = i ? i.height : (s[0] || s).blockSize);
                }), r === s && n === i || l();
            });
        }), n.observe(t.el)) : (r.addEventListener("resize", l), r.addEventListener("orientationchange", o));
    }), s("destroy", function() {
        a && r.cancelAnimationFrame(a), n && n.unobserve && t.el && (n.unobserve(t.el), n = null), r.removeEventListener("resize", l), r.removeEventListener("orientationchange", o);
    });
}
function $7704c8facc3d92c9$var$Observer(e) {
    var t = e.swiper, s = e.extendParams, i = e.on, r = e.emit;
    var n = [], a = (0, $650091777930d0d5$export$407448d2b89b1813)(), l = function l(e, s) {
        void 0 === s && (s = {});
        var i = new (a.MutationObserver || a.WebkitMutationObserver)(function(e) {
            if (t.__preventObserver__) return;
            if (1 === e.length) return void r("observerUpdate", e[0]);
            var _$s = function s() {
                r("observerUpdate", e[0]);
            };
            a.requestAnimationFrame ? a.requestAnimationFrame(_$s) : a.setTimeout(_$s, 0);
        });
        i.observe(e, {
            attributes: void 0 === s.attributes || s.attributes,
            childList: t.isElement || (void 0 === s.childList || s).childList,
            characterData: void 0 === s.characterData || s.characterData
        }), n.push(i);
    };
    s({
        observer: !1,
        observeParents: !1,
        observeSlideChildren: !1
    }), i("init", function() {
        if (t.params.observer) {
            if (t.params.observeParents) {
                var _$e = (0, $3d818fcc5f3623ef$export$407448d2b89b1813)(t.hostEl);
                for(var t1 = 0; t1 < _$e.length; t1 += 1)l(_$e[t1]);
            }
            l(t.hostEl, {
                childList: t.params.observeSlideChildren
            }), l(t.wrapperEl, {
                attributes: !1
            });
        }
    }), i("destroy", function() {
        n.forEach(function(e) {
            e.disconnect();
        }), n.splice(0, n.length);
    });
}
var $7704c8facc3d92c9$var$eventsEmitter = {
    on: function(e, t, s) {
        var i = this;
        if (!i.eventsListeners || i.destroyed) return i;
        if ("function" != typeof t) return i;
        var r = s ? "unshift" : "push";
        return e.split(" ").forEach(function(e) {
            i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][r](t);
        }), i;
    },
    once: function(e, t, s) {
        var i = this;
        if (!i.eventsListeners || i.destroyed) return i;
        if ("function" != typeof t) return i;
        function r() {
            i.off(e, r), r.__emitterProxy && delete r.__emitterProxy;
            for(var _$s = arguments.length, n = new Array(_$s), a = 0; a < _$s; a++)n[a] = arguments[a];
            t.apply(i, n);
        }
        return r.__emitterProxy = t, i.on(e, r, s);
    },
    onAny: function(e, t) {
        var s = this;
        if (!s.eventsListeners || s.destroyed) return s;
        if ("function" != typeof e) return s;
        var i = t ? "unshift" : "push";
        return s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[i](e), s;
    },
    offAny: function(e) {
        var t = this;
        if (!t.eventsListeners || t.destroyed) return t;
        if (!t.eventsAnyListeners) return t;
        var s = t.eventsAnyListeners.indexOf(e);
        return s >= 0 && t.eventsAnyListeners.splice(s, 1), t;
    },
    off: function(e, t) {
        var s = this;
        return !s.eventsListeners || s.destroyed ? s : s.eventsListeners ? (e.split(" ").forEach(function(e) {
            void 0 === t ? s.eventsListeners[e] = [] : s.eventsListeners[e] && s.eventsListeners[e].forEach(function(i, r) {
                (i === t || i.__emitterProxy && i.__emitterProxy === t) && s.eventsListeners[e].splice(r, 1);
            });
        }), s) : s;
    },
    emit: function() {
        var e = this;
        if (!e.eventsListeners || e.destroyed) return e;
        if (!e.eventsListeners) return e;
        var t, s, i;
        for(var r = arguments.length, n = new Array(r), a = 0; a < r; a++)n[a] = arguments[a];
        "string" == typeof n[0] || Array.isArray(n[0]) ? (t = n[0], s = n.slice(1, n.length), i = e) : (t = n[0].events, s = n[0].data, i = n[0].context || e), s.unshift(i);
        return (Array.isArray(t) ? t : t.split(" ")).forEach(function(t) {
            e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach(function(e) {
                e.apply(i, [
                    t
                ].concat((0, $1961f7bca441a4c6$export$71511d61b312f219)(s)));
            }), e.eventsListeners && e.eventsListeners[t] && e.eventsListeners[t].forEach(function(e) {
                e.apply(i, s);
            });
        }), e;
    }
};
function $7704c8facc3d92c9$var$updateSize() {
    var e = this;
    var t, s;
    var i = e.el;
    t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : i.clientWidth, s = void 0 !== e.params.height && null !== e.params.height ? e.params.height : i.clientHeight, 0 === t && e.isHorizontal() || 0 === s && e.isVertical() || (t = t - parseInt((0, $3d818fcc5f3623ef$export$ffb5f4729a158638)(i, "padding-left") || 0, 10) - parseInt((0, $3d818fcc5f3623ef$export$ffb5f4729a158638)(i, "padding-right") || 0, 10), s = s - parseInt((0, $3d818fcc5f3623ef$export$ffb5f4729a158638)(i, "padding-top") || 0, 10) - parseInt((0, $3d818fcc5f3623ef$export$ffb5f4729a158638)(i, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(s) && (s = 0), Object.assign(e, {
        width: t,
        height: s,
        size: e.isHorizontal() ? t : s
    }));
}
function $7704c8facc3d92c9$var$updateSlides() {
    var e = this;
    function t(t, s) {
        return parseFloat(t.getPropertyValue(e.getDirectionLabel(s)) || 0);
    }
    var s = e.params, i = e.wrapperEl, r = e.slidesEl, n = e.size, a = e.rtlTranslate, l = e.wrongRTL, o = e.virtual && s.virtual.enabled, d = o ? e.virtual.slides.length : e.slides.length, c = (0, $3d818fcc5f3623ef$export$f1e1789686576879)(r, ".".concat(e.params.slideClass, ", swiper-slide")), p = o ? e.virtual.slides.length : c.length;
    var u = [];
    var h = [], m = [];
    var f = s.slidesOffsetBefore;
    "function" == typeof f && (f = s.slidesOffsetBefore.call(e));
    var v = s.slidesOffsetAfter;
    "function" == typeof v && (v = s.slidesOffsetAfter.call(e));
    var g = e.snapGrid.length, w = e.slidesGrid.length;
    var S = s.spaceBetween, T = -f, b = 0, x = 0;
    if (void 0 === n) return;
    "string" == typeof S && S.indexOf("%") >= 0 ? S = parseFloat(S.replace("%", "")) / 100 * n : "string" == typeof S && (S = parseFloat(S)), e.virtualSize = -S, c.forEach(function(e) {
        a ? e.style.marginLeft = "" : e.style.marginRight = "", e.style.marginBottom = "", e.style.marginTop = "";
    }), s.centeredSlides && s.cssMode && ((0, $3d818fcc5f3623ef$export$2408f22a0fab9ae5)(i, "--swiper-centered-offset-before", ""), (0, $3d818fcc5f3623ef$export$2408f22a0fab9ae5)(i, "--swiper-centered-offset-after", ""));
    var y = s.grid && s.grid.rows > 1 && e.grid;
    var E;
    y ? e.grid.initSlides(c) : e.grid && e.grid.unsetSlides();
    var C = "auto" === s.slidesPerView && s.breakpoints && Object.keys(s.breakpoints).filter(function(e) {
        return void 0 !== s.breakpoints[e].slidesPerView;
    }).length > 0;
    for(var i1 = 0; i1 < p; i1 += 1){
        var r1 = void 0;
        if (E = 0, c[i1] && (r1 = c[i1]), y && e.grid.updateSlide(i1, r1, c), !c[i1] || "none" !== (0, $3d818fcc5f3623ef$export$ffb5f4729a158638)(r1, "display")) {
            if ("auto" === s.slidesPerView) {
                C && (c[i1].style[e.getDirectionLabel("width")] = "");
                var n1 = getComputedStyle(r1), a1 = r1.style.transform, l1 = r1.style.webkitTransform;
                if (a1 && (r1.style.transform = "none"), l1 && (r1.style.webkitTransform = "none"), s.roundLengths) E = e.isHorizontal() ? (0, $3d818fcc5f3623ef$export$2d1720544b23b823)(r1, "width", !0) : (0, $3d818fcc5f3623ef$export$2d1720544b23b823)(r1, "height", !0);
                else {
                    var e1 = t(n1, "width"), s1 = t(n1, "padding-left"), i2 = t(n1, "padding-right"), a2 = t(n1, "margin-left"), l2 = t(n1, "margin-right"), o1 = n1.getPropertyValue("box-sizing");
                    if (o1 && "border-box" === o1) E = e1 + a2 + l2;
                    else {
                        var _$t = r1.clientWidth, n2 = r1.offsetWidth;
                        E = e1 + s1 + i2 + a2 + l2 + (n2 - _$t);
                    }
                }
                a1 && (r1.style.transform = a1), l1 && (r1.style.webkitTransform = l1), s.roundLengths && (E = Math.floor(E));
            } else E = (n - (s.slidesPerView - 1) * S) / s.slidesPerView, s.roundLengths && (E = Math.floor(E)), c[i1] && (c[i1].style[e.getDirectionLabel("width")] = "".concat(E, "px"));
            c[i1] && (c[i1].swiperSlideSize = E), m.push(E), s.centeredSlides ? (T = T + E / 2 + b / 2 + S, 0 === b && 0 !== i1 && (T = T - n / 2 - S), 0 === i1 && (T = T - n / 2 - S), Math.abs(T) < .001 && (T = 0), s.roundLengths && (T = Math.floor(T)), x % s.slidesPerGroup == 0 && u.push(T), h.push(T)) : (s.roundLengths && (T = Math.floor(T)), (x - Math.min(e.params.slidesPerGroupSkip, x)) % e.params.slidesPerGroup == 0 && u.push(T), h.push(T), T = T + E + S), e.virtualSize += E + S, b = E, x += 1;
        }
    }
    if (e.virtualSize = Math.max(e.virtualSize, n) + v, a && l && ("slide" === s.effect || "coverflow" === s.effect) && (i.style.width = "".concat(e.virtualSize + S, "px")), s.setWrapperSize && (i.style[e.getDirectionLabel("width")] = "".concat(e.virtualSize + S, "px")), y && e.grid.updateWrapperSize(E, u), !s.centeredSlides) {
        var _$t1 = [];
        for(var i3 = 0; i3 < u.length; i3 += 1){
            var r2 = u[i3];
            s.roundLengths && (r2 = Math.floor(r2)), u[i3] <= e.virtualSize - n && _$t1.push(r2);
        }
        u = _$t1, Math.floor(e.virtualSize - n) - Math.floor(u[u.length - 1]) > 1 && u.push(e.virtualSize - n);
    }
    if (o && s.loop) {
        var _$t2 = m[0] + S;
        if (s.slidesPerGroup > 1) {
            var i4 = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / s.slidesPerGroup), r3 = _$t2 * s.slidesPerGroup;
            for(var e2 = 0; e2 < i4; e2 += 1)u.push(u[u.length - 1] + r3);
        }
        for(var i5 = 0; i5 < e.virtual.slidesBefore + e.virtual.slidesAfter; i5 += 1)1 === s.slidesPerGroup && u.push(u[u.length - 1] + _$t2), h.push(h[h.length - 1] + _$t2), e.virtualSize += _$t2;
    }
    if (0 === u.length && (u = [
        0
    ]), 0 !== S) {
        var _$t3 = e.isHorizontal() && a ? "marginLeft" : e.getDirectionLabel("marginRight");
        c.filter(function(e, t) {
            return !(s.cssMode && !s.loop) || t !== c.length - 1;
        }).forEach(function(e) {
            e.style[_$t3] = "".concat(S, "px");
        });
    }
    if (s.centeredSlides && s.centeredSlidesBounds) {
        var e3 = 0;
        m.forEach(function(t) {
            e3 += t + (S || 0);
        }), e3 -= S;
        var _$t4 = e3 > n ? e3 - n : 0;
        u = u.map(function(e) {
            return e <= 0 ? -f : e > _$t4 ? _$t4 + v : e;
        });
    }
    if (s.centerInsufficientSlides) {
        var e4 = 0;
        m.forEach(function(t) {
            e4 += t + (S || 0);
        }), e4 -= S;
        var _$t5 = (s.slidesOffsetBefore || 0) + (s.slidesOffsetAfter || 0);
        if (e4 + _$t5 < n) {
            var s2 = (n - e4 - _$t5) / 2;
            u.forEach(function(e, t) {
                u[t] = e - s2;
            }), h.forEach(function(e, t) {
                h[t] = e + s2;
            });
        }
    }
    if (Object.assign(e, {
        slides: c,
        snapGrid: u,
        slidesGrid: h,
        slidesSizesGrid: m
    }), s.centeredSlides && s.cssMode && !s.centeredSlidesBounds) {
        (0, $3d818fcc5f3623ef$export$2408f22a0fab9ae5)(i, "--swiper-centered-offset-before", -u[0] + "px"), (0, $3d818fcc5f3623ef$export$2408f22a0fab9ae5)(i, "--swiper-centered-offset-after", e.size / 2 - m[m.length - 1] / 2 + "px");
        var _$t6 = -e.snapGrid[0], s3 = -e.slidesGrid[0];
        e.snapGrid = e.snapGrid.map(function(e) {
            return e + _$t6;
        }), e.slidesGrid = e.slidesGrid.map(function(e) {
            return e + s3;
        });
    }
    if (p !== d && e.emit("slidesLengthChange"), u.length !== g && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), h.length !== w && e.emit("slidesGridLengthChange"), s.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !(o || s.cssMode || "slide" !== s.effect && "fade" !== s.effect)) {
        var _$t7 = "".concat(s.containerModifierClass, "backface-hidden"), i6 = e.el.classList.contains(_$t7);
        p <= s.maxBackfaceHiddenSlides ? i6 || e.el.classList.add(_$t7) : i6 && e.el.classList.remove(_$t7);
    }
}
function $7704c8facc3d92c9$var$updateAutoHeight(e) {
    var t = this, s = [], i = t.virtual && t.params.virtual.enabled;
    var r, n = 0;
    "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
    var a = function(e) {
        return i ? t.slides[t.getSlideIndexByData(e)] : t.slides[e];
    };
    if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1) {
        if (t.params.centeredSlides) (t.visibleSlides || []).forEach(function(e) {
            s.push(e);
        });
        else for(r = 0; r < Math.ceil(t.params.slidesPerView); r += 1){
            var _$e = t.activeIndex + r;
            if (_$e > t.slides.length && !i) break;
            s.push(a(_$e));
        }
    } else s.push(a(t.activeIndex));
    for(r = 0; r < s.length; r += 1)if (void 0 !== s[r]) {
        var _$e1 = s[r].offsetHeight;
        n = _$e1 > n ? _$e1 : n;
    }
    (n || 0 === n) && (t.wrapperEl.style.height = "".concat(n, "px"));
}
function $7704c8facc3d92c9$var$updateSlidesOffset() {
    var e = this, t = e.slides, s = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
    for(var i = 0; i < t.length; i += 1)t[i].swiperSlideOffset = (e.isHorizontal() ? t[i].offsetLeft : t[i].offsetTop) - s - e.cssOverflowAdjustment();
}
var $7704c8facc3d92c9$var$toggleSlideClasses$1 = function(e, t, s) {
    t && !e.classList.contains(s) ? e.classList.add(s) : !t && e.classList.contains(s) && e.classList.remove(s);
};
function $7704c8facc3d92c9$var$updateSlidesProgress(e) {
    void 0 === e && (e = this && this.translate || 0);
    var t = this, s = t.params, i = t.slides, r = t.rtlTranslate, n = t.snapGrid;
    if (0 === i.length) return;
    void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
    var a = -e;
    r && (a = e), t.visibleSlidesIndexes = [], t.visibleSlides = [];
    var l = s.spaceBetween;
    "string" == typeof l && l.indexOf("%") >= 0 ? l = parseFloat(l.replace("%", "")) / 100 * t.size : "string" == typeof l && (l = parseFloat(l));
    for(var _$e = 0; _$e < i.length; _$e += 1){
        var o = i[_$e];
        var d = o.swiperSlideOffset;
        s.cssMode && s.centeredSlides && (d -= i[0].swiperSlideOffset);
        var c = (a + (s.centeredSlides ? t.minTranslate() : 0) - d) / (o.swiperSlideSize + l), p = (a - n[0] + (s.centeredSlides ? t.minTranslate() : 0) - d) / (o.swiperSlideSize + l), u = -(a - d), h = u + t.slidesSizesGrid[_$e], m = u >= 0 && u <= t.size - t.slidesSizesGrid[_$e], f = u >= 0 && u < t.size - 1 || h > 1 && h <= t.size || u <= 0 && h >= t.size;
        f && (t.visibleSlides.push(o), t.visibleSlidesIndexes.push(_$e)), $7704c8facc3d92c9$var$toggleSlideClasses$1(o, f, s.slideVisibleClass), $7704c8facc3d92c9$var$toggleSlideClasses$1(o, m, s.slideFullyVisibleClass), o.progress = r ? -c : c, o.originalProgress = r ? -p : p;
    }
}
function $7704c8facc3d92c9$var$updateProgress(e) {
    var t = this;
    if (void 0 === e) {
        var s = t.rtlTranslate ? -1 : 1;
        e = t && t.translate && t.translate * s || 0;
    }
    var s1 = t.params, i = t.maxTranslate() - t.minTranslate();
    var r = t.progress, n = t.isBeginning, a = t.isEnd, l = t.progressLoop;
    var o = n, d = a;
    if (0 === i) r = 0, n = !0, a = !0;
    else {
        r = (e - t.minTranslate()) / i;
        var s2 = Math.abs(e - t.minTranslate()) < 1, l1 = Math.abs(e - t.maxTranslate()) < 1;
        n = s2 || r <= 0, a = l1 || r >= 1, s2 && (r = 0), l1 && (r = 1);
    }
    if (s1.loop) {
        var s3 = t.getSlideIndexByData(0), i1 = t.getSlideIndexByData(t.slides.length - 1), r1 = t.slidesGrid[s3], n1 = t.slidesGrid[i1], a1 = t.slidesGrid[t.slidesGrid.length - 1], o1 = Math.abs(e);
        l = o1 >= r1 ? (o1 - r1) / a1 : (o1 + a1 - n1) / a1, l > 1 && (l -= 1);
    }
    Object.assign(t, {
        progress: r,
        progressLoop: l,
        isBeginning: n,
        isEnd: a
    }), (s1.watchSlidesProgress || s1.centeredSlides && s1.autoHeight) && t.updateSlidesProgress(e), n && !o && t.emit("reachBeginning toEdge"), a && !d && t.emit("reachEnd toEdge"), (o && !n || d && !a) && t.emit("fromEdge"), t.emit("progress", r);
}
var $7704c8facc3d92c9$var$toggleSlideClasses = function(e, t, s) {
    t && !e.classList.contains(s) ? e.classList.add(s) : !t && e.classList.contains(s) && e.classList.remove(s);
};
function $7704c8facc3d92c9$var$updateSlidesClasses() {
    var e = this, t = e.slides, s = e.params, i = e.slidesEl, r = e.activeIndex, n = e.virtual && s.virtual.enabled, a = e.grid && s.grid && s.grid.rows > 1, l = function(e) {
        return (0, $3d818fcc5f3623ef$export$f1e1789686576879)(i, ".".concat(s.slideClass).concat(e, ", swiper-slide").concat(e))[0];
    };
    var o, d, c;
    if (n) {
        if (s.loop) {
            var t1 = r - e.virtual.slidesBefore;
            t1 < 0 && (t1 = e.virtual.slides.length + t1), t1 >= e.virtual.slides.length && (t1 -= e.virtual.slides.length), o = l('[data-swiper-slide-index="'.concat(t1, '"]'));
        } else o = l('[data-swiper-slide-index="'.concat(r, '"]'));
    } else a ? (o = t.filter(function(e) {
        return e.column === r;
    })[0], c = t.filter(function(e) {
        return e.column === r + 1;
    })[0], d = t.filter(function(e) {
        return e.column === r - 1;
    })[0]) : o = t[r];
    o && (a || (c = (0, $3d818fcc5f3623ef$export$9e5f44173e64f162)(o, ".".concat(s.slideClass, ", swiper-slide"))[0], s.loop && !c && (c = t[0]), d = (0, $3d818fcc5f3623ef$export$43caf9889c228507)(o, ".".concat(s.slideClass, ", swiper-slide"))[0], s.loop)), t.forEach(function(e) {
        $7704c8facc3d92c9$var$toggleSlideClasses(e, e === o, s.slideActiveClass), $7704c8facc3d92c9$var$toggleSlideClasses(e, e === c, s.slideNextClass), $7704c8facc3d92c9$var$toggleSlideClasses(e, e === d, s.slidePrevClass);
    }), e.emitSlidesClasses();
}
var $7704c8facc3d92c9$var$processLazyPreloader = function(e, t) {
    if (!e || e.destroyed || !e.params) return;
    var s = t.closest(e.isElement ? "swiper-slide" : ".".concat(e.params.slideClass));
    if (s) {
        var _$t = s.querySelector(".".concat(e.params.lazyPreloaderClass));
        !_$t && e.isElement && (s.shadowRoot ? _$t = s.shadowRoot.querySelector(".".concat(e.params.lazyPreloaderClass)) : requestAnimationFrame(function() {
            s.shadowRoot && (_$t = s.shadowRoot.querySelector(".".concat(e.params.lazyPreloaderClass)), _$t && _$t.remove());
        })), _$t && _$t.remove();
    }
}, $7704c8facc3d92c9$var$unlazy = function(e, t) {
    if (!e.slides[t]) return;
    var s = e.slides[t].querySelector('[loading="lazy"]');
    s && s.removeAttribute("loading");
}, $7704c8facc3d92c9$var$preload = function(e) {
    if (!e || e.destroyed || !e.params) return;
    var t = e.params.lazyPreloadPrevNext;
    var s = e.slides.length;
    if (!s || !t || t < 0) return;
    t = Math.min(t, s);
    var i = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), r = e.activeIndex;
    if (e.params.grid && e.params.grid.rows > 1) {
        var _n;
        var s1 = r, n = [
            s1 - t
        ];
        return (_n = n).push.apply(_n, (0, $1961f7bca441a4c6$export$71511d61b312f219)(Array.from({
            length: t
        }).map(function(e, t) {
            return s1 + i + t;
        }))), void e.slides.forEach(function(t, s) {
            n.includes(t.column) && $7704c8facc3d92c9$var$unlazy(e, s);
        });
    }
    var n1 = r + i - 1;
    if (e.params.rewind || e.params.loop) for(var i1 = r - t; i1 <= n1 + t; i1 += 1){
        var t1 = (i1 % s + s) % s;
        (t1 < r || t1 > n1) && $7704c8facc3d92c9$var$unlazy(e, t1);
    }
    else for(var i2 = Math.max(r - t, 0); i2 <= Math.min(n1 + t, s - 1); i2 += 1)i2 !== r && (i2 > n1 || i2 < r) && $7704c8facc3d92c9$var$unlazy(e, i2);
};
function $7704c8facc3d92c9$var$getActiveIndexByTranslate(e) {
    var t = e.slidesGrid, s = e.params, i = e.rtlTranslate ? e.translate : -e.translate;
    var r;
    for(var _$e = 0; _$e < t.length; _$e += 1)void 0 !== t[_$e + 1] ? i >= t[_$e] && i < t[_$e + 1] - (t[_$e + 1] - t[_$e]) / 2 ? r = _$e : i >= t[_$e] && i < t[_$e + 1] && (r = _$e + 1) : i >= t[_$e] && (r = _$e);
    return s.normalizeSlideIndex && (r < 0 || void 0 === r) && (r = 0), r;
}
function $7704c8facc3d92c9$var$updateActiveIndex(e) {
    var t = this, s = t.rtlTranslate ? t.translate : -t.translate, i = t.snapGrid, r = t.params, n = t.activeIndex, a = t.realIndex, l = t.snapIndex;
    var o, d = e;
    var c = function(e) {
        var s = e - t.virtual.slidesBefore;
        return s < 0 && (s = t.virtual.slides.length + s), s >= t.virtual.slides.length && (s -= t.virtual.slides.length), s;
    };
    if (void 0 === d && (d = $7704c8facc3d92c9$var$getActiveIndexByTranslate(t)), i.indexOf(s) >= 0) o = i.indexOf(s);
    else {
        var _$e = Math.min(r.slidesPerGroupSkip, d);
        o = _$e + Math.floor((d - _$e) / r.slidesPerGroup);
    }
    if (o >= i.length && (o = i.length - 1), d === n && !t.params.loop) return void (o !== l && (t.snapIndex = o, t.emit("snapIndexChange")));
    if (d === n && t.params.loop && t.virtual && t.params.virtual.enabled) return void (t.realIndex = c(d));
    var p = t.grid && r.grid && r.grid.rows > 1;
    var u;
    if (t.virtual && r.virtual.enabled && r.loop) u = c(d);
    else if (p) {
        var _$e1 = t.slides.filter(function(e) {
            return e.column === d;
        })[0];
        var s1 = parseInt(_$e1.getAttribute("data-swiper-slide-index"), 10);
        Number.isNaN(s1) && (s1 = Math.max(t.slides.indexOf(_$e1), 0)), u = Math.floor(s1 / r.grid.rows);
    } else if (t.slides[d]) {
        var _$e2 = t.slides[d].getAttribute("data-swiper-slide-index");
        u = _$e2 ? parseInt(_$e2, 10) : d;
    } else u = d;
    Object.assign(t, {
        previousSnapIndex: l,
        snapIndex: o,
        previousRealIndex: a,
        realIndex: u,
        previousIndex: n,
        activeIndex: d
    }), t.initialized && $7704c8facc3d92c9$var$preload(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (a !== u && t.emit("realIndexChange"), t.emit("slideChange"));
}
function $7704c8facc3d92c9$var$updateClickedSlide(e, t) {
    var s = this, i = s.params;
    var r = e.closest(".".concat(i.slideClass, ", swiper-slide"));
    !r && s.isElement && t && t.length > 1 && t.includes(e) && (0, $1961f7bca441a4c6$export$71511d61b312f219)(t.slice(t.indexOf(e) + 1, t.length)).forEach(function(e) {
        !r && e.matches && e.matches(".".concat(i.slideClass, ", swiper-slide")) && (r = e);
    });
    var n, a = !1;
    if (r) {
        for(var _$e = 0; _$e < s.slides.length; _$e += 1)if (s.slides[_$e] === r) {
            a = !0, n = _$e;
            break;
        }
    }
    if (!r || !a) return s.clickedSlide = void 0, void (s.clickedIndex = void 0);
    s.clickedSlide = r, s.virtual && s.params.virtual.enabled ? s.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10) : s.clickedIndex = n, i.slideToClickedSlide && void 0 !== s.clickedIndex && s.clickedIndex !== s.activeIndex && s.slideToClickedSlide();
}
var $7704c8facc3d92c9$var$update = {
    updateSize: $7704c8facc3d92c9$var$updateSize,
    updateSlides: $7704c8facc3d92c9$var$updateSlides,
    updateAutoHeight: $7704c8facc3d92c9$var$updateAutoHeight,
    updateSlidesOffset: $7704c8facc3d92c9$var$updateSlidesOffset,
    updateSlidesProgress: $7704c8facc3d92c9$var$updateSlidesProgress,
    updateProgress: $7704c8facc3d92c9$var$updateProgress,
    updateSlidesClasses: $7704c8facc3d92c9$var$updateSlidesClasses,
    updateActiveIndex: $7704c8facc3d92c9$var$updateActiveIndex,
    updateClickedSlide: $7704c8facc3d92c9$var$updateClickedSlide
};
function $7704c8facc3d92c9$var$getSwiperTranslate(e) {
    void 0 === e && (e = this.isHorizontal() ? "x" : "y");
    var _this = this, t = _this.params, s = _this.rtlTranslate, i = _this.translate, r = _this.wrapperEl;
    if (t.virtualTranslate) return s ? -i : i;
    if (t.cssMode) return i;
    var n = (0, $3d818fcc5f3623ef$export$35e795649ee09318)(r, e);
    return n += this.cssOverflowAdjustment(), s && (n = -n), n || 0;
}
function $7704c8facc3d92c9$var$setTranslate(e, t) {
    var s = this, i = s.rtlTranslate, r = s.params, n = s.wrapperEl, a = s.progress;
    var l = 0, o = 0;
    var d;
    s.isHorizontal() ? l = i ? -e : e : o = e, r.roundLengths && (l = Math.floor(l), o = Math.floor(o)), s.previousTranslate = s.translate, s.translate = s.isHorizontal() ? l : o, r.cssMode ? n[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal() ? -l : -o : r.virtualTranslate || (s.isHorizontal() ? l -= s.cssOverflowAdjustment() : o -= s.cssOverflowAdjustment(), n.style.transform = "translate3d(".concat(l, "px, ").concat(o, "px, 0px)"));
    var c = s.maxTranslate() - s.minTranslate();
    d = 0 === c ? 0 : (e - s.minTranslate()) / c, d !== a && s.updateProgress(e), s.emit("setTranslate", s.translate, t);
}
function $7704c8facc3d92c9$var$minTranslate() {
    return -this.snapGrid[0];
}
function $7704c8facc3d92c9$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $7704c8facc3d92c9$var$translateTo(e, t, s, i, r) {
    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === s && (s = !0), void 0 === i && (i = !0);
    var n = this, a = n.params, l = n.wrapperEl;
    if (n.animating && a.preventInteractionOnTransition) return !1;
    var o = n.minTranslate(), d = n.maxTranslate();
    var c;
    if (c = i && e > o ? o : i && e < d ? d : e, n.updateProgress(c), a.cssMode) {
        var _$e = n.isHorizontal();
        if (0 === t) l[_$e ? "scrollLeft" : "scrollTop"] = -c;
        else {
            if (!n.support.smoothScroll) return (0, $3d818fcc5f3623ef$export$625550452a3fa3ec)({
                swiper: n,
                targetPosition: -c,
                side: _$e ? "left" : "top"
            }), !0;
            var _obj;
            l.scrollTo((_obj = {}, (0, $71081ebd7d211bed$export$71511d61b312f219)(_obj, _$e ? "left" : "top", -c), (0, $71081ebd7d211bed$export$71511d61b312f219)(_obj, "behavior", "smooth"), _obj));
        }
        return !0;
    }
    return 0 === t ? (n.setTransition(0), n.setTranslate(c), s && (n.emit("beforeTransitionStart", t, r), n.emit("transitionEnd"))) : (n.setTransition(t), n.setTranslate(c), s && (n.emit("beforeTransitionStart", t, r), n.emit("transitionStart")), n.animating || (n.animating = !0, n.onTranslateToWrapperTransitionEnd || (n.onTranslateToWrapperTransitionEnd = function(e) {
        n && !n.destroyed && e.target === this && (n.wrapperEl.removeEventListener("transitionend", n.onTranslateToWrapperTransitionEnd), n.onTranslateToWrapperTransitionEnd = null, delete n.onTranslateToWrapperTransitionEnd, n.animating = !1, s && n.emit("transitionEnd"));
    }), n.wrapperEl.addEventListener("transitionend", n.onTranslateToWrapperTransitionEnd))), !0;
}
var $7704c8facc3d92c9$var$translate = {
    getTranslate: $7704c8facc3d92c9$var$getSwiperTranslate,
    setTranslate: $7704c8facc3d92c9$var$setTranslate,
    minTranslate: $7704c8facc3d92c9$var$minTranslate,
    maxTranslate: $7704c8facc3d92c9$var$maxTranslate,
    translateTo: $7704c8facc3d92c9$var$translateTo
};
function $7704c8facc3d92c9$var$setTransition(e, t) {
    var s = this;
    s.params.cssMode || (s.wrapperEl.style.transitionDuration = "".concat(e, "ms"), s.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : ""), s.emit("setTransition", e, t);
}
function $7704c8facc3d92c9$var$transitionEmit(e) {
    var t = e.swiper, s = e.runCallbacks, i = e.direction, r = e.step;
    var n = t.activeIndex, a = t.previousIndex;
    var l = i;
    if (l || (l = n > a ? "next" : n < a ? "prev" : "reset"), t.emit("transition".concat(r)), s && n !== a) {
        if ("reset" === l) return void t.emit("slideResetTransition".concat(r));
        t.emit("slideChangeTransition".concat(r)), "next" === l ? t.emit("slideNextTransition".concat(r)) : t.emit("slidePrevTransition".concat(r));
    }
}
function $7704c8facc3d92c9$var$transitionStart(e, t) {
    void 0 === e && (e = !0);
    var s = this, i = s.params;
    i.cssMode || (i.autoHeight && s.updateAutoHeight(), $7704c8facc3d92c9$var$transitionEmit({
        swiper: s,
        runCallbacks: e,
        direction: t,
        step: "Start"
    }));
}
function $7704c8facc3d92c9$var$transitionEnd(e, t) {
    void 0 === e && (e = !0);
    var s = this, i = s.params;
    s.animating = !1, i.cssMode || (s.setTransition(0), $7704c8facc3d92c9$var$transitionEmit({
        swiper: s,
        runCallbacks: e,
        direction: t,
        step: "End"
    }));
}
var $7704c8facc3d92c9$var$transition = {
    setTransition: $7704c8facc3d92c9$var$setTransition,
    transitionStart: $7704c8facc3d92c9$var$transitionStart,
    transitionEnd: $7704c8facc3d92c9$var$transitionEnd
};
function $7704c8facc3d92c9$var$slideTo(e, t, s, i, r) {
    void 0 === e && (e = 0), void 0 === s && (s = !0), "string" == typeof e && (e = parseInt(e, 10));
    var n = this;
    var a = e;
    a < 0 && (a = 0);
    var l = n.params, o = n.snapGrid, d = n.slidesGrid, c = n.previousIndex, p = n.activeIndex, u = n.rtlTranslate, h = n.wrapperEl, m = n.enabled;
    if (!m && !i && !r || n.destroyed || n.animating && l.preventInteractionOnTransition) return !1;
    void 0 === t && (t = n.params.speed);
    var f = Math.min(n.params.slidesPerGroupSkip, a);
    var v = f + Math.floor((a - f) / n.params.slidesPerGroup);
    v >= o.length && (v = o.length - 1);
    var g = -o[v];
    if (l.normalizeSlideIndex) for(var _$e = 0; _$e < d.length; _$e += 1){
        var _$t = -Math.floor(100 * g), _$s = Math.floor(100 * d[_$e]), _$i = Math.floor(100 * d[_$e + 1]);
        void 0 !== d[_$e + 1] ? _$t >= _$s && _$t < _$i - (_$i - _$s) / 2 ? a = _$e : _$t >= _$s && _$t < _$i && (a = _$e + 1) : _$t >= _$s && (a = _$e);
    }
    if (n.initialized && a !== p) {
        if (!n.allowSlideNext && (u ? g > n.translate && g > n.minTranslate() : g < n.translate && g < n.minTranslate())) return !1;
        if (!n.allowSlidePrev && g > n.translate && g > n.maxTranslate() && (p || 0) !== a) return !1;
    }
    var w;
    a !== (c || 0) && s && n.emit("beforeSlideChangeStart"), n.updateProgress(g), w = a > p ? "next" : a < p ? "prev" : "reset";
    var S = n.virtual && n.params.virtual.enabled;
    if (!(S && r) && (u && -g === n.translate || !u && g === n.translate)) return n.updateActiveIndex(a), l.autoHeight && n.updateAutoHeight(), n.updateSlidesClasses(), "slide" !== l.effect && n.setTranslate(g), "reset" !== w && (n.transitionStart(s, w), n.transitionEnd(s, w)), !1;
    if (l.cssMode) {
        var _$e1 = n.isHorizontal(), _$s1 = u ? g : -g;
        if (0 === t) S && (n.wrapperEl.style.scrollSnapType = "none", n._immediateVirtual = !0), S && !n._cssModeVirtualInitialSet && n.params.initialSlide > 0 ? (n._cssModeVirtualInitialSet = !0, requestAnimationFrame(function() {
            h[_$e1 ? "scrollLeft" : "scrollTop"] = _$s1;
        })) : h[_$e1 ? "scrollLeft" : "scrollTop"] = _$s1, S && requestAnimationFrame(function() {
            n.wrapperEl.style.scrollSnapType = "", n._immediateVirtual = !1;
        });
        else {
            if (!n.support.smoothScroll) return (0, $3d818fcc5f3623ef$export$625550452a3fa3ec)({
                swiper: n,
                targetPosition: _$s1,
                side: _$e1 ? "left" : "top"
            }), !0;
            var _obj;
            h.scrollTo((_obj = {}, (0, $71081ebd7d211bed$export$71511d61b312f219)(_obj, _$e1 ? "left" : "top", _$s1), (0, $71081ebd7d211bed$export$71511d61b312f219)(_obj, "behavior", "smooth"), _obj));
        }
        return !0;
    }
    return n.setTransition(t), n.setTranslate(g), n.updateActiveIndex(a), n.updateSlidesClasses(), n.emit("beforeTransitionStart", t, i), n.transitionStart(s, w), 0 === t ? n.transitionEnd(s, w) : n.animating || (n.animating = !0, n.onSlideToWrapperTransitionEnd || (n.onSlideToWrapperTransitionEnd = function(e) {
        n && !n.destroyed && e.target === this && (n.wrapperEl.removeEventListener("transitionend", n.onSlideToWrapperTransitionEnd), n.onSlideToWrapperTransitionEnd = null, delete n.onSlideToWrapperTransitionEnd, n.transitionEnd(s, w));
    }), n.wrapperEl.addEventListener("transitionend", n.onSlideToWrapperTransitionEnd)), !0;
}
function $7704c8facc3d92c9$var$slideToLoop(e, t, s, i) {
    if (void 0 === e && (e = 0), void 0 === s && (s = !0), "string" == typeof e) e = parseInt(e, 10);
    var r = this;
    if (r.destroyed) return;
    void 0 === t && (t = r.params.speed);
    var n = r.grid && r.params.grid && r.params.grid.rows > 1;
    var a = e;
    if (r.params.loop) {
        if (r.virtual && r.params.virtual.enabled) a += r.virtual.slidesBefore;
        else {
            var _$e;
            if (n) {
                var _$t = a * r.params.grid.rows;
                _$e = r.slides.filter(function(e) {
                    return 1 * e.getAttribute("data-swiper-slide-index") === _$t;
                })[0].column;
            } else _$e = r.getSlideIndexByData(a);
            var _$t1 = n ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length, _r_params = r.params, _$s = _r_params.centeredSlides;
            var l = r.params.slidesPerView;
            "auto" === l ? l = r.slidesPerViewDynamic() : (l = Math.ceil(parseFloat(r.params.slidesPerView, 10)), _$s && l % 2 == 0 && (l += 1));
            var o = _$t1 - _$e < l;
            if (_$s && (o = o || _$e < Math.ceil(l / 2)), i && _$s && "auto" !== r.params.slidesPerView && !n && (o = !1), o) {
                var _$i = _$s ? _$e < r.activeIndex ? "prev" : "next" : _$e - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
                r.loopFix({
                    direction: _$i,
                    slideTo: !0,
                    activeSlideIndex: "next" === _$i ? _$e + 1 : _$e - _$t1 + 1,
                    slideRealIndex: "next" === _$i ? r.realIndex : void 0
                });
            }
            if (n) {
                var _$e1 = a * r.params.grid.rows;
                a = r.slides.filter(function(t) {
                    return 1 * t.getAttribute("data-swiper-slide-index") === _$e1;
                })[0].column;
            } else a = r.getSlideIndexByData(a);
        }
    }
    return requestAnimationFrame(function() {
        r.slideTo(a, t, s, i);
    }), r;
}
function $7704c8facc3d92c9$var$slideNext(e, t, s) {
    void 0 === t && (t = !0);
    var i = this, r = i.enabled, n = i.params, a = i.animating;
    if (!r || i.destroyed) return i;
    void 0 === e && (e = i.params.speed);
    var l = n.slidesPerGroup;
    "auto" === n.slidesPerView && 1 === n.slidesPerGroup && n.slidesPerGroupAuto && (l = Math.max(i.slidesPerViewDynamic("current", !0), 1));
    var o = i.activeIndex < n.slidesPerGroupSkip ? 1 : l, d = i.virtual && n.virtual.enabled;
    if (n.loop) {
        if (a && !d && n.loopPreventsSliding) return !1;
        if (i.loopFix({
            direction: "next"
        }), i._clientLeft = i.wrapperEl.clientLeft, i.activeIndex === i.slides.length - 1 && n.cssMode) return requestAnimationFrame(function() {
            i.slideTo(i.activeIndex + o, e, t, s);
        }), !0;
    }
    return n.rewind && i.isEnd ? i.slideTo(0, e, t, s) : i.slideTo(i.activeIndex + o, e, t, s);
}
function $7704c8facc3d92c9$var$slidePrev(e, t, s) {
    void 0 === t && (t = !0);
    var i = this, r = i.params, n = i.snapGrid, a = i.slidesGrid, l = i.rtlTranslate, o = i.enabled, d = i.animating;
    if (!o || i.destroyed) return i;
    void 0 === e && (e = i.params.speed);
    var c = i.virtual && r.virtual.enabled;
    if (r.loop) {
        if (d && !c && r.loopPreventsSliding) return !1;
        i.loopFix({
            direction: "prev"
        }), i._clientLeft = i.wrapperEl.clientLeft;
    }
    function p(e) {
        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
    }
    var u = p(l ? i.translate : -i.translate), h = n.map(function(e) {
        return p(e);
    });
    var m = n[h.indexOf(u) - 1];
    if (void 0 === m && r.cssMode) {
        var _$e;
        n.forEach(function(t, s) {
            u >= t && (_$e = s);
        }), void 0 !== _$e && (m = n[_$e > 0 ? _$e - 1 : _$e]);
    }
    var f = 0;
    if (void 0 !== m && (f = a.indexOf(m), f < 0 && (f = i.activeIndex - 1), "auto" === r.slidesPerView && 1 === r.slidesPerGroup && r.slidesPerGroupAuto && (f = f - i.slidesPerViewDynamic("previous", !0) + 1, f = Math.max(f, 0))), r.rewind && i.isBeginning) {
        var r1 = i.params.virtual && i.params.virtual.enabled && i.virtual ? i.virtual.slides.length - 1 : i.slides.length - 1;
        return i.slideTo(r1, e, t, s);
    }
    return r.loop && 0 === i.activeIndex && r.cssMode ? (requestAnimationFrame(function() {
        i.slideTo(f, e, t, s);
    }), !0) : i.slideTo(f, e, t, s);
}
function $7704c8facc3d92c9$var$slideReset(e, t, s) {
    void 0 === t && (t = !0);
    var i = this;
    if (!i.destroyed) return void 0 === e && (e = i.params.speed), i.slideTo(i.activeIndex, e, t, s);
}
function $7704c8facc3d92c9$var$slideToClosest(e, t, s, i) {
    void 0 === t && (t = !0), void 0 === i && (i = .5);
    var r = this;
    if (r.destroyed) return;
    void 0 === e && (e = r.params.speed);
    var n = r.activeIndex;
    var a = Math.min(r.params.slidesPerGroupSkip, n), l = a + Math.floor((n - a) / r.params.slidesPerGroup), o = r.rtlTranslate ? r.translate : -r.translate;
    if (o >= r.snapGrid[l]) {
        var _$e = r.snapGrid[l];
        o - _$e > (r.snapGrid[l + 1] - _$e) * i && (n += r.params.slidesPerGroup);
    } else {
        var _$e1 = r.snapGrid[l - 1];
        o - _$e1 <= (r.snapGrid[l] - _$e1) * i && (n -= r.params.slidesPerGroup);
    }
    return n = Math.max(n, 0), n = Math.min(n, r.slidesGrid.length - 1), r.slideTo(n, e, t, s);
}
function $7704c8facc3d92c9$var$slideToClickedSlide() {
    var e = this;
    if (e.destroyed) return;
    var t = e.params, s = e.slidesEl, i = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
    var r, n = e.clickedIndex;
    var a = e.isElement ? "swiper-slide" : ".".concat(t.slideClass);
    if (t.loop) {
        if (e.animating) return;
        r = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? n < e.loopedSlides - i / 2 || n > e.slides.length - e.loopedSlides + i / 2 ? (e.loopFix(), n = e.getSlideIndex((0, $3d818fcc5f3623ef$export$f1e1789686576879)(s, "".concat(a, '[data-swiper-slide-index="').concat(r, '"]'))[0]), (0, $3d818fcc5f3623ef$export$7ccc53e8f1e7dfc5)(function() {
            e.slideTo(n);
        })) : e.slideTo(n) : n > e.slides.length - i ? (e.loopFix(), n = e.getSlideIndex((0, $3d818fcc5f3623ef$export$f1e1789686576879)(s, "".concat(a, '[data-swiper-slide-index="').concat(r, '"]'))[0]), (0, $3d818fcc5f3623ef$export$7ccc53e8f1e7dfc5)(function() {
            e.slideTo(n);
        })) : e.slideTo(n);
    } else e.slideTo(n);
}
var $7704c8facc3d92c9$var$slide = {
    slideTo: $7704c8facc3d92c9$var$slideTo,
    slideToLoop: $7704c8facc3d92c9$var$slideToLoop,
    slideNext: $7704c8facc3d92c9$var$slideNext,
    slidePrev: $7704c8facc3d92c9$var$slidePrev,
    slideReset: $7704c8facc3d92c9$var$slideReset,
    slideToClosest: $7704c8facc3d92c9$var$slideToClosest,
    slideToClickedSlide: $7704c8facc3d92c9$var$slideToClickedSlide
};
function $7704c8facc3d92c9$var$loopCreate(e) {
    var t = this, s = t.params, i = t.slidesEl;
    if (!s.loop || t.virtual && t.params.virtual.enabled) return;
    var r = function() {
        (0, $3d818fcc5f3623ef$export$f1e1789686576879)(i, ".".concat(s.slideClass, ", swiper-slide")).forEach(function(e, t) {
            e.setAttribute("data-swiper-slide-index", t);
        });
    }, n = t.grid && s.grid && s.grid.rows > 1, a = s.slidesPerGroup * (n ? s.grid.rows : 1), l = t.slides.length % a != 0, o = n && t.slides.length % s.grid.rows != 0, d = function(e) {
        for(var i = 0; i < e; i += 1){
            var _$e = t.isElement ? (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("swiper-slide", [
                s.slideBlankClass
            ]) : (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("div", [
                s.slideClass,
                s.slideBlankClass
            ]);
            t.slidesEl.append(_$e);
        }
    };
    if (l) {
        if (s.loopAddBlankSlides) d(a - t.slides.length % a), t.recalcSlides(), t.updateSlides();
        else (0, $3d818fcc5f3623ef$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        r();
    } else if (o) {
        if (s.loopAddBlankSlides) d(s.grid.rows - t.slides.length % s.grid.rows), t.recalcSlides(), t.updateSlides();
        else (0, $3d818fcc5f3623ef$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        r();
    } else r();
    t.loopFix({
        slideRealIndex: e,
        direction: s.centeredSlides ? void 0 : "next"
    });
}
function $7704c8facc3d92c9$var$loopFix(e) {
    var _ref = void 0 === e ? {} : e, t = _ref.slideRealIndex, tmp = _ref.slideTo, s = tmp === void 0 ? !0 : tmp, i = _ref.direction, r = _ref.setTranslate, n = _ref.activeSlideIndex, a = _ref.byController, l = _ref.byMousewheel;
    var o = this;
    if (!o.params.loop) return;
    o.emit("beforeLoopFix");
    var d = o.slides, c = o.allowSlidePrev, p = o.allowSlideNext, u = o.slidesEl, h = o.params, m = h.centeredSlides;
    if (o.allowSlidePrev = !0, o.allowSlideNext = !0, o.virtual && h.virtual.enabled) return s && (h.centeredSlides || 0 !== o.snapIndex ? h.centeredSlides && o.snapIndex < h.slidesPerView ? o.slideTo(o.virtual.slides.length + o.snapIndex, 0, !1, !0) : o.snapIndex === o.snapGrid.length - 1 && o.slideTo(o.virtual.slidesBefore, 0, !1, !0) : o.slideTo(o.virtual.slides.length, 0, !1, !0)), o.allowSlidePrev = c, o.allowSlideNext = p, void o.emit("loopFix");
    var f = h.slidesPerView;
    "auto" === f ? f = o.slidesPerViewDynamic() : (f = Math.ceil(parseFloat(h.slidesPerView, 10)), m && f % 2 == 0 && (f += 1));
    var v = h.slidesPerGroupAuto ? f : h.slidesPerGroup;
    var g = v;
    g % v != 0 && (g += v - g % v), g += h.loopAdditionalSlides, o.loopedSlides = g;
    var w = o.grid && h.grid && h.grid.rows > 1;
    d.length < f + g ? (0, $3d818fcc5f3623ef$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : w && "row" === h.grid.fill && (0, $3d818fcc5f3623ef$export$3b14a55fb2447963)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    var S = [], T = [];
    var b = o.activeIndex;
    void 0 === n ? n = o.getSlideIndex(d.filter(function(e) {
        return e.classList.contains(h.slideActiveClass);
    })[0]) : b = n;
    var x = "next" === i || !i, y = "prev" === i || !i;
    var E = 0, C = 0;
    var P = w ? Math.ceil(d.length / h.grid.rows) : d.length, M = (w ? d[n].column : n) + (m && void 0 === r ? -f / 2 + .5 : 0);
    if (M < g) {
        E = Math.max(g - M, v);
        for(var _$e = 0; _$e < g - M; _$e += 1){
            var t1 = _$e - Math.floor(_$e / P) * P;
            if (w) {
                var _$e1 = P - t1 - 1;
                for(var t2 = d.length - 1; t2 >= 0; t2 -= 1)d[t2].column === _$e1 && S.push(t2);
            } else S.push(P - t1 - 1);
        }
    } else if (M + f > P - g) {
        var _loop = function(_$e2) {
            var t = _$e2 - Math.floor(_$e2 / P) * P;
            w ? d.forEach(function(e, s) {
                e.column === t && T.push(s);
            }) : T.push(t);
        };
        C = Math.max(M - (P - 2 * g), v);
        for(var _$e2 = 0; _$e2 < C; _$e2 += 1)_loop(_$e2);
    }
    if (o.__preventObserver__ = !0, requestAnimationFrame(function() {
        o.__preventObserver__ = !1;
    }), y && S.forEach(function(e) {
        d[e].swiperLoopMoveDOM = !0, u.prepend(d[e]), d[e].swiperLoopMoveDOM = !1;
    }), x && T.forEach(function(e) {
        d[e].swiperLoopMoveDOM = !0, u.append(d[e]), d[e].swiperLoopMoveDOM = !1;
    }), o.recalcSlides(), "auto" === h.slidesPerView ? o.updateSlides() : w && (S.length > 0 && y || T.length > 0 && x) && o.slides.forEach(function(e, t) {
        o.grid.updateSlide(t, e, o.slides);
    }), h.watchSlidesProgress && o.updateSlidesOffset(), s) {
        if (S.length > 0 && y) {
            if (void 0 === t) {
                var _$e3 = o.slidesGrid[b], t3 = o.slidesGrid[b + E] - _$e3;
                l ? o.setTranslate(o.translate - t3) : (o.slideTo(b + Math.ceil(E), 0, !1, !0), r && (o.touchEventsData.startTranslate = o.touchEventsData.startTranslate - t3, o.touchEventsData.currentTranslate = o.touchEventsData.currentTranslate - t3));
            } else if (r) {
                var _$e4 = w ? S.length / h.grid.rows : S.length;
                o.slideTo(o.activeIndex + _$e4, 0, !1, !0), o.touchEventsData.currentTranslate = o.translate;
            }
        } else if (T.length > 0 && x) {
            if (void 0 === t) {
                var _$e5 = o.slidesGrid[b], t4 = o.slidesGrid[b - C] - _$e5;
                l ? o.setTranslate(o.translate - t4) : (o.slideTo(b - C, 0, !1, !0), r && (o.touchEventsData.startTranslate = o.touchEventsData.startTranslate - t4, o.touchEventsData.currentTranslate = o.touchEventsData.currentTranslate - t4));
            } else {
                var _$e6 = w ? T.length / h.grid.rows : T.length;
                o.slideTo(o.activeIndex - _$e6, 0, !1, !0);
            }
        }
    }
    if (o.allowSlidePrev = c, o.allowSlideNext = p, o.controller && o.controller.control && !a) {
        var _$e7 = {
            slideRealIndex: t,
            direction: i,
            setTranslate: r,
            activeSlideIndex: n,
            byController: !0
        };
        Array.isArray(o.controller.control) ? o.controller.control.forEach(function(t) {
            !t.destroyed && t.params.loop && t.loopFix((0, $82dbc585330cff66$export$71511d61b312f219)((0, $34448b2f636abc71$export$71511d61b312f219)({}, _$e7), {
                slideTo: t.params.slidesPerView === h.slidesPerView && s
            }));
        }) : o.controller.control instanceof o.constructor && o.controller.control.params.loop && o.controller.control.loopFix((0, $82dbc585330cff66$export$71511d61b312f219)((0, $34448b2f636abc71$export$71511d61b312f219)({}, _$e7), {
            slideTo: o.controller.control.params.slidesPerView === h.slidesPerView && s
        }));
    }
    o.emit("loopFix");
}
function $7704c8facc3d92c9$var$loopDestroy() {
    var e = this, t = e.params, s = e.slidesEl;
    if (!t.loop || e.virtual && e.params.virtual.enabled) return;
    e.recalcSlides();
    var i = [];
    e.slides.forEach(function(e) {
        var t = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex;
        i[t] = e;
    }), e.slides.forEach(function(e) {
        e.removeAttribute("data-swiper-slide-index");
    }), i.forEach(function(e) {
        s.append(e);
    }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
var $7704c8facc3d92c9$var$loop = {
    loopCreate: $7704c8facc3d92c9$var$loopCreate,
    loopFix: $7704c8facc3d92c9$var$loopFix,
    loopDestroy: $7704c8facc3d92c9$var$loopDestroy
};
function $7704c8facc3d92c9$var$setGrabCursor(e) {
    var t = this;
    if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
    var s = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
    t.isElement && (t.__preventObserver__ = !0), s.style.cursor = "move", s.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(function() {
        t.__preventObserver__ = !1;
    });
}
function $7704c8facc3d92c9$var$unsetGrabCursor() {
    var e = this;
    e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(function() {
        e.__preventObserver__ = !1;
    }));
}
var $7704c8facc3d92c9$var$grabCursor = {
    setGrabCursor: $7704c8facc3d92c9$var$setGrabCursor,
    unsetGrabCursor: $7704c8facc3d92c9$var$unsetGrabCursor
};
function $7704c8facc3d92c9$var$closestElement(e, t) {
    return void 0 === t && (t = this), function t(s) {
        if (!s || s === (0, $650091777930d0d5$export$39b482c5e57630a8)() || s === (0, $650091777930d0d5$export$407448d2b89b1813)()) return null;
        s.assignedSlot && (s = s.assignedSlot);
        var i = s.closest(e);
        return i || s.getRootNode ? i || t(s.getRootNode().host) : null;
    }(t);
}
function $7704c8facc3d92c9$var$preventEdgeSwipe(e, t, s) {
    var i = (0, $650091777930d0d5$export$407448d2b89b1813)(), r = e.params, n = r.edgeSwipeDetection, a = r.edgeSwipeThreshold;
    return !n || !(s <= a || s >= i.innerWidth - a) || "prevent" === n && (t.preventDefault(), !0);
}
function $7704c8facc3d92c9$var$onTouchStart(e) {
    var t = this, s = (0, $650091777930d0d5$export$39b482c5e57630a8)();
    var i = e;
    i.originalEvent && (i = i.originalEvent);
    var r = t.touchEventsData;
    if ("pointerdown" === i.type) {
        if (null !== r.pointerId && r.pointerId !== i.pointerId) return;
        r.pointerId = i.pointerId;
    } else "touchstart" === i.type && 1 === i.targetTouches.length && (r.touchId = i.targetTouches[0].identifier);
    if ("touchstart" === i.type) return void $7704c8facc3d92c9$var$preventEdgeSwipe(t, i, i.targetTouches[0].pageX);
    var n = t.params, a = t.touches, l = t.enabled;
    if (!l) return;
    if (!n.simulateTouch && "mouse" === i.pointerType) return;
    if (t.animating && n.preventInteractionOnTransition) return;
    !t.animating && n.cssMode && n.loop && t.loopFix();
    var o = i.target;
    if ("wrapper" === n.touchEventsTarget && !(0, $3d818fcc5f3623ef$export$90a7f3efeed30595)(o, t.wrapperEl)) return;
    if ("which" in i && 3 === i.which) return;
    if ("button" in i && i.button > 0) return;
    if (r.isTouched && r.isMoved) return;
    var d = !!n.noSwipingClass && "" !== n.noSwipingClass, c = i.composedPath ? i.composedPath() : i.path;
    d && i.target && i.target.shadowRoot && c && (o = c[0]);
    var p = n.noSwipingSelector ? n.noSwipingSelector : ".".concat(n.noSwipingClass), u = !(!i.target || !i.target.shadowRoot);
    if (n.noSwiping && (u ? $7704c8facc3d92c9$var$closestElement(p, o) : o.closest(p))) return void (t.allowClick = !0);
    if (n.swipeHandler && !o.closest(n.swipeHandler)) return;
    a.currentX = i.pageX, a.currentY = i.pageY;
    var h = a.currentX, m = a.currentY;
    if (!$7704c8facc3d92c9$var$preventEdgeSwipe(t, i, h)) return;
    Object.assign(r, {
        isTouched: !0,
        isMoved: !1,
        allowTouchCallbacks: !0,
        isScrolling: void 0,
        startMoving: void 0
    }), a.startX = h, a.startY = m, r.touchStartTime = (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, n.threshold > 0 && (r.allowThresholdMove = !1);
    var f = !0;
    o.matches(r.focusableElements) && (f = !1, "SELECT" === o.nodeName && (r.isTouched = !1)), s.activeElement && s.activeElement.matches(r.focusableElements) && s.activeElement !== o && ("mouse" === i.pointerType || "mouse" !== i.pointerType && !o.matches(r.focusableElements)) && s.activeElement.blur();
    var v = f && t.allowTouchMove && n.touchStartPreventDefault;
    !n.touchStartForcePreventDefault && !v || o.isContentEditable || i.preventDefault(), n.freeMode && n.freeMode.enabled && t.freeMode && t.animating && !n.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", i);
}
function $7704c8facc3d92c9$var$onTouchMove(e) {
    var t = (0, $650091777930d0d5$export$39b482c5e57630a8)(), s = this, i = s.touchEventsData, r = s.params, n = s.touches, a = s.rtlTranslate, l = s.enabled;
    if (!l) return;
    if (!r.simulateTouch && "mouse" === e.pointerType) return;
    var o, d = e;
    if (d.originalEvent && (d = d.originalEvent), "pointermove" === d.type) {
        if (null !== i.touchId) return;
        if (d.pointerId !== i.pointerId) return;
    }
    if ("touchmove" === d.type) {
        if (o = (0, $1961f7bca441a4c6$export$71511d61b312f219)(d.changedTouches).filter(function(e) {
            return e.identifier === i.touchId;
        })[0], !o || o.identifier !== i.touchId) return;
    } else o = d;
    if (!i.isTouched) return void (i.startMoving && i.isScrolling && s.emit("touchMoveOpposite", d));
    var c = o.pageX, p = o.pageY;
    if (d.preventedByNestedSwiper) return n.startX = c, void (n.startY = p);
    if (!s.allowTouchMove) return d.target.matches(i.focusableElements) || (s.allowClick = !1), void (i.isTouched && (Object.assign(n, {
        startX: c,
        startY: p,
        currentX: c,
        currentY: p
    }), i.touchStartTime = (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)()));
    if (r.touchReleaseOnEdges && !r.loop) {
        if (s.isVertical()) {
            if (p < n.startY && s.translate <= s.maxTranslate() || p > n.startY && s.translate >= s.minTranslate()) return i.isTouched = !1, void (i.isMoved = !1);
        } else if (c < n.startX && s.translate <= s.maxTranslate() || c > n.startX && s.translate >= s.minTranslate()) return;
    }
    if (t.activeElement && t.activeElement.matches(i.focusableElements) && t.activeElement !== d.target && "mouse" !== d.pointerType && t.activeElement.blur(), t.activeElement && d.target === t.activeElement && d.target.matches(i.focusableElements)) return i.isMoved = !0, void (s.allowClick = !1);
    i.allowTouchCallbacks && s.emit("touchMove", d), n.previousX = n.currentX, n.previousY = n.currentY, n.currentX = c, n.currentY = p;
    var u = n.currentX - n.startX, h = n.currentY - n.startY;
    if (s.params.threshold && Math.sqrt(Math.pow(u, 2) + Math.pow(h, 2)) < s.params.threshold) return;
    if (void 0 === i.isScrolling) {
        var _$e;
        s.isHorizontal() && n.currentY === n.startY || s.isVertical() && n.currentX === n.startX ? i.isScrolling = !1 : u * u + h * h >= 25 && (_$e = 180 * Math.atan2(Math.abs(h), Math.abs(u)) / Math.PI, i.isScrolling = s.isHorizontal() ? _$e > r.touchAngle : 90 - _$e > r.touchAngle);
    }
    if (i.isScrolling && s.emit("touchMoveOpposite", d), void 0 === i.startMoving && (n.currentX === n.startX && n.currentY === n.startY || (i.startMoving = !0)), i.isScrolling || "touchmove" === d.type && i.preventTouchMoveFromPointerMove) return void (i.isTouched = !1);
    if (!i.startMoving) return;
    s.allowClick = !1, !r.cssMode && d.cancelable && d.preventDefault(), r.touchMoveStopPropagation && !r.nested && d.stopPropagation();
    var m = s.isHorizontal() ? u : h, f = s.isHorizontal() ? n.currentX - n.previousX : n.currentY - n.previousY;
    r.oneWayMovement && (m = Math.abs(m) * (a ? 1 : -1), f = Math.abs(f) * (a ? 1 : -1)), n.diff = m, m *= r.touchRatio, a && (m = -m, f = -f);
    var v = s.touchesDirection;
    s.swipeDirection = m > 0 ? "prev" : "next", s.touchesDirection = f > 0 ? "prev" : "next";
    var g = s.params.loop && !r.cssMode, w = "next" === s.touchesDirection && s.allowSlideNext || "prev" === s.touchesDirection && s.allowSlidePrev;
    if (!i.isMoved) {
        if (g && w && s.loopFix({
            direction: s.swipeDirection
        }), i.startTranslate = s.getTranslate(), s.setTransition(0), s.animating) {
            var _$e1 = new window.CustomEvent("transitionend", {
                bubbles: !0,
                cancelable: !0,
                detail: {
                    bySwiperTouchMove: !0
                }
            });
            s.wrapperEl.dispatchEvent(_$e1);
        }
        i.allowMomentumBounce = !1, !r.grabCursor || !0 !== s.allowSlideNext && !0 !== s.allowSlidePrev || s.setGrabCursor(!0), s.emit("sliderFirstMove", d);
    }
    if ((new Date).getTime(), i.isMoved && i.allowThresholdMove && v !== s.touchesDirection && g && w && Math.abs(m) >= 1) return Object.assign(n, {
        startX: c,
        startY: p,
        currentX: c,
        currentY: p,
        startTranslate: i.currentTranslate
    }), i.loopSwapReset = !0, void (i.startTranslate = i.currentTranslate);
    s.emit("sliderMove", d), i.isMoved = !0, i.currentTranslate = m + i.startTranslate;
    var S = !0, T = r.resistanceRatio;
    if (r.touchReleaseOnEdges && (T = 0), m > 0 ? (g && w && i.allowThresholdMove && i.currentTranslate > (r.centeredSlides ? s.minTranslate() - s.slidesSizesGrid[s.activeIndex + 1] - ("auto" !== r.slidesPerView && s.slides.length - r.slidesPerView >= 2 ? s.slidesSizesGrid[s.activeIndex + 1] + s.params.spaceBetween : 0) - s.params.spaceBetween : s.minTranslate()) && s.loopFix({
        direction: "prev",
        setTranslate: !0,
        activeSlideIndex: 0
    }), i.currentTranslate > s.minTranslate() && (S = !1, r.resistance && (i.currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + i.startTranslate + m, T)))) : m < 0 && (g && w && i.allowThresholdMove && i.currentTranslate < (r.centeredSlides ? s.maxTranslate() + s.slidesSizesGrid[s.slidesSizesGrid.length - 1] + s.params.spaceBetween + ("auto" !== r.slidesPerView && s.slides.length - r.slidesPerView >= 2 ? s.slidesSizesGrid[s.slidesSizesGrid.length - 1] + s.params.spaceBetween : 0) : s.maxTranslate()) && s.loopFix({
        direction: "next",
        setTranslate: !0,
        activeSlideIndex: s.slides.length - ("auto" === r.slidesPerView ? s.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10)))
    }), i.currentTranslate < s.maxTranslate() && (S = !1, r.resistance && (i.currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - i.startTranslate - m, T)))), S && (d.preventedByNestedSwiper = !0), !s.allowSlideNext && "next" === s.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !s.allowSlidePrev && "prev" === s.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), s.allowSlidePrev || s.allowSlideNext || (i.currentTranslate = i.startTranslate), r.threshold > 0) {
        if (!(Math.abs(m) > r.threshold || i.allowThresholdMove)) return void (i.currentTranslate = i.startTranslate);
        if (!i.allowThresholdMove) return i.allowThresholdMove = !0, n.startX = n.currentX, n.startY = n.currentY, i.currentTranslate = i.startTranslate, void (n.diff = s.isHorizontal() ? n.currentX - n.startX : n.currentY - n.startY);
    }
    r.followFinger && !r.cssMode && ((r.freeMode && r.freeMode.enabled && s.freeMode || r.watchSlidesProgress) && (s.updateActiveIndex(), s.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && s.freeMode && s.freeMode.onTouchMove(), s.updateProgress(i.currentTranslate), s.setTranslate(i.currentTranslate));
}
function $7704c8facc3d92c9$var$onTouchEnd(e) {
    var t = this, s = t.touchEventsData;
    var i, r = e;
    r.originalEvent && (r = r.originalEvent);
    if ("touchend" === r.type || "touchcancel" === r.type) {
        if (i = (0, $1961f7bca441a4c6$export$71511d61b312f219)(r.changedTouches).filter(function(e) {
            return e.identifier === s.touchId;
        })[0], !i || i.identifier !== s.touchId) return;
    } else {
        if (null !== s.touchId) return;
        if (r.pointerId !== s.pointerId) return;
        i = r;
    }
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(r.type)) {
        if (!([
            "pointercancel",
            "contextmenu"
        ].includes(r.type) && (t.browser.isSafari || t.browser.isWebView))) return;
    }
    s.pointerId = null, s.touchId = null;
    var n = t.params, a = t.touches, l = t.rtlTranslate, o = t.slidesGrid, d = t.enabled;
    if (!d) return;
    if (!n.simulateTouch && "mouse" === r.pointerType) return;
    if (s.allowTouchCallbacks && t.emit("touchEnd", r), s.allowTouchCallbacks = !1, !s.isTouched) return s.isMoved && n.grabCursor && t.setGrabCursor(!1), s.isMoved = !1, void (s.startMoving = !1);
    n.grabCursor && s.isMoved && s.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
    var c = (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)(), p = c - s.touchStartTime;
    if (t.allowClick) {
        var _$e = r.path || r.composedPath && r.composedPath();
        t.updateClickedSlide(_$e && _$e[0] || r.target, _$e), t.emit("tap click", r), p < 300 && c - s.lastClickTime < 300 && t.emit("doubleTap doubleClick", r);
    }
    if (s.lastClickTime = (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)(), (0, $3d818fcc5f3623ef$export$7ccc53e8f1e7dfc5)(function() {
        t.destroyed || (t.allowClick = !0);
    }), !s.isTouched || !s.isMoved || !t.swipeDirection || 0 === a.diff && !s.loopSwapReset || s.currentTranslate === s.startTranslate && !s.loopSwapReset) return s.isTouched = !1, s.isMoved = !1, void (s.startMoving = !1);
    var u;
    if (s.isTouched = !1, s.isMoved = !1, s.startMoving = !1, u = n.followFinger ? l ? t.translate : -t.translate : -s.currentTranslate, n.cssMode) return;
    if (n.freeMode && n.freeMode.enabled) return void t.freeMode.onTouchEnd({
        currentPos: u
    });
    var h = u >= -t.maxTranslate() && !t.params.loop;
    var m = 0, f = t.slidesSizesGrid[0];
    for(var _$e1 = 0; _$e1 < o.length; _$e1 += _$e1 < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup){
        var t1 = _$e1 < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
        void 0 !== o[_$e1 + t1] ? (h || u >= o[_$e1] && u < o[_$e1 + t1]) && (m = _$e1, f = o[_$e1 + t1] - o[_$e1]) : (h || u >= o[_$e1]) && (m = _$e1, f = o[o.length - 1] - o[o.length - 2]);
    }
    var v = null, g = null;
    n.rewind && (t.isBeginning ? g = n.virtual && n.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (v = 0));
    var w = (u - o[m]) / f, S = m < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
    if (p > n.longSwipesMs) {
        if (!n.longSwipes) return void t.slideTo(t.activeIndex);
        "next" === t.swipeDirection && (w >= n.longSwipesRatio ? t.slideTo(n.rewind && t.isEnd ? v : m + S) : t.slideTo(m)), "prev" === t.swipeDirection && (w > 1 - n.longSwipesRatio ? t.slideTo(m + S) : null !== g && w < 0 && Math.abs(w) > n.longSwipesRatio ? t.slideTo(g) : t.slideTo(m));
    } else {
        if (!n.shortSwipes) return void t.slideTo(t.activeIndex);
        t.navigation && (r.target === t.navigation.nextEl || r.target === t.navigation.prevEl) ? r.target === t.navigation.nextEl ? t.slideTo(m + S) : t.slideTo(m) : ("next" === t.swipeDirection && t.slideTo(null !== v ? v : m + S), "prev" === t.swipeDirection && t.slideTo(null !== g ? g : m));
    }
}
function $7704c8facc3d92c9$var$onResize() {
    var e = this, t = e.params, s = e.el;
    if (s && 0 === s.offsetWidth) return;
    t.breakpoints && e.setBreakpoint();
    var i = e.allowSlideNext, r = e.allowSlidePrev, n = e.snapGrid, a = e.virtual && e.params.virtual.enabled;
    e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
    var l = a && t.loop;
    !("auto" === t.slidesPerView || t.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || l ? e.params.loop && !a ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0) : e.slideTo(e.slides.length - 1, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(function() {
        e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
    }, 500)), e.allowSlidePrev = r, e.allowSlideNext = i, e.params.watchOverflow && n !== e.snapGrid && e.checkOverflow();
}
function $7704c8facc3d92c9$var$onClick(e) {
    var t = this;
    t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function $7704c8facc3d92c9$var$onScroll() {
    var e = this, t = e.wrapperEl, s = e.rtlTranslate, i = e.enabled;
    if (!i) return;
    var r;
    e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, 0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
    var n = e.maxTranslate() - e.minTranslate();
    r = 0 === n ? 0 : (e.translate - e.minTranslate()) / n, r !== e.progress && e.updateProgress(s ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function $7704c8facc3d92c9$var$onLoad(e) {
    var t = this;
    $7704c8facc3d92c9$var$processLazyPreloader(t, e.target), t.params.cssMode || "auto" !== t.params.slidesPerView && !t.params.autoHeight || t.update();
}
function $7704c8facc3d92c9$var$onDocumentTouchStart() {
    var e = this;
    e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
var $7704c8facc3d92c9$var$events = function(e, t) {
    var s = (0, $650091777930d0d5$export$39b482c5e57630a8)(), i = e.params, r = e.el, n = e.wrapperEl, a = e.device, l = !!i.nested, o = "on" === t ? "addEventListener" : "removeEventListener", d = t;
    r && "string" != typeof r && (s[o]("touchstart", e.onDocumentTouchStart, {
        passive: !1,
        capture: l
    }), r[o]("touchstart", e.onTouchStart, {
        passive: !1
    }), r[o]("pointerdown", e.onTouchStart, {
        passive: !1
    }), s[o]("touchmove", e.onTouchMove, {
        passive: !1,
        capture: l
    }), s[o]("pointermove", e.onTouchMove, {
        passive: !1,
        capture: l
    }), s[o]("touchend", e.onTouchEnd, {
        passive: !0
    }), s[o]("pointerup", e.onTouchEnd, {
        passive: !0
    }), s[o]("pointercancel", e.onTouchEnd, {
        passive: !0
    }), s[o]("touchcancel", e.onTouchEnd, {
        passive: !0
    }), s[o]("pointerout", e.onTouchEnd, {
        passive: !0
    }), s[o]("pointerleave", e.onTouchEnd, {
        passive: !0
    }), s[o]("contextmenu", e.onTouchEnd, {
        passive: !0
    }), (i.preventClicks || i.preventClicksPropagation) && r[o]("click", e.onClick, !0), i.cssMode && n[o]("scroll", e.onScroll), i.updateOnWindowResize ? e[d](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $7704c8facc3d92c9$var$onResize, !0) : e[d]("observerUpdate", $7704c8facc3d92c9$var$onResize, !0), r[o]("load", e.onLoad, {
        capture: !0
    }));
};
function $7704c8facc3d92c9$var$attachEvents() {
    var e = this, t = e.params;
    e.onTouchStart = $7704c8facc3d92c9$var$onTouchStart.bind(e), e.onTouchMove = $7704c8facc3d92c9$var$onTouchMove.bind(e), e.onTouchEnd = $7704c8facc3d92c9$var$onTouchEnd.bind(e), e.onDocumentTouchStart = $7704c8facc3d92c9$var$onDocumentTouchStart.bind(e), t.cssMode && (e.onScroll = $7704c8facc3d92c9$var$onScroll.bind(e)), e.onClick = $7704c8facc3d92c9$var$onClick.bind(e), e.onLoad = $7704c8facc3d92c9$var$onLoad.bind(e), $7704c8facc3d92c9$var$events(e, "on");
}
function $7704c8facc3d92c9$var$detachEvents() {
    $7704c8facc3d92c9$var$events(this, "off");
}
var $7704c8facc3d92c9$var$events$1 = {
    attachEvents: $7704c8facc3d92c9$var$attachEvents,
    detachEvents: $7704c8facc3d92c9$var$detachEvents
};
var $7704c8facc3d92c9$var$isGridEnabled = function(e, t) {
    return e.grid && t.grid && t.grid.rows > 1;
};
function $7704c8facc3d92c9$var$setBreakpoint() {
    var e = this, t = e.realIndex, s = e.initialized, i = e.params, r = e.el, n = i.breakpoints;
    if (!n || n && 0 === Object.keys(n).length) return;
    var a = e.getBreakpoint(n, e.params.breakpointsBase, e.el);
    if (!a || e.currentBreakpoint === a) return;
    var l = (a in n ? n[a] : void 0) || e.originalParams, o = $7704c8facc3d92c9$var$isGridEnabled(e, i), d = $7704c8facc3d92c9$var$isGridEnabled(e, l), c = e.params.grabCursor, p = l.grabCursor, u = i.enabled;
    o && !d ? (r.classList.remove("".concat(i.containerModifierClass, "grid"), "".concat(i.containerModifierClass, "grid-column")), e.emitContainerClasses()) : !o && d && (r.classList.add("".concat(i.containerModifierClass, "grid")), (l.grid.fill && "column" === l.grid.fill || !l.grid.fill && "column" === i.grid.fill) && r.classList.add("".concat(i.containerModifierClass, "grid-column")), e.emitContainerClasses()), c && !p ? e.unsetGrabCursor() : !c && p && e.setGrabCursor(), [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach(function(t) {
        if (void 0 === l[t]) return;
        var s = i[t] && i[t].enabled, r = l[t] && l[t].enabled;
        s && !r && e[t].disable(), !s && r && e[t].enable();
    });
    var h = l.direction && l.direction !== i.direction, m = i.loop && (l.slidesPerView !== i.slidesPerView || h), f = i.loop;
    h && s && e.changeDirection(), (0, $3d818fcc5f3623ef$export$efccba1c4a2ef57b)(e.params, l);
    var v = e.params.enabled, g = e.params.loop;
    Object.assign(e, {
        allowTouchMove: e.params.allowTouchMove,
        allowSlideNext: e.params.allowSlideNext,
        allowSlidePrev: e.params.allowSlidePrev
    }), u && !v ? e.disable() : !u && v && e.enable(), e.currentBreakpoint = a, e.emit("_beforeBreakpoint", l), s && (m ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !f && g ? (e.loopCreate(t), e.updateSlides()) : f && !g && e.loopDestroy()), e.emit("breakpoint", l);
}
function $7704c8facc3d92c9$var$getBreakpoint(e, t, s) {
    if (void 0 === t && (t = "window"), !e || "container" === t && !s) return;
    var i = !1;
    var r = (0, $650091777930d0d5$export$407448d2b89b1813)(), n = "window" === t ? r.innerHeight : s.clientHeight, a = Object.keys(e).map(function(e) {
        if ("string" == typeof e && 0 === e.indexOf("@")) {
            var _$t = parseFloat(e.substr(1));
            return {
                value: n * _$t,
                point: e
            };
        }
        return {
            value: e,
            point: e
        };
    });
    a.sort(function(e, t) {
        return parseInt(e.value, 10) - parseInt(t.value, 10);
    });
    for(var _$e = 0; _$e < a.length; _$e += 1){
        var _a_e = a[_$e], n1 = _a_e.point, l = _a_e.value;
        "window" === t ? r.matchMedia("(min-width: ".concat(l, "px)")).matches && (i = n1) : l <= s.clientWidth && (i = n1);
    }
    return i || "max";
}
var $7704c8facc3d92c9$var$breakpoints = {
    setBreakpoint: $7704c8facc3d92c9$var$setBreakpoint,
    getBreakpoint: $7704c8facc3d92c9$var$getBreakpoint
};
function $7704c8facc3d92c9$var$prepareClasses(e, t) {
    var s = [];
    return e.forEach(function(e) {
        "object" == (typeof e === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(e)) ? Object.keys(e).forEach(function(i) {
            e[i] && s.push(t + i);
        }) : "string" == typeof e && s.push(t + e);
    }), s;
}
function $7704c8facc3d92c9$var$addClasses() {
    var _t, _r_classList;
    var e = this, t = e.classNames, s = e.params, i = e.rtl, r = e.el, n = e.device, a = $7704c8facc3d92c9$var$prepareClasses([
        "initialized",
        s.direction,
        {
            "free-mode": e.params.freeMode && s.freeMode.enabled
        },
        {
            autoheight: s.autoHeight
        },
        {
            rtl: i
        },
        {
            grid: s.grid && s.grid.rows > 1
        },
        {
            "grid-column": s.grid && s.grid.rows > 1 && "column" === s.grid.fill
        },
        {
            android: n.android
        },
        {
            ios: n.ios
        },
        {
            "css-mode": s.cssMode
        },
        {
            centered: s.cssMode && s.centeredSlides
        },
        {
            "watch-progress": s.watchSlidesProgress
        }
    ], s.containerModifierClass);
    (_t = t).push.apply(_t, (0, $1961f7bca441a4c6$export$71511d61b312f219)(a)), (_r_classList = r.classList).add.apply(_r_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(t)), e.emitContainerClasses();
}
function $7704c8facc3d92c9$var$removeClasses() {
    var _e_classList;
    var _this = this, e = _this.el, t = _this.classNames;
    e && "string" != typeof e && ((_e_classList = e.classList).remove.apply(_e_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(t)), this.emitContainerClasses());
}
var $7704c8facc3d92c9$var$classes = {
    addClasses: $7704c8facc3d92c9$var$addClasses,
    removeClasses: $7704c8facc3d92c9$var$removeClasses
};
function $7704c8facc3d92c9$var$checkOverflow() {
    var e = this, t = e.isLocked, s = e.params, i = s.slidesOffsetBefore;
    if (i) {
        var t1 = e.slides.length - 1, s1 = e.slidesGrid[t1] + e.slidesSizesGrid[t1] + 2 * i;
        e.isLocked = e.size > s1;
    } else e.isLocked = 1 === e.snapGrid.length;
    !0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked), !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
var $7704c8facc3d92c9$var$checkOverflow$1 = {
    checkOverflow: $7704c8facc3d92c9$var$checkOverflow
}, $7704c8facc3d92c9$export$4368d992c4eafac0 = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: "swiper",
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: .5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: .85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1
};
function $7704c8facc3d92c9$var$moduleExtendParams(e, t) {
    return function(s) {
        void 0 === s && (s = {});
        var i = Object.keys(s)[0], r = s[i];
        "object" == (typeof r === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(r)) && null !== r ? (!0 === e[i] && (e[i] = {
            enabled: !0
        }), "navigation" === i && e[i] && e[i].enabled && !e[i].prevEl && !e[i].nextEl && (e[i].auto = !0), [
            "pagination",
            "scrollbar"
        ].indexOf(i) >= 0 && e[i] && e[i].enabled && !e[i].el && (e[i].auto = !0), i in e && "enabled" in r ? ("object" != (0, $17c6da0aa640e82f$export$71511d61b312f219)(e[i]) || "enabled" in e[i] || (e[i].enabled = !0), e[i] || (e[i] = {
            enabled: !1
        }), (0, $3d818fcc5f3623ef$export$efccba1c4a2ef57b)(t, s)) : (0, $3d818fcc5f3623ef$export$efccba1c4a2ef57b)(t, s)) : (0, $3d818fcc5f3623ef$export$efccba1c4a2ef57b)(t, s);
    };
}
var $7704c8facc3d92c9$var$prototypes = {
    eventsEmitter: $7704c8facc3d92c9$var$eventsEmitter,
    update: $7704c8facc3d92c9$var$update,
    translate: $7704c8facc3d92c9$var$translate,
    transition: $7704c8facc3d92c9$var$transition,
    slide: $7704c8facc3d92c9$var$slide,
    loop: $7704c8facc3d92c9$var$loop,
    grabCursor: $7704c8facc3d92c9$var$grabCursor,
    events: $7704c8facc3d92c9$var$events$1,
    breakpoints: $7704c8facc3d92c9$var$breakpoints,
    checkOverflow: $7704c8facc3d92c9$var$checkOverflow$1,
    classes: $7704c8facc3d92c9$var$classes
}, $7704c8facc3d92c9$var$extendedDefaults = {};
var $7704c8facc3d92c9$export$25ce5a424b770e84 = /*#__PURE__*/ function() {
    "use strict";
    function Swiper() {
        var _a_modules;
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Swiper);
        var e, t;
        for(var s = arguments.length, i = new Array(s), r = 0; r < s; r++)i[r] = arguments[r];
        var ref;
        1 === i.length && i[0].constructor && "Object" === Object.prototype.toString.call(i[0]).slice(8, -1) ? t = i[0] : (ref = (0, $d98b89efad01a571$export$71511d61b312f219)(i, 2), e = ref[0], t = ref[1], ref), t || (t = {}), t = (0, $3d818fcc5f3623ef$export$efccba1c4a2ef57b)({}, t), e && !t.el && (t.el = e);
        var n = (0, $650091777930d0d5$export$39b482c5e57630a8)();
        if (t.el && "string" == typeof t.el && n.querySelectorAll(t.el).length > 1) {
            var e1 = [];
            return n.querySelectorAll(t.el).forEach(function(s) {
                var i = (0, $3d818fcc5f3623ef$export$efccba1c4a2ef57b)({}, t, {
                    el: s
                });
                e1.push(new Swiper(i));
            }), e1;
        }
        var a = this;
        a.__swiper__ = !0, a.support = $7704c8facc3d92c9$var$getSupport(), a.device = $7704c8facc3d92c9$var$getDevice({
            userAgent: t.userAgent
        }), a.browser = $7704c8facc3d92c9$var$getBrowser(), a.eventsListeners = {}, a.eventsAnyListeners = [], a.modules = (0, $1961f7bca441a4c6$export$71511d61b312f219)(a.__modules__), t.modules && Array.isArray(t.modules) && (_a_modules = a.modules).push.apply(_a_modules, (0, $1961f7bca441a4c6$export$71511d61b312f219)(t.modules));
        var l = {};
        a.modules.forEach(function(e) {
            e({
                params: t,
                swiper: a,
                extendParams: $7704c8facc3d92c9$var$moduleExtendParams(t, l),
                on: a.on.bind(a),
                once: a.once.bind(a),
                off: a.off.bind(a),
                emit: a.emit.bind(a)
            });
        });
        var o = (0, $3d818fcc5f3623ef$export$efccba1c4a2ef57b)({}, $7704c8facc3d92c9$export$4368d992c4eafac0, l);
        return a.params = (0, $3d818fcc5f3623ef$export$efccba1c4a2ef57b)({}, o, $7704c8facc3d92c9$var$extendedDefaults, t), a.originalParams = (0, $3d818fcc5f3623ef$export$efccba1c4a2ef57b)({}, a.params), a.passedParams = (0, $3d818fcc5f3623ef$export$efccba1c4a2ef57b)({}, t), a.params && a.params.on && Object.keys(a.params.on).forEach(function(e) {
            a.on(e, a.params.on[e]);
        }), a.params && a.params.onAny && a.onAny(a.params.onAny), Object.assign(a, {
            enabled: a.params.enabled,
            el: e,
            classNames: [],
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            isHorizontal: function() {
                return "horizontal" === a.params.direction;
            },
            isVertical: function() {
                return "vertical" === a.params.direction;
            },
            activeIndex: 0,
            realIndex: 0,
            isBeginning: !0,
            isEnd: !1,
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: !1,
            cssOverflowAdjustment: function() {
                return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
            },
            allowSlideNext: a.params.allowSlideNext,
            allowSlidePrev: a.params.allowSlidePrev,
            touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: a.params.focusableElements,
                lastClickTime: 0,
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                startMoving: void 0,
                pointerId: null,
                touchId: null
            },
            allowClick: !0,
            allowTouchMove: a.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            imagesToLoad: [],
            imagesLoaded: 0
        }), a.emit("_swiper"), a.params.init && a.init(), a;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Swiper, [
        {
            key: "getDirectionLabel",
            value: function getDirectionLabel(e) {
                return this.isHorizontal() ? e : ({
                    width: "height",
                    "margin-top": "margin-left",
                    "margin-bottom ": "margin-right",
                    "margin-left": "margin-top",
                    "margin-right": "margin-bottom",
                    "padding-left": "padding-top",
                    "padding-right": "padding-bottom",
                    marginRight: "marginBottom"
                })[e];
            }
        },
        {
            key: "getSlideIndex",
            value: function getSlideIndex(e) {
                var _this = this, t = _this.slidesEl, s = _this.params, i = (0, $3d818fcc5f3623ef$export$f1e1789686576879)(t, ".".concat(s.slideClass, ", swiper-slide")), r = (0, $3d818fcc5f3623ef$export$dda1d9f60106f0e9)(i[0]);
                return (0, $3d818fcc5f3623ef$export$dda1d9f60106f0e9)(e) - r;
            }
        },
        {
            key: "getSlideIndexByData",
            value: function getSlideIndexByData(e) {
                return this.getSlideIndex(this.slides.filter(function(t) {
                    return 1 * t.getAttribute("data-swiper-slide-index") === e;
                })[0]);
            }
        },
        {
            key: "recalcSlides",
            value: function recalcSlides() {
                var _this = this, e = _this.slidesEl, t = _this.params;
                this.slides = (0, $3d818fcc5f3623ef$export$f1e1789686576879)(e, ".".concat(t.slideClass, ", swiper-slide"));
            }
        },
        {
            key: "enable",
            value: function enable() {
                var e = this;
                e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
            }
        },
        {
            key: "disable",
            value: function disable() {
                var e = this;
                e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
            }
        },
        {
            key: "setProgress",
            value: function setProgress(e, t) {
                var s = this;
                e = Math.min(Math.max(e, 0), 1);
                var i = s.minTranslate(), r = (s.maxTranslate() - i) * e + i;
                s.translateTo(r, void 0 === t ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses();
            }
        },
        {
            key: "emitContainerClasses",
            value: function emitContainerClasses() {
                var e = this;
                if (!e.params._emitClasses || !e.el) return;
                var t = e.el.className.split(" ").filter(function(t) {
                    return 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass);
                });
                e.emit("_containerClasses", t.join(" "));
            }
        },
        {
            key: "getSlideClasses",
            value: function getSlideClasses(e) {
                var t = this;
                return t.destroyed ? "" : e.className.split(" ").filter(function(e) {
                    return 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass);
                }).join(" ");
            }
        },
        {
            key: "emitSlidesClasses",
            value: function emitSlidesClasses() {
                var e = this;
                if (!e.params._emitClasses || !e.el) return;
                var t = [];
                e.slides.forEach(function(s) {
                    var i = e.getSlideClasses(s);
                    t.push({
                        slideEl: s,
                        classNames: i
                    }), e.emit("_slideClass", s, i);
                }), e.emit("_slideClasses", t);
            }
        },
        {
            key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic(e, t) {
                void 0 === e && (e = "current"), void 0 === t && (t = !1);
                var _this = this, s = _this.params, i = _this.slides, r = _this.slidesGrid, n = _this.slidesSizesGrid, a = _this.size, l = _this.activeIndex;
                var o = 1;
                if ("number" == typeof s.slidesPerView) return s.slidesPerView;
                if (s.centeredSlides) {
                    var _$e, _$t = i[l] ? Math.ceil(i[l].swiperSlideSize) : 0;
                    for(var s1 = l + 1; s1 < i.length; s1 += 1)i[s1] && !_$e && (_$t += Math.ceil(i[s1].swiperSlideSize), o += 1, _$t > a && (_$e = !0));
                    for(var s2 = l - 1; s2 >= 0; s2 -= 1)i[s2] && !_$e && (_$t += i[s2].swiperSlideSize, o += 1, _$t > a && (_$e = !0));
                } else if ("current" === e) for(var _$e1 = l + 1; _$e1 < i.length; _$e1 += 1)(t ? r[_$e1] + n[_$e1] - r[l] < a : r[_$e1] - r[l] < a) && (o += 1);
                else for(var _$e2 = l - 1; _$e2 >= 0; _$e2 -= 1)r[l] - r[_$e2] < a && (o += 1);
                return o;
            }
        },
        {
            key: "update",
            value: function update() {
                var e = this;
                if (!e || e.destroyed) return;
                var t = e.snapGrid, s = e.params;
                function i() {
                    var t = e.rtlTranslate ? -1 * e.translate : e.translate, s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                    e.setTranslate(s), e.updateActiveIndex(), e.updateSlidesClasses();
                }
                var r;
                if (s.breakpoints && e.setBreakpoint(), (0, $1961f7bca441a4c6$export$71511d61b312f219)(e.el.querySelectorAll('[loading="lazy"]')).forEach(function(t) {
                    t.complete && $7704c8facc3d92c9$var$processLazyPreloader(e, t);
                }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), s.freeMode && s.freeMode.enabled && !s.cssMode) i(), s.autoHeight && e.updateAutoHeight();
                else {
                    if (("auto" === s.slidesPerView || s.slidesPerView > 1) && e.isEnd && !s.centeredSlides) {
                        var t1 = e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides;
                        r = e.slideTo(t1.length - 1, 0, !1, !0);
                    } else r = e.slideTo(e.activeIndex, 0, !1, !0);
                    r || i();
                }
                s.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
            }
        },
        {
            key: "changeDirection",
            value: function changeDirection(e, t) {
                void 0 === t && (t = !0);
                var s = this, i = s.params.direction;
                return e || (e = "horizontal" === i ? "vertical" : "horizontal"), e === i || "horizontal" !== e && "vertical" !== e || (s.el.classList.remove("".concat(s.params.containerModifierClass).concat(i)), s.el.classList.add("".concat(s.params.containerModifierClass).concat(e)), s.emitContainerClasses(), s.params.direction = e, s.slides.forEach(function(t) {
                    "vertical" === e ? t.style.width = "" : t.style.height = "";
                }), s.emit("changeDirection"), t && s.update()), s;
            }
        },
        {
            key: "changeLanguageDirection",
            value: function changeLanguageDirection(e) {
                var t = this;
                t.rtl && "rtl" === e || !t.rtl && "ltr" === e || (t.rtl = "rtl" === e, t.rtlTranslate = "horizontal" === t.params.direction && t.rtl, t.rtl ? (t.el.classList.add("".concat(t.params.containerModifierClass, "rtl")), t.el.dir = "rtl") : (t.el.classList.remove("".concat(t.params.containerModifierClass, "rtl")), t.el.dir = "ltr"), t.update());
            }
        },
        {
            key: "mount",
            value: function mount(e) {
                var t = this;
                if (t.mounted) return !0;
                var s = e || t.params.el;
                if ("string" == typeof s && (s = document.querySelector(s)), !s) return !1;
                s.swiper = t, s.parentNode && s.parentNode.host && s.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
                var i = function() {
                    return ".".concat((t.params.wrapperClass || "").trim().split(" ").join("."));
                };
                var r = function() {
                    if (s && s.shadowRoot && s.shadowRoot.querySelector) return s.shadowRoot.querySelector(i());
                    return (0, $3d818fcc5f3623ef$export$f1e1789686576879)(s, i())[0];
                }();
                return !r && t.params.createElements && (r = (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("div", t.params.wrapperClass), s.append(r), (0, $3d818fcc5f3623ef$export$f1e1789686576879)(s, ".".concat(t.params.slideClass)).forEach(function(e) {
                    r.append(e);
                })), Object.assign(t, {
                    el: s,
                    wrapperEl: r,
                    slidesEl: t.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : r,
                    hostEl: t.isElement ? s.parentNode.host : s,
                    mounted: !0,
                    rtl: "rtl" === s.dir.toLowerCase() || "rtl" === (0, $3d818fcc5f3623ef$export$ffb5f4729a158638)(s, "direction"),
                    rtlTranslate: "horizontal" === t.params.direction && ("rtl" === s.dir.toLowerCase() || "rtl" === (0, $3d818fcc5f3623ef$export$ffb5f4729a158638)(s, "direction")),
                    wrongRTL: "-webkit-box" === (0, $3d818fcc5f3623ef$export$ffb5f4729a158638)(r, "display")
                }), !0;
            }
        },
        {
            key: "init",
            value: function init(e) {
                var _s;
                var t = this;
                if (t.initialized) return t;
                if (!1 === t.mount(e)) return t;
                t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(), t.attachEvents();
                var s = (0, $1961f7bca441a4c6$export$71511d61b312f219)(t.el.querySelectorAll('[loading="lazy"]'));
                return t.isElement && (_s = s).push.apply(_s, (0, $1961f7bca441a4c6$export$71511d61b312f219)(t.hostEl.querySelectorAll('[loading="lazy"]'))), s.forEach(function(e) {
                    e.complete ? $7704c8facc3d92c9$var$processLazyPreloader(t, e) : e.addEventListener("load", function(e) {
                        $7704c8facc3d92c9$var$processLazyPreloader(t, e.target);
                    });
                }), $7704c8facc3d92c9$var$preload(t), t.initialized = !0, $7704c8facc3d92c9$var$preload(t), t.emit("init"), t.emit("afterInit"), t;
            }
        },
        {
            key: "destroy",
            value: function destroy(e, t) {
                void 0 === e && (e = !0), void 0 === t && (t = !0);
                var s = this, i = s.params, r = s.el, n = s.wrapperEl, a = s.slides;
                return void 0 === s.params || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), i.loop && s.loopDestroy(), t && (s.removeClasses(), r && "string" != typeof r && r.removeAttribute("style"), n && n.removeAttribute("style"), a && a.length && a.forEach(function(e) {
                    e.classList.remove(i.slideVisibleClass, i.slideFullyVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index");
                })), s.emit("destroy"), Object.keys(s.eventsListeners).forEach(function(e) {
                    s.off(e);
                }), !1 !== e && (s.el && "string" != typeof s.el && (s.el.swiper = null), (0, $3d818fcc5f3623ef$export$d141bba7fdc215a3)(s)), s.destroyed = !0), null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(e) {
                (0, $3d818fcc5f3623ef$export$efccba1c4a2ef57b)($7704c8facc3d92c9$var$extendedDefaults, e);
            }
        },
        {
            key: "extendedDefaults",
            get: function get() {
                return $7704c8facc3d92c9$var$extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return $7704c8facc3d92c9$export$4368d992c4eafac0;
            }
        },
        {
            key: "installModule",
            value: function installModule(e) {
                Swiper.prototype.__modules__ || (Swiper.prototype.__modules__ = []);
                var t = Swiper.prototype.__modules__;
                "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
            }
        },
        {
            key: "use",
            value: function use(e) {
                return Array.isArray(e) ? (e.forEach(function(e) {
                    return Swiper.installModule(e);
                }), Swiper) : (Swiper.installModule(e), Swiper);
            }
        }
    ]);
    return Swiper;
}();
Object.keys($7704c8facc3d92c9$var$prototypes).forEach(function(e) {
    Object.keys($7704c8facc3d92c9$var$prototypes[e]).forEach(function(t) {
        $7704c8facc3d92c9$export$25ce5a424b770e84.prototype[t] = $7704c8facc3d92c9$var$prototypes[e][t];
    });
}), $7704c8facc3d92c9$export$25ce5a424b770e84.use([
    $7704c8facc3d92c9$var$Resize,
    $7704c8facc3d92c9$var$Observer
]);






function $b8fb24d539d209e4$export$2e2bcd8739ae039(e) {
    var s, t = e.swiper, i = e.extendParams, r = e.on, a = e.emit;
    i({
        virtual: {
            enabled: !1,
            slides: [],
            cache: !0,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: !0,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    var l = (0, $650091777930d0d5$export$39b482c5e57630a8)();
    t.virtual = {
        cache: {},
        from: void 0,
        to: void 0,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    var d = l.createElement("div");
    function n(e, s) {
        var i = t.params.virtual;
        if (i.cache && t.virtual.cache[s]) return t.virtual.cache[s];
        var r;
        return i.renderSlide ? (r = i.renderSlide.call(t, e, s), "string" == typeof r && (d.innerHTML = r, r = d.children[0])) : r = t.isElement ? (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("swiper-slide") : (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("div", t.params.slideClass), r.setAttribute("data-swiper-slide-index", s), i.renderSlide || (r.innerHTML = e), i.cache && (t.virtual.cache[s] = r), r;
    }
    function c(e, s) {
        var _loop = function(_$e) {
            if (_$e < S || _$e > b) {
                var _$s = j(_$e);
                t.slides.filter(function(e) {
                    return e.matches(".".concat(t.params.slideClass, '[data-swiper-slide-index="').concat(_$s, '"], swiper-slide[data-swiper-slide-index="').concat(_$s, '"]'));
                }).forEach(function(e) {
                    e.remove();
                });
            }
        };
        var _t_params = t.params, i = _t_params.slidesPerView, r = _t_params.slidesPerGroup, l = _t_params.centeredSlides, d = _t_params.loop, _$c = _t_params.initialSlide;
        if (s && !d && _$c > 0) return;
        var _t_params_virtual = t.params.virtual, o = _t_params_virtual.addSlidesBefore, u = _t_params_virtual.addSlidesAfter, _t_virtual = t.virtual, p = _t_virtual.from, h = _t_virtual.to, f = _t_virtual.slides, v = _t_virtual.slidesGrid, m = _t_virtual.offset;
        t.params.cssMode || t.updateActiveIndex();
        var g = t.activeIndex || 0;
        var E, x, w;
        E = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top", l ? (x = Math.floor(i / 2) + r + u, w = Math.floor(i / 2) + r + o) : (x = i + (r - 1) + u, w = (d ? i : r) + o);
        var S = g - w, b = g + x;
        d || (S = Math.max(S, 0), b = Math.min(b, f.length - 1));
        var A = (t.slidesGrid[S] || 0) - (t.slidesGrid[0] || 0);
        function M() {
            t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), a("virtualUpdate");
        }
        if (d && g >= w ? (S -= w, l || (A += t.slidesGrid[0])) : d && g < w && (S = -w, l && (A += t.slidesGrid[0])), Object.assign(t.virtual, {
            from: S,
            to: b,
            offset: A,
            slidesGrid: t.slidesGrid,
            slidesBefore: w,
            slidesAfter: x
        }), p === S && h === b && !e) return t.slidesGrid !== v && A !== m && t.slides.forEach(function(e) {
            e.style[E] = A - Math.abs(t.cssOverflowAdjustment()) + "px";
        }), t.updateProgress(), void a("virtualUpdate");
        if (t.params.virtual.renderExternal) return t.params.virtual.renderExternal.call(t, {
            offset: A,
            from: S,
            to: b,
            slides: function() {
                var _$e = [];
                for(var _$s = S; _$s <= b; _$s += 1)_$e.push(f[_$s]);
                return _$e;
            }()
        }), void (t.params.virtual.renderExternalUpdate ? M() : a("virtualUpdate"));
        var y = [], P = [], j = function(e) {
            var _$s = e;
            return e < 0 ? _$s = f.length + e : _$s >= f.length && (_$s -= f.length), _$s;
        };
        if (e) t.slides.filter(function(e) {
            return e.matches(".".concat(t.params.slideClass, ", swiper-slide"));
        }).forEach(function(e) {
            e.remove();
        });
        else for(var _$e = p; _$e <= h; _$e += 1)_loop(_$e);
        var C = d ? -f.length : 0, G = d ? 2 * f.length : f.length;
        for(var _$s = C; _$s < G; _$s += 1)if (_$s >= S && _$s <= b) {
            var t1 = j(_$s);
            void 0 === h || e ? P.push(t1) : (_$s > h && P.push(t1), _$s < p && y.push(t1));
        }
        if (P.forEach(function(e) {
            t.slidesEl.append(n(f[e], e));
        }), d) for(var _$e1 = y.length - 1; _$e1 >= 0; _$e1 -= 1){
            var _$s1 = y[_$e1];
            t.slidesEl.prepend(n(f[_$s1], _$s1));
        }
        else y.sort(function(e, s) {
            return s - e;
        }), y.forEach(function(e) {
            t.slidesEl.prepend(n(f[e], e));
        });
        (0, $3d818fcc5f3623ef$export$f1e1789686576879)(t.slidesEl, ".swiper-slide, swiper-slide").forEach(function(e) {
            e.style[E] = A - Math.abs(t.cssOverflowAdjustment()) + "px";
        }), M();
    }
    r("beforeInit", function() {
        if (!t.params.virtual.enabled) return;
        var _$e;
        if (void 0 === t.passedParams.virtual.slides) {
            var s = (0, $1961f7bca441a4c6$export$71511d61b312f219)(t.slidesEl.children).filter(function(e) {
                return e.matches(".".concat(t.params.slideClass, ", swiper-slide"));
            });
            s && s.length && (t.virtual.slides = (0, $1961f7bca441a4c6$export$71511d61b312f219)(s), _$e = !0, s.forEach(function(e, s) {
                e.setAttribute("data-swiper-slide-index", s), t.virtual.cache[s] = e, e.remove();
            }));
        }
        _$e || (t.virtual.slides = t.params.virtual.slides), t.classNames.push("".concat(t.params.containerModifierClass, "virtual")), t.params.watchSlidesProgress = !0, t.originalParams.watchSlidesProgress = !0, c(!1, !0);
    }), r("setTranslate", function() {
        t.params.virtual.enabled && (t.params.cssMode && !t._immediateVirtual ? (clearTimeout(s), s = setTimeout(function() {
            c();
        }, 100)) : c());
    }), r("init update resize", function() {
        t.params.virtual.enabled && t.params.cssMode && (0, $3d818fcc5f3623ef$export$2408f22a0fab9ae5)(t.wrapperEl, "--swiper-virtual-size", "".concat(t.virtualSize, "px"));
    }), Object.assign(t.virtual, {
        appendSlide: function appendSlide(e) {
            if ("object" == (typeof e === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(e)) && "length" in e) for(var s = 0; s < e.length; s += 1)e[s] && t.virtual.slides.push(e[s]);
            else t.virtual.slides.push(e);
            c(!0);
        },
        prependSlide: function prependSlide(e) {
            var s = t.activeIndex;
            var i = s + 1, r = 1;
            if (Array.isArray(e)) {
                for(var s1 = 0; s1 < e.length; s1 += 1)e[s1] && t.virtual.slides.unshift(e[s1]);
                i = s + e.length, r = e.length;
            } else t.virtual.slides.unshift(e);
            if (t.params.virtual.cache) {
                var _$e = t.virtual.cache, s2 = {};
                Object.keys(_$e).forEach(function(t) {
                    var i = _$e[t], a = i.getAttribute("data-swiper-slide-index");
                    a && i.setAttribute("data-swiper-slide-index", parseInt(a, 10) + r), s2[parseInt(t, 10) + r] = i;
                }), t.virtual.cache = s2;
            }
            c(!0), t.slideTo(i, 0);
        },
        removeSlide: function removeSlide(e) {
            if (null == e) return;
            var s = t.activeIndex;
            if (Array.isArray(e)) for(var i = e.length - 1; i >= 0; i -= 1)t.params.virtual.cache && (delete t.virtual.cache[e[i]], Object.keys(t.virtual.cache).forEach(function(s) {
                s > e && (t.virtual.cache[s - 1] = t.virtual.cache[s], t.virtual.cache[s - 1].setAttribute("data-swiper-slide-index", s - 1), delete t.virtual.cache[s]);
            })), t.virtual.slides.splice(e[i], 1), e[i] < s && (s -= 1), s = Math.max(s, 0);
            else t.params.virtual.cache && (delete t.virtual.cache[e], Object.keys(t.virtual.cache).forEach(function(s) {
                s > e && (t.virtual.cache[s - 1] = t.virtual.cache[s], t.virtual.cache[s - 1].setAttribute("data-swiper-slide-index", s - 1), delete t.virtual.cache[s]);
            })), t.virtual.slides.splice(e, 1), e < s && (s -= 1), s = Math.max(s, 0);
            c(!0), t.slideTo(s, 0);
        },
        removeAllSlides: function removeAllSlides() {
            t.virtual.slides = [], t.params.virtual.cache && (t.virtual.cache = {}), c(!0), t.slideTo(0, 0);
        },
        update: c
    });
}




function $607eef6585fb7b7e$export$2e2bcd8739ae039(e) {
    var t = e.swiper, n = e.extendParams, a = e.on, r = e.emit;
    var l = (0, $650091777930d0d5$export$39b482c5e57630a8)(), i = (0, $650091777930d0d5$export$407448d2b89b1813)();
    function o(e) {
        if (!t.enabled) return;
        var n = t.rtlTranslate;
        var a = e;
        a.originalEvent && (a = a.originalEvent);
        var o = a.keyCode || a.charCode, _$s = t.params.keyboard.pageUpDown, _$d = _$s && 33 === o, f = _$s && 34 === o, m = 37 === o, b = 39 === o, c = 38 === o, p = 40 === o;
        if (!t.allowSlideNext && (t.isHorizontal() && b || t.isVertical() && p || f)) return !1;
        if (!t.allowSlidePrev && (t.isHorizontal() && m || t.isVertical() && c || _$d)) return !1;
        if (!(a.shiftKey || a.altKey || a.ctrlKey || a.metaKey || l.activeElement && l.activeElement.nodeName && ("input" === l.activeElement.nodeName.toLowerCase() || "textarea" === l.activeElement.nodeName.toLowerCase()))) {
            if (t.params.keyboard.onlyInViewport && (_$d || f || m || b || c || p)) {
                var _$e = !1;
                if ((0, $3d818fcc5f3623ef$export$407448d2b89b1813)(t.el, ".".concat(t.params.slideClass, ", swiper-slide")).length > 0 && 0 === (0, $3d818fcc5f3623ef$export$407448d2b89b1813)(t.el, ".".concat(t.params.slideActiveClass)).length) return;
                var a1 = t.el, r1 = a1.clientWidth, l1 = a1.clientHeight, o1 = i.innerWidth, _$s1 = i.innerHeight, _$d1 = (0, $3d818fcc5f3623ef$export$8b22cf2602fb60ce)(a1);
                n && (_$d1.left -= a1.scrollLeft);
                var f1 = [
                    [
                        _$d1.left,
                        _$d1.top
                    ],
                    [
                        _$d1.left + r1,
                        _$d1.top
                    ],
                    [
                        _$d1.left,
                        _$d1.top + l1
                    ],
                    [
                        _$d1.left + r1,
                        _$d1.top + l1
                    ]
                ];
                for(var t1 = 0; t1 < f1.length; t1 += 1){
                    var n1 = f1[t1];
                    if (n1[0] >= 0 && n1[0] <= o1 && n1[1] >= 0 && n1[1] <= _$s1) {
                        if (0 === n1[0] && 0 === n1[1]) continue;
                        _$e = !0;
                    }
                }
                if (!_$e) return;
            }
            t.isHorizontal() ? ((_$d || f || m || b) && (a.preventDefault ? a.preventDefault() : a.returnValue = !1), ((f || b) && !n || (_$d || m) && n) && t.slideNext(), ((_$d || m) && !n || (f || b) && n) && t.slidePrev()) : ((_$d || f || c || p) && (a.preventDefault ? a.preventDefault() : a.returnValue = !1), (f || p) && t.slideNext(), (_$d || c) && t.slidePrev()), r("keyPress", o);
        }
    }
    function s() {
        t.keyboard.enabled || (l.addEventListener("keydown", o), t.keyboard.enabled = !0);
    }
    function d() {
        t.keyboard.enabled && (l.removeEventListener("keydown", o), t.keyboard.enabled = !1);
    }
    t.keyboard = {
        enabled: !1
    }, n({
        keyboard: {
            enabled: !1,
            onlyInViewport: !0,
            pageUpDown: !0
        }
    }), a("init", function() {
        t.params.keyboard.enabled && s();
    }), a("destroy", function() {
        t.keyboard.enabled && d();
    }), Object.assign(t.keyboard, {
        enable: s,
        disable: d
    });
}




function $5928d7bd776b2661$export$2e2bcd8739ae039(e) {
    var t = e.swiper, a = e.extendParams, s = e.on, n = e.emit;
    var l = (0, $650091777930d0d5$export$407448d2b89b1813)();
    var i;
    a({
        mousewheel: {
            enabled: !1,
            releaseOnEdges: !1,
            invert: !1,
            forceToAxis: !1,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    }), t.mousewheel = {
        enabled: !1
    };
    var r, o = (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)();
    var d = [];
    function m() {
        t.enabled && (t.mouseEntered = !0);
    }
    function p() {
        t.enabled && (t.mouseEntered = !1);
    }
    function u(e) {
        return !(t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta) && !(t.params.mousewheel.thresholdTime && (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)() - o < t.params.mousewheel.thresholdTime) && (e.delta >= 6 && (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)() - o < 60 || (e.direction < 0 ? t.isEnd && !t.params.loop || t.animating || (t.slideNext(), n("scroll", e.raw)) : t.isBeginning && !t.params.loop || t.animating || (t.slidePrev(), n("scroll", e.raw)), o = (new l.Date).getTime(), !1));
    }
    function h(e) {
        var a = e, s = !0;
        if (!t.enabled) return;
        if (e.target.closest(".".concat(t.params.mousewheel.noMousewheelClass))) return;
        var l = t.params.mousewheel;
        t.params.cssMode && a.preventDefault();
        var o = t.el;
        "container" !== t.params.mousewheel.eventsTarget && (o = document.querySelector(t.params.mousewheel.eventsTarget));
        var m = o && o.contains(a.target);
        if (!t.mouseEntered && !m && !l.releaseOnEdges) return !0;
        a.originalEvent && (a = a.originalEvent);
        var p = 0;
        var h = t.rtlTranslate ? -1 : 1, c = function(e) {
            var t = 0, a = 0, s = 0, n = 0;
            return "detail" in e && (a = e.detail), "wheelDelta" in e && (a = -e.wheelDelta / 120), "wheelDeltaY" in e && (a = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (t = a, a = 0), s = 10 * t, n = 10 * a, "deltaY" in e && (n = e.deltaY), "deltaX" in e && (s = e.deltaX), e.shiftKey && !s && (s = n, n = 0), (s || n) && e.deltaMode && (1 === e.deltaMode ? (s *= 40, n *= 40) : (s *= 800, n *= 800)), s && !t && (t = s < 1 ? -1 : 1), n && !a && (a = n < 1 ? -1 : 1), {
                spinX: t,
                spinY: a,
                pixelX: s,
                pixelY: n
            };
        }(a);
        if (l.forceToAxis) {
            if (t.isHorizontal()) {
                if (!(Math.abs(c.pixelX) > Math.abs(c.pixelY))) return !0;
                p = -c.pixelX * h;
            } else {
                if (!(Math.abs(c.pixelY) > Math.abs(c.pixelX))) return !0;
                p = -c.pixelY;
            }
        } else p = Math.abs(c.pixelX) > Math.abs(c.pixelY) ? -c.pixelX * h : -c.pixelY;
        if (0 === p) return !0;
        l.invert && (p = -p);
        var _$w = t.getTranslate() + p * l.sensitivity;
        if (_$w >= t.minTranslate() && (_$w = t.minTranslate()), _$w <= t.maxTranslate() && (_$w = t.maxTranslate()), s = !!t.params.loop || !(_$w === t.minTranslate() || _$w === t.maxTranslate()), s && t.params.nested && a.stopPropagation(), t.params.freeMode && t.params.freeMode.enabled) {
            var _$e = {
                time: (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)(),
                delta: Math.abs(p),
                direction: Math.sign(p)
            }, s1 = r && _$e.time < r.time + 500 && _$e.delta <= r.delta && _$e.direction === r.direction;
            if (!s1) {
                r = void 0;
                var o1 = t.getTranslate() + p * l.sensitivity;
                var m1 = t.isBeginning, _$u = t.isEnd;
                if (o1 >= t.minTranslate() && (o1 = t.minTranslate()), o1 <= t.maxTranslate() && (o1 = t.maxTranslate()), t.setTransition(0), t.setTranslate(o1), t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses(), (!m1 && t.isBeginning || !_$u && t.isEnd) && t.updateSlidesClasses(), t.params.loop && t.loopFix({
                    direction: _$e.direction < 0 ? "next" : "prev",
                    byMousewheel: !0
                }), t.params.freeMode.sticky) {
                    clearTimeout(i), i = void 0, d.length >= 15 && d.shift();
                    var a1 = d.length ? d[d.length - 1] : void 0, s2 = d[0];
                    if (d.push(_$e), a1 && (_$e.delta > a1.delta || _$e.direction !== a1.direction)) d.splice(0);
                    else if (d.length >= 15 && _$e.time - s2.time < 500 && s2.delta - _$e.delta >= 1 && _$e.delta <= 6) {
                        var a2 = p > 0 ? .8 : .2;
                        r = _$e, d.splice(0), i = (0, $3d818fcc5f3623ef$export$7ccc53e8f1e7dfc5)(function() {
                            !t.destroyed && t.params && t.slideToClosest(t.params.speed, !0, void 0, a2);
                        }, 0);
                    }
                    i || (i = (0, $3d818fcc5f3623ef$export$7ccc53e8f1e7dfc5)(function() {
                        if (t.destroyed || !t.params) return;
                        r = _$e, d.splice(0), t.slideToClosest(t.params.speed, !0, void 0, .5);
                    }, 500));
                }
                if (s1 || n("scroll", a), t.params.autoplay && t.params.autoplayDisableOnInteraction && t.autoplay.stop(), l.releaseOnEdges && (o1 === t.minTranslate() || o1 === t.maxTranslate())) return !0;
            }
        } else {
            var a3 = {
                time: (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)(),
                delta: Math.abs(p),
                direction: Math.sign(p),
                raw: e
            };
            d.length >= 2 && d.shift();
            var s3 = d.length ? d[d.length - 1] : void 0;
            if (d.push(a3), s3 ? (a3.direction !== s3.direction || a3.delta > s3.delta || a3.time > s3.time + 150) && u(a3) : u(a3), function(e) {
                var a = t.params.mousewheel;
                if (e.direction < 0) {
                    if (t.isEnd && !t.params.loop && a.releaseOnEdges) return !0;
                } else if (t.isBeginning && !t.params.loop && a.releaseOnEdges) return !0;
                return !1;
            }(a3)) return !0;
        }
        return a.preventDefault ? a.preventDefault() : a.returnValue = !1, !1;
    }
    function c(e) {
        var a = t.el;
        "container" !== t.params.mousewheel.eventsTarget && (a = document.querySelector(t.params.mousewheel.eventsTarget)), a[e]("mouseenter", m), a[e]("mouseleave", p), a[e]("wheel", h);
    }
    function w() {
        return t.params.cssMode ? (t.wrapperEl.removeEventListener("wheel", h), !0) : !t.mousewheel.enabled && (c("addEventListener"), t.mousewheel.enabled = !0, !0);
    }
    function f() {
        return t.params.cssMode ? (t.wrapperEl.addEventListener(event, h), !0) : !!t.mousewheel.enabled && (c("removeEventListener"), t.mousewheel.enabled = !1, !0);
    }
    s("init", function() {
        !t.params.mousewheel.enabled && t.params.cssMode && f(), t.params.mousewheel.enabled && w();
    }), s("destroy", function() {
        t.params.cssMode && w(), t.mousewheel.enabled && f();
    }), Object.assign(t.mousewheel, {
        enable: w,
        disable: f
    });
}




function $a393b6449813307b$export$db3b6bfb95261072(e, t, n, a) {
    return e.params.createElements && Object.keys(a).forEach(function(l) {
        if (!n[l] && !0 === n.auto) {
            var r = (0, $3d818fcc5f3623ef$export$f1e1789686576879)(e.el, ".".concat(a[l]))[0];
            r || (r = (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("div", a[l]), r.className = a[l], e.el.append(r)), n[l] = r, t[l] = r;
        }
    }), n;
}



function $2acb5e3868b1053e$export$2e2bcd8739ae039(a) {
    var e = a.swiper, n = a.extendParams, i = a.on, t = a.emit;
    function s(a) {
        var n;
        return a && "string" == typeof a && e.isElement && (n = e.el.querySelector(a) || e.hostEl.querySelector(a), n) ? n : (a && ("string" == typeof a && (n = (0, $1961f7bca441a4c6$export$71511d61b312f219)(document.querySelectorAll(a))), e.params.uniqueNavElements && "string" == typeof a && n && n.length > 1 && 1 === e.el.querySelectorAll(a).length ? n = e.el.querySelector(a) : n && 1 === n.length && (n = n[0])), a && !n ? a : n);
    }
    function l(a, n) {
        var i = e.params.navigation;
        (a = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(a)).forEach(function(a) {
            var _a_classList;
            a && ((_a_classList = a.classList)[n ? "add" : "remove"].apply(_a_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(i.disabledClass.split(" "))), "BUTTON" === a.tagName && (a.disabled = n), e.params.watchOverflow && e.enabled && a.classList[e.isLocked ? "add" : "remove"](i.lockClass));
        });
    }
    function r() {
        var _e_navigation = e.navigation, _$a = _e_navigation.nextEl, n = _e_navigation.prevEl;
        if (e.params.loop) return l(n, !1), void l(_$a, !1);
        l(n, e.isBeginning && !e.params.rewind), l(_$a, e.isEnd && !e.params.rewind);
    }
    function o(a) {
        a.preventDefault(), (!e.isBeginning || e.params.loop || e.params.rewind) && (e.slidePrev(), t("navigationPrev"));
    }
    function d(a) {
        a.preventDefault(), (!e.isEnd || e.params.loop || e.params.rewind) && (e.slideNext(), t("navigationNext"));
    }
    function c() {
        var _$a = e.params.navigation;
        if (e.params.navigation = (0, $a393b6449813307b$export$db3b6bfb95261072)(e, e.originalParams.navigation, e.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        }), !_$a.nextEl && !_$a.prevEl) return;
        var n = s(_$a.nextEl), i = s(_$a.prevEl);
        Object.assign(e.navigation, {
            nextEl: n,
            prevEl: i
        }), n = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(n), i = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(i);
        var t = function(n, i) {
            var _n_classList;
            n && n.addEventListener("click", "next" === i ? d : o), !e.enabled && n && (_n_classList = n.classList).add.apply(_n_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(_$a.lockClass.split(" ")));
        };
        n.forEach(function(a) {
            return t(a, "next");
        }), i.forEach(function(a) {
            return t(a, "prev");
        });
    }
    function m() {
        var _e_navigation = e.navigation, _$a = _e_navigation.nextEl, n = _e_navigation.prevEl;
        _$a = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(_$a), n = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(n);
        var i = function(a, n) {
            var _a_classList;
            a.removeEventListener("click", "next" === n ? d : o), (_a_classList = a.classList).remove.apply(_a_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(e.params.navigation.disabledClass.split(" ")));
        };
        _$a.forEach(function(a) {
            return i(a, "next");
        }), n.forEach(function(a) {
            return i(a, "prev");
        });
    }
    n({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    }), e.navigation = {
        nextEl: null,
        prevEl: null
    }, i("init", function() {
        !1 === e.params.navigation.enabled ? p() : (c(), r());
    }), i("toEdge fromEdge lock unlock", function() {
        r();
    }), i("destroy", function() {
        m();
    }), i("enable disable", function() {
        var _e_navigation = e.navigation, _$a = _e_navigation.nextEl, n = _e_navigation.prevEl;
        _$a = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(_$a), n = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(n), e.enabled ? r() : (0, $1961f7bca441a4c6$export$71511d61b312f219)(_$a).concat((0, $1961f7bca441a4c6$export$71511d61b312f219)(n)).filter(function(a) {
            return !!a;
        }).forEach(function(a) {
            return a.classList.add(e.params.navigation.lockClass);
        });
    }), i("click", function(a, n) {
        var _e_navigation = e.navigation, i = _e_navigation.nextEl, s = _e_navigation.prevEl;
        i = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(i), s = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(s);
        var l = n.target;
        var _$r = s.includes(l) || i.includes(l);
        if (e.isElement && !_$r) {
            var _$a = n.path || n.composedPath && n.composedPath();
            _$a && (_$r = _$a.find(function(a) {
                return i.includes(a) || s.includes(a);
            }));
        }
        if (e.params.navigation.hideOnClick && !_$r) {
            if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === l || e.pagination.el.contains(l))) return;
            var _$a1;
            i.length ? _$a1 = i[0].classList.contains(e.params.navigation.hiddenClass) : s.length && (_$a1 = s[0].classList.contains(e.params.navigation.hiddenClass)), t(!0 === _$a1 ? "navigationShow" : "navigationHide"), (0, $1961f7bca441a4c6$export$71511d61b312f219)(i).concat((0, $1961f7bca441a4c6$export$71511d61b312f219)(s)).filter(function(a) {
                return !!a;
            }).forEach(function(a) {
                return a.classList.toggle(e.params.navigation.hiddenClass);
            });
        }
    });
    var p = function() {
        var _e_el_classList;
        (_e_el_classList = e.el.classList).add.apply(_e_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(e.params.navigation.navigationDisabledClass.split(" "))), m();
    };
    Object.assign(e.navigation, {
        enable: function() {
            var _e_el_classList;
            (_e_el_classList = e.el.classList).remove.apply(_e_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(e.params.navigation.navigationDisabledClass.split(" "))), c(), r();
        },
        disable: p,
        update: r,
        init: c,
        destroy: m
    });
}



function $0e48cc04843c0fec$export$db3b6bfb95261072(e) {
    return void 0 === e && (e = ""), ".".concat(e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, "."));
}




function $0ff460f2e2cdf036$export$2e2bcd8739ae039(e) {
    var a = e.swiper, s = e.extendParams, l = e.on, t = e.emit;
    var i = "swiper-pagination";
    var n;
    s({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(e) {
                return e;
            },
            formatFractionTotal: function(e) {
                return e;
            },
            bulletClass: "".concat(i, "-bullet"),
            bulletActiveClass: "".concat(i, "-bullet-active"),
            modifierClass: "".concat(i, "-"),
            currentClass: "".concat(i, "-current"),
            totalClass: "".concat(i, "-total"),
            hiddenClass: "".concat(i, "-hidden"),
            progressbarFillClass: "".concat(i, "-progressbar-fill"),
            progressbarOppositeClass: "".concat(i, "-progressbar-opposite"),
            clickableClass: "".concat(i, "-clickable"),
            lockClass: "".concat(i, "-lock"),
            horizontalClass: "".concat(i, "-horizontal"),
            verticalClass: "".concat(i, "-vertical"),
            paginationDisabledClass: "".concat(i, "-disabled")
        }
    }), a.pagination = {
        el: null,
        bullets: []
    };
    var r = 0;
    function o() {
        return !a.params.pagination.el || !a.pagination.el || Array.isArray(a.pagination.el) && 0 === a.pagination.el.length;
    }
    function p(e, s) {
        var _a_params_pagination = a.params.pagination, l = _a_params_pagination.bulletActiveClass;
        e && (e = e[("prev" === s ? "previous" : "next") + "ElementSibling"]) && (e.classList.add("".concat(l, "-").concat(s)), (e = e[("prev" === s ? "previous" : "next") + "ElementSibling"]) && e.classList.add("".concat(l, "-").concat(s, "-").concat(s)));
    }
    function c(e) {
        var s = e.target.closest((0, $0e48cc04843c0fec$export$db3b6bfb95261072)(a.params.pagination.bulletClass));
        if (!s) return;
        e.preventDefault();
        var l = (0, $3d818fcc5f3623ef$export$dda1d9f60106f0e9)(s) * a.params.slidesPerGroup;
        if (a.params.loop) {
            if (a.realIndex === l) return;
            var _$e = (t = a.realIndex, i = l, n = a.slides.length, (i %= n) == 1 + (t %= n) ? "next" : i === t - 1 ? "previous" : void 0);
            "next" === _$e ? a.slideNext() : "previous" === _$e ? a.slidePrev() : a.slideToLoop(l);
        } else a.slideTo(l);
        var t, i, n;
    }
    function d() {
        var _$e = a.rtl, s = a.params.pagination;
        if (o()) return;
        var l, i, c = a.pagination.el;
        c = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(c);
        var _$d = a.virtual && a.params.virtual.enabled ? a.virtual.slides.length : a.slides.length, _$m = a.params.loop ? Math.ceil(_$d / a.params.slidesPerGroup) : a.snapGrid.length;
        if (a.params.loop ? (i = a.previousRealIndex || 0, l = a.params.slidesPerGroup > 1 ? Math.floor(a.realIndex / a.params.slidesPerGroup) : a.realIndex) : void 0 !== a.snapIndex ? (l = a.snapIndex, i = a.previousSnapIndex) : (i = a.previousIndex || 0, l = a.activeIndex || 0), "bullets" === s.type && a.pagination.bullets && a.pagination.bullets.length > 0) {
            var t1 = a.pagination.bullets;
            var _$o, _$d1, _$m1;
            if (s.dynamicBullets && (n = (0, $3d818fcc5f3623ef$export$2d1720544b23b823)(t1[0], a.isHorizontal() ? "width" : "height", !0), c.forEach(function(e) {
                e.style[a.isHorizontal() ? "width" : "height"] = n * (s.dynamicMainBullets + 4) + "px";
            }), s.dynamicMainBullets > 1 && void 0 !== i && (r += l - (i || 0), r > s.dynamicMainBullets - 1 ? r = s.dynamicMainBullets - 1 : r < 0 && (r = 0)), _$o = Math.max(l - r, 0), _$d1 = _$o + (Math.min(t1.length, s.dynamicMainBullets) - 1), _$m1 = (_$d1 + _$o) / 2), t1.forEach(function(e) {
                var _e_classList;
                var a = (0, $1961f7bca441a4c6$export$71511d61b312f219)([
                    "",
                    "-next",
                    "-next-next",
                    "-prev",
                    "-prev-prev",
                    "-main"
                ].map(function(e) {
                    return "".concat(s.bulletActiveClass).concat(e);
                })).map(function(e) {
                    return "string" == typeof e && e.includes(" ") ? e.split(" ") : e;
                }).flat();
                (_e_classList = e.classList).remove.apply(_e_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(a));
            }), c.length > 1) t1.forEach(function(e) {
                var _e_classList, _e_classList1;
                var t = (0, $3d818fcc5f3623ef$export$dda1d9f60106f0e9)(e);
                t === l ? (_e_classList = e.classList).add.apply(_e_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(s.bulletActiveClass.split(" "))) : a.isElement && e.setAttribute("part", "bullet"), s.dynamicBullets && (t >= _$o && t <= _$d1 && (_e_classList1 = e.classList).add.apply(_e_classList1, (0, $1961f7bca441a4c6$export$71511d61b312f219)("".concat(s.bulletActiveClass, "-main").split(" "))), t === _$o && p(e, "prev"), t === _$d1 && p(e, "next"));
            });
            else {
                var _e_classList;
                var _$e1 = t1[l];
                if (_$e1 && (_e_classList = _$e1.classList).add.apply(_e_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(s.bulletActiveClass.split(" "))), a.isElement && t1.forEach(function(e, a) {
                    e.setAttribute("part", a === l ? "bullet-active" : "bullet");
                }), s.dynamicBullets) {
                    var _t_e_classList;
                    var _$e2 = t1[_$o], a1 = t1[_$d1];
                    for(var _$e3 = _$o; _$e3 <= _$d1; _$e3 += 1)t1[_$e3] && (_t_e_classList = t1[_$e3].classList).add.apply(_t_e_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)("".concat(s.bulletActiveClass, "-main").split(" ")));
                    p(_$e2, "prev"), p(a1, "next");
                }
            }
            if (s.dynamicBullets) {
                var l1 = Math.min(t1.length, s.dynamicMainBullets + 4), i1 = (n * l1 - n) / 2 - _$m1 * n, r1 = _$e ? "right" : "left";
                t1.forEach(function(e) {
                    e.style[a.isHorizontal() ? r1 : "top"] = "".concat(i1, "px");
                });
            }
        }
        c.forEach(function(e, i) {
            if ("fraction" === s.type && (e.querySelectorAll((0, $0e48cc04843c0fec$export$db3b6bfb95261072)(s.currentClass)).forEach(function(e) {
                e.textContent = s.formatFractionCurrent(l + 1);
            }), e.querySelectorAll((0, $0e48cc04843c0fec$export$db3b6bfb95261072)(s.totalClass)).forEach(function(e) {
                e.textContent = s.formatFractionTotal(_$m);
            })), "progressbar" === s.type) {
                var t1;
                t1 = s.progressbarOpposite ? a.isHorizontal() ? "vertical" : "horizontal" : a.isHorizontal() ? "horizontal" : "vertical";
                var _$i = (l + 1) / _$m;
                var n = 1, r = 1;
                "horizontal" === t1 ? n = _$i : r = _$i, e.querySelectorAll((0, $0e48cc04843c0fec$export$db3b6bfb95261072)(s.progressbarFillClass)).forEach(function(e) {
                    e.style.transform = "translate3d(0,0,0) scaleX(".concat(n, ") scaleY(").concat(r, ")"), e.style.transitionDuration = "".concat(a.params.speed, "ms");
                });
            }
            "custom" === s.type && s.renderCustom ? (e.innerHTML = s.renderCustom(a, l + 1, _$m), 0 === i && t("paginationRender", e)) : (0 === i && t("paginationRender", e), t("paginationUpdate", e)), a.params.watchOverflow && a.enabled && e.classList[a.isLocked ? "add" : "remove"](s.lockClass);
        });
    }
    function m() {
        var _$e = a.params.pagination;
        if (o()) return;
        var s = a.virtual && a.params.virtual.enabled ? a.virtual.slides.length : a.grid && a.params.grid.rows > 1 ? a.slides.length / Math.ceil(a.params.grid.rows) : a.slides.length;
        var l = a.pagination.el;
        l = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(l);
        var i = "";
        if ("bullets" === _$e.type) {
            var l1 = a.params.loop ? Math.ceil(s / a.params.slidesPerGroup) : a.snapGrid.length;
            a.params.freeMode && a.params.freeMode.enabled && l1 > s && (l1 = s);
            for(var s1 = 0; s1 < l1; s1 += 1)_$e.renderBullet ? i += _$e.renderBullet.call(a, s1, _$e.bulletClass) : i += "<".concat(_$e.bulletElement, " ").concat(a.isElement ? 'part="bullet"' : "", ' class="').concat(_$e.bulletClass, '"></').concat(_$e.bulletElement, ">");
        }
        "fraction" === _$e.type && (i = _$e.renderFraction ? _$e.renderFraction.call(a, _$e.currentClass, _$e.totalClass) : '<span class="'.concat(_$e.currentClass, '"></span> / <span class="').concat(_$e.totalClass, '"></span>')), "progressbar" === _$e.type && (i = _$e.renderProgressbar ? _$e.renderProgressbar.call(a, _$e.progressbarFillClass) : '<span class="'.concat(_$e.progressbarFillClass, '"></span>')), a.pagination.bullets = [], l.forEach(function(s) {
            var _a_pagination_bullets;
            "custom" !== _$e.type && (s.innerHTML = i || ""), "bullets" === _$e.type && (_a_pagination_bullets = a.pagination.bullets).push.apply(_a_pagination_bullets, (0, $1961f7bca441a4c6$export$71511d61b312f219)(s.querySelectorAll((0, $0e48cc04843c0fec$export$db3b6bfb95261072)(_$e.bulletClass))));
        }), "custom" !== _$e.type && t("paginationRender", l[0]);
    }
    function u() {
        a.params.pagination = (0, $a393b6449813307b$export$db3b6bfb95261072)(a, a.originalParams.pagination, a.params.pagination, {
            el: "swiper-pagination"
        });
        var _$e = a.params.pagination;
        if (!_$e.el) return;
        var s;
        "string" == typeof _$e.el && a.isElement && (s = a.el.querySelector(_$e.el)), s || "string" != typeof _$e.el || (s = (0, $1961f7bca441a4c6$export$71511d61b312f219)(document.querySelectorAll(_$e.el))), s || (s = _$e.el), s && 0 !== s.length && (a.params.uniqueNavElements && "string" == typeof _$e.el && Array.isArray(s) && s.length > 1 && (s = (0, $1961f7bca441a4c6$export$71511d61b312f219)(a.el.querySelectorAll(_$e.el)), s.length > 1 && (s = s.filter(function(e) {
            return (0, $3d818fcc5f3623ef$export$407448d2b89b1813)(e, ".swiper")[0] === a.el;
        })[0])), Array.isArray(s) && 1 === s.length && (s = s[0]), Object.assign(a.pagination, {
            el: s
        }), s = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(s), s.forEach(function(s) {
            var _s_classList;
            "bullets" === _$e.type && _$e.clickable && (_s_classList = s.classList).add.apply(_s_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((_$e.clickableClass || "").split(" "))), s.classList.add(_$e.modifierClass + _$e.type), s.classList.add(a.isHorizontal() ? _$e.horizontalClass : _$e.verticalClass), "bullets" === _$e.type && _$e.dynamicBullets && (s.classList.add("".concat(_$e.modifierClass).concat(_$e.type, "-dynamic")), r = 0, _$e.dynamicMainBullets < 1 && (_$e.dynamicMainBullets = 1)), "progressbar" === _$e.type && _$e.progressbarOpposite && s.classList.add(_$e.progressbarOppositeClass), _$e.clickable && s.addEventListener("click", c), a.enabled || s.classList.add(_$e.lockClass);
        }));
    }
    function g() {
        var _a_classList;
        var _$e = a.params.pagination;
        if (o()) return;
        var s = a.pagination.el;
        s && (s = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(s), s.forEach(function(s) {
            var _s_classList;
            s.classList.remove(_$e.hiddenClass), s.classList.remove(_$e.modifierClass + _$e.type), s.classList.remove(a.isHorizontal() ? _$e.horizontalClass : _$e.verticalClass), _$e.clickable && ((_s_classList = s.classList).remove.apply(_s_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((_$e.clickableClass || "").split(" "))), s.removeEventListener("click", c));
        })), a.pagination.bullets && a.pagination.bullets.forEach(function(a) {
            return (_a_classList = a.classList).remove.apply(_a_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(_$e.bulletActiveClass.split(" ")));
        });
    }
    l("changeDirection", function() {
        if (!a.pagination || !a.pagination.el) return;
        var _$e = a.params.pagination;
        var _a_pagination = a.pagination, s = _a_pagination.el;
        s = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(s), s.forEach(function(s) {
            s.classList.remove(_$e.horizontalClass, _$e.verticalClass), s.classList.add(a.isHorizontal() ? _$e.horizontalClass : _$e.verticalClass);
        });
    }), l("init", function() {
        !1 === a.params.pagination.enabled ? b() : (u(), m(), d());
    }), l("activeIndexChange", function() {
        void 0 === a.snapIndex && d();
    }), l("snapIndexChange", function() {
        d();
    }), l("snapGridLengthChange", function() {
        m(), d();
    }), l("destroy", function() {
        g();
    }), l("enable disable", function() {
        var _a_pagination = a.pagination, _$e = _a_pagination.el;
        _$e && (_$e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(_$e), _$e.forEach(function(e) {
            return e.classList[a.enabled ? "remove" : "add"](a.params.pagination.lockClass);
        }));
    }), l("lock unlock", function() {
        d();
    }), l("click", function(e, s) {
        var l = s.target, i = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(a.pagination.el);
        if (a.params.pagination.el && a.params.pagination.hideOnClick && i && i.length > 0 && !l.classList.contains(a.params.pagination.bulletClass)) {
            if (a.navigation && (a.navigation.nextEl && l === a.navigation.nextEl || a.navigation.prevEl && l === a.navigation.prevEl)) return;
            var _$e = i[0].classList.contains(a.params.pagination.hiddenClass);
            t(!0 === _$e ? "paginationShow" : "paginationHide"), i.forEach(function(e) {
                return e.classList.toggle(a.params.pagination.hiddenClass);
            });
        }
    });
    var b = function() {
        a.el.classList.add(a.params.pagination.paginationDisabledClass);
        var _a_pagination = a.pagination, _$e = _a_pagination.el;
        _$e && (_$e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(_$e), _$e.forEach(function(e) {
            return e.classList.add(a.params.pagination.paginationDisabledClass);
        })), g();
    };
    Object.assign(a.pagination, {
        enable: function() {
            a.el.classList.remove(a.params.pagination.paginationDisabledClass);
            var _a_pagination = a.pagination, _$e = _a_pagination.el;
            _$e && (_$e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(_$e), _$e.forEach(function(e) {
                return e.classList.remove(a.params.pagination.paginationDisabledClass);
            })), u(), m(), d();
        },
        disable: b,
        render: m,
        update: d,
        init: u,
        destroy: g
    });
}







function $af4e7a815fd0758b$export$2e2bcd8739ae039(s) {
    var l = s.swiper, e = s.extendParams, a = s.on, r = s.emit;
    var t = (0, $650091777930d0d5$export$39b482c5e57630a8)();
    var o, n, i, c, p = !1, m = null, d = null;
    function b() {
        if (!l.params.scrollbar.el || !l.scrollbar.el) return;
        var _$s = l.scrollbar, e = l.rtlTranslate, a = _$s.dragEl, r = _$s.el, t = l.params.scrollbar, o = l.params.loop ? l.progressLoop : l.progress;
        var c = n, p = (i - n) * o;
        e ? (p = -p, p > 0 ? (c = n - p, p = 0) : -p + n > i && (c = i + p)) : p < 0 ? (c = n + p, p = 0) : p + n > i && (c = i - p), l.isHorizontal() ? (a.style.transform = "translate3d(".concat(p, "px, 0, 0)"), a.style.width = "".concat(c, "px")) : (a.style.transform = "translate3d(0px, ".concat(p, "px, 0)"), a.style.height = "".concat(c, "px")), t.hide && (clearTimeout(m), r.style.opacity = 1, m = setTimeout(function() {
            r.style.opacity = 0, r.style.transitionDuration = "400ms";
        }, 1e3));
    }
    function u() {
        if (!l.params.scrollbar.el || !l.scrollbar.el) return;
        var _$s = l.scrollbar, e = _$s.dragEl, a = _$s.el;
        e.style.width = "", e.style.height = "", i = l.isHorizontal() ? a.offsetWidth : a.offsetHeight, c = l.size / (l.virtualSize + l.params.slidesOffsetBefore - (l.params.centeredSlides ? l.snapGrid[0] : 0)), n = "auto" === l.params.scrollbar.dragSize ? i * c : parseInt(l.params.scrollbar.dragSize, 10), l.isHorizontal() ? e.style.width = "".concat(n, "px") : e.style.height = "".concat(n, "px"), a.style.display = c >= 1 ? "none" : "", l.params.scrollbar.hide && (a.style.opacity = 0), l.params.watchOverflow && l.enabled && _$s.el.classList[l.isLocked ? "add" : "remove"](l.params.scrollbar.lockClass);
    }
    function f(s) {
        return l.isHorizontal() ? s.clientX : s.clientY;
    }
    function g(s) {
        var e = l.scrollbar, a = l.rtlTranslate, r = e.el;
        var t;
        t = (f(s) - (0, $3d818fcc5f3623ef$export$8b22cf2602fb60ce)(r)[l.isHorizontal() ? "left" : "top"] - (null !== o ? o : n / 2)) / (i - n), t = Math.max(Math.min(t, 1), 0), a && (t = 1 - t);
        var c = l.minTranslate() + (l.maxTranslate() - l.minTranslate()) * t;
        l.updateProgress(c), l.setTranslate(c), l.updateActiveIndex(), l.updateSlidesClasses();
    }
    function y(s) {
        var e = l.params.scrollbar, a = l.scrollbar, t = l.wrapperEl, n = a.el, i = a.dragEl;
        p = !0, o = s.target === i ? f(s) - s.target.getBoundingClientRect()[l.isHorizontal() ? "left" : "top"] : null, s.preventDefault(), s.stopPropagation(), t.style.transitionDuration = "100ms", i.style.transitionDuration = "100ms", g(s), clearTimeout(d), n.style.transitionDuration = "0ms", e.hide && (n.style.opacity = 1), l.params.cssMode && (l.wrapperEl.style["scroll-snap-type"] = "none"), r("scrollbarDragStart", s);
    }
    function h(s) {
        var e = l.scrollbar, a = l.wrapperEl, t = e.el, o = e.dragEl;
        p && (s.preventDefault && s.cancelable ? s.preventDefault() : s.returnValue = !1, g(s), a.style.transitionDuration = "0ms", t.style.transitionDuration = "0ms", o.style.transitionDuration = "0ms", r("scrollbarDragMove", s));
    }
    function T(s) {
        var e = l.params.scrollbar, a = l.scrollbar, t = l.wrapperEl, o = a.el;
        p && (p = !1, l.params.cssMode && (l.wrapperEl.style["scroll-snap-type"] = "", t.style.transitionDuration = ""), e.hide && (clearTimeout(d), d = (0, $3d818fcc5f3623ef$export$7ccc53e8f1e7dfc5)(function() {
            o.style.opacity = 0, o.style.transitionDuration = "400ms";
        }, 1e3)), r("scrollbarDragEnd", s), e.snapOnRelease && l.slideToClosest());
    }
    function v(s) {
        var e = l.scrollbar, a = l.params, r = e.el;
        if (!r) return;
        var o = r, n = !!a.passiveListeners && {
            passive: !1,
            capture: !1
        }, i = !!a.passiveListeners && {
            passive: !0,
            capture: !1
        };
        if (!o) return;
        var c = "on" === s ? "addEventListener" : "removeEventListener";
        o[c]("pointerdown", y, n), t[c]("pointermove", h, n), t[c]("pointerup", T, i);
    }
    function D() {
        var _r_classList;
        var _$s = l.scrollbar, e = l.el;
        l.params.scrollbar = (0, $a393b6449813307b$export$db3b6bfb95261072)(l, l.originalParams.scrollbar, l.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        var a = l.params.scrollbar;
        if (!a.el) return;
        var r, o;
        if ("string" == typeof a.el && l.isElement && (r = l.el.querySelector(a.el)), r || "string" != typeof a.el) r || (r = a.el);
        else if (r = t.querySelectorAll(a.el), !r.length) return;
        l.params.uniqueNavElements && "string" == typeof a.el && r.length > 1 && 1 === e.querySelectorAll(a.el).length && (r = e.querySelector(a.el)), r.length > 0 && (r = r[0]), r.classList.add(l.isHorizontal() ? a.horizontalClass : a.verticalClass), r && (o = r.querySelector((0, $0e48cc04843c0fec$export$db3b6bfb95261072)(l.params.scrollbar.dragClass)), o || (o = (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("div", l.params.scrollbar.dragClass), r.append(o))), Object.assign(_$s, {
            el: r,
            dragEl: o
        }), a.draggable && l.params.scrollbar.el && l.scrollbar.el && v("on"), r && (_r_classList = r.classList)[l.enabled ? "remove" : "add"].apply(_r_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $3d818fcc5f3623ef$export$23f2a1d2818174ef)(l.params.scrollbar.lockClass)));
    }
    function C() {
        var _e_classList;
        var _$s = l.params.scrollbar, e = l.scrollbar.el;
        e && (_e_classList = e.classList).remove.apply(_e_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $3d818fcc5f3623ef$export$23f2a1d2818174ef)(l.isHorizontal() ? _$s.horizontalClass : _$s.verticalClass))), l.params.scrollbar.el && l.scrollbar.el && v("off");
    }
    e({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: !1,
            draggable: !1,
            snapOnRelease: !0,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: "swiper-scrollbar-horizontal",
            verticalClass: "swiper-scrollbar-vertical"
        }
    }), l.scrollbar = {
        el: null,
        dragEl: null
    }, a("changeDirection", function() {
        if (!l.scrollbar || !l.scrollbar.el) return;
        var _$s = l.params.scrollbar;
        var _l_scrollbar = l.scrollbar, e = _l_scrollbar.el;
        e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(e), e.forEach(function(e) {
            e.classList.remove(_$s.horizontalClass, _$s.verticalClass), e.classList.add(l.isHorizontal() ? _$s.horizontalClass : _$s.verticalClass);
        });
    }), a("init", function() {
        !1 === l.params.scrollbar.enabled ? E() : (D(), u(), b());
    }), a("update resize observerUpdate lock unlock changeDirection", function() {
        u();
    }), a("setTranslate", function() {
        b();
    }), a("setTransition", function(s, e) {
        !function(s) {
            l.params.scrollbar.el && l.scrollbar.el && (l.scrollbar.dragEl.style.transitionDuration = "".concat(s, "ms"));
        }(e);
    }), a("enable disable", function() {
        var _s_classList;
        var _l_scrollbar = l.scrollbar, _$s = _l_scrollbar.el;
        _$s && (_s_classList = _$s.classList)[l.enabled ? "remove" : "add"].apply(_s_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $3d818fcc5f3623ef$export$23f2a1d2818174ef)(l.params.scrollbar.lockClass)));
    }), a("destroy", function() {
        C();
    });
    var E = function() {
        var _l_el_classList, _l_scrollbar_el_classList;
        (_l_el_classList = l.el.classList).add.apply(_l_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $3d818fcc5f3623ef$export$23f2a1d2818174ef)(l.params.scrollbar.scrollbarDisabledClass))), l.scrollbar.el && (_l_scrollbar_el_classList = l.scrollbar.el.classList).add.apply(_l_scrollbar_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $3d818fcc5f3623ef$export$23f2a1d2818174ef)(l.params.scrollbar.scrollbarDisabledClass))), C();
    };
    Object.assign(l.scrollbar, {
        enable: function() {
            var _l_el_classList, _l_scrollbar_el_classList;
            (_l_el_classList = l.el.classList).remove.apply(_l_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $3d818fcc5f3623ef$export$23f2a1d2818174ef)(l.params.scrollbar.scrollbarDisabledClass))), l.scrollbar.el && (_l_scrollbar_el_classList = l.scrollbar.el.classList).remove.apply(_l_scrollbar_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $3d818fcc5f3623ef$export$23f2a1d2818174ef)(l.params.scrollbar.scrollbarDisabledClass))), D(), u(), b();
        },
        disable: E,
        updateSize: u,
        setTranslate: b,
        init: D,
        destroy: C
    });
}




function $3ca97b77ee35cc1e$export$2e2bcd8739ae039(a) {
    var e = a.swiper, t = a.extendParams, l = a.on;
    t({
        parallax: {
            enabled: !1
        }
    });
    var r = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", s = function(a, t) {
        var l = e.rtl, r = l ? -1 : 1, s = a.getAttribute("data-swiper-parallax") || "0";
        var i = a.getAttribute("data-swiper-parallax-x"), p = a.getAttribute("data-swiper-parallax-y");
        var n = a.getAttribute("data-swiper-parallax-scale"), o = a.getAttribute("data-swiper-parallax-opacity"), d = a.getAttribute("data-swiper-parallax-rotate");
        if (i || p ? (i = i || "0", p = p || "0") : e.isHorizontal() ? (i = s, p = "0") : (p = s, i = "0"), i = i.indexOf("%") >= 0 ? parseInt(i, 10) * t * r + "%" : i * t * r + "px", p = p.indexOf("%") >= 0 ? parseInt(p, 10) * t + "%" : p * t + "px", null != o) {
            var e1 = o - (o - 1) * (1 - Math.abs(t));
            a.style.opacity = e1;
        }
        var x = "translate3d(".concat(i, ", ").concat(p, ", 0px)");
        if (null != n) x += " scale(".concat(n - (n - 1) * (1 - Math.abs(t)), ")");
        if (d && null != d) x += " rotate(".concat(d * t * -1, "deg)");
        a.style.transform = x;
    }, i = function() {
        var _n;
        var _$a = e.el, t = e.slides, l = e.progress, i = e.snapGrid, p = e.isElement, n = (0, $3d818fcc5f3623ef$export$f1e1789686576879)(_$a, r);
        e.isElement && (_n = n).push.apply(_n, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $3d818fcc5f3623ef$export$f1e1789686576879)(e.hostEl, r))), n.forEach(function(a) {
            s(a, l);
        }), t.forEach(function(a, t) {
            var p = a.progress;
            e.params.slidesPerGroup > 1 && "auto" !== e.params.slidesPerView && (p += Math.ceil(t / 2) - l * (i.length - 1)), p = Math.min(Math.max(p, -1), 1), a.querySelectorAll("".concat(r, ", [data-swiper-parallax-rotate]")).forEach(function(a) {
                s(a, p);
            });
        });
    };
    l("beforeInit", function() {
        e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
    }), l("init", function() {
        e.params.parallax.enabled && i();
    }), l("setTranslate", function() {
        e.params.parallax.enabled && i();
    }), l("setTransition", function(a, t) {
        e.params.parallax.enabled && function(a) {
            var _s;
            void 0 === a && (a = e.params.speed);
            var _$t = e.el, l = e.hostEl, s = (0, $1961f7bca441a4c6$export$71511d61b312f219)(_$t.querySelectorAll(r));
            e.isElement && (_s = s).push.apply(_s, (0, $1961f7bca441a4c6$export$71511d61b312f219)(l.querySelectorAll(r))), s.forEach(function(e) {
                var _$t = parseInt(e.getAttribute("data-swiper-parallax-duration"), 10) || a;
                0 === a && (_$t = 0), e.style.transitionDuration = "".concat(_$t, "ms");
            });
        }(t);
    });
}






function $ef6e216fccc43749$export$2e2bcd8739ae039(e) {
    var t = e.swiper, i = e.extendParams, a = e.on, r = e.emit;
    var s = (0, $650091777930d0d5$export$407448d2b89b1813)();
    i({
        zoom: {
            enabled: !1,
            limitToOriginalSize: !1,
            maxRatio: 3,
            minRatio: 1,
            toggle: !0,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    }), t.zoom = {
        enabled: !1
    };
    var o, n, l = 1, m = !1;
    var c = [], d = {
        originX: 0,
        originY: 0,
        slideEl: void 0,
        slideWidth: void 0,
        slideHeight: void 0,
        imageEl: void 0,
        imageWrapEl: void 0,
        maxRatio: 3
    }, u = {
        isTouched: void 0,
        isMoved: void 0,
        currentX: void 0,
        currentY: void 0,
        minX: void 0,
        minY: void 0,
        maxX: void 0,
        maxY: void 0,
        width: void 0,
        height: void 0,
        startX: void 0,
        startY: void 0,
        touchesStart: {},
        touchesCurrent: {}
    }, p = {
        x: void 0,
        y: void 0,
        prevPositionX: void 0,
        prevPositionY: void 0,
        prevTime: void 0
    };
    var g, h = 1;
    function v() {
        if (c.length < 2) return 1;
        var _$e = c[0].pageX, t = c[0].pageY, i = c[1].pageX, a = c[1].pageY;
        return Math.sqrt(Math.pow(i - _$e, 2) + Math.pow(a - t, 2));
    }
    function E() {
        var _$e = t.params.zoom, i = d.imageWrapEl.getAttribute("data-swiper-zoom") || _$e.maxRatio;
        if (_$e.limitToOriginalSize && d.imageEl && d.imageEl.naturalWidth) {
            var _$e1 = d.imageEl.naturalWidth / d.imageEl.offsetWidth;
            return Math.min(_$e1, i);
        }
        return i;
    }
    function f(e) {
        var i = t.isElement ? "swiper-slide" : ".".concat(t.params.slideClass);
        return !!e.target.matches(i) || t.slides.filter(function(t) {
            return t.contains(e.target);
        }).length > 0;
    }
    function x(e) {
        if ("mouse" === e.pointerType && c.splice(0, c.length), !f(e)) return;
        var i = t.params.zoom;
        if (o = !1, n = !1, c.push(e), !(c.length < 2)) {
            if (o = !0, d.scaleStart = v(), !d.slideEl) {
                d.slideEl = e.target.closest(".".concat(t.params.slideClass, ", swiper-slide")), d.slideEl || (d.slideEl = t.slides[t.activeIndex]);
                var a = d.slideEl.querySelector(".".concat(i.containerClass));
                if (a && (a = a.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), d.imageEl = a, d.imageWrapEl = a ? (0, $3d818fcc5f3623ef$export$407448d2b89b1813)(d.imageEl, ".".concat(i.containerClass))[0] : void 0, !d.imageWrapEl) return void (d.imageEl = void 0);
                d.maxRatio = E();
            }
            if (d.imageEl) {
                var _ref = (0, $d98b89efad01a571$export$71511d61b312f219)(function() {
                    if (c.length < 2) return {
                        x: null,
                        y: null
                    };
                    var _$e = d.imageEl.getBoundingClientRect();
                    return [
                        (c[0].pageX + (c[1].pageX - c[0].pageX) / 2 - _$e.x - s.scrollX) / l,
                        (c[0].pageY + (c[1].pageY - c[0].pageY) / 2 - _$e.y - s.scrollY) / l
                    ];
                }(), 2), _$e = _ref[0], t1 = _ref[1];
                d.originX = _$e, d.originY = t1, d.imageEl.style.transitionDuration = "0ms";
            }
            m = !0;
        }
    }
    function y(e) {
        if (!f(e)) return;
        var i = t.params.zoom, a = t.zoom, r = c.findIndex(function(t) {
            return t.pointerId === e.pointerId;
        });
        r >= 0 && (c[r] = e), c.length < 2 || (n = !0, d.scaleMove = v(), d.imageEl && (a.scale = d.scaleMove / d.scaleStart * l, a.scale > d.maxRatio && (a.scale = d.maxRatio - 1 + Math.pow(a.scale - d.maxRatio + 1, .5)), a.scale < i.minRatio && (a.scale = i.minRatio + 1 - Math.pow(i.minRatio - a.scale + 1, .5)), d.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(a.scale, ")")));
    }
    function X(e) {
        if (!f(e)) return;
        if ("mouse" === e.pointerType && "pointerout" === e.type) return;
        var i = t.params.zoom, a = t.zoom, r = c.findIndex(function(t) {
            return t.pointerId === e.pointerId;
        });
        r >= 0 && c.splice(r, 1), o && n && (o = !1, n = !1, d.imageEl && (a.scale = Math.max(Math.min(a.scale, d.maxRatio), i.minRatio), d.imageEl.style.transitionDuration = "".concat(t.params.speed, "ms"), d.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(a.scale, ")"), l = a.scale, m = !1, a.scale > 1 && d.slideEl ? d.slideEl.classList.add("".concat(i.zoomedSlideClass)) : a.scale <= 1 && d.slideEl && d.slideEl.classList.remove("".concat(i.zoomedSlideClass)), 1 === a.scale && (d.originX = 0, d.originY = 0, d.slideEl = void 0)));
    }
    function Y() {
        t.touchEventsData.preventTouchMoveFromPointerMove = !1;
    }
    function z(e) {
        if (!f(e) || !function(e) {
            var i = ".".concat(t.params.zoom.containerClass);
            return !!e.target.matches(i) || (0, $1961f7bca441a4c6$export$71511d61b312f219)(t.hostEl.querySelectorAll(i)).filter(function(t) {
                return t.contains(e.target);
            }).length > 0;
        }(e)) return;
        var i = t.zoom;
        if (!d.imageEl) return;
        if (!u.isTouched || !d.slideEl) return;
        u.isMoved || (u.width = d.imageEl.offsetWidth || d.imageEl.clientWidth, u.height = d.imageEl.offsetHeight || d.imageEl.clientHeight, u.startX = (0, $3d818fcc5f3623ef$export$35e795649ee09318)(d.imageWrapEl, "x") || 0, u.startY = (0, $3d818fcc5f3623ef$export$35e795649ee09318)(d.imageWrapEl, "y") || 0, d.slideWidth = d.slideEl.offsetWidth, d.slideHeight = d.slideEl.offsetHeight, d.imageWrapEl.style.transitionDuration = "0ms");
        var a = u.width * i.scale, r = u.height * i.scale;
        u.minX = Math.min(d.slideWidth / 2 - a / 2, 0), u.maxX = -u.minX, u.minY = Math.min(d.slideHeight / 2 - r / 2, 0), u.maxY = -u.minY, u.touchesCurrent.x = c.length > 0 ? c[0].pageX : e.pageX, u.touchesCurrent.y = c.length > 0 ? c[0].pageY : e.pageY;
        if (Math.max(Math.abs(u.touchesCurrent.x - u.touchesStart.x), Math.abs(u.touchesCurrent.y - u.touchesStart.y)) > 5 && (t.allowClick = !1), !u.isMoved && !m) {
            if (t.isHorizontal() && (Math.floor(u.minX) === Math.floor(u.startX) && u.touchesCurrent.x < u.touchesStart.x || Math.floor(u.maxX) === Math.floor(u.startX) && u.touchesCurrent.x > u.touchesStart.x)) return u.isTouched = !1, void Y();
            if (!t.isHorizontal() && (Math.floor(u.minY) === Math.floor(u.startY) && u.touchesCurrent.y < u.touchesStart.y || Math.floor(u.maxY) === Math.floor(u.startY) && u.touchesCurrent.y > u.touchesStart.y)) return u.isTouched = !1, void Y();
        }
        e.cancelable && e.preventDefault(), e.stopPropagation(), clearTimeout(g), t.touchEventsData.preventTouchMoveFromPointerMove = !0, g = setTimeout(function() {
            t.destroyed || Y();
        }), u.isMoved = !0;
        var s = (i.scale - l) / (d.maxRatio - t.params.zoom.minRatio), o = d.originX, n = d.originY;
        u.currentX = u.touchesCurrent.x - u.touchesStart.x + u.startX + s * (u.width - 2 * o), u.currentY = u.touchesCurrent.y - u.touchesStart.y + u.startY + s * (u.height - 2 * n), u.currentX < u.minX && (u.currentX = u.minX + 1 - Math.pow(u.minX - u.currentX + 1, .8)), u.currentX > u.maxX && (u.currentX = u.maxX - 1 + Math.pow(u.currentX - u.maxX + 1, .8)), u.currentY < u.minY && (u.currentY = u.minY + 1 - Math.pow(u.minY - u.currentY + 1, .8)), u.currentY > u.maxY && (u.currentY = u.maxY - 1 + Math.pow(u.currentY - u.maxY + 1, .8)), p.prevPositionX || (p.prevPositionX = u.touchesCurrent.x), p.prevPositionY || (p.prevPositionY = u.touchesCurrent.y), p.prevTime || (p.prevTime = Date.now()), p.x = (u.touchesCurrent.x - p.prevPositionX) / (Date.now() - p.prevTime) / 2, p.y = (u.touchesCurrent.y - p.prevPositionY) / (Date.now() - p.prevTime) / 2, Math.abs(u.touchesCurrent.x - p.prevPositionX) < 2 && (p.x = 0), Math.abs(u.touchesCurrent.y - p.prevPositionY) < 2 && (p.y = 0), p.prevPositionX = u.touchesCurrent.x, p.prevPositionY = u.touchesCurrent.y, p.prevTime = Date.now(), d.imageWrapEl.style.transform = "translate3d(".concat(u.currentX, "px, ").concat(u.currentY, "px,0)");
    }
    function C() {
        var _$e = t.zoom;
        d.slideEl && t.activeIndex !== t.slides.indexOf(d.slideEl) && (d.imageEl && (d.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), d.imageWrapEl && (d.imageWrapEl.style.transform = "translate3d(0,0,0)"), d.slideEl.classList.remove("".concat(t.params.zoom.zoomedSlideClass)), _$e.scale = 1, l = 1, d.slideEl = void 0, d.imageEl = void 0, d.imageWrapEl = void 0, d.originX = 0, d.originY = 0);
    }
    function M(e) {
        var i = t.zoom, a = t.params.zoom;
        if (!d.slideEl) {
            e && e.target && (d.slideEl = e.target.closest(".".concat(t.params.slideClass, ", swiper-slide"))), d.slideEl || (t.params.virtual && t.params.virtual.enabled && t.virtual ? d.slideEl = (0, $3d818fcc5f3623ef$export$f1e1789686576879)(t.slidesEl, ".".concat(t.params.slideActiveClass))[0] : d.slideEl = t.slides[t.activeIndex]);
            var i1 = d.slideEl.querySelector(".".concat(a.containerClass));
            i1 && (i1 = i1.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), d.imageEl = i1, d.imageWrapEl = i1 ? (0, $3d818fcc5f3623ef$export$407448d2b89b1813)(d.imageEl, ".".concat(a.containerClass))[0] : void 0;
        }
        if (!d.imageEl || !d.imageWrapEl) return;
        var r, o, n, m, c, p, g, h, v, f, x, y, X, Y, z, C, _$M, _$w;
        t.params.cssMode && (t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.touchAction = "none"), d.slideEl.classList.add("".concat(a.zoomedSlideClass)), void 0 === u.touchesStart.x && e ? (r = e.pageX, o = e.pageY) : (r = u.touchesStart.x, o = u.touchesStart.y);
        var _$W = "number" == typeof e ? e : null;
        1 === l && _$W && (r = void 0, o = void 0, u.touchesStart.x = void 0, u.touchesStart.y = void 0);
        var S = E();
        i.scale = _$W || S, l = _$W || S, !e || 1 === l && _$W ? (g = 0, h = 0) : (_$M = d.slideEl.offsetWidth, _$w = d.slideEl.offsetHeight, n = (0, $3d818fcc5f3623ef$export$8b22cf2602fb60ce)(d.slideEl).left + s.scrollX, m = (0, $3d818fcc5f3623ef$export$8b22cf2602fb60ce)(d.slideEl).top + s.scrollY, c = n + _$M / 2 - r, p = m + _$w / 2 - o, v = d.imageEl.offsetWidth || d.imageEl.clientWidth, f = d.imageEl.offsetHeight || d.imageEl.clientHeight, x = v * i.scale, y = f * i.scale, X = Math.min(_$M / 2 - x / 2, 0), Y = Math.min(_$w / 2 - y / 2, 0), z = -X, C = -Y, g = c * i.scale, h = p * i.scale, g < X && (g = X), g > z && (g = z), h < Y && (h = Y), h > C && (h = C)), _$W && 1 === i.scale && (d.originX = 0, d.originY = 0), d.imageWrapEl.style.transitionDuration = "300ms", d.imageWrapEl.style.transform = "translate3d(".concat(g, "px, ").concat(h, "px,0)"), d.imageEl.style.transitionDuration = "300ms", d.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(i.scale, ")");
    }
    function w() {
        var _$e = t.zoom, i = t.params.zoom;
        if (!d.slideEl) {
            t.params.virtual && t.params.virtual.enabled && t.virtual ? d.slideEl = (0, $3d818fcc5f3623ef$export$f1e1789686576879)(t.slidesEl, ".".concat(t.params.slideActiveClass))[0] : d.slideEl = t.slides[t.activeIndex];
            var _$e1 = d.slideEl.querySelector(".".concat(i.containerClass));
            _$e1 && (_$e1 = _$e1.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), d.imageEl = _$e1, d.imageWrapEl = _$e1 ? (0, $3d818fcc5f3623ef$export$407448d2b89b1813)(d.imageEl, ".".concat(i.containerClass))[0] : void 0;
        }
        d.imageEl && d.imageWrapEl && (t.params.cssMode && (t.wrapperEl.style.overflow = "", t.wrapperEl.style.touchAction = ""), _$e.scale = 1, l = 1, u.touchesStart.x = void 0, u.touchesStart.y = void 0, d.imageWrapEl.style.transitionDuration = "300ms", d.imageWrapEl.style.transform = "translate3d(0,0,0)", d.imageEl.style.transitionDuration = "300ms", d.imageEl.style.transform = "translate3d(0,0,0) scale(1)", d.slideEl.classList.remove("".concat(i.zoomedSlideClass)), d.slideEl = void 0, d.originX = 0, d.originY = 0);
    }
    function W(e) {
        var i = t.zoom;
        i.scale && 1 !== i.scale ? w() : M(e);
    }
    function S() {
        return {
            passiveListener: !!t.params.passiveListeners && {
                passive: !0,
                capture: !1
            },
            activeListenerWithCapture: !t.params.passiveListeners || {
                passive: !1,
                capture: !0
            }
        };
    }
    function b() {
        var _$e = t.zoom;
        if (_$e.enabled) return;
        _$e.enabled = !0;
        var _S = S(), i = _S.passiveListener, a = _S.activeListenerWithCapture;
        t.wrapperEl.addEventListener("pointerdown", x, i), t.wrapperEl.addEventListener("pointermove", y, a), [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach(function(e) {
            t.wrapperEl.addEventListener(e, X, i);
        }), t.wrapperEl.addEventListener("pointermove", z, a);
    }
    function $() {
        var _$e = t.zoom;
        if (!_$e.enabled) return;
        _$e.enabled = !1;
        var _S = S(), i = _S.passiveListener, a = _S.activeListenerWithCapture;
        t.wrapperEl.removeEventListener("pointerdown", x, i), t.wrapperEl.removeEventListener("pointermove", y, a), [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach(function(e) {
            t.wrapperEl.removeEventListener(e, X, i);
        }), t.wrapperEl.removeEventListener("pointermove", z, a);
    }
    Object.defineProperty(t.zoom, "scale", {
        get: function() {
            return h;
        },
        set: function(e) {
            if (h !== e) {
                var t = d.imageEl, i = d.slideEl;
                r("zoomChange", e, t, i);
            }
            h = e;
        }
    }), a("init", function() {
        t.params.zoom.enabled && b();
    }), a("destroy", function() {
        $();
    }), a("touchStart", function(e, i) {
        t.zoom.enabled && function(e) {
            var _$i = t.device;
            if (!d.imageEl) return;
            if (u.isTouched) return;
            _$i.android && e.cancelable && e.preventDefault(), u.isTouched = !0;
            var a = c.length > 0 ? c[0] : e;
            u.touchesStart.x = a.pageX, u.touchesStart.y = a.pageY;
        }(i);
    }), a("touchEnd", function(e, i) {
        t.zoom.enabled && function() {
            var _$e = t.zoom;
            if (!d.imageEl) return;
            if (!u.isTouched || !u.isMoved) return u.isTouched = !1, void (u.isMoved = !1);
            u.isTouched = !1, u.isMoved = !1;
            var i = 300, a = 300;
            var r = p.x * i, s = u.currentX + r, o = p.y * a, n = u.currentY + o;
            0 !== p.x && (i = Math.abs((s - u.currentX) / p.x)), 0 !== p.y && (a = Math.abs((n - u.currentY) / p.y));
            var l = Math.max(i, a);
            u.currentX = s, u.currentY = n;
            var m = u.width * _$e.scale, c = u.height * _$e.scale;
            u.minX = Math.min(d.slideWidth / 2 - m / 2, 0), u.maxX = -u.minX, u.minY = Math.min(d.slideHeight / 2 - c / 2, 0), u.maxY = -u.minY, u.currentX = Math.max(Math.min(u.currentX, u.maxX), u.minX), u.currentY = Math.max(Math.min(u.currentY, u.maxY), u.minY), d.imageWrapEl.style.transitionDuration = "".concat(l, "ms"), d.imageWrapEl.style.transform = "translate3d(".concat(u.currentX, "px, ").concat(u.currentY, "px,0)");
        }();
    }), a("doubleTap", function(e, i) {
        !t.animating && t.params.zoom.enabled && t.zoom.enabled && t.params.zoom.toggle && W(i);
    }), a("transitionEnd", function() {
        t.zoom.enabled && t.params.zoom.enabled && C();
    }), a("slideChange", function() {
        t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode && C();
    }), Object.assign(t.zoom, {
        enable: b,
        disable: $,
        in: M,
        out: w,
        toggle: W
    });
}




function $9a809c9b08b3f142$export$2e2bcd8739ae039(t) {
    var r = t.swiper, e = t.extendParams, n = t.on;
    function o(t, r) {
        var e = function() {
            var _$t, _$r, e;
            return function(n, o) {
                for(_$r = -1, _$t = n.length; _$t - _$r > 1;)e = _$t + _$r >> 1, n[e] <= o ? _$r = e : _$t = e;
                return _$t;
            };
        }();
        var n, o;
        return this.x = t, this.y = r, this.lastIndex = t.length - 1, this.interpolate = function(t) {
            return t ? (o = e(this.x, t), n = o - 1, (t - this.x[n]) * (this.y[o] - this.y[n]) / (this.x[o] - this.x[n]) + this.y[n]) : 0;
        }, this;
    }
    function l() {
        r.controller.control && r.controller.spline && (r.controller.spline = void 0, delete r.controller.spline);
    }
    e({
        controller: {
            control: void 0,
            inverse: !1,
            by: "slide"
        }
    }), r.controller = {
        control: void 0
    }, n("beforeInit", function() {
        if ("undefined" != typeof window && ("string" == typeof r.params.controller.control || r.params.controller.control instanceof HTMLElement)) ("string" == typeof r.params.controller.control ? (0, $1961f7bca441a4c6$export$71511d61b312f219)(document.querySelectorAll(r.params.controller.control)) : [
            r.params.controller.control
        ]).forEach(function(t) {
            if (r.controller.control || (r.controller.control = []), t && t.swiper) r.controller.control.push(t.swiper);
            else if (t) {
                var e = "".concat(r.params.eventsPrefix, "init"), n = function(o) {
                    r.controller.control.push(o.detail[0]), r.update(), t.removeEventListener(e, n);
                };
                t.addEventListener(e, n);
            }
        });
        else r.controller.control = r.params.controller.control;
    }), n("update", function() {
        l();
    }), n("resize", function() {
        l();
    }), n("observerUpdate", function() {
        l();
    }), n("setTranslate", function(t, e, n) {
        r.controller.control && !r.controller.control.destroyed && r.controller.setTranslate(e, n);
    }), n("setTransition", function(t, e, n) {
        r.controller.control && !r.controller.control.destroyed && r.controller.setTransition(e, n);
    }), Object.assign(r.controller, {
        setTranslate: function setTranslate(t, e) {
            var n = r.controller.control;
            var l, s;
            var i = r.constructor;
            function a(t) {
                if (t.destroyed) return;
                var _$e = r.rtlTranslate ? -r.translate : r.translate;
                "slide" === r.params.controller.by && (!function(t) {
                    r.controller.spline = r.params.loop ? new o(r.slidesGrid, t.slidesGrid) : new o(r.snapGrid, t.snapGrid);
                }(t), s = -r.controller.spline.interpolate(-_$e)), s && "container" !== r.params.controller.by || (l = (t.maxTranslate() - t.minTranslate()) / (r.maxTranslate() - r.minTranslate()), !Number.isNaN(l) && Number.isFinite(l) || (l = 1), s = (_$e - r.minTranslate()) * l + t.minTranslate()), r.params.controller.inverse && (s = t.maxTranslate() - s), t.updateProgress(s), t.setTranslate(s, r), t.updateActiveIndex(), t.updateSlidesClasses();
            }
            if (Array.isArray(n)) for(var _$t = 0; _$t < n.length; _$t += 1)n[_$t] !== e && n[_$t] instanceof i && a(n[_$t]);
            else n instanceof i && e !== n && a(n);
        },
        setTransition: function setTransition(t, e) {
            var n = r.constructor, o = r.controller.control;
            var l;
            function s(e) {
                e.destroyed || (e.setTransition(t, r), 0 !== t && (e.transitionStart(), e.params.autoHeight && (0, $3d818fcc5f3623ef$export$7ccc53e8f1e7dfc5)(function() {
                    e.updateAutoHeight();
                }), (0, $3d818fcc5f3623ef$export$342063e11d6c3cad)(e.wrapperEl, function() {
                    o && e.transitionEnd();
                })));
            }
            if (Array.isArray(o)) for(l = 0; l < o.length; l += 1)o[l] !== e && o[l] instanceof n && s(o[l]);
            else o instanceof n && e !== o && s(o);
        }
    });
}





function $a6e98af9a406f094$export$2e2bcd8739ae039(e) {
    var a = e.swiper, t = e.extendParams, n = e.on;
    t({
        a11y: {
            enabled: !0,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null,
            scrollOnFocus: !0
        }
    }), a.a11y = {
        clicked: !1
    };
    var i, s, r = null, l = (new Date).getTime();
    function o(e) {
        var a = r;
        0 !== a.length && (a.innerHTML = "", a.innerHTML = e);
    }
    function c(e) {
        (e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(e)).forEach(function(e) {
            e.setAttribute("tabIndex", "0");
        });
    }
    function d(e) {
        (e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(e)).forEach(function(e) {
            e.setAttribute("tabIndex", "-1");
        });
    }
    function m(e, a) {
        (e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(e)).forEach(function(e) {
            e.setAttribute("role", a);
        });
    }
    function p(e, a) {
        (e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(e)).forEach(function(e) {
            e.setAttribute("aria-roledescription", a);
        });
    }
    function g(e, a) {
        (e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(e)).forEach(function(e) {
            e.setAttribute("aria-label", a);
        });
    }
    function u(e) {
        (e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(e)).forEach(function(e) {
            e.setAttribute("aria-disabled", !0);
        });
    }
    function E(e) {
        (e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(e)).forEach(function(e) {
            e.setAttribute("aria-disabled", !1);
        });
    }
    function f(e) {
        if (13 !== e.keyCode && 32 !== e.keyCode) return;
        var t = a.params.a11y, n = e.target;
        if (!a.pagination || !a.pagination.el || n !== a.pagination.el && !a.pagination.el.contains(e.target) || e.target.matches((0, $0e48cc04843c0fec$export$db3b6bfb95261072)(a.params.pagination.bulletClass))) {
            if (a.navigation && a.navigation.prevEl && a.navigation.nextEl) {
                var _$e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(a.navigation.prevEl);
                (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(a.navigation.nextEl).includes(n) && (a.isEnd && !a.params.loop || a.slideNext(), a.isEnd ? o(t.lastSlideMessage) : o(t.nextSlideMessage)), _$e.includes(n) && (a.isBeginning && !a.params.loop || a.slidePrev(), a.isBeginning ? o(t.firstSlideMessage) : o(t.prevSlideMessage));
            }
            a.pagination && n.matches((0, $0e48cc04843c0fec$export$db3b6bfb95261072)(a.params.pagination.bulletClass)) && n.click();
        }
    }
    function v() {
        return a.pagination && a.pagination.bullets && a.pagination.bullets.length;
    }
    function y() {
        return v() && a.params.pagination.clickable;
    }
    var b = function(e, a, t) {
        c(e), "BUTTON" !== e.tagName && (m(e, "button"), e.addEventListener("keydown", f)), g(e, t), function(e, a) {
            (e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(e)).forEach(function(e) {
                e.setAttribute("aria-controls", a);
            });
        }(e, a);
    }, h = function(e) {
        s && s !== e.target && !s.contains(e.target) && (i = !0), a.a11y.clicked = !0;
    }, A = function() {
        i = !1, requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                a.destroyed || (a.a11y.clicked = !1);
            });
        });
    }, k = function(e) {
        l = (new Date).getTime();
    }, M = function(e) {
        if (a.a11y.clicked || !a.params.a11y.scrollOnFocus) return;
        if ((new Date).getTime() - l < 100) return;
        var t = e.target.closest(".".concat(a.params.slideClass, ", swiper-slide"));
        if (!t || !a.slides.includes(t)) return;
        s = t;
        var n = a.slides.indexOf(t) === a.activeIndex, r = a.params.watchSlidesProgress && a.visibleSlides && a.visibleSlides.includes(t);
        n || r || e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents || (a.isHorizontal() ? a.el.scrollLeft = 0 : a.el.scrollTop = 0, requestAnimationFrame(function() {
            i || (a.params.loop ? a.slideToLoop(parseInt(t.getAttribute("data-swiper-slide-index")), 0) : a.slideTo(a.slides.indexOf(t), 0), i = !1);
        }));
    }, x = function() {
        var _$e = a.params.a11y;
        _$e.itemRoleDescriptionMessage && p(a.slides, _$e.itemRoleDescriptionMessage), _$e.slideRole && m(a.slides, _$e.slideRole);
        var t = a.slides.length;
        _$e.slideLabelMessage && a.slides.forEach(function(n, i) {
            var s = a.params.loop ? parseInt(n.getAttribute("data-swiper-slide-index"), 10) : i;
            g(n, _$e.slideLabelMessage.replace(/\{\{index\}\}/, s + 1).replace(/\{\{slidesLength\}\}/, t));
        });
    }, L = function() {
        var _$e = a.params.a11y;
        a.el.append(r);
        var t = a.el;
        _$e.containerRoleDescriptionMessage && p(t, _$e.containerRoleDescriptionMessage), _$e.containerMessage && g(t, _$e.containerMessage), _$e.containerRole && m(t, _$e.containerRole);
        var n = a.wrapperEl, i = _$e.id || n.getAttribute("id") || "swiper-wrapper-".concat((s = 16, void 0 === s && (s = 16), "x".repeat(s).replace(/x/g, function() {
            return Math.round(16 * Math.random()).toString(16);
        })));
        var s;
        var l = a.params.autoplay && a.params.autoplay.enabled ? "off" : "polite";
        var o;
        o = i, (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(n).forEach(function(e) {
            e.setAttribute("id", o);
        }), function(e, a) {
            (e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(e)).forEach(function(e) {
                e.setAttribute("aria-live", a);
            });
        }(n, l), x();
        var _ref = a.navigation ? a.navigation : {}, c = _ref.nextEl, d = _ref.prevEl;
        if (c = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(c), d = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(d), c && c.forEach(function(a) {
            return b(a, i, _$e.nextSlideMessage);
        }), d && d.forEach(function(a) {
            return b(a, i, _$e.prevSlideMessage);
        }), y()) (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(a.pagination.el).forEach(function(e) {
            e.addEventListener("keydown", f);
        });
        (0, $650091777930d0d5$export$39b482c5e57630a8)().addEventListener("visibilitychange", k), a.el.addEventListener("focus", M, !0), a.el.addEventListener("focus", M, !0), a.el.addEventListener("pointerdown", h, !0), a.el.addEventListener("pointerup", A, !0);
    };
    n("beforeInit", function() {
        r = (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("span", a.params.a11y.notificationClass), r.setAttribute("aria-live", "assertive"), r.setAttribute("aria-atomic", "true");
    }), n("afterInit", function() {
        a.params.a11y.enabled && L();
    }), n("slidesLengthChange snapGridLengthChange slidesGridLengthChange", function() {
        a.params.a11y.enabled && x();
    }), n("fromEdge toEdge afterInit lock unlock", function() {
        a.params.a11y.enabled && function() {
            if (a.params.loop || a.params.rewind || !a.navigation) return;
            var _a_navigation = a.navigation, _$e = _a_navigation.nextEl, t = _a_navigation.prevEl;
            t && (a.isBeginning ? (u(t), d(t)) : (E(t), c(t))), _$e && (a.isEnd ? (u(_$e), d(_$e)) : (E(_$e), c(_$e)));
        }();
    }), n("paginationUpdate", function() {
        a.params.a11y.enabled && function() {
            var _$e = a.params.a11y;
            v() && a.pagination.bullets.forEach(function(t) {
                a.params.pagination.clickable && (c(t), a.params.pagination.renderBullet || (m(t, "button"), g(t, _$e.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $3d818fcc5f3623ef$export$dda1d9f60106f0e9)(t) + 1)))), t.matches((0, $0e48cc04843c0fec$export$db3b6bfb95261072)(a.params.pagination.bulletActiveClass)) ? t.setAttribute("aria-current", "true") : t.removeAttribute("aria-current");
            });
        }();
    }), n("destroy", function() {
        a.params.a11y.enabled && function() {
            r && r.remove();
            var _ref = a.navigation ? a.navigation : {}, _$e = _ref.nextEl, t = _ref.prevEl;
            _$e = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(_$e), t = (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(t), _$e && _$e.forEach(function(e) {
                return e.removeEventListener("keydown", f);
            }), t && t.forEach(function(e) {
                return e.removeEventListener("keydown", f);
            }), y() && (0, $3d818fcc5f3623ef$export$953cecd6e717a553)(a.pagination.el).forEach(function(e) {
                e.removeEventListener("keydown", f);
            });
            (0, $650091777930d0d5$export$39b482c5e57630a8)().removeEventListener("visibilitychange", k), a.el && "string" != typeof a.el && (a.el.removeEventListener("focus", M, !0), a.el.removeEventListener("pointerdown", h, !0), a.el.removeEventListener("pointerup", A, !0));
        }();
    });
}



function $388762d23b1d407c$export$2e2bcd8739ae039(e) {
    var t = e.swiper, a = e.extendParams, s = e.on;
    a({
        history: {
            enabled: !1,
            root: "",
            replaceState: !1,
            key: "slides",
            keepQuery: !1
        }
    });
    var r = !1, i = {};
    var l = function(e) {
        return e.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    }, o = function(e) {
        var t = (0, $650091777930d0d5$export$407448d2b89b1813)();
        var a;
        a = e ? new URL(e) : t.location;
        var s = a.pathname.slice(1).split("/").filter(function(e) {
            return "" !== e;
        }), r = s.length;
        return {
            key: s[r - 2],
            value: s[r - 1]
        };
    }, n = function(e, a) {
        var s = (0, $650091777930d0d5$export$407448d2b89b1813)();
        if (!r || !t.params.history.enabled) return;
        var i;
        i = t.params.url ? new URL(t.params.url) : s.location;
        var o = t.virtual && t.params.virtual.enabled ? t.slidesEl.querySelector('[data-swiper-slide-index="'.concat(a, '"]')) : t.slides[a];
        var n = l(o.getAttribute("data-history"));
        if (t.params.history.root.length > 0) {
            var _$a = t.params.history.root;
            "/" === _$a[_$a.length - 1] && (_$a = _$a.slice(0, _$a.length - 1)), n = "".concat(_$a, "/").concat(e ? "".concat(e, "/") : "").concat(n);
        } else i.pathname.includes(e) || (n = "".concat(e ? "".concat(e, "/") : "").concat(n));
        t.params.history.keepQuery && (n += i.search);
        var p = s.history.state;
        p && p.value === n || (t.params.history.replaceState ? s.history.replaceState({
            value: n
        }, null, n) : s.history.pushState({
            value: n
        }, null, n));
    }, p = function(e, a, s) {
        if (a) for(var r = 0, i = t.slides.length; r < i; r += 1){
            var i1 = t.slides[r];
            if (l(i1.getAttribute("data-history")) === a) {
                var _$a = t.getSlideIndex(i1);
                t.slideTo(_$a, e, s);
            }
        }
        else t.slideTo(0, e, s);
    }, d = function() {
        i = o(t.params.url), p(t.params.speed, i.value, !1);
    };
    s("init", function() {
        t.params.history.enabled && function() {
            var _$e = (0, $650091777930d0d5$export$407448d2b89b1813)();
            if (t.params.history) {
                if (!_$e.history || !_$e.history.pushState) return t.params.history.enabled = !1, void (t.params.hashNavigation.enabled = !0);
                r = !0, i = o(t.params.url), i.key || i.value ? (p(0, i.value, t.params.runCallbacksOnInit), t.params.history.replaceState || _$e.addEventListener("popstate", d)) : t.params.history.replaceState || _$e.addEventListener("popstate", d);
            }
        }();
    }), s("destroy", function() {
        t.params.history.enabled && function() {
            var _$e = (0, $650091777930d0d5$export$407448d2b89b1813)();
            t.params.history.replaceState || _$e.removeEventListener("popstate", d);
        }();
    }), s("transitionEnd _freeModeNoMomentumRelease", function() {
        r && n(t.params.history.key, t.activeIndex);
    }), s("slideChange", function() {
        r && t.params.cssMode && n(t.params.history.key, t.activeIndex);
    });
}




function $44b3e235203ce2e1$export$2e2bcd8739ae039(a) {
    var e = a.swiper, t = a.extendParams, s = a.emit, i = a.on, n = !1;
    var r = (0, $650091777930d0d5$export$39b482c5e57630a8)(), h = (0, $650091777930d0d5$export$407448d2b89b1813)();
    t({
        hashNavigation: {
            enabled: !1,
            replaceState: !1,
            watchState: !1,
            getSlideIndex: function(a, t) {
                if (e.virtual && e.params.virtual.enabled) {
                    var _$a = e.slides.filter(function(a) {
                        return a.getAttribute("data-hash") === t;
                    })[0];
                    if (!_$a) return 0;
                    return parseInt(_$a.getAttribute("data-swiper-slide-index"), 10);
                }
                return e.getSlideIndex((0, $3d818fcc5f3623ef$export$f1e1789686576879)(e.slidesEl, ".".concat(e.params.slideClass, '[data-hash="').concat(t, '"], swiper-slide[data-hash="').concat(t, '"]'))[0]);
            }
        }
    });
    var d = function() {
        s("hashChange");
        var _$a = r.location.hash.replace("#", ""), t = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector('[data-swiper-slide-index="'.concat(e.activeIndex, '"]')) : e.slides[e.activeIndex];
        if (_$a !== (t ? t.getAttribute("data-hash") : "")) {
            var t1 = e.params.hashNavigation.getSlideIndex(e, _$a);
            if (void 0 === t1 || Number.isNaN(t1)) return;
            e.slideTo(t1);
        }
    }, l = function() {
        if (!n || !e.params.hashNavigation.enabled) return;
        var _$a = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector('[data-swiper-slide-index="'.concat(e.activeIndex, '"]')) : e.slides[e.activeIndex], t = _$a ? _$a.getAttribute("data-hash") || _$a.getAttribute("data-history") : "";
        e.params.hashNavigation.replaceState && h.history && h.history.replaceState ? (h.history.replaceState(null, null, "#".concat(t) || ""), s("hashSet")) : (r.location.hash = t || "", s("hashSet"));
    };
    i("init", function() {
        e.params.hashNavigation.enabled && function() {
            if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
            n = !0;
            var _$a = r.location.hash.replace("#", "");
            if (_$a) {
                var t = 0, s = e.params.hashNavigation.getSlideIndex(e, _$a);
                e.slideTo(s || 0, t, e.params.runCallbacksOnInit, !0);
            }
            e.params.hashNavigation.watchState && h.addEventListener("hashchange", d);
        }();
    }), i("destroy", function() {
        e.params.hashNavigation.enabled && e.params.hashNavigation.watchState && h.removeEventListener("hashchange", d);
    }), i("transitionEnd _freeModeNoMomentumRelease", function() {
        n && l();
    }), i("slideChange", function() {
        n && e.params.cssMode && l();
    });
}



function $c5a028391d499387$export$2e2bcd8739ae039(e) {
    var a, t, n = e.swiper, i = e.extendParams, r = e.on, o = e.emit, s = e.params;
    n.autoplay = {
        running: !1,
        paused: !1,
        timeLeft: 0
    }, i({
        autoplay: {
            enabled: !1,
            delay: 3e3,
            waitForTransition: !0,
            disableOnInteraction: !1,
            stopOnLastSlide: !1,
            reverseDirection: !1,
            pauseOnMouseEnter: !1
        }
    });
    var l, p, u, d, y, m, c, g, v = s && s.autoplay ? s.autoplay.delay : 3e3, T = s && s.autoplay ? s.autoplay.delay : 3e3, f = (new Date).getTime();
    function w(e) {
        n && !n.destroyed && n.wrapperEl && e.target === n.wrapperEl && (n.wrapperEl.removeEventListener("transitionend", w), g || e.detail && e.detail.bySwiperTouchMove || S());
    }
    var b = function() {
        if (n.destroyed || !n.autoplay.running) return;
        n.autoplay.paused ? p = !0 : p && (T = l, p = !1);
        var _$e = n.autoplay.paused ? l : f + T - (new Date).getTime();
        n.autoplay.timeLeft = _$e, o("autoplayTimeLeft", _$e, _$e / v), t = requestAnimationFrame(function() {
            b();
        });
    }, E = function(e) {
        if (n.destroyed || !n.autoplay.running) return;
        cancelAnimationFrame(t), b();
        var i = void 0 === e ? n.params.autoplay.delay : e;
        v = n.params.autoplay.delay, T = n.params.autoplay.delay;
        var r = function() {
            var _$e;
            if (_$e = n.virtual && n.params.virtual.enabled ? n.slides.filter(function(e) {
                return e.classList.contains("swiper-slide-active");
            })[0] : n.slides[n.activeIndex], !_$e) return;
            return parseInt(_$e.getAttribute("data-swiper-autoplay"), 10);
        }();
        !Number.isNaN(r) && r > 0 && void 0 === e && (i = r, v = r, T = r), l = i;
        var s = n.params.speed, p = function() {
            n && !n.destroyed && (n.params.autoplay.reverseDirection ? !n.isBeginning || n.params.loop || n.params.rewind ? (n.slidePrev(s, !0, !0), o("autoplay")) : n.params.autoplay.stopOnLastSlide || (n.slideTo(n.slides.length - 1, s, !0, !0), o("autoplay")) : !n.isEnd || n.params.loop || n.params.rewind ? (n.slideNext(s, !0, !0), o("autoplay")) : n.params.autoplay.stopOnLastSlide || (n.slideTo(0, s, !0, !0), o("autoplay")), n.params.cssMode && (f = (new Date).getTime(), requestAnimationFrame(function() {
                E();
            })));
        };
        return i > 0 ? (clearTimeout(a), a = setTimeout(function() {
            p();
        }, i)) : requestAnimationFrame(function() {
            p();
        }), i;
    }, L = function() {
        f = (new Date).getTime(), n.autoplay.running = !0, E(), o("autoplayStart");
    }, D = function() {
        n.autoplay.running = !1, clearTimeout(a), cancelAnimationFrame(t), o("autoplayStop");
    }, O = function(e, t) {
        if (n.destroyed || !n.autoplay.running) return;
        clearTimeout(a), e || (c = !0);
        var i = function() {
            o("autoplayPause"), n.params.autoplay.waitForTransition ? n.wrapperEl.addEventListener("transitionend", w) : S();
        };
        if (n.autoplay.paused = !0, t) return m && (l = n.params.autoplay.delay), m = !1, void i();
        var r = l || n.params.autoplay.delay;
        l = r - ((new Date).getTime() - f), n.isEnd && l < 0 && !n.params.loop || (l < 0 && (l = 0), i());
    }, S = function() {
        n.isEnd && l < 0 && !n.params.loop || n.destroyed || !n.autoplay.running || (f = (new Date).getTime(), c ? (c = !1, E(l)) : E(), n.autoplay.paused = !1, o("autoplayResume"));
    }, M = function() {
        if (n.destroyed || !n.autoplay.running) return;
        var _$e = (0, $650091777930d0d5$export$39b482c5e57630a8)();
        "hidden" === _$e.visibilityState && (c = !0, O(!0)), "visible" === _$e.visibilityState && S();
    }, h = function(e) {
        "mouse" === e.pointerType && (c = !0, g = !0, n.animating || n.autoplay.paused || O(!0));
    }, A = function(e) {
        "mouse" === e.pointerType && (g = !1, n.autoplay.paused && S());
    };
    r("init", function() {
        n.params.autoplay.enabled && (n.params.autoplay.pauseOnMouseEnter && (n.el.addEventListener("pointerenter", h), n.el.addEventListener("pointerleave", A)), (0, $650091777930d0d5$export$39b482c5e57630a8)().addEventListener("visibilitychange", M), L());
    }), r("destroy", function() {
        n.el && "string" != typeof n.el && (n.el.removeEventListener("pointerenter", h), n.el.removeEventListener("pointerleave", A)), (0, $650091777930d0d5$export$39b482c5e57630a8)().removeEventListener("visibilitychange", M), n.autoplay.running && D();
    }), r("_freeModeStaticRelease", function() {
        (d || c) && S();
    }), r("_freeModeNoMomentumRelease", function() {
        n.params.autoplay.disableOnInteraction ? D() : O(!0, !0);
    }), r("beforeTransitionStart", function(e, a, t) {
        !n.destroyed && n.autoplay.running && (t || !n.params.autoplay.disableOnInteraction ? O(!0, !0) : D());
    }), r("sliderFirstMove", function() {
        !n.destroyed && n.autoplay.running && (n.params.autoplay.disableOnInteraction ? D() : (u = !0, d = !1, c = !1, y = setTimeout(function() {
            c = !0, d = !0, O(!0);
        }, 200)));
    }), r("touchEnd", function() {
        if (!n.destroyed && n.autoplay.running && u) {
            if (clearTimeout(y), clearTimeout(a), n.params.autoplay.disableOnInteraction) return d = !1, void (u = !1);
            d && n.params.cssMode && S(), d = !1, u = !1;
        }
    }), r("slideChange", function() {
        !n.destroyed && n.autoplay.running && (m = !0);
    }), Object.assign(n.autoplay, {
        start: L,
        stop: D,
        pause: O,
        resume: S
    });
}




function $879a041fb00d3e14$export$2e2bcd8739ae039(e) {
    var s = e.swiper, i = e.extendParams, t = e.on;
    i({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: !0,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    var r = !1, a = !1;
    function l() {
        var _$e = s.thumbs.swiper;
        if (!_$e || _$e.destroyed) return;
        var i = _$e.clickedIndex, t = _$e.clickedSlide;
        if (t && t.classList.contains(s.params.thumbs.slideThumbActiveClass)) return;
        if (null == i) return;
        var r;
        r = _$e.params.loop ? parseInt(_$e.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : i, s.params.loop ? s.slideToLoop(r) : s.slideTo(r);
    }
    function n() {
        var _s_params = s.params, _$e = _s_params.thumbs;
        if (r) return !1;
        r = !0;
        var i = s.constructor;
        if (_$e.swiper instanceof i) s.thumbs.swiper = _$e.swiper, Object.assign(s.thumbs.swiper.originalParams, {
            watchSlidesProgress: !0,
            slideToClickedSlide: !1
        }), Object.assign(s.thumbs.swiper.params, {
            watchSlidesProgress: !0,
            slideToClickedSlide: !1
        }), s.thumbs.swiper.update();
        else if ((0, $3d818fcc5f3623ef$export$882b5998b3b9117c)(_$e.swiper)) {
            var t = Object.assign({}, _$e.swiper);
            Object.assign(t, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            }), s.thumbs.swiper = new i(t), a = !0;
        }
        return s.thumbs.swiper.el.classList.add(s.params.thumbs.thumbsContainerClass), s.thumbs.swiper.on("tap", l), !0;
    }
    function d(e) {
        var i = s.thumbs.swiper;
        if (!i || i.destroyed) return;
        var t = "auto" === i.params.slidesPerView ? i.slidesPerViewDynamic() : i.params.slidesPerView;
        var r = 1;
        var a = s.params.thumbs.slideThumbActiveClass;
        if (s.params.slidesPerView > 1 && !s.params.centeredSlides && (r = s.params.slidesPerView), s.params.thumbs.multipleActiveThumbs || (r = 1), r = Math.floor(r), i.slides.forEach(function(e) {
            return e.classList.remove(a);
        }), i.params.loop || i.params.virtual && i.params.virtual.enabled) for(var _$e = 0; _$e < r; _$e += 1)(0, $3d818fcc5f3623ef$export$f1e1789686576879)(i.slidesEl, '[data-swiper-slide-index="'.concat(s.realIndex + _$e, '"]')).forEach(function(e) {
            e.classList.add(a);
        });
        else for(var _$e1 = 0; _$e1 < r; _$e1 += 1)i.slides[s.realIndex + _$e1] && i.slides[s.realIndex + _$e1].classList.add(a);
        var l = s.params.thumbs.autoScrollOffset, _$n = l && !i.params.loop;
        if (s.realIndex !== i.realIndex || _$n) {
            var r1 = i.activeIndex;
            var a1, _$d;
            if (i.params.loop) {
                var _$e2 = i.slides.filter(function(e) {
                    return e.getAttribute("data-swiper-slide-index") === "".concat(s.realIndex);
                })[0];
                a1 = i.slides.indexOf(_$e2), _$d = s.activeIndex > s.previousIndex ? "next" : "prev";
            } else a1 = s.realIndex, _$d = a1 > s.previousIndex ? "next" : "prev";
            _$n && (a1 += "next" === _$d ? l : -1 * l), i.visibleSlidesIndexes && i.visibleSlidesIndexes.indexOf(a1) < 0 && (i.params.centeredSlides ? a1 = a1 > r1 ? a1 - Math.floor(t / 2) + 1 : a1 + Math.floor(t / 2) - 1 : a1 > r1 && i.params.slidesPerGroup, i.slideTo(a1, e ? 0 : void 0));
        }
    }
    s.thumbs = {
        swiper: null
    }, t("beforeInit", function() {
        var _s_params = s.params, _$e = _s_params.thumbs;
        if (_$e && _$e.swiper) {
            if ("string" == typeof _$e.swiper || _$e.swiper instanceof HTMLElement) {
                var i = (0, $650091777930d0d5$export$39b482c5e57630a8)(), t = function() {
                    var t = "string" == typeof _$e.swiper ? i.querySelector(_$e.swiper) : _$e.swiper;
                    if (t && t.swiper) _$e.swiper = t.swiper, n(), d(!0);
                    else if (t) {
                        var i1 = "".concat(s.params.eventsPrefix, "init"), r = function(a) {
                            _$e.swiper = a.detail[0], t.removeEventListener(i1, r), n(), d(!0), _$e.swiper.update(), s.update();
                        };
                        t.addEventListener(i1, r);
                    }
                    return t;
                }, r = function() {
                    if (s.destroyed) return;
                    t() || requestAnimationFrame(r);
                };
                requestAnimationFrame(r);
            } else n(), d(!0);
        }
    }), t("slideChange update resize observerUpdate", function() {
        d();
    }), t("setTransition", function(e, i) {
        var t = s.thumbs.swiper;
        t && !t.destroyed && t.setTransition(i);
    }), t("beforeDestroy", function() {
        var _$e = s.thumbs.swiper;
        _$e && !_$e.destroyed && a && _$e.destroy();
    }), Object.assign(s.thumbs, {
        init: n,
        update: d
    });
}



function $559be6446ef208c3$export$2e2bcd8739ae039(e) {
    var t = e.swiper, o = e.extendParams, n = e.emit, s = e.once;
    o({
        freeMode: {
            enabled: !1,
            momentum: !0,
            momentumRatio: 1,
            momentumBounce: !0,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: !1,
            minimumVelocity: .02
        }
    }), Object.assign(t, {
        freeMode: {
            onTouchStart: function onTouchStart() {
                if (t.params.cssMode) return;
                var _$e = t.getTranslate();
                t.setTranslate(_$e), t.setTransition(0), t.touchEventsData.velocities.length = 0, t.freeMode.onTouchEnd({
                    currentPos: t.rtl ? t.translate : -t.translate
                });
            },
            onTouchMove: function onTouchMove() {
                if (t.params.cssMode) return;
                var _$e = t.touchEventsData, o = t.touches;
                0 === _$e.velocities.length && _$e.velocities.push({
                    position: o[t.isHorizontal() ? "startX" : "startY"],
                    time: _$e.touchStartTime
                }), _$e.velocities.push({
                    position: o[t.isHorizontal() ? "currentX" : "currentY"],
                    time: (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)()
                });
            },
            onTouchEnd: function onTouchEnd(e) {
                var o = e.currentPos;
                if (t.params.cssMode) return;
                var i = t.params, a = t.wrapperEl, r = t.rtlTranslate, l = t.snapGrid, m = t.touchEventsData, c = (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)() - m.touchStartTime;
                if (o < -t.minTranslate()) t.slideTo(t.activeIndex);
                else if (o > -t.maxTranslate()) t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1);
                else {
                    if (i.freeMode.momentum) {
                        if (m.velocities.length > 1) {
                            var _$e = m.velocities.pop(), o1 = m.velocities.pop(), n1 = _$e.position - o1.position, s1 = _$e.time - o1.time;
                            t.velocity = n1 / s1, t.velocity /= 2, Math.abs(t.velocity) < i.freeMode.minimumVelocity && (t.velocity = 0), (s1 > 150 || (0, $3d818fcc5f3623ef$export$4368d992c4eafac0)() - _$e.time > 300) && (t.velocity = 0);
                        } else t.velocity = 0;
                        t.velocity *= i.freeMode.momentumVelocityRatio, m.velocities.length = 0;
                        var _$e1 = 1e3 * i.freeMode.momentumRatio;
                        var o2 = t.velocity * _$e1;
                        var c1 = t.translate + o2;
                        r && (c1 = -c1);
                        var d, u = !1;
                        var f = 20 * Math.abs(t.velocity) * i.freeMode.momentumBounceRatio;
                        var p;
                        if (c1 < t.maxTranslate()) i.freeMode.momentumBounce ? (c1 + t.maxTranslate() < -f && (c1 = t.maxTranslate() - f), d = t.maxTranslate(), u = !0, m.allowMomentumBounce = !0) : c1 = t.maxTranslate(), i.loop && i.centeredSlides && (p = !0);
                        else if (c1 > t.minTranslate()) i.freeMode.momentumBounce ? (c1 - t.minTranslate() > f && (c1 = t.minTranslate() + f), d = t.minTranslate(), u = !0, m.allowMomentumBounce = !0) : c1 = t.minTranslate(), i.loop && i.centeredSlides && (p = !0);
                        else if (i.freeMode.sticky) {
                            var _$e2;
                            for(var t1 = 0; t1 < l.length; t1 += 1)if (l[t1] > -c1) {
                                _$e2 = t1;
                                break;
                            }
                            c1 = Math.abs(l[_$e2] - c1) < Math.abs(l[_$e2 - 1] - c1) || "next" === t.swipeDirection ? l[_$e2] : l[_$e2 - 1], c1 = -c1;
                        }
                        if (p && s("transitionEnd", function() {
                            t.loopFix();
                        }), 0 !== t.velocity) {
                            if (_$e1 = r ? Math.abs((-c1 - t.translate) / t.velocity) : Math.abs((c1 - t.translate) / t.velocity), i.freeMode.sticky) {
                                var o3 = Math.abs((r ? -c1 : c1) - t.translate), n2 = t.slidesSizesGrid[t.activeIndex];
                                _$e1 = o3 < n2 ? i.speed : o3 < 2 * n2 ? 1.5 * i.speed : 2.5 * i.speed;
                            }
                        } else if (i.freeMode.sticky) return void t.slideToClosest();
                        i.freeMode.momentumBounce && u ? (t.updateProgress(d), t.setTransition(_$e1), t.setTranslate(c1), t.transitionStart(!0, t.swipeDirection), t.animating = !0, (0, $3d818fcc5f3623ef$export$342063e11d6c3cad)(a, function() {
                            t && !t.destroyed && m.allowMomentumBounce && (n("momentumBounce"), t.setTransition(i.speed), setTimeout(function() {
                                t.setTranslate(d), (0, $3d818fcc5f3623ef$export$342063e11d6c3cad)(a, function() {
                                    t && !t.destroyed && t.transitionEnd();
                                });
                            }, 0));
                        })) : t.velocity ? (n("_freeModeNoMomentumRelease"), t.updateProgress(c1), t.setTransition(_$e1), t.setTranslate(c1), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, (0, $3d818fcc5f3623ef$export$342063e11d6c3cad)(a, function() {
                            t && !t.destroyed && t.transitionEnd();
                        }))) : t.updateProgress(c1), t.updateActiveIndex(), t.updateSlidesClasses();
                    } else {
                        if (i.freeMode.sticky) return void t.slideToClosest();
                        i.freeMode && n("_freeModeNoMomentumRelease");
                    }
                    (!i.freeMode.momentum || c >= i.longSwipesMs) && (n("_freeModeStaticRelease"), t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
                }
            }
        }
    });
}



function $58a15e9618d5ba1c$export$2e2bcd8739ae039(e) {
    var i, r, a, t, s = e.swiper, l = e.extendParams, o = e.on;
    l({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    var n = function() {
        var _$e = s.params.spaceBetween;
        return "string" == typeof _$e && _$e.indexOf("%") >= 0 ? _$e = parseFloat(_$e.replace("%", "")) / 100 * s.size : "string" == typeof _$e && (_$e = parseFloat(_$e)), _$e;
    };
    o("init", function() {
        t = s.params.grid && s.params.grid.rows > 1;
    }), o("update", function() {
        var _$e = s.params, i = s.el, r = _$e.grid && _$e.grid.rows > 1;
        t && !r ? (i.classList.remove("".concat(_$e.containerModifierClass, "grid"), "".concat(_$e.containerModifierClass, "grid-column")), a = 1, s.emitContainerClasses()) : !t && r && (i.classList.add("".concat(_$e.containerModifierClass, "grid")), "column" === _$e.grid.fill && i.classList.add("".concat(_$e.containerModifierClass, "grid-column")), s.emitContainerClasses()), t = r;
    }), s.grid = {
        initSlides: function(e) {
            var _s_params = s.params, t = _s_params.slidesPerView, _s_params_grid = s.params.grid, l = _s_params_grid.rows, o = _s_params_grid.fill, n = s.virtual && s.params.virtual.enabled ? s.virtual.slides.length : e.length;
            a = Math.floor(n / l), i = Math.floor(n / l) === n / l ? n : Math.ceil(n / l) * l, "auto" !== t && "row" === o && (i = Math.max(i, t * l)), r = i / l;
        },
        unsetSlides: function() {
            s.slides && s.slides.forEach(function(e) {
                e.swiperSlideGridSet && (e.style.height = "", e.style[s.getDirectionLabel("margin-top")] = "");
            });
        },
        updateSlide: function(e, t, l) {
            var _s_params = s.params, o = _s_params.slidesPerGroup, d = n(), _s_params_grid = s.params.grid, p = _s_params_grid.rows, c = _s_params_grid.fill, g = s.virtual && s.params.virtual.enabled ? s.virtual.slides.length : l.length;
            var u, h, m;
            if ("row" === c && o > 1) {
                var r1 = Math.floor(e / (o * p)), a1 = e - p * o * r1, s1 = 0 === r1 ? o : Math.min(Math.ceil((g - r1 * p * o) / p), o);
                m = Math.floor(a1 / s1), h = a1 - m * s1 + r1 * o, u = h + m * i / p, t.style.order = u;
            } else "column" === c ? (h = Math.floor(e / p), m = e - h * p, (h > a || h === a && m === p - 1) && (m += 1, m >= p && (m = 0, h += 1))) : (m = Math.floor(e / r), h = e - m * r);
            t.row = m, t.column = h, t.style.height = "calc((100% - ".concat((p - 1) * d, "px) / ").concat(p, ")"), t.style[s.getDirectionLabel("margin-top")] = 0 !== m ? d && "".concat(d, "px") : "", t.swiperSlideGridSet = !0;
        },
        updateWrapperSize: function(e, r) {
            var _s_params = s.params, a = _s_params.centeredSlides, t = _s_params.roundLengths, l = n(), _s_params_grid = s.params.grid, o = _s_params_grid.rows;
            if (s.virtualSize = (e + l) * i, s.virtualSize = Math.ceil(s.virtualSize / o) - l, s.params.cssMode || (s.wrapperEl.style[s.getDirectionLabel("width")] = "".concat(s.virtualSize + l, "px")), a) {
                var _r;
                var _$e = [];
                for(var i1 = 0; i1 < r.length; i1 += 1){
                    var a1 = r[i1];
                    t && (a1 = Math.floor(a1)), r[i1] < s.virtualSize + r[0] && _$e.push(a1);
                }
                r.splice(0, r.length), (_r = r).push.apply(_r, (0, $1961f7bca441a4c6$export$71511d61b312f219)(_$e));
            }
        }
    };
}



function $7d87364182dc34e5$var$appendSlide(e) {
    var l = this, o = l.params, i = l.slidesEl;
    o.loop && l.loopDestroy();
    var t = function(e) {
        if ("string" == typeof e) {
            var l = document.createElement("div");
            l.innerHTML = e, i.append(l.children[0]), l.innerHTML = "";
        } else i.append(e);
    };
    if ("object" == (typeof e === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(e)) && "length" in e) for(var l1 = 0; l1 < e.length; l1 += 1)e[l1] && t(e[l1]);
    else t(e);
    l.recalcSlides(), o.loop && l.loopCreate(), o.observer && !l.isElement || l.update();
}
function $7d87364182dc34e5$var$prependSlide(e) {
    var l = this, o = l.params, i = l.activeIndex, t = l.slidesEl;
    o.loop && l.loopDestroy();
    var n = i + 1;
    var d = function(e) {
        if ("string" == typeof e) {
            var l = document.createElement("div");
            l.innerHTML = e, t.prepend(l.children[0]), l.innerHTML = "";
        } else t.prepend(e);
    };
    if ("object" == (typeof e === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(e)) && "length" in e) {
        for(var l1 = 0; l1 < e.length; l1 += 1)e[l1] && d(e[l1]);
        n = i + e.length;
    } else d(e);
    l.recalcSlides(), o.loop && l.loopCreate(), o.observer && !l.isElement || l.update(), l.slideTo(n, 0, !1);
}
function $7d87364182dc34e5$var$addSlide(e, l) {
    var o = this, i = o.params, t = o.activeIndex, n = o.slidesEl;
    var d = t;
    i.loop && (d -= o.loopedSlides, o.loopDestroy(), o.recalcSlides());
    var s = o.slides.length;
    if (e <= 0) return void o.prependSlide(l);
    if (e >= s) return void o.appendSlide(l);
    var p = d > e ? d + 1 : d;
    var r = [];
    for(var _$l = s - 1; _$l >= e; _$l -= 1){
        var _$e = o.slides[_$l];
        _$e.remove(), r.unshift(_$e);
    }
    if ("object" == (typeof l === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(l)) && "length" in l) {
        for(var _$e1 = 0; _$e1 < l.length; _$e1 += 1)l[_$e1] && n.append(l[_$e1]);
        p = d > e ? d + l.length : d;
    } else n.append(l);
    for(var _$e2 = 0; _$e2 < r.length; _$e2 += 1)n.append(r[_$e2]);
    o.recalcSlides(), i.loop && o.loopCreate(), i.observer && !o.isElement || o.update(), i.loop ? o.slideTo(p + o.loopedSlides, 0, !1) : o.slideTo(p, 0, !1);
}
function $7d87364182dc34e5$var$removeSlide(e) {
    var l = this, o = l.params, i = l.activeIndex;
    var t = i;
    o.loop && (t -= l.loopedSlides, l.loopDestroy());
    var n, d = t;
    if ("object" == (typeof e === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(e)) && "length" in e) {
        for(var o1 = 0; o1 < e.length; o1 += 1)n = e[o1], l.slides[n] && l.slides[n].remove(), n < d && (d -= 1);
        d = Math.max(d, 0);
    } else n = e, l.slides[n] && l.slides[n].remove(), n < d && (d -= 1), d = Math.max(d, 0);
    l.recalcSlides(), o.loop && l.loopCreate(), o.observer && !l.isElement || l.update(), o.loop ? l.slideTo(d + l.loopedSlides, 0, !1) : l.slideTo(d, 0, !1);
}
function $7d87364182dc34e5$var$removeAllSlides() {
    var e = this, l = [];
    for(var o = 0; o < e.slides.length; o += 1)l.push(o);
    e.removeSlide(l);
}
function $7d87364182dc34e5$export$2e2bcd8739ae039(e) {
    var l = e.swiper;
    Object.assign(l, {
        appendSlide: $7d87364182dc34e5$var$appendSlide.bind(l),
        prependSlide: $7d87364182dc34e5$var$prependSlide.bind(l),
        addSlide: $7d87364182dc34e5$var$addSlide.bind(l),
        removeSlide: $7d87364182dc34e5$var$removeSlide.bind(l),
        removeAllSlides: $7d87364182dc34e5$var$removeAllSlides.bind(l)
    });
}


function $9098ef0f27106a99$export$f1e1789686576879(e) {
    var s = e.effect, a = e.swiper, t = e.on, r = e.setTranslate, i = e.setTransition, n = e.overwriteParams, o = e.perspective, f = e.recreateShadows, l = e.getEffectParams;
    var c;
    t("beforeInit", function() {
        if (a.params.effect !== s) return;
        a.classNames.push("".concat(a.params.containerModifierClass).concat(s)), o && o() && a.classNames.push("".concat(a.params.containerModifierClass, "3d"));
        var _$e = n ? n() : {};
        Object.assign(a.params, _$e), Object.assign(a.originalParams, _$e);
    }), t("setTranslate", function() {
        a.params.effect === s && r();
    }), t("setTransition", function(e, t) {
        a.params.effect === s && i(t);
    }), t("transitionEnd", function() {
        if (a.params.effect === s && f) {
            if (!l || !l().slideShadows) return;
            a.slides.forEach(function(e) {
                e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(e) {
                    return e.remove();
                });
            }), f();
        }
    }), t("virtualUpdate", function() {
        a.params.effect === s && (a.slides.length || (c = !0), requestAnimationFrame(function() {
            c && a.slides && a.slides.length && (r(), c = !1);
        }));
    });
}



function $e7f15398eb23ab92$export$f1e1789686576879(e, i) {
    var t = (0, $3d818fcc5f3623ef$export$39b482c5e57630a8)(i);
    return t !== i && (t.style.backfaceVisibility = "hidden", t.style["-webkit-backface-visibility"] = "hidden"), t;
}



function $7f75e8e871e908f6$export$f1e1789686576879(e) {
    var t = e.swiper, n = e.duration, r = e.transformElements, i = e.allSlides;
    var a = t.activeIndex;
    if (t.params.virtualTranslate && 0 !== n) {
        var _$e, n1 = !1;
        _$e = i ? r : r.filter(function(e) {
            var n = e.classList.contains("swiper-slide-transform") ? function(e) {
                if (!e.parentElement) return t.slides.filter(function(t) {
                    return t.shadowRoot && t.shadowRoot === e.parentNode;
                })[0];
                return e.parentElement;
            }(e) : e;
            return t.getSlideIndex(n) === a;
        }), _$e.forEach(function(e) {
            (0, $3d818fcc5f3623ef$export$342063e11d6c3cad)(e, function() {
                if (n1) return;
                if (!t || t.destroyed) return;
                n1 = !0, t.animating = !1;
                var _$e = new window.CustomEvent("transitionend", {
                    bubbles: !0,
                    cancelable: !0
                });
                t.wrapperEl.dispatchEvent(_$e);
            });
        });
    }
}



function $48b4eb7b02f56e3c$export$2e2bcd8739ae039(e) {
    var t = e.swiper, s = e.extendParams, a = e.on;
    s({
        fadeEffect: {
            crossFade: !1
        }
    });
    (0, $9098ef0f27106a99$export$f1e1789686576879)({
        effect: "fade",
        swiper: t,
        on: a,
        setTranslate: function() {
            var _$e = t.slides, s = t.params.fadeEffect;
            for(var a = 0; a < _$e.length; a += 1){
                var _$e1 = t.slides[a];
                var r = -_$e1.swiperSlideOffset;
                t.params.virtualTranslate || (r -= t.translate);
                var i = 0;
                t.isHorizontal() || (i = r, r = 0);
                var f = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(_$e1.progress), 0) : 1 + Math.min(Math.max(_$e1.progress, -1), 0), n = (0, $e7f15398eb23ab92$export$f1e1789686576879)(s, _$e1);
                n.style.opacity = f, n.style.transform = "translate3d(".concat(r, "px, ").concat(i, "px, 0px)");
            }
        },
        setTransition: function(e) {
            var s = t.slides.map(function(e) {
                return (0, $3d818fcc5f3623ef$export$39b482c5e57630a8)(e);
            });
            s.forEach(function(t) {
                t.style.transitionDuration = "".concat(e, "ms");
            }), (0, $7f75e8e871e908f6$export$f1e1789686576879)({
                swiper: t,
                duration: e,
                transformElements: s,
                allSlides: !0
            });
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                spaceBetween: 0,
                virtualTranslate: !t.params.cssMode
            };
        }
    });
}




function $e4b05f06709975e1$export$2e2bcd8739ae039(e) {
    var t = e.swiper, s = e.extendParams, a = e.on;
    s({
        cubeEffect: {
            slideShadows: !0,
            shadow: !0,
            shadowOffset: 20,
            shadowScale: .94
        }
    });
    var r = function(e, t, s) {
        var a = s ? e.querySelector(".swiper-slide-shadow-left") : e.querySelector(".swiper-slide-shadow-top"), r = s ? e.querySelector(".swiper-slide-shadow-right") : e.querySelector(".swiper-slide-shadow-bottom");
        a || (a = (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (s ? "left" : "top")).split(" ")), e.append(a)), r || (r = (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (s ? "right" : "bottom")).split(" ")), e.append(r)), a && (a.style.opacity = Math.max(-t, 0)), r && (r.style.opacity = Math.max(t, 0));
    };
    (0, $9098ef0f27106a99$export$f1e1789686576879)({
        effect: "cube",
        swiper: t,
        on: a,
        setTranslate: function() {
            var _$e = t.el, s = t.wrapperEl, a = t.slides, o = t.width, i = t.height, l = t.rtlTranslate, d = t.size, n = t.browser, p = (0, $3d818fcc5f3623ef$export$ae1af26003f05816)(t), c = t.params.cubeEffect, w = t.isHorizontal(), h = t.virtual && t.params.virtual.enabled;
            var f, m = 0;
            c.shadow && (w ? (f = t.wrapperEl.querySelector(".swiper-cube-shadow"), f || (f = (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("div", "swiper-cube-shadow"), t.wrapperEl.append(f)), f.style.height = "".concat(o, "px")) : (f = _$e.querySelector(".swiper-cube-shadow"), f || (f = (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("div", "swiper-cube-shadow"), _$e.append(f))));
            for(var _$e1 = 0; _$e1 < a.length; _$e1 += 1){
                var t1 = a[_$e1];
                var s1 = _$e1;
                h && (s1 = parseInt(t1.getAttribute("data-swiper-slide-index"), 10));
                var o1 = 90 * s1, i1 = Math.floor(o1 / 360);
                l && (o1 = -o1, i1 = Math.floor(-o1 / 360));
                var n1 = Math.max(Math.min(t1.progress, 1), -1);
                var f1 = 0, u = 0, b = 0;
                s1 % 4 == 0 ? (f1 = 4 * -i1 * d, b = 0) : (s1 - 1) % 4 == 0 ? (f1 = 0, b = 4 * -i1 * d) : (s1 - 2) % 4 == 0 ? (f1 = d + 4 * i1 * d, b = d) : (s1 - 3) % 4 == 0 && (f1 = -d, b = 3 * d + 4 * d * i1), l && (f1 = -f1), w || (u = f1, f1 = 0);
                var x = "rotateX(".concat(p(w ? 0 : -o1), "deg) rotateY(").concat(p(w ? o1 : 0), "deg) translate3d(").concat(f1, "px, ").concat(u, "px, ").concat(b, "px)");
                n1 <= 1 && n1 > -1 && (m = 90 * s1 + 90 * n1, l && (m = 90 * -s1 - 90 * n1)), t1.style.transform = x, c.slideShadows && r(t1, n1, w);
            }
            if (s.style.transformOrigin = "50% 50% -".concat(d / 2, "px"), s.style["-webkit-transform-origin"] = "50% 50% -".concat(d / 2, "px"), c.shadow) {
                if (w) f.style.transform = "translate3d(0px, ".concat(o / 2 + c.shadowOffset, "px, ").concat(-o / 2, "px) rotateX(89.99deg) rotateZ(0deg) scale(").concat(c.shadowScale, ")");
                else {
                    var _$e2 = Math.abs(m) - 90 * Math.floor(Math.abs(m) / 90), t2 = 1.5 - (Math.sin(2 * _$e2 * Math.PI / 360) / 2 + Math.cos(2 * _$e2 * Math.PI / 360) / 2), s2 = c.shadowScale, a1 = c.shadowScale / t2, r1 = c.shadowOffset;
                    f.style.transform = "scale3d(".concat(s2, ", 1, ").concat(a1, ") translate3d(0px, ").concat(i / 2 + r1, "px, ").concat(-i / 2 / a1, "px) rotateX(-89.99deg)");
                }
            }
            var u1 = (n.isSafari || n.isWebView) && n.needPerspectiveFix ? -d / 2 : 0;
            s.style.transform = "translate3d(0px,0,".concat(u1, "px) rotateX(").concat(p(t.isHorizontal() ? 0 : m), "deg) rotateY(").concat(p(t.isHorizontal() ? -m : 0), "deg)"), s.style.setProperty("--swiper-cube-translate-z", "".concat(u1, "px"));
        },
        setTransition: function(e) {
            var s = t.el, a = t.slides;
            if (a.forEach(function(t) {
                t.style.transitionDuration = "".concat(e, "ms"), t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(t) {
                    t.style.transitionDuration = "".concat(e, "ms");
                });
            }), t.params.cubeEffect.shadow && !t.isHorizontal()) {
                var t1 = s.querySelector(".swiper-cube-shadow");
                t1 && (t1.style.transitionDuration = "".concat(e, "ms"));
            }
        },
        recreateShadows: function() {
            var _$e = t.isHorizontal();
            t.slides.forEach(function(t) {
                var s = Math.max(Math.min(t.progress, 1), -1);
                r(t, s, _$e);
            });
        },
        getEffectParams: function() {
            return t.params.cubeEffect;
        },
        perspective: function() {
            return !0;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: !1,
                virtualTranslate: !0
            };
        }
    });
}



function $2419434afdd3d6b4$export$db3b6bfb95261072(e, t, r) {
    var s = "swiper-slide-shadow".concat(r ? "-".concat(r) : "").concat(e ? " swiper-slide-shadow-".concat(e) : ""), a = (0, $3d818fcc5f3623ef$export$39b482c5e57630a8)(t);
    var i = a.querySelector(".".concat(s.split(" ").join(".")));
    return i || (i = (0, $3d818fcc5f3623ef$export$db3b6bfb95261072)("div", s.split(" ")), a.append(i)), i;
}






function $09307598adc1728c$export$2e2bcd8739ae039(e) {
    var t = e.swiper, s = e.extendParams, a = e.on;
    s({
        flipEffect: {
            slideShadows: !0,
            limitRotation: !0
        }
    });
    var r = function(e, s) {
        var a = t.isHorizontal() ? e.querySelector(".swiper-slide-shadow-left") : e.querySelector(".swiper-slide-shadow-top"), r = t.isHorizontal() ? e.querySelector(".swiper-slide-shadow-right") : e.querySelector(".swiper-slide-shadow-bottom");
        a || (a = (0, $2419434afdd3d6b4$export$db3b6bfb95261072)("flip", e, t.isHorizontal() ? "left" : "top")), r || (r = (0, $2419434afdd3d6b4$export$db3b6bfb95261072)("flip", e, t.isHorizontal() ? "right" : "bottom")), a && (a.style.opacity = Math.max(-s, 0)), r && (r.style.opacity = Math.max(s, 0));
    };
    (0, $9098ef0f27106a99$export$f1e1789686576879)({
        effect: "flip",
        swiper: t,
        on: a,
        setTranslate: function() {
            var _$e = t.slides, s = t.rtlTranslate, a = t.params.flipEffect, i = (0, $3d818fcc5f3623ef$export$ae1af26003f05816)(t);
            for(var o = 0; o < _$e.length; o += 1){
                var l = _$e[o];
                var f = l.progress;
                t.params.flipEffect.limitRotation && (f = Math.max(Math.min(l.progress, 1), -1));
                var n = l.swiperSlideOffset;
                var p = -180 * f, d = 0, m = t.params.cssMode ? -n - t.translate : -n, c = 0;
                t.isHorizontal() ? s && (p = -p) : (c = m, m = 0, d = -p, p = 0), l.style.zIndex = -Math.abs(Math.round(f)) + _$e.length, a.slideShadows && r(l, f);
                var h = "translate3d(".concat(m, "px, ").concat(c, "px, 0px) rotateX(").concat(i(d), "deg) rotateY(").concat(i(p), "deg)");
                (0, $e7f15398eb23ab92$export$f1e1789686576879)(a, l).style.transform = h;
            }
        },
        setTransition: function(e) {
            var s = t.slides.map(function(e) {
                return (0, $3d818fcc5f3623ef$export$39b482c5e57630a8)(e);
            });
            s.forEach(function(t) {
                t.style.transitionDuration = "".concat(e, "ms"), t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(t) {
                    t.style.transitionDuration = "".concat(e, "ms");
                });
            }), (0, $7f75e8e871e908f6$export$f1e1789686576879)({
                swiper: t,
                duration: e,
                transformElements: s
            });
        },
        recreateShadows: function() {
            t.params.flipEffect, t.slides.forEach(function(e) {
                var s = e.progress;
                t.params.flipEffect.limitRotation && (s = Math.max(Math.min(e.progress, 1), -1)), r(e, s);
            });
        },
        getEffectParams: function() {
            return t.params.flipEffect;
        },
        perspective: function() {
            return !0;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: !0,
                spaceBetween: 0,
                virtualTranslate: !t.params.cssMode
            };
        }
    });
}






function $6dfccc208e7e2f5d$export$2e2bcd8739ae039(e) {
    var t = e.swiper, s = e.extendParams, r = e.on;
    s({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: !0
        }
    });
    (0, $9098ef0f27106a99$export$f1e1789686576879)({
        effect: "coverflow",
        swiper: t,
        on: r,
        setTranslate: function() {
            var _$e = t.width, s = t.height, r = t.slides, o = t.slidesSizesGrid, a = t.params.coverflowEffect, i = t.isHorizontal(), l = t.translate, f = i ? _$e / 2 - l : s / 2 - l, d = i ? a.rotate : -a.rotate, c = a.depth, h = (0, $3d818fcc5f3623ef$export$ae1af26003f05816)(t);
            for(var _$e1 = 0, t1 = r.length; _$e1 < t1; _$e1 += 1){
                var t2 = r[_$e1], s1 = o[_$e1], l1 = (f - t2.swiperSlideOffset - s1 / 2) / s1, n = "function" == typeof a.modifier ? a.modifier(l1) : l1 * a.modifier;
                var w = i ? d * n : 0, p = i ? 0 : d * n, m = -c * Math.abs(n), g = a.stretch;
                "string" == typeof g && -1 !== g.indexOf("%") && (g = parseFloat(a.stretch) / 100 * s1);
                var y = i ? 0 : g * n, S = i ? g * n : 0, b = 1 - (1 - a.scale) * Math.abs(n);
                Math.abs(S) < .001 && (S = 0), Math.abs(y) < .001 && (y = 0), Math.abs(m) < .001 && (m = 0), Math.abs(w) < .001 && (w = 0), Math.abs(p) < .001 && (p = 0), Math.abs(b) < .001 && (b = 0);
                var u = "translate3d(".concat(S, "px,").concat(y, "px,").concat(m, "px)  rotateX(").concat(h(p), "deg) rotateY(").concat(h(w), "deg) scale(").concat(b, ")");
                if ((0, $e7f15398eb23ab92$export$f1e1789686576879)(a, t2).style.transform = u, t2.style.zIndex = 1 - Math.abs(Math.round(n)), a.slideShadows) {
                    var _$e2 = i ? t2.querySelector(".swiper-slide-shadow-left") : t2.querySelector(".swiper-slide-shadow-top"), s2 = i ? t2.querySelector(".swiper-slide-shadow-right") : t2.querySelector(".swiper-slide-shadow-bottom");
                    _$e2 || (_$e2 = (0, $2419434afdd3d6b4$export$db3b6bfb95261072)("coverflow", t2, i ? "left" : "top")), s2 || (s2 = (0, $2419434afdd3d6b4$export$db3b6bfb95261072)("coverflow", t2, i ? "right" : "bottom")), _$e2 && (_$e2.style.opacity = n > 0 ? n : 0), s2 && (s2.style.opacity = -n > 0 ? -n : 0);
                }
            }
        },
        setTransition: function(e) {
            t.slides.map(function(e) {
                return (0, $3d818fcc5f3623ef$export$39b482c5e57630a8)(e);
            }).forEach(function(t) {
                t.style.transitionDuration = "".concat(e, "ms"), t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(t) {
                    t.style.transitionDuration = "".concat(e, "ms");
                });
            });
        },
        perspective: function() {
            return !0;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: !0
            };
        }
    });
}







function $b83484df1f0d4d63$export$2e2bcd8739ae039(e) {
    var t = e.swiper, s = e.extendParams, r = e.on;
    s({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: !1,
            progressMultiplier: 1,
            perspective: !0,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    var a = function(e) {
        return "string" == typeof e ? e : "".concat(e, "px");
    };
    (0, $9098ef0f27106a99$export$f1e1789686576879)({
        effect: "creative",
        swiper: t,
        on: r,
        setTranslate: function() {
            var _loop = function(s1) {
                var r = _$e[s1], c = r.progress, f = Math.min(Math.max(r.progress, -i.limitProgress), i.limitProgress);
                var m = f;
                l || (m = Math.min(Math.max(r.originalProgress, -i.limitProgress), i.limitProgress));
                var p = r.swiperSlideOffset, d = [
                    t.params.cssMode ? -p - t.translate : -p,
                    0,
                    0
                ], g = [
                    0,
                    0,
                    0
                ];
                var h = !1;
                t.isHorizontal() || (d[1] = d[0], d[0] = 0);
                var w = {
                    translate: [
                        0,
                        0,
                        0
                    ],
                    rotate: [
                        0,
                        0,
                        0
                    ],
                    scale: 1,
                    opacity: 1
                };
                f < 0 ? (w = i.next, h = !0) : f > 0 && (w = i.prev, h = !0), d.forEach(function(e, t) {
                    d[t] = "calc(".concat(e, "px + (").concat(a(w.translate[t]), " * ").concat(Math.abs(f * o), "))");
                }), g.forEach(function(e, t) {
                    var s = w.rotate[t] * Math.abs(f * o);
                    g[t] = s;
                }), r.style.zIndex = -Math.abs(Math.round(c)) + _$e.length;
                var y = d.join(", "), u = "rotateX(".concat(n(g[0]), "deg) rotateY(").concat(n(g[1]), "deg) rotateZ(").concat(n(g[2]), "deg)"), v = m < 0 ? "scale(".concat(1 + (1 - w.scale) * m * o, ")") : "scale(".concat(1 - (1 - w.scale) * m * o, ")"), E = m < 0 ? 1 + (1 - w.opacity) * m * o : 1 - (1 - w.opacity) * m * o, M = "translate3d(".concat(y, ") ").concat(u, " ").concat(v);
                if (h && w.shadow || !h) {
                    var _$e1 = r.querySelector(".swiper-slide-shadow");
                    if (!_$e1 && w.shadow && (_$e1 = (0, $2419434afdd3d6b4$export$db3b6bfb95261072)("creative", r)), _$e1) {
                        var t1 = i.shadowPerProgress ? f * (1 / i.limitProgress) : f;
                        _$e1.style.opacity = Math.min(Math.max(Math.abs(t1), 0), 1);
                    }
                }
                var $ = (0, $e7f15398eb23ab92$export$f1e1789686576879)(i, r);
                $.style.transform = M, $.style.opacity = E, w.origin && ($.style.transformOrigin = w.origin);
            };
            var _$e = t.slides, s = t.wrapperEl, r = t.slidesSizesGrid, i = t.params.creativeEffect, o = i.progressMultiplier, l = t.params.centeredSlides, n = (0, $3d818fcc5f3623ef$export$ae1af26003f05816)(t);
            if (l) {
                var _$e1 = r[0] / 2 - t.params.slidesOffsetBefore || 0;
                s.style.transform = "translateX(calc(50% - ".concat(_$e1, "px))");
            }
            for(var s1 = 0; s1 < _$e.length; s1 += 1)_loop(s1);
        },
        setTransition: function(e) {
            var s = t.slides.map(function(e) {
                return (0, $3d818fcc5f3623ef$export$39b482c5e57630a8)(e);
            });
            s.forEach(function(t) {
                t.style.transitionDuration = "".concat(e, "ms"), t.querySelectorAll(".swiper-slide-shadow").forEach(function(t) {
                    t.style.transitionDuration = "".concat(e, "ms");
                });
            }), (0, $7f75e8e871e908f6$export$f1e1789686576879)({
                swiper: t,
                duration: e,
                transformElements: s,
                allSlides: !0
            });
        },
        perspective: function() {
            return t.params.creativeEffect.perspective;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: !0,
                virtualTranslate: !t.params.cssMode
            };
        }
    });
}







function $acc980c35aa1c65c$export$2e2bcd8739ae039(e) {
    var t = e.swiper, a = e.extendParams, s = e.on;
    a({
        cardsEffect: {
            slideShadows: !0,
            rotate: !0,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    (0, $9098ef0f27106a99$export$f1e1789686576879)({
        effect: "cards",
        swiper: t,
        on: s,
        setTranslate: function() {
            var _$e = t.slides, a = t.activeIndex, s = t.rtlTranslate, r = t.params.cardsEffect, _t_touchEventsData = t.touchEventsData, i = _t_touchEventsData.startTranslate, n = _t_touchEventsData.isTouched, o = s ? -t.translate : t.translate;
            for(var l = 0; l < _$e.length; l += 1){
                var d = _$e[l], f = d.progress, c = Math.min(Math.max(f, -4), 4);
                var m = d.swiperSlideOffset;
                t.params.centeredSlides && !t.params.cssMode && (t.wrapperEl.style.transform = "translateX(".concat(t.minTranslate(), "px)")), t.params.centeredSlides && t.params.cssMode && (m -= _$e[0].swiperSlideOffset);
                var p = t.params.cssMode ? -m - t.translate : -m, h = 0;
                var M = -100 * Math.abs(c);
                var u = 1, w = -r.perSlideRotate * c, S = r.perSlideOffset - .75 * Math.abs(c);
                var $ = t.virtual && t.params.virtual.enabled ? t.virtual.from + l : l, E = ($ === a || $ === a - 1) && c > 0 && c < 1 && (n || t.params.cssMode) && o < i, T = ($ === a || $ === a + 1) && c < 0 && c > -1 && (n || t.params.cssMode) && o > i;
                if (E || T) {
                    var _$e1 = Math.pow(1 - Math.abs((Math.abs(c) - .5) / .5), .5);
                    w += -28 * c * _$e1, u += -0.5 * _$e1, S += 96 * _$e1, h = -25 * _$e1 * Math.abs(c) + "%";
                }
                if (p = c < 0 ? "calc(".concat(p, "px ").concat(s ? "-" : "+", " (").concat(S * Math.abs(c), "%))") : c > 0 ? "calc(".concat(p, "px ").concat(s ? "-" : "+", " (-").concat(S * Math.abs(c), "%))") : "".concat(p, "px"), !t.isHorizontal()) {
                    var _$e2 = h;
                    h = p, p = _$e2;
                }
                var g = c < 0 ? "" + (1 + (1 - u) * c) : "" + (1 - (1 - u) * c), x = "\n        translate3d(".concat(p, ", ").concat(h, ", ").concat(M, "px)\n        rotateZ(").concat(r.rotate ? s ? -w : w : 0, "deg)\n        scale(").concat(g, ")\n      ");
                if (r.slideShadows) {
                    var _$e3 = d.querySelector(".swiper-slide-shadow");
                    _$e3 || (_$e3 = (0, $2419434afdd3d6b4$export$db3b6bfb95261072)("cards", d)), _$e3 && (_$e3.style.opacity = Math.min(Math.max((Math.abs(c) - .5) / .5, 0), 1));
                }
                d.style.zIndex = -Math.abs(Math.round(f)) + _$e.length;
                (0, $e7f15398eb23ab92$export$f1e1789686576879)(r, d).style.transform = x;
            }
        },
        setTransition: function(e) {
            var a = t.slides.map(function(e) {
                return (0, $3d818fcc5f3623ef$export$39b482c5e57630a8)(e);
            });
            a.forEach(function(t) {
                t.style.transitionDuration = "".concat(e, "ms"), t.querySelectorAll(".swiper-slide-shadow").forEach(function(t) {
                    t.style.transitionDuration = "".concat(e, "ms");
                });
            }), (0, $7f75e8e871e908f6$export$f1e1789686576879)({
                swiper: t,
                duration: e,
                transformElements: a
            });
        },
        perspective: function() {
            return !0;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: !0,
                virtualTranslate: !t.params.cssMode
            };
        }
    });
}


var $d381a9f09f9db25d$var$modules = [
    (0, $b8fb24d539d209e4$export$2e2bcd8739ae039),
    (0, $607eef6585fb7b7e$export$2e2bcd8739ae039),
    (0, $5928d7bd776b2661$export$2e2bcd8739ae039),
    (0, $2acb5e3868b1053e$export$2e2bcd8739ae039),
    (0, $0ff460f2e2cdf036$export$2e2bcd8739ae039),
    (0, $af4e7a815fd0758b$export$2e2bcd8739ae039),
    (0, $3ca97b77ee35cc1e$export$2e2bcd8739ae039),
    (0, $ef6e216fccc43749$export$2e2bcd8739ae039),
    (0, $9a809c9b08b3f142$export$2e2bcd8739ae039),
    (0, $a6e98af9a406f094$export$2e2bcd8739ae039),
    (0, $388762d23b1d407c$export$2e2bcd8739ae039),
    (0, $44b3e235203ce2e1$export$2e2bcd8739ae039),
    (0, $c5a028391d499387$export$2e2bcd8739ae039),
    (0, $879a041fb00d3e14$export$2e2bcd8739ae039),
    (0, $559be6446ef208c3$export$2e2bcd8739ae039),
    (0, $58a15e9618d5ba1c$export$2e2bcd8739ae039),
    (0, $7d87364182dc34e5$export$2e2bcd8739ae039),
    (0, $48b4eb7b02f56e3c$export$2e2bcd8739ae039),
    (0, $e4b05f06709975e1$export$2e2bcd8739ae039),
    (0, $09307598adc1728c$export$2e2bcd8739ae039),
    (0, $6dfccc208e7e2f5d$export$2e2bcd8739ae039),
    (0, $b83484df1f0d4d63$export$2e2bcd8739ae039),
    (0, $acc980c35aa1c65c$export$2e2bcd8739ae039)
];
(0, $7704c8facc3d92c9$export$25ce5a424b770e84).use($d381a9f09f9db25d$var$modules);


document.addEventListener('DOMContentLoaded', function() {
    var heroswiper = document.querySelectorAll('#myHeroSlider');
    if (heroswiper.length) {
        var videoInSwiper = function videoInSwiper(swiper, video) {
            var waitForDuration = setInterval(function() {
                if (!isNaN(video.duration) && !video.classList.contains('pause')) {
                    console.log(video.classList);
                    video.volume = 0;
                    video.currentTime = 0;
                    video.play();
                    var newAutoplayTime = video.duration * 1000;
                    swiper.params.autoplay.delay = newAutoplayTime;
                    clearInterval(waitForDuration);
                }
            }, 50);
        };
        var regularAutoplayTime = 5000;
        var AutoplayTimeIsKnown = 0;
        var autoplayTime;
        if (document.querySelectorAll('#myHeroSlider .swiper-slide > video').length) {
            var video = document.querySelector('#myHeroSlider .swiper-slide > video');
            var waitForDuration = setInterval(function() {
                if (!isNaN(video.duration)) {
                    autoplayTime = video.duration * 1000;
                    AutoplayTimeIsKnown = 1;
                    clearInterval(waitForDuration);
                }
            }, 50);
        } else {
            autoplayTime = regularAutoplayTime;
            AutoplayTimeIsKnown = 1;
            console.log('video loaded');
        }
        var initHeroSwiper = setInterval(function() {
            if (AutoplayTimeIsKnown == 1) {
                var mySwiper = new (0, $7704c8facc3d92c9$export$25ce5a424b770e84)('.mySwiper', {
                    // Optional parameters
                    direction: 'horizontal',
                    loop: true,
                    speed: 1200,
                    grabCursor: false,
                    mousewheel: false,
                    // Autoplay aus
                    // autoplay: {
                    //   delay: autoplayTime
                    // },
                    pauseOnMouseEnter: false,
                    slidesPerView: 1,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    // Navigation arrows
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                });
                mySwiper.on('slideChange', function() {
                    var swiper = this;
                    // console.log('change slide');
                    if (document.querySelector('#myHeroSlider .swiper-slide-next').querySelectorAll('video').length) videoInSwiper(swiper, document.querySelector('#myHeroSlider .swiper-slide-next').querySelector('video'));
                    else swiper.params.autoplay.delay = regularAutoplayTime;
                });
                if (document.querySelector('#myHeroSlider .swiper-slide-active').querySelectorAll('video').length) videoInSwiper(mySwiper, document.querySelector('#myHeroSlider .swiper-slide-active').querySelector('video'));
                else mySwiper.params.autoplay.delay = regularAutoplayTime;
                clearInterval(initHeroSwiper);
            }
        }, 100);
        var viewportWidth = window.innerWidth;
        var element = document.querySelector('.carousel-caption');
        if (element && viewportWidth > 1199) {
            var observer = new IntersectionObserver(function(entries) {
                element.classList.toggle('slide-in-left', entries[0].isIntersecting);
            });
            observer.observe(element);
        }
    }
});
// Swiper mit Play/Pause Button
document.addEventListener('DOMContentLoaded', function() {
    var buttons = document.querySelectorAll('.play-pause-btn');
    var videos = document.querySelectorAll('.swiper-video');
    function addPlayPauseFunctionality(button, video) {
        button.addEventListener('click', function() {
            if (video.paused) {
                video.play();
                button.classList.add('play');
                button.classList.remove('pause');
                video.classList.add('play');
                video.classList.remove('pause');
            } else {
                video.pause();
                button.classList.add('pause');
                button.classList.remove('play');
                video.classList.add('pause');
                video.classList.remove('play');
            }
        });
        video.addEventListener('ended', videoEnded);
        function videoEnded() {
            // console.log('video ended');
            button.classList.add('pause');
            button.classList.remove('play');
            video.classList.add('pause');
            video.classList.remove('play');
        }
    }
    buttons.forEach(function(button, index) {
        addPlayPauseFunctionality(button, videos[index]);
    });
});
// Hero-Swiper Play-Botton Position
function $84e3e29ac4d35627$var$updateButtonPosition() {
    var viewportWidth = window.innerWidth;
    var swiperCaptions = document.querySelectorAll('.swiper-caption');
    var btnPositions = document.querySelectorAll('.play-pause-btn');
    if (swiperCaptions && btnPositions) swiperCaptions.forEach(function(swiperCaption, index) {
        var btnPosition = btnPositions[index];
        if (btnPosition) {
            if (viewportWidth < 991) {
                var captionHeight = swiperCaption.clientHeight;
                captionHeight += 20;
                btnPosition.style.bottom = captionHeight + 'px';
            } else btnPosition.style.bottom = "50px";
        }
    });
}
window.addEventListener('load', $84e3e29ac4d35627$var$updateButtonPosition);
window.addEventListener('resize', $84e3e29ac4d35627$var$updateButtonPosition);
var $84e3e29ac4d35627$var$swiper1 = new (0, $7704c8facc3d92c9$export$25ce5a424b770e84)('.wasteSwiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    loop: true,
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    breakpoints: {
        640: {
            slidesPerView: 2.5,
            spaceBetween: 20
        },
        991: {
            slidesPerView: 3.5,
            spaceBetween: 40
        },
        1199: {
            slidesPerView: 3.5,
            spaceBetween: 40
        },
        1599: {
            slidesPerView: 5,
            spaceBetween: 50
        }
    },
    watchSlidesProgress: true
});
var $84e3e29ac4d35627$var$swiper2 = new (0, $7704c8facc3d92c9$export$25ce5a424b770e84)('.wasteSwiper2', {
    loop: true,
    spaceBetween: 10,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    thumbs: {
        swiper: $84e3e29ac4d35627$var$swiper1
    }
});


/*####################################################################################################################
#######################################################################################################################
 
 ##     ## ######## ########   #######      ######  ##       #### ########  ######## ########  
 ##     ## ##       ##     ## ##     ##    ##    ## ##        ##  ##     ## ##       ##     ## 
 ##     ## ##       ##     ## ##     ##    ##       ##        ##  ##     ## ##       ##     ## 
 ######### ######   ########  ##     ##     ######  ##        ##  ##     ## ######   ########  
 ##     ## ##       ##   ##   ##     ##          ## ##        ##  ##     ## ##       ##   ##   
 ##     ## ##       ##    ##  ##     ##    ##    ## ##        ##  ##     ## ##       ##    ##  
 ##     ## ######## ##     ##  #######      ######  ######## #### ########  ######## ##     ## 
 
#######################################################################################################################
#####################################################################################################################*/ /**
 * Swiper 11.1.15
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: November 18, 2024
 */ 







/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ 
function $1cc2be8866fc9c93$var$isObject(obj) {
    return obj !== null && (typeof obj === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(obj)) === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $1cc2be8866fc9c93$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach(function(key) {
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($1cc2be8866fc9c93$var$isObject(src[key]) && $1cc2be8866fc9c93$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $1cc2be8866fc9c93$var$extend(target[key], src[key]);
    });
}
var $1cc2be8866fc9c93$var$ssrDocument = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ''
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $1cc2be8866fc9c93$export$39b482c5e57630a8() {
    var doc = typeof document !== 'undefined' ? document : {};
    $1cc2be8866fc9c93$var$extend(doc, $1cc2be8866fc9c93$var$ssrDocument);
    return doc;
}
var $1cc2be8866fc9c93$var$ssrWindow = {
    document: $1cc2be8866fc9c93$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return '';
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function(id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $1cc2be8866fc9c93$export$407448d2b89b1813() {
    var win = typeof window !== 'undefined' ? window : {};
    $1cc2be8866fc9c93$var$extend(win, $1cc2be8866fc9c93$var$ssrWindow);
    return win;
}






function $1d888d7d8ce4491f$export$23f2a1d2818174ef(classes) {
    if (classes === void 0) classes = '';
    return classes.trim().split(' ').filter(function(c) {
        return !!c.trim();
    });
}
function $1d888d7d8ce4491f$export$d141bba7fdc215a3(obj) {
    var object = obj;
    Object.keys(object).forEach(function(key) {
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $1d888d7d8ce4491f$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $1d888d7d8ce4491f$export$4368d992c4eafac0() {
    return Date.now();
}
function $1d888d7d8ce4491f$var$getComputedStyle(el) {
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    var style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $1d888d7d8ce4491f$export$35e795649ee09318(el, axis) {
    if (axis === void 0) axis = 'x';
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = $1d888d7d8ce4491f$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map(function(a) {
            return a.replace(',', '.');
        }).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $1d888d7d8ce4491f$export$882b5998b3b9117c(o) {
    return (typeof o === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(o)) === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $1d888d7d8ce4491f$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $1d888d7d8ce4491f$export$efccba1c4a2ef57b() {
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    var noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(var i = 1; i < arguments.length; i += 1){
        var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$1d888d7d8ce4491f$var$isNode(nextSource)) {
            var keysArray = Object.keys(Object(nextSource)).filter(function(key) {
                return noExtend.indexOf(key) < 0;
            });
            for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($1d888d7d8ce4491f$export$882b5998b3b9117c(to[nextKey]) && $1d888d7d8ce4491f$export$882b5998b3b9117c(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $1d888d7d8ce4491f$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else if (!$1d888d7d8ce4491f$export$882b5998b3b9117c(to[nextKey]) && $1d888d7d8ce4491f$export$882b5998b3b9117c(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $1d888d7d8ce4491f$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $1d888d7d8ce4491f$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $1d888d7d8ce4491f$export$625550452a3fa3ec(_ref) {
    var swiper = _ref.swiper, targetPosition = _ref.targetPosition, side = _ref.side;
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    var startPosition = -swiper.translate;
    var startTime = null;
    var time;
    var duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    var dir = targetPosition > startPosition ? 'next' : 'prev';
    var isOutOfBound = function(current, target) {
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    var animate = function() {
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo((0, $71081ebd7d211bed$export$71511d61b312f219)({}, side, currentPosition));
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(function() {
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo((0, $71081ebd7d211bed$export$71511d61b312f219)({}, side, currentPosition));
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $1d888d7d8ce4491f$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $1d888d7d8ce4491f$export$f1e1789686576879(element, selector) {
    var _children;
    if (selector === void 0) selector = '';
    var children = (0, $1961f7bca441a4c6$export$71511d61b312f219)(element.children);
    if (element instanceof HTMLSlotElement) (_children = children).push.apply(_children, (0, $1961f7bca441a4c6$export$71511d61b312f219)(element.assignedElements()));
    if (!selector) return children;
    return children.filter(function(el) {
        return el.matches(selector);
    });
}
function $1d888d7d8ce4491f$export$90a7f3efeed30595(el, parent) {
    var isChild = parent.contains(el);
    if (!isChild && parent instanceof HTMLSlotElement) {
        var children = (0, $1961f7bca441a4c6$export$71511d61b312f219)(parent.assignedElements());
        return children.includes(el);
    }
    return isChild;
}
function $1d888d7d8ce4491f$export$3b14a55fb2447963(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $1d888d7d8ce4491f$export$db3b6bfb95261072(tag, classes) {
    var _el_classList;
    if (classes === void 0) classes = [];
    var el = document.createElement(tag);
    (_el_classList = el.classList).add.apply(_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(Array.isArray(classes) ? classes : $1d888d7d8ce4491f$export$23f2a1d2818174ef(classes)));
    return el;
}
function $1d888d7d8ce4491f$export$8b22cf2602fb60ce(el) {
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    var document1 = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
    var box = el.getBoundingClientRect();
    var body = document1.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    var scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $1d888d7d8ce4491f$export$43caf9889c228507(el, selector) {
    var prevEls = [];
    while(el.previousElementSibling){
        var prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $1d888d7d8ce4491f$export$9e5f44173e64f162(el, selector) {
    var nextEls = [];
    while(el.nextElementSibling){
        var next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $1d888d7d8ce4491f$export$ffb5f4729a158638(el, prop) {
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $1d888d7d8ce4491f$export$dda1d9f60106f0e9(el) {
    var child = el;
    var i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $1d888d7d8ce4491f$export$407448d2b89b1813(el, selector) {
    var parents = []; // eslint-disable-line
    var parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $1d888d7d8ce4491f$export$342063e11d6c3cad(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $1d888d7d8ce4491f$export$2d1720544b23b823(el, size, includeMargins) {
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $1d888d7d8ce4491f$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter(function(e) {
        return !!e;
    });
}
function $1d888d7d8ce4491f$export$ae1af26003f05816(swiper) {
    return function(v) {
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}


var $b91af9c6f5c98917$var$support;
function $b91af9c6f5c98917$var$calcSupport() {
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    var document1 = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $b91af9c6f5c98917$var$getSupport() {
    if (!$b91af9c6f5c98917$var$support) $b91af9c6f5c98917$var$support = $b91af9c6f5c98917$var$calcSupport();
    return $b91af9c6f5c98917$var$support;
}
var $b91af9c6f5c98917$var$deviceCached;
function $b91af9c6f5c98917$var$calcDevice(_temp) {
    var userAgent = (_temp === void 0 ? {} : _temp).userAgent;
    var support = $b91af9c6f5c98917$var$getSupport();
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    var platform = window1.navigator.platform;
    var ua = userAgent || window1.navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var screenWidth = window1.screen.width;
    var screenHeight = window1.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === 'Win32';
    var macos = platform === 'MacIntel';
    // iPadOs 13 fix
    var iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf("".concat(screenWidth, "x").concat(screenHeight)) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $b91af9c6f5c98917$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$b91af9c6f5c98917$var$deviceCached) $b91af9c6f5c98917$var$deviceCached = $b91af9c6f5c98917$var$calcDevice(overrides);
    return $b91af9c6f5c98917$var$deviceCached;
}
var $b91af9c6f5c98917$var$browser;
function $b91af9c6f5c98917$var$calcBrowser() {
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    var device = $b91af9c6f5c98917$var$getDevice();
    var needPerspectiveFix = false;
    function isSafari() {
        var ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        var ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            var _ua_split__split__split_map = (0, $d98b89efad01a571$export$71511d61b312f219)(ua.split('Version/')[1].split(' ')[0].split('.').map(function(num) {
                return Number(num);
            }), 2), major = _ua_split__split__split_map[0], minor = _ua_split__split__split_map[1];
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    var isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    var isSafariBrowser = isSafari();
    var need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $b91af9c6f5c98917$var$getBrowser() {
    if (!$b91af9c6f5c98917$var$browser) $b91af9c6f5c98917$var$browser = $b91af9c6f5c98917$var$calcBrowser();
    return $b91af9c6f5c98917$var$browser;
}
function $b91af9c6f5c98917$var$Resize(_ref) {
    var swiper = _ref.swiper, on = _ref.on, emit = _ref.emit;
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    var observer = null;
    var animationFrame = null;
    var resizeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    var createObserver = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver(function(entries) {
            animationFrame = window1.requestAnimationFrame(function() {
                var width = swiper.width, height = swiper.height;
                var newWidth = width;
                var newHeight = height;
                entries.forEach(function(_ref2) {
                    var contentBoxSize = _ref2.contentBoxSize, contentRect = _ref2.contentRect, target = _ref2.target;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    var removeObserver = function() {
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    var orientationChangeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', function() {
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', function() {
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $b91af9c6f5c98917$var$Observer(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var observers = [];
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    var attach = function attach(target, options) {
        if (options === void 0) options = {};
        var ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    var init = function() {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = (0, $1d888d7d8ce4491f$export$407448d2b89b1813)(swiper.hostEl);
            for(var i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    var destroy = function() {
        observers.forEach(function(observer) {
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $b91af9c6f5c98917$var$eventsEmitter = {
    on: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        events.split(' ').forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function(handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function(handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function(events, handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach(function(event) {
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function() {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat((0, $1961f7bca441a4c6$export$71511d61b312f219)(data)));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $b91af9c6f5c98917$var$updateSize() {
    var swiper = this;
    var width;
    var height;
    var el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $1d888d7d8ce4491f$export$ffb5f4729a158638)(el, 'padding-left') || 0, 10) - parseInt((0, $1d888d7d8ce4491f$export$ffb5f4729a158638)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $1d888d7d8ce4491f$export$ffb5f4729a158638)(el, 'padding-top') || 0, 10) - parseInt((0, $1d888d7d8ce4491f$export$ffb5f4729a158638)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $b91af9c6f5c98917$var$updateSlides() {
    var swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    var params = swiper.params;
    var wrapperEl = swiper.wrapperEl, slidesEl = swiper.slidesEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = (0, $1d888d7d8ce4491f$export$f1e1789686576879)(slidesEl, ".".concat(swiper.params.slideClass, ", swiper-slide"));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach(function(slideEl) {
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $1d888d7d8ce4491f$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $1d888d7d8ce4491f$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    var slideSize;
    var shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(function(key) {
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = void 0;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $1d888d7d8ce4491f$export$ffb5f4729a158638)(slide, 'display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel('width')] = "";
            var slideStyles = getComputedStyle(slide);
            var currentTransform = slide.style.transform;
            var currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $1d888d7d8ce4491f$export$2d1720544b23b823)(slide, 'width', true) : (0, $1d888d7d8ce4491f$export$2d1720544b23b823)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                var width = getDirectionPropertyValue(slideStyles, 'width');
                var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                var boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    var clientWidth = slide.clientWidth, offsetWidth = slide.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel('width')] = "".concat(slideSize, "px");
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        var newSlidesGrid = [];
        for(var i1 = 0; i1 < snapGrid.length; i1 += 1){
            var slidesGridItem = snapGrid[i1];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i1] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        var size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            var groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            var groupSize = size * params.slidesPerGroup;
            for(var i2 = 0; i2 < groups; i2 += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(var i3 = 0; i3 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i3 += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        var key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach(function(slideEl) {
            slideEl.style[key] = "".concat(spaceBetween, "px");
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        var maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map(function(snap) {
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var allSlidesSize1 = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize1 += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize1 -= spaceBetween;
        var offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize1 + offsetSize < swiperSize) {
            var allSlidesOffset = (swiperSize - allSlidesSize1 - offsetSize) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $1d888d7d8ce4491f$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-before', "".concat(-snapGrid[0], "px"));
        (0, $1d888d7d8ce4491f$export$2408f22a0fab9ae5)(wrapperEl, '--swiper-centered-offset-after', "".concat(swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2, "px"));
        var addToSnapGrid = -swiper.snapGrid[0];
        var addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map(function(v) {
            return v + addToSnapGrid;
        });
        swiper.slidesGrid = swiper.slidesGrid.map(function(v) {
            return v + addToSlidesGrid;
        });
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        var backFaceHiddenClass = "".concat(params.containerModifierClass, "backface-hidden");
        var hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $b91af9c6f5c98917$var$updateAutoHeight(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function(index) {
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = "".concat(newHeight, "px");
}
function $b91af9c6f5c98917$var$updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;
    // eslint-disable-next-line
    var minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
var $b91af9c6f5c98917$var$toggleSlideClasses$1 = function(slideEl, condition, className) {
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $b91af9c6f5c98917$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    var spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var slideBefore = -(offsetCenter - slideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $b91af9c6f5c98917$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $b91af9c6f5c98917$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $b91af9c6f5c98917$var$updateProgress(translate) {
    var swiper = this;
    if (typeof translate === 'undefined') {
        var multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd, progressLoop = swiper.progressLoop;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        var isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        var isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        var firstSlideIndex = swiper.getSlideIndexByData(0);
        var lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        var firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        var lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        var translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        var translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
var $b91af9c6f5c98917$var$toggleSlideClasses = function(slideEl, condition, className) {
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $b91af9c6f5c98917$var$updateSlidesClasses() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, slidesEl = swiper.slidesEl, activeIndex = swiper.activeIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    var getFilteredSlide = function(selector) {
        return (0, $1d888d7d8ce4491f$export$f1e1789686576879)(slidesEl, ".".concat(params.slideClass).concat(selector, ", swiper-slide").concat(selector))[0];
    };
    var activeSlide;
    var prevSlide;
    var nextSlide;
    if (isVirtual) {
        if (params.loop) {
            var slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(slideIndex, '"]'));
        } else activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(activeIndex, '"]'));
    } else if (gridEnabled) {
        activeSlide = slides.filter(function(slideEl) {
            return slideEl.column === activeIndex;
        })[0];
        nextSlide = slides.filter(function(slideEl) {
            return slideEl.column === activeIndex + 1;
        })[0];
        prevSlide = slides.filter(function(slideEl) {
            return slideEl.column === activeIndex - 1;
        })[0];
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $1d888d7d8ce4491f$export$9e5f44173e64f162)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $1d888d7d8ce4491f$export$43caf9889c228507)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
            params.loop;
        }
    }
    slides.forEach(function(slideEl) {
        $b91af9c6f5c98917$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $b91af9c6f5c98917$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $b91af9c6f5c98917$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
var $b91af9c6f5c98917$var$processLazyPreloader = function(swiper, imageEl) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var slideSelector = function() {
        return swiper.isElement ? "swiper-slide" : ".".concat(swiper.params.slideClass);
    };
    var slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        var lazyEl = slideEl.querySelector(".".concat(swiper.params.lazyPreloaderClass));
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(".".concat(swiper.params.lazyPreloaderClass));
            else // init later
            requestAnimationFrame(function() {
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(".".concat(swiper.params.lazyPreloaderClass));
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
var $b91af9c6f5c98917$var$unlazy = function(swiper, index) {
    if (!swiper.slides[index]) return;
    var imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
var $b91af9c6f5c98917$var$preload = function(swiper) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var amount = swiper.params.lazyPreloadPrevNext;
    var len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    var slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    var activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        var _preloadColumns;
        var activeColumn = activeIndex;
        var preloadColumns = [
            activeColumn - amount
        ];
        (_preloadColumns = preloadColumns).push.apply(_preloadColumns, (0, $1961f7bca441a4c6$export$71511d61b312f219)(Array.from({
            length: amount
        }).map(function(_, i) {
            return activeColumn + slidesPerView + i;
        })));
        swiper.slides.forEach(function(slideEl, i) {
            if (preloadColumns.includes(slideEl.column)) $b91af9c6f5c98917$var$unlazy(swiper, i);
        });
        return;
    }
    var slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(var i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        var realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $b91af9c6f5c98917$var$unlazy(swiper, realIndex);
    }
    else {
        for(var i1 = Math.max(activeIndex - amount, 0); i1 <= Math.min(slideIndexLastInView + amount, len - 1); i1 += 1)if (i1 !== activeIndex && (i1 > slideIndexLastInView || i1 < activeIndex)) $b91af9c6f5c98917$var$unlazy(swiper, i1);
    }
};
function $b91af9c6f5c98917$var$getActiveIndexByTranslate(swiper) {
    var slidesGrid = swiper.slidesGrid, params = swiper.params;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var activeIndex;
    for(var i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $b91af9c6f5c98917$var$updateActiveIndex(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    var getVirtualRealIndex = function(aIndex) {
        var realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $b91af9c6f5c98917$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    var realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        var firstSlideInColumn = swiper.slides.filter(function(slideEl) {
            return slideEl.column === activeIndex;
        })[0];
        var activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        var slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $b91af9c6f5c98917$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $b91af9c6f5c98917$var$updateClickedSlide(el, path) {
    var swiper = this;
    var params = swiper.params;
    var slide = el.closest(".".concat(params.slideClass, ", swiper-slide"));
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) (0, $1961f7bca441a4c6$export$71511d61b312f219)(path.slice(path.indexOf(el) + 1, path.length)).forEach(function(pathEl) {
        if (!slide && pathEl.matches && pathEl.matches(".".concat(params.slideClass, ", swiper-slide"))) slide = pathEl;
    });
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $b91af9c6f5c98917$var$update = {
    updateSize: $b91af9c6f5c98917$var$updateSize,
    updateSlides: $b91af9c6f5c98917$var$updateSlides,
    updateAutoHeight: $b91af9c6f5c98917$var$updateAutoHeight,
    updateSlidesOffset: $b91af9c6f5c98917$var$updateSlidesOffset,
    updateSlidesProgress: $b91af9c6f5c98917$var$updateSlidesProgress,
    updateProgress: $b91af9c6f5c98917$var$updateProgress,
    updateSlidesClasses: $b91af9c6f5c98917$var$updateSlidesClasses,
    updateActiveIndex: $b91af9c6f5c98917$var$updateActiveIndex,
    updateClickedSlide: $b91af9c6f5c98917$var$updateClickedSlide
};
function $b91af9c6f5c98917$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, wrapperEl = swiper.wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, $1d888d7d8ce4491f$export$35e795649ee09318)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $b91af9c6f5c98917$var$setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = "translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)");
    }
    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $b91af9c6f5c98917$var$minTranslate() {
    return -this.snapGrid[0];
}
function $b91af9c6f5c98917$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $b91af9c6f5c98917$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var _$minTranslate = swiper.minTranslate();
    var _$maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > _$minTranslate) newTranslate = _$minTranslate;
    else if (translateBounds && translate < _$maxTranslate) newTranslate = _$maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $1d888d7d8ce4491f$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $71081ebd7d211bed$export$71511d61b312f219)(_obj, isH ? 'left' : 'top', -newTranslate), (0, $71081ebd7d211bed$export$71511d61b312f219)(_obj, "behavior", 'smooth'), _obj));
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $b91af9c6f5c98917$var$translate = {
    getTranslate: $b91af9c6f5c98917$var$getSwiperTranslate,
    setTranslate: $b91af9c6f5c98917$var$setTranslate,
    minTranslate: $b91af9c6f5c98917$var$minTranslate,
    maxTranslate: $b91af9c6f5c98917$var$maxTranslate,
    translateTo: $b91af9c6f5c98917$var$translateTo
};
function $b91af9c6f5c98917$var$setTransition(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = "".concat(duration, "ms");
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? "0ms" : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $b91af9c6f5c98917$var$transitionEmit(_ref) {
    var swiper = _ref.swiper, runCallbacks = _ref.runCallbacks, direction = _ref.direction, step = _ref.step;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex;
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit("transition".concat(step));
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit("slideResetTransition".concat(step));
            return;
        }
        swiper.emit("slideChangeTransition".concat(step));
        if (dir === 'next') swiper.emit("slideNextTransition".concat(step));
        else swiper.emit("slidePrevTransition".concat(step));
    }
}
function $b91af9c6f5c98917$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $b91af9c6f5c98917$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $b91af9c6f5c98917$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $b91af9c6f5c98917$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $b91af9c6f5c98917$var$transition = {
    setTransition: $b91af9c6f5c98917$var$setTransition,
    transitionStart: $b91af9c6f5c98917$var$transitionStart,
    transitionEnd: $b91af9c6f5c98917$var$transitionEnd
};
function $b91af9c6f5c98917$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') index = parseInt(index, 10);
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    var translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGrid = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    var direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(function() {
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(function() {
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $1d888d7d8ce4491f$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $71081ebd7d211bed$export$71511d61b312f219)(_obj, isH ? 'left' : 'top', t), (0, $71081ebd7d211bed$export$71511d61b312f219)(_obj, "behavior", 'smooth'), _obj));
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $b91af9c6f5c98917$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') {
        var indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    var newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            var targetSlideIndex;
            if (gridEnabled) {
                var slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.filter(function(slideEl) {
                    return slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex;
                })[0].column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            var cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            var centeredSlides = swiper.params.centeredSlides;
            var slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            var needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                var direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                var slideIndex1 = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.filter(function(slideEl) {
                    return slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex1;
                })[0].column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(function() {
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $b91af9c6f5c98917$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var enabled = swiper.enabled, params = swiper.params, animating = swiper.animating;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(function() {
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $b91af9c6f5c98917$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled, animating = swiper.animating;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
        var prevSnapIndex;
        snapGrid.forEach(function(snap, snapIndex) {
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    var prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        var lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(function() {
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $b91af9c6f5c98917$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $b91af9c6f5c98917$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var currentSnap1 = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap1 - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $b91af9c6f5c98917$var$slideToClickedSlide() {
    var swiper = this;
    if (swiper.destroyed) return;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    var slideSelector = swiper.isElement ? "swiper-slide" : ".".concat(params.slideClass);
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $1d888d7d8ce4491f$export$f1e1789686576879)(slidesEl, "".concat(slideSelector, '[data-swiper-slide-index="').concat(realIndex, '"]'))[0]);
                (0, $1d888d7d8ce4491f$export$7ccc53e8f1e7dfc5)(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $1d888d7d8ce4491f$export$f1e1789686576879)(slidesEl, "".concat(slideSelector, '[data-swiper-slide-index="').concat(realIndex, '"]'))[0]);
            (0, $1d888d7d8ce4491f$export$7ccc53e8f1e7dfc5)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $b91af9c6f5c98917$var$slide = {
    slideTo: $b91af9c6f5c98917$var$slideTo,
    slideToLoop: $b91af9c6f5c98917$var$slideToLoop,
    slideNext: $b91af9c6f5c98917$var$slideNext,
    slidePrev: $b91af9c6f5c98917$var$slidePrev,
    slideReset: $b91af9c6f5c98917$var$slideReset,
    slideToClosest: $b91af9c6f5c98917$var$slideToClosest,
    slideToClickedSlide: $b91af9c6f5c98917$var$slideToClickedSlide
};
function $b91af9c6f5c98917$var$loopCreate(slideRealIndex) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    var initSlides = function() {
        var slides = (0, $1d888d7d8ce4491f$export$f1e1789686576879)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
        slides.forEach(function(el, index) {
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    var slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    var shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    var shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    var addBlankSlides = function(amountOfSlides) {
        for(var i = 0; i < amountOfSlides; i += 1){
            var slideEl = swiper.isElement ? (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            var slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $1d888d7d8ce4491f$export$3b14a55fb2447963)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            var slidesToAdd1 = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd1);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $1d888d7d8ce4491f$export$3b14a55fb2447963)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : 'next'
    });
}
function $b91af9c6f5c98917$var$loopFix(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, slideRealIndex = _ref.slideRealIndex, _ref_slideTo = _ref.slideTo, _$slideTo = _ref_slideTo === void 0 ? true : _ref_slideTo, direction = _ref.direction, _$setTranslate = _ref.setTranslate, activeSlideIndex = _ref.activeSlideIndex, byController = _ref.byController, byMousewheel = _ref.byMousewheel;
    var swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    var slides = swiper.slides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, slidesEl = swiper.slidesEl, params = swiper.params;
    var centeredSlides = params.centeredSlides;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (_$slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    var slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    var slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    var loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides) (0, $1d888d7d8ce4491f$export$3b14a55fb2447963)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $1d888d7d8ce4491f$export$3b14a55fb2447963)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    var prependSlidesIndexes = [];
    var appendSlidesIndexes = [];
    var activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.filter(function(el) {
        return el.classList.contains(params.slideActiveClass);
    })[0]);
    else activeIndex = activeSlideIndex;
    var isNext = direction === 'next' || !direction;
    var isPrev = direction === 'prev' || !direction;
    var slidesPrepended = 0;
    var slidesAppended = 0;
    var cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    var activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    var activeColIndexWithShift = activeColIndex + (centeredSlides && typeof _$setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(var i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            var index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                var colIndexToPrepend = cols - index - 1;
                for(var i1 = slides.length - 1; i1 >= 0; i1 -= 1)if (slides[i1].column === colIndexToPrepend) prependSlidesIndexes.push(i1);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        var _loop = function(i2) {
            var index = i2 - Math.floor(i2 / cols) * cols;
            if (gridEnabled) slides.forEach(function(slide, slideIndex) {
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        };
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        for(var i2 = 0; i2 < slidesAppended; i2 += 1)_loop(i2);
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
    if (isPrev) prependSlidesIndexes.forEach(function(index) {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach(function(index) {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach(function(slide, slideIndex) {
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (_$slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                var currentSlideTranslate = swiper.slidesGrid[activeIndex];
                var newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                var diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (_$setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (_$setTranslate) {
                var shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                var currentSlideTranslate1 = swiper.slidesGrid[activeIndex];
                var newSlideTranslate1 = swiper.slidesGrid[activeIndex - slidesAppended];
                var diff1 = newSlideTranslate1 - currentSlideTranslate1;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff1);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (_$setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff1;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff1;
                    }
                }
            } else {
                var shift1 = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift1, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        var loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: _$setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach(function(c) {
            if (!c.destroyed && c.params.loop) c.loopFix((0, $82dbc585330cff66$export$71511d61b312f219)((0, $34448b2f636abc71$export$71511d61b312f219)({}, loopParams), {
                slideTo: c.params.slidesPerView === params.slidesPerView ? _$slideTo : false
            }));
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix((0, $82dbc585330cff66$export$71511d61b312f219)((0, $34448b2f636abc71$export$71511d61b312f219)({}, loopParams), {
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? _$slideTo : false
        }));
    }
    swiper.emit('loopFix');
}
function $b91af9c6f5c98917$var$loopDestroy() {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    var newSlidesOrder = [];
    swiper.slides.forEach(function(slideEl) {
        var index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach(function(slideEl) {
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach(function(slideEl) {
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $b91af9c6f5c98917$var$loop = {
    loopCreate: $b91af9c6f5c98917$var$loopCreate,
    loopFix: $b91af9c6f5c98917$var$loopFix,
    loopDestroy: $b91af9c6f5c98917$var$loopDestroy
};
function $b91af9c6f5c98917$var$setGrabCursor(moving) {
    var swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}
function $b91af9c6f5c98917$var$unsetGrabCursor() {
    var swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}
var $b91af9c6f5c98917$var$grabCursor = {
    setGrabCursor: $b91af9c6f5c98917$var$setGrabCursor,
    unsetGrabCursor: $b91af9c6f5c98917$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $b91af9c6f5c98917$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)() || el === (0, $1cc2be8866fc9c93$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        var found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $b91af9c6f5c98917$var$preventEdgeSwipe(swiper, event, startX) {
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    var params = swiper.params;
    var edgeSwipeDetection = params.edgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $b91af9c6f5c98917$var$onTouchStart(event) {
    var swiper = this;
    var document1 = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $b91af9c6f5c98917$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    var targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $1d888d7d8ce4491f$export$90a7f3efeed30595)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    var eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass);
    var isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $b91af9c6f5c98917$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$b91af9c6f5c98917$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    var preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $b91af9c6f5c98917$var$onTouchMove(event) {
    var document1 = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        var id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    var targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = (0, $1961f7bca441a4c6$export$71511d61b312f219)(e.changedTouches).filter(function(t) {
            return t.identifier === data.touchId;
        })[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    var pageX = targetTouch.pageX;
    var pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    var diff = swiper.isHorizontal() ? diffX : diffY;
    var touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    var prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    var isLoop = swiper.params.loop && !params.cssMode;
    var allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            var evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    var loopFixed;
    new Date().getTime();
    if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $b91af9c6f5c98917$var$onTouchEnd(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var targetTouch;
    var isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = (0, $1961f7bca441a4c6$export$71511d61b312f219)(e.changedTouches).filter(function(t) {
            return t.identifier === data.touchId;
        })[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        var proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, slidesGrid = swiper.slidesGrid, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    var touchEndTime = (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)();
    var timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        var pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)();
    (0, $1d888d7d8ce4491f$export$7ccc53e8f1e7dfc5)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    var swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    var rewindFirstIndex = null;
    var rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment1 = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment1);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment1);
        else swiper.slideTo(stopIndex);
    }
}
function $b91af9c6f5c98917$var$onResize() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    var isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(function() {
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $b91af9c6f5c98917$var$onClick(e) {
    var swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $b91af9c6f5c98917$var$onScroll() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $b91af9c6f5c98917$var$onLoad(e) {
    var swiper = this;
    $b91af9c6f5c98917$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $b91af9c6f5c98917$var$onDocumentTouchStart() {
    var swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
var $b91af9c6f5c98917$var$events = function(swiper, method) {
    var document1 = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
    var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device;
    var capture = !!params.nested;
    var domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    var swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $b91af9c6f5c98917$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $b91af9c6f5c98917$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $b91af9c6f5c98917$var$attachEvents() {
    var swiper = this;
    var params = swiper.params;
    swiper.onTouchStart = $b91af9c6f5c98917$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $b91af9c6f5c98917$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $b91af9c6f5c98917$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $b91af9c6f5c98917$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $b91af9c6f5c98917$var$onScroll.bind(swiper);
    swiper.onClick = $b91af9c6f5c98917$var$onClick.bind(swiper);
    swiper.onLoad = $b91af9c6f5c98917$var$onLoad.bind(swiper);
    $b91af9c6f5c98917$var$events(swiper, 'on');
}
function $b91af9c6f5c98917$var$detachEvents() {
    var swiper = this;
    $b91af9c6f5c98917$var$events(swiper, 'off');
}
var $b91af9c6f5c98917$var$events$1 = {
    attachEvents: $b91af9c6f5c98917$var$attachEvents,
    detachEvents: $b91af9c6f5c98917$var$detachEvents
};
var $b91af9c6f5c98917$var$isGridEnabled = function(swiper, params) {
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $b91af9c6f5c98917$var$setBreakpoint() {
    var swiper = this;
    var realIndex = swiper.realIndex, initialized = swiper.initialized, params = swiper.params, el = swiper.el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = $b91af9c6f5c98917$var$isGridEnabled(swiper, params);
    var isMultiRow = $b91af9c6f5c98917$var$isGridEnabled(swiper, breakpointParams);
    var wasGrabCursor = swiper.params.grabCursor;
    var isGrabCursor = breakpointParams.grabCursor;
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove("".concat(params.containerModifierClass, "grid"), "".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add("".concat(params.containerModifierClass, "grid"));
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add("".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach(function(prop) {
        if (typeof breakpointParams[prop] === 'undefined') return;
        var wasModuleEnabled = params[prop] && params[prop].enabled;
        var isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    var wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $1d888d7d8ce4491f$export$efccba1c4a2ef57b)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    var hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $b91af9c6f5c98917$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = 'window';
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    var breakpoint = false;
    var window1 = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    var currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points_i = points[i], point = _points_i.point, value = _points_i.value;
        if (base === 'window') {
            if (window1.matchMedia("(min-width: ".concat(value, "px)")).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $b91af9c6f5c98917$var$breakpoints = {
    setBreakpoint: $b91af9c6f5c98917$var$setBreakpoint,
    getBreakpoint: $b91af9c6f5c98917$var$getBreakpoint
};
function $b91af9c6f5c98917$var$prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if ((typeof item === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(item)) === 'object') Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $b91af9c6f5c98917$var$addClasses() {
    var _classNames, _el_classList;
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, el = swiper.el, device = swiper.device;
    // prettier-ignore
    var suffixes = $b91af9c6f5c98917$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    (_classNames = classNames).push.apply(_classNames, (0, $1961f7bca441a4c6$export$71511d61b312f219)(suffixes));
    (_el_classList = el.classList).add.apply(_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(classNames));
    swiper.emitContainerClasses();
}
function $b91af9c6f5c98917$var$removeClasses() {
    var _el_classList;
    var swiper = this;
    var el = swiper.el, classNames = swiper.classNames;
    if (!el || typeof el === 'string') return;
    (_el_classList = el.classList).remove.apply(_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(classNames));
    swiper.emitContainerClasses();
}
var $b91af9c6f5c98917$var$classes = {
    addClasses: $b91af9c6f5c98917$var$addClasses,
    removeClasses: $b91af9c6f5c98917$var$removeClasses
};
function $b91af9c6f5c98917$var$checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked, params = swiper.params;
    var slidesOffsetBefore = params.slidesOffsetBefore;
    if (slidesOffsetBefore) {
        var lastSlideIndex = swiper.slides.length - 1;
        var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $b91af9c6f5c98917$var$checkOverflow$1 = {
    checkOverflow: $b91af9c6f5c98917$var$checkOverflow
};
var $b91af9c6f5c98917$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $b91af9c6f5c98917$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        var moduleParamName = Object.keys(obj)[0];
        var moduleParams = obj[moduleParamName];
        if ((typeof moduleParams === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(moduleParams)) !== 'object' || moduleParams === null) {
            (0, $1d888d7d8ce4491f$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $1d888d7d8ce4491f$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if ((0, $17c6da0aa640e82f$export$71511d61b312f219)(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $1d888d7d8ce4491f$export$efccba1c4a2ef57b)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ var $b91af9c6f5c98917$var$prototypes = {
    eventsEmitter: $b91af9c6f5c98917$var$eventsEmitter,
    update: $b91af9c6f5c98917$var$update,
    translate: $b91af9c6f5c98917$var$translate,
    transition: $b91af9c6f5c98917$var$transition,
    slide: $b91af9c6f5c98917$var$slide,
    loop: $b91af9c6f5c98917$var$loop,
    grabCursor: $b91af9c6f5c98917$var$grabCursor,
    events: $b91af9c6f5c98917$var$events$1,
    breakpoints: $b91af9c6f5c98917$var$breakpoints,
    checkOverflow: $b91af9c6f5c98917$var$checkOverflow$1,
    classes: $b91af9c6f5c98917$var$classes
};
var $b91af9c6f5c98917$var$extendedDefaults = {};
var $b91af9c6f5c98917$export$25ce5a424b770e84 = /*#__PURE__*/ function() {
    "use strict";
    function Swiper() {
        var _swiper_modules;
        (0, $aa63010954ffd74c$export$71511d61b312f219)(this, Swiper);
        var el;
        var params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var ref;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else ref = (0, $d98b89efad01a571$export$71511d61b312f219)(args, 2), el = ref[0], params = ref[1], ref;
        if (!params) params = {};
        params = (0, $1d888d7d8ce4491f$export$efccba1c4a2ef57b)({}, params);
        if (el && !params.el) params.el = el;
        var document1 = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            var swipers = [];
            document1.querySelectorAll(params.el).forEach(function(containerEl) {
                var newParams = (0, $1d888d7d8ce4491f$export$efccba1c4a2ef57b)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $b91af9c6f5c98917$var$getSupport();
        swiper.device = $b91af9c6f5c98917$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $b91af9c6f5c98917$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = (0, $1961f7bca441a4c6$export$71511d61b312f219)(swiper.__modules__);
        if (params.modules && Array.isArray(params.modules)) (_swiper_modules = swiper.modules).push.apply(_swiper_modules, (0, $1961f7bca441a4c6$export$71511d61b312f219)(params.modules));
        var allModulesParams = {};
        swiper.modules.forEach(function(mod) {
            mod({
                params: params,
                swiper: swiper,
                extendParams: $b91af9c6f5c98917$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        var swiperParams = (0, $1d888d7d8ce4491f$export$efccba1c4a2ef57b)({}, $b91af9c6f5c98917$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $1d888d7d8ce4491f$export$efccba1c4a2ef57b)({}, swiperParams, $b91af9c6f5c98917$var$extendedDefaults, params);
        swiper.originalParams = (0, $1d888d7d8ce4491f$export$efccba1c4a2ef57b)({}, swiper.params);
        swiper.passedParams = (0, $1d888d7d8ce4491f$export$efccba1c4a2ef57b)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach(function(eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function() {
                return swiper.params.direction === 'horizontal';
            },
            isVertical: function() {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment: function() {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    (0, $5a9423d6bdf9478a$export$71511d61b312f219)(Swiper, [
        {
            key: "getDirectionLabel",
            value: function getDirectionLabel(property) {
                if (this.isHorizontal()) return property;
                // prettier-ignore
                return ({
                    'width': 'height',
                    'margin-top': 'margin-left',
                    'margin-bottom ': 'margin-right',
                    'margin-left': 'margin-top',
                    'margin-right': 'margin-bottom',
                    'padding-left': 'padding-top',
                    'padding-right': 'padding-bottom',
                    'marginRight': 'marginBottom'
                })[property];
            }
        },
        {
            key: "getSlideIndex",
            value: function getSlideIndex(slideEl) {
                var _this = this, slidesEl = _this.slidesEl, params = _this.params;
                var slides = (0, $1d888d7d8ce4491f$export$f1e1789686576879)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
                var firstSlideIndex = (0, $1d888d7d8ce4491f$export$dda1d9f60106f0e9)(slides[0]);
                return (0, $1d888d7d8ce4491f$export$dda1d9f60106f0e9)(slideEl) - firstSlideIndex;
            }
        },
        {
            key: "getSlideIndexByData",
            value: function getSlideIndexByData(index) {
                return this.getSlideIndex(this.slides.filter(function(slideEl) {
                    return slideEl.getAttribute('data-swiper-slide-index') * 1 === index;
                })[0]);
            }
        },
        {
            key: "recalcSlides",
            value: function recalcSlides() {
                var swiper = this;
                var slidesEl = swiper.slidesEl, params = swiper.params;
                swiper.slides = (0, $1d888d7d8ce4491f$export$f1e1789686576879)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
            }
        },
        {
            key: "enable",
            value: function enable() {
                var swiper = this;
                if (swiper.enabled) return;
                swiper.enabled = true;
                if (swiper.params.grabCursor) swiper.setGrabCursor();
                swiper.emit('enable');
            }
        },
        {
            key: "disable",
            value: function disable() {
                var swiper = this;
                if (!swiper.enabled) return;
                swiper.enabled = false;
                if (swiper.params.grabCursor) swiper.unsetGrabCursor();
                swiper.emit('disable');
            }
        },
        {
            key: "setProgress",
            value: function setProgress(progress, speed) {
                var swiper = this;
                progress = Math.min(Math.max(progress, 0), 1);
                var min = swiper.minTranslate();
                var max = swiper.maxTranslate();
                var current = (max - min) * progress + min;
                swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
            }
        },
        {
            key: "emitContainerClasses",
            value: function emitContainerClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var cls = swiper.el.className.split(' ').filter(function(className) {
                    return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
                });
                swiper.emit('_containerClasses', cls.join(' '));
            }
        },
        {
            key: "getSlideClasses",
            value: function getSlideClasses(slideEl) {
                var swiper = this;
                if (swiper.destroyed) return '';
                return slideEl.className.split(' ').filter(function(className) {
                    return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
                }).join(' ');
            }
        },
        {
            key: "emitSlidesClasses",
            value: function emitSlidesClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var updates = [];
                swiper.slides.forEach(function(slideEl) {
                    var classNames = swiper.getSlideClasses(slideEl);
                    updates.push({
                        slideEl: slideEl,
                        classNames: classNames
                    });
                    swiper.emit('_slideClass', slideEl, classNames);
                });
                swiper.emit('_slideClasses', updates);
            }
        },
        {
            key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic(view, exact) {
                if (view === void 0) view = 'current';
                if (exact === void 0) exact = false;
                var swiper = this;
                var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, slidesSizesGrid = swiper.slidesSizesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
                var spv = 1;
                if (typeof params.slidesPerView === 'number') return params.slidesPerView;
                if (params.centeredSlides) {
                    var slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
                    var breakLoop;
                    for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                        slideSize += Math.ceil(slides[i].swiperSlideSize);
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                    for(var i1 = activeIndex - 1; i1 >= 0; i1 -= 1)if (slides[i1] && !breakLoop) {
                        slideSize += slides[i1].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                } else {
                    // eslint-disable-next-line
                    if (view === 'current') for(var i2 = activeIndex + 1; i2 < slides.length; i2 += 1){
                        var slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
                        if (slideInView) spv += 1;
                    }
                    else // previous
                    for(var i3 = activeIndex - 1; i3 >= 0; i3 -= 1){
                        var slideInView1 = slidesGrid[activeIndex] - slidesGrid[i3] < swiperSize;
                        if (slideInView1) spv += 1;
                    }
                }
                return spv;
            }
        },
        {
            key: "update",
            value: function update() {
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid, params = swiper.params;
                // Breakpoints
                if (params.breakpoints) swiper.setBreakpoint();
                (0, $1961f7bca441a4c6$export$71511d61b312f219)(swiper.el.querySelectorAll('[loading="lazy"]')).forEach(function(imageEl) {
                    if (imageEl.complete) $b91af9c6f5c98917$var$processLazyPreloader(swiper, imageEl);
                });
                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                function setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                }
                var translated;
                if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
                    setTranslate();
                    if (params.autoHeight) swiper.updateAutoHeight();
                } else {
                    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                        var slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                        translated = swiper.slideTo(slides.length - 1, 0, false, true);
                    } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    if (!translated) setTranslate();
                }
                if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
                swiper.emit('update');
            }
        },
        {
            key: "changeDirection",
            value: function changeDirection(newDirection, needUpdate) {
                if (needUpdate === void 0) needUpdate = true;
                var swiper = this;
                var currentDirection = swiper.params.direction;
                if (!newDirection) // eslint-disable-next-line
                newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
                if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
                swiper.el.classList.remove("".concat(swiper.params.containerModifierClass).concat(currentDirection));
                swiper.el.classList.add("".concat(swiper.params.containerModifierClass).concat(newDirection));
                swiper.emitContainerClasses();
                swiper.params.direction = newDirection;
                swiper.slides.forEach(function(slideEl) {
                    if (newDirection === 'vertical') slideEl.style.width = '';
                    else slideEl.style.height = '';
                });
                swiper.emit('changeDirection');
                if (needUpdate) swiper.update();
                return swiper;
            }
        },
        {
            key: "changeLanguageDirection",
            value: function changeLanguageDirection(direction) {
                var swiper = this;
                if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
                swiper.rtl = direction === 'rtl';
                swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
                if (swiper.rtl) {
                    swiper.el.classList.add("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = 'rtl';
                } else {
                    swiper.el.classList.remove("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = 'ltr';
                }
                swiper.update();
            }
        },
        {
            key: "mount",
            value: function mount(element) {
                var swiper = this;
                if (swiper.mounted) return true;
                // Find el
                var el = element || swiper.params.el;
                if (typeof el === 'string') el = document.querySelector(el);
                if (!el) return false;
                el.swiper = swiper;
                if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
                var getWrapperSelector = function() {
                    return ".".concat((swiper.params.wrapperClass || '').trim().split(' ').join('.'));
                };
                var getWrapper = function() {
                    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                        var res = el.shadowRoot.querySelector(getWrapperSelector());
                        // Children needs to return slot items
                        return res;
                    }
                    return (0, $1d888d7d8ce4491f$export$f1e1789686576879)(el, getWrapperSelector())[0];
                };
                // Find Wrapper
                var wrapperEl = getWrapper();
                if (!wrapperEl && swiper.params.createElements) {
                    wrapperEl = (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
                    el.append(wrapperEl);
                    (0, $1d888d7d8ce4491f$export$f1e1789686576879)(el, ".".concat(swiper.params.slideClass)).forEach(function(slideEl) {
                        wrapperEl.append(slideEl);
                    });
                }
                Object.assign(swiper, {
                    el: el,
                    wrapperEl: wrapperEl,
                    slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
                    hostEl: swiper.isElement ? el.parentNode.host : el,
                    mounted: true,
                    // RTL
                    rtl: el.dir.toLowerCase() === 'rtl' || (0, $1d888d7d8ce4491f$export$ffb5f4729a158638)(el, 'direction') === 'rtl',
                    rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $1d888d7d8ce4491f$export$ffb5f4729a158638)(el, 'direction') === 'rtl'),
                    wrongRTL: (0, $1d888d7d8ce4491f$export$ffb5f4729a158638)(wrapperEl, 'display') === '-webkit-box'
                });
                return true;
            }
        },
        {
            key: "init",
            value: function init(el) {
                var _lazyElements;
                var swiper = this;
                if (swiper.initialized) return swiper;
                var mounted = swiper.mount(el);
                if (mounted === false) return swiper;
                swiper.emit('beforeInit');
                // Set breakpoint
                if (swiper.params.breakpoints) swiper.setBreakpoint();
                // Add Classes
                swiper.addClasses();
                // Update size
                swiper.updateSize();
                // Update slides
                swiper.updateSlides();
                if (swiper.params.watchOverflow) swiper.checkOverflow();
                // Set Grab Cursor
                if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
                // Slide To Initial Slide
                if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
                else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
                // Create loop
                if (swiper.params.loop) swiper.loopCreate();
                // Attach events
                swiper.attachEvents();
                var lazyElements = (0, $1961f7bca441a4c6$export$71511d61b312f219)(swiper.el.querySelectorAll('[loading="lazy"]'));
                if (swiper.isElement) (_lazyElements = lazyElements).push.apply(_lazyElements, (0, $1961f7bca441a4c6$export$71511d61b312f219)(swiper.hostEl.querySelectorAll('[loading="lazy"]')));
                lazyElements.forEach(function(imageEl) {
                    if (imageEl.complete) $b91af9c6f5c98917$var$processLazyPreloader(swiper, imageEl);
                    else imageEl.addEventListener('load', function(e) {
                        $b91af9c6f5c98917$var$processLazyPreloader(swiper, e.target);
                    });
                });
                $b91af9c6f5c98917$var$preload(swiper);
                // Init Flag
                swiper.initialized = true;
                $b91af9c6f5c98917$var$preload(swiper);
                // Emit
                swiper.emit('init');
                swiper.emit('afterInit');
                return swiper;
            }
        },
        {
            key: "destroy",
            value: function destroy(deleteInstance, cleanStyles) {
                if (deleteInstance === void 0) deleteInstance = true;
                if (cleanStyles === void 0) cleanStyles = true;
                var swiper = this;
                var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides;
                if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
                swiper.emit('beforeDestroy');
                // Init Flag
                swiper.initialized = false;
                // Detach events
                swiper.detachEvents();
                // Destroy loop
                if (params.loop) swiper.loopDestroy();
                // Cleanup styles
                if (cleanStyles) {
                    swiper.removeClasses();
                    if (el && typeof el !== 'string') el.removeAttribute('style');
                    if (wrapperEl) wrapperEl.removeAttribute('style');
                    if (slides && slides.length) slides.forEach(function(slideEl) {
                        slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                        slideEl.removeAttribute('style');
                        slideEl.removeAttribute('data-swiper-slide-index');
                    });
                }
                swiper.emit('destroy');
                // Detach emitter events
                Object.keys(swiper.eventsListeners).forEach(function(eventName) {
                    swiper.off(eventName);
                });
                if (deleteInstance !== false) {
                    if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
                    (0, $1d888d7d8ce4491f$export$d141bba7fdc215a3)(swiper);
                }
                swiper.destroyed = true;
                return null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(newDefaults) {
                (0, $1d888d7d8ce4491f$export$efccba1c4a2ef57b)($b91af9c6f5c98917$var$extendedDefaults, newDefaults);
            }
        },
        {
            key: "extendedDefaults",
            get: function get() {
                return $b91af9c6f5c98917$var$extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return $b91af9c6f5c98917$export$4368d992c4eafac0;
            }
        },
        {
            key: "installModule",
            value: function installModule(mod) {
                if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
                var modules = Swiper.prototype.__modules__;
                if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (Array.isArray(module)) {
                    module.forEach(function(m) {
                        return Swiper.installModule(m);
                    });
                    return Swiper;
                }
                Swiper.installModule(module);
                return Swiper;
            }
        }
    ]);
    return Swiper;
}();
Object.keys($b91af9c6f5c98917$var$prototypes).forEach(function(prototypeGroup) {
    Object.keys($b91af9c6f5c98917$var$prototypes[prototypeGroup]).forEach(function(protoMethod) {
        $b91af9c6f5c98917$export$25ce5a424b770e84.prototype[protoMethod] = $b91af9c6f5c98917$var$prototypes[prototypeGroup][protoMethod];
    });
});
$b91af9c6f5c98917$export$25ce5a424b770e84.use([
    $b91af9c6f5c98917$var$Resize,
    $b91af9c6f5c98917$var$Observer
]);








function $f15309b01d881d55$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    var cssModeTimeout;
    var document = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    var tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        var slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('swiper-slide');
        else slideEl = (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit) {
        var _swiper_params = swiper.params, slidesPerView = _swiper_params.slidesPerView, slidesPerGroup = _swiper_params.slidesPerGroup, centeredSlides = _swiper_params.centeredSlides, isLoop = _swiper_params.loop, initialSlide = _swiper_params.initialSlide;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        var _swiper_params_virtual = swiper.params.virtual, addSlidesBefore = _swiper_params_virtual.addSlidesBefore, addSlidesAfter = _swiper_params_virtual.addSlidesAfter;
        var _swiper_virtual = swiper.virtual, previousFrom = _swiper_virtual.from, previousTo = _swiper_virtual.to, slides = _swiper_virtual.slides, previousSlidesGrid = _swiper_virtual.slidesGrid, previousOffset = _swiper_virtual.offset;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        var from = activeIndex - slidesBefore;
        var to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach(function(slideEl) {
                slideEl.style[offsetProp] = "".concat(offset - Math.abs(swiper.cssOverflowAdjustment()), "px");
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    var slidesToRender = [];
                    for(var i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        var getSlideIndex = function(index) {
            var slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter(function(el) {
            return el.matches(".".concat(swiper.params.slideClass, ", swiper-slide"));
        }).forEach(function(slideEl) {
            slideEl.remove();
        });
        else {
            var _loop = function(i) {
                if (i < from || i > to) {
                    var slideIndex = getSlideIndex(i);
                    swiper.slides.filter(function(el) {
                        return el.matches(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(slideIndex, '"], swiper-slide[data-swiper-slide-index="').concat(slideIndex, '"]'));
                    }).forEach(function(slideEl) {
                        slideEl.remove();
                    });
                }
            };
            for(var i = previousFrom; i <= previousTo; i += 1)_loop(i);
        }
        var loopFrom = isLoop ? -slides.length : 0;
        var loopTo = isLoop ? slides.length * 2 : slides.length;
        for(var i1 = loopFrom; i1 < loopTo; i1 += 1)if (i1 >= from && i1 <= to) {
            var slideIndex = getSlideIndex(i1);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i1 > previousTo) appendIndexes.push(slideIndex);
                if (i1 < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(var i2 = prependIndexes.length - 1; i2 >= 0; i2 -= 1){
            var index = prependIndexes[i2];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort(function(a, b) {
                return b - a;
            });
            prependIndexes.forEach(function(index) {
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $1d888d7d8ce4491f$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach(function(slideEl) {
            slideEl.style[offsetProp] = "".concat(offset - Math.abs(swiper.cssOverflowAdjustment()), "px");
        });
        onRendered();
    }
    function appendSlide(slides) {
        if ((typeof slides === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(slides)) === 'object' && 'length' in slides) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                var cachedEl = cache[cachedIndex];
                var cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach(function(key) {
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach(function(key) {
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', function() {
        if (!swiper.params.virtual.enabled) return;
        var domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            var slides = (0, $1961f7bca441a4c6$export$71511d61b312f219)(swiper.slidesEl.children).filter(function(el) {
                return el.matches(".".concat(swiper.params.slideClass, ", swiper-slide"));
            });
            if (slides && slides.length) {
                swiper.virtual.slides = (0, $1961f7bca441a4c6$export$71511d61b312f219)(slides);
                domSlidesAssigned = true;
                slides.forEach(function(slideEl, slideIndex) {
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(function() {
                update();
            }, 100);
        } else update();
    });
    on('init update resize', function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $1d888d7d8ce4491f$export$2408f22a0fab9ae5)(swiper.wrapperEl, '--swiper-virtual-size', "".concat(swiper.virtualSize, "px"));
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $dadd4256e0b8da45$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var document = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
    var window = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var kc = e.keyCode || e.charCode;
        var pageUpDown = swiper.params.keyboard.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            var inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $1d888d7d8ce4491f$export$407448d2b89b1813)(swiper.el, ".".concat(swiper.params.slideClass, ", swiper-slide")).length > 0 && (0, $1d888d7d8ce4491f$export$407448d2b89b1813)(swiper.el, ".".concat(swiper.params.slideActiveClass)).length === 0) return undefined;
            var el = swiper.el;
            var swiperWidth = el.clientWidth;
            var swiperHeight = el.clientHeight;
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var swiperOffset = (0, $1d888d7d8ce4491f$export$8b22cf2602fb60ce)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', function() {
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', function() {
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $59a218f0b882ca3b$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var window = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    var timeout;
    var lastScrollTime = (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)();
    var lastEventBeforeSnap;
    var recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        var params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        var e = event1;
        var disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(".".concat(swiper.params.mousewheel.noMousewheelClass))) return;
        var params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        var targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        var targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        var positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            var newEvent = {
                time: (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            var newEvent1 = {
                time: (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            var ignoreWheelEvents = lastEventBeforeSnap && newEvent1.time < lastEventBeforeSnap.time + 500 && newEvent1.delta <= lastEventBeforeSnap.delta && newEvent1.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                var position = swiper.getTranslate() + delta * params.sensitivity;
                var wasBeginning = swiper.isBeginning;
                var wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent1.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    var prevEvent1 = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    var firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent1);
                    if (prevEvent1 && (newEvent1.delta > prevEvent1.delta || newEvent1.direction !== prevEvent1.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent1.time - firstEvent.time < 500 && firstEvent.delta - newEvent1.delta >= 1 && newEvent1.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        timeout = (0, $1d888d7d8ce4491f$export$7ccc53e8f1e7dfc5)(function() {
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $1d888d7d8ce4491f$export$7ccc53e8f1e7dfc5)(function() {
                        if (swiper.destroyed || !swiper.params) return;
                        var snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        var targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', function() {
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', function() {
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}




function $2249e959d4460717$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach(function(key) {
        if (!params[key] && params.auto === true) {
            var element = (0, $1d888d7d8ce4491f$export$f1e1789686576879)(swiper.el, ".".concat(checkProps[key]))[0];
            if (!element) {
                element = (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $22f35a00b59f007d$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        var res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = (0, $1961f7bca441a4c6$export$71511d61b312f219)(document.querySelectorAll(el));
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        var params = swiper.params.navigation;
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            if (subEl) {
                var _subEl_classList;
                (_subEl_classList = subEl.classList)[disabled ? 'add' : 'remove'].apply(_subEl_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(params.disabledClass.split(' ')));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        var params = swiper.params.navigation;
        swiper.params.navigation = (0, $2249e959d4460717$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        var nextEl = getEl(params.nextEl);
        var prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(prevEl);
        var initButton = function(el, dir) {
            var _el_classList;
            if (el) el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) (_el_classList = el.classList).add.apply(_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(params.lockClass.split(' ')));
        };
        nextEl.forEach(function(el) {
            return initButton(el, 'next');
        });
        prevEl.forEach(function(el) {
            return initButton(el, 'prev');
        });
    }
    function destroy() {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(prevEl);
        var destroyButton = function(el, dir) {
            var _el_classList;
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            (_el_classList = el.classList).remove.apply(_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(swiper.params.navigation.disabledClass.split(' ')));
        };
        nextEl.forEach(function(el) {
            return destroyButton(el, 'next');
        });
        prevEl.forEach(function(el) {
            return destroyButton(el, 'prev');
        });
    }
    on('init', function() {
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', function() {
        update();
    });
    on('destroy', function() {
        destroy();
    });
    on('enable disable', function() {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        (0, $1961f7bca441a4c6$export$71511d61b312f219)(nextEl).concat((0, $1961f7bca441a4c6$export$71511d61b312f219)(prevEl)).filter(function(el) {
            return !!el;
        }).forEach(function(el) {
            return el.classList.add(swiper.params.navigation.lockClass);
        });
    });
    on('click', function(_s, e) {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(prevEl);
        var targetEl = e.target;
        var targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            var path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find(function(pathEl) {
                return nextEl.includes(pathEl) || prevEl.includes(pathEl);
            });
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            var isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            (0, $1961f7bca441a4c6$export$71511d61b312f219)(nextEl).concat((0, $1961f7bca441a4c6$export$71511d61b312f219)(prevEl)).filter(function(el) {
                return !!el;
            }).forEach(function(el) {
                return el.classList.toggle(swiper.params.navigation.hiddenClass);
            });
        }
    });
    var enable = function() {
        var _swiper_el_classList;
        (_swiper_el_classList = swiper.el.classList).remove.apply(_swiper_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(swiper.params.navigation.navigationDisabledClass.split(' ')));
        init();
        update();
    };
    var disable = function() {
        var _swiper_el_classList;
        (_swiper_el_classList = swiper.el.classList).add.apply(_swiper_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(swiper.params.navigation.navigationDisabledClass.split(' ')));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}



function $9adfcaa468ba5790$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = '';
    return ".".concat(classes.trim().replace(/([\.:!+\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.'));
}




function $3156b0fb5cd1dd61$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(number) {
                return number;
            },
            formatFractionTotal: function(number) {
                return number;
            },
            bulletClass: "".concat(pfx, "-bullet"),
            bulletActiveClass: "".concat(pfx, "-bullet-active"),
            modifierClass: "".concat(pfx, "-"),
            currentClass: "".concat(pfx, "-current"),
            totalClass: "".concat(pfx, "-total"),
            hiddenClass: "".concat(pfx, "-hidden"),
            progressbarFillClass: "".concat(pfx, "-progressbar-fill"),
            progressbarOppositeClass: "".concat(pfx, "-progressbar-opposite"),
            clickableClass: "".concat(pfx, "-clickable"),
            lockClass: "".concat(pfx, "-lock"),
            horizontalClass: "".concat(pfx, "-horizontal"),
            verticalClass: "".concat(pfx, "-vertical"),
            paginationDisabledClass: "".concat(pfx, "-disabled")
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    var bulletSize;
    var dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        var bulletActiveClass = swiper.params.pagination.bulletActiveClass;
        if (!bulletEl) return;
        bulletEl = bulletEl["".concat(position === 'prev' ? 'previous' : 'next', "ElementSibling")];
        if (bulletEl) {
            bulletEl.classList.add("".concat(bulletActiveClass, "-").concat(position));
            bulletEl = bulletEl["".concat(position === 'prev' ? 'previous' : 'next', "ElementSibling")];
            if (bulletEl) bulletEl.classList.add("".concat(bulletActiveClass, "-").concat(position, "-").concat(position));
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        var bulletEl = e.target.closest((0, $9adfcaa468ba5790$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        var index = (0, $1d888d7d8ce4491f$export$dda1d9f60106f0e9)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            var moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var el = swiper.pagination.el;
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        // Current/Total
        var current;
        var previousIndex;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $1d888d7d8ce4491f$export$2d1720544b23b823)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach(function(subEl) {
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = "".concat(bulletSize * (params.dynamicMainBullets + 4), "px");
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach(function(bulletEl) {
                var _bulletEl_classList;
                var classesToRemove = (0, $1961f7bca441a4c6$export$71511d61b312f219)([
                    '',
                    '-next',
                    '-next-next',
                    '-prev',
                    '-prev-prev',
                    '-main'
                ].map(function(suffix) {
                    return "".concat(params.bulletActiveClass).concat(suffix);
                })).map(function(s) {
                    return typeof s === 'string' && s.includes(' ') ? s.split(' ') : s;
                }).flat();
                (_bulletEl_classList = bulletEl.classList).remove.apply(_bulletEl_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(classesToRemove));
            });
            if (el.length > 1) bullets.forEach(function(bullet) {
                var _bullet_classList;
                var bulletIndex = (0, $1d888d7d8ce4491f$export$dda1d9f60106f0e9)(bullet);
                if (bulletIndex === current) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(params.bulletActiveClass.split(' ')));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    var _bullet_classList1;
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) (_bullet_classList1 = bullet.classList).add.apply(_bullet_classList1, (0, $1961f7bca441a4c6$export$71511d61b312f219)("".concat(params.bulletActiveClass, "-main").split(' ')));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                var _bullet_classList;
                var bullet = bullets[current];
                if (bullet) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(params.bulletActiveClass.split(' ')));
                if (swiper.isElement) bullets.forEach(function(bulletEl, bulletIndex) {
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    var _bullets_i_classList;
                    var firstDisplayedBullet = bullets[firstIndex];
                    var lastDisplayedBullet = bullets[lastIndex];
                    for(var i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) (_bullets_i_classList = bullets[i].classList).add.apply(_bullets_i_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)("".concat(params.bulletActiveClass, "-main").split(' ')));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                var offsetProp = rtl ? 'right' : 'left';
                bullets.forEach(function(bullet) {
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = "".concat(bulletsOffset, "px");
                });
            }
        }
        el.forEach(function(subEl, subElIndex) {
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $9adfcaa468ba5790$export$db3b6bfb95261072)(params.currentClass)).forEach(function(fractionEl) {
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $9adfcaa468ba5790$export$db3b6bfb95261072)(params.totalClass)).forEach(function(totalEl) {
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                var progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                var scale = (current + 1) / total;
                var scaleX = 1;
                var scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $9adfcaa468ba5790$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach(function(progressEl) {
                    progressEl.style.transform = "translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")");
                    progressEl.style.transitionDuration = "".concat(swiper.params.speed, "ms");
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        var el = swiper.pagination.el;
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        var paginationHTML = '';
        if (params.type === 'bullets') {
            var numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += "<".concat(params.bulletElement, " ").concat(swiper.isElement ? 'part="bullet"' : '', ' class="').concat(params.bulletClass, '"></').concat(params.bulletElement, ">");
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = '<span class="'.concat(params.currentClass, '"></span>') + ' / ' + '<span class="'.concat(params.totalClass, '"></span>');
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = '<span class="'.concat(params.progressbarFillClass, '"></span>');
        }
        swiper.pagination.bullets = [];
        el.forEach(function(subEl) {
            var _swiper_pagination_bullets;
            if (params.type !== 'custom') subEl.innerHTML = paginationHTML || '';
            if (params.type === 'bullets') (_swiper_pagination_bullets = swiper.pagination.bullets).push.apply(_swiper_pagination_bullets, (0, $1961f7bca441a4c6$export$71511d61b312f219)(subEl.querySelectorAll((0, $9adfcaa468ba5790$export$db3b6bfb95261072)(params.bulletClass))));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $2249e959d4460717$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        var params = swiper.params.pagination;
        if (!params.el) return;
        var el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = (0, $1961f7bca441a4c6$export$71511d61b312f219)(document.querySelectorAll(params.el));
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = (0, $1961f7bca441a4c6$export$71511d61b312f219)(swiper.el.querySelectorAll(params.el));
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter(function(subEl) {
                if ((0, $1d888d7d8ce4491f$export$407448d2b89b1813)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            var _subEl_classList;
            if (params.type === 'bullets' && params.clickable) (_subEl_classList = subEl.classList).add.apply(_subEl_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((params.clickableClass || '').split(' ')));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add("".concat(params.modifierClass).concat(params.type, "-dynamic"));
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        var _subEl_classList;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var el = swiper.pagination.el;
        if (el) {
            el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
            el.forEach(function(subEl) {
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    var _subEl_classList;
                    (_subEl_classList = subEl.classList).remove.apply(_subEl_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((params.clickableClass || '').split(' ')));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(function(subEl) {
            return (_subEl_classList = subEl.classList).remove.apply(_subEl_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)(params.bulletActiveClass.split(' ')));
        });
    }
    on('changeDirection', function() {
        if (!swiper.pagination || !swiper.pagination.el) return;
        var params = swiper.params.pagination;
        var el = swiper.pagination.el;
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', function() {
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', function() {
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', function() {
        update();
    });
    on('snapGridLengthChange', function() {
        render();
        update();
    });
    on('destroy', function() {
        destroy();
    });
    on('enable disable', function() {
        var el = swiper.pagination.el;
        if (el) {
            el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
            el.forEach(function(subEl) {
                return subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass);
            });
        }
    });
    on('lock unlock', function() {
        update();
    });
    on('click', function(_s, e) {
        var targetEl = e.target;
        var el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            var isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach(function(subEl) {
                return subEl.classList.toggle(swiper.params.pagination.hiddenClass);
            });
        }
    });
    var enable = function() {
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
            el.forEach(function(subEl) {
                return subEl.classList.remove(swiper.params.pagination.paginationDisabledClass);
            });
        }
        init();
        render();
        update();
    };
    var disable = function() {
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
            el.forEach(function(subEl) {
                return subEl.classList.add(swiper.params.pagination.paginationDisabledClass);
            });
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}







function $3bb3cfe3cbed3903$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var document = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
    var isTouched = false;
    var timeout = null;
    var dragTimeout = null;
    var dragStartPos;
    var dragSize;
    var trackSize;
    var divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: "swiper-scrollbar-horizontal",
            verticalClass: "swiper-scrollbar-vertical"
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        var params = swiper.params.scrollbar;
        var progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = "translate3d(".concat(newPos, "px, 0, 0)");
            dragEl.style.width = "".concat(newSize, "px");
        } else {
            dragEl.style.transform = "translate3d(0px, ".concat(newPos, "px, 0)");
            dragEl.style.height = "".concat(newSize, "px");
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(function() {
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = "".concat(duration, "ms");
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = "".concat(dragSize, "px");
        else dragEl.style.height = "".concat(dragSize, "px");
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var el = scrollbar.el;
        var positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $1d888d7d8ce4491f$export$8b22cf2602fb60ce)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $1d888d7d8ce4491f$export$7ccc53e8f1e7dfc5)(function() {
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        var scrollbar = swiper.scrollbar, params = swiper.params;
        var el = scrollbar.el;
        if (!el) return;
        var target = el;
        var activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        var eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        var _el_classList;
        var scrollbar = swiper.scrollbar, swiperEl = swiper.el;
        swiper.params.scrollbar = (0, $2249e959d4460717$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        var params = swiper.params.scrollbar;
        if (!params.el) return;
        var el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        var dragEl;
        if (el) {
            dragEl = el.querySelector((0, $9adfcaa468ba5790$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) (_el_classList = el.classList)[swiper.enabled ? 'remove' : 'add'].apply(_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $1d888d7d8ce4491f$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass)));
    }
    function destroy() {
        var _el_classList;
        var params = swiper.params.scrollbar;
        var el = swiper.scrollbar.el;
        if (el) (_el_classList = el.classList).remove.apply(_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $1d888d7d8ce4491f$export$23f2a1d2818174ef)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass)));
        disableDraggable();
    }
    on('changeDirection', function() {
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        var params = swiper.params.scrollbar;
        var el = swiper.scrollbar.el;
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', function() {
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', function() {
        updateSize();
    });
    on('setTranslate', function() {
        setTranslate();
    });
    on('setTransition', function(_s, duration) {
        setTransition(duration);
    });
    on('enable disable', function() {
        var _el_classList;
        var el = swiper.scrollbar.el;
        if (el) (_el_classList = el.classList)[swiper.enabled ? 'remove' : 'add'].apply(_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $1d888d7d8ce4491f$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass)));
    });
    on('destroy', function() {
        destroy();
    });
    var enable = function() {
        var _swiper_el_classList, _swiper_scrollbar_el_classList;
        (_swiper_el_classList = swiper.el.classList).remove.apply(_swiper_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $1d888d7d8ce4491f$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass)));
        if (swiper.scrollbar.el) (_swiper_scrollbar_el_classList = swiper.scrollbar.el.classList).remove.apply(_swiper_scrollbar_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $1d888d7d8ce4491f$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass)));
        init();
        updateSize();
        setTranslate();
    };
    var disable = function() {
        var _swiper_el_classList, _swiper_scrollbar_el_classList;
        (_swiper_el_classList = swiper.el.classList).add.apply(_swiper_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $1d888d7d8ce4491f$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass)));
        if (swiper.scrollbar.el) (_swiper_scrollbar_el_classList = swiper.scrollbar.el.classList).add.apply(_swiper_scrollbar_el_classList, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $1d888d7d8ce4491f$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass)));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}




function $f128207d733c1854$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    var elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    var setTransform = function(el, progress) {
        var rtl = swiper.rtl;
        var rtlFactor = rtl ? -1 : 1;
        var p = el.getAttribute('data-swiper-parallax') || '0';
        var x = el.getAttribute('data-swiper-parallax-x');
        var y = el.getAttribute('data-swiper-parallax-y');
        var scale = el.getAttribute('data-swiper-parallax-scale');
        var opacity = el.getAttribute('data-swiper-parallax-opacity');
        var rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
        else x = "".concat(x * progress * rtlFactor, "px");
        if (y.indexOf('%') >= 0) y = "".concat(parseInt(y, 10) * progress, "%");
        else y = "".concat(y * progress, "px");
        if (typeof opacity !== 'undefined' && opacity !== null) {
            var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        var transform = "translate3d(".concat(x, ", ").concat(y, ", 0px)");
        if (typeof scale !== 'undefined' && scale !== null) {
            var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += " scale(".concat(currentScale, ")");
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            var currentRotate = rotate * progress * -1;
            transform += " rotate(".concat(currentRotate, "deg)");
        }
        el.style.transform = transform;
    };
    var setTranslate = function() {
        var _elements;
        var el = swiper.el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid, isElement = swiper.isElement;
        var elements = (0, $1d888d7d8ce4491f$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) (_elements = elements).push.apply(_elements, (0, $1961f7bca441a4c6$export$71511d61b312f219)((0, $1d888d7d8ce4491f$export$f1e1789686576879)(swiper.hostEl, elementsSelector)));
        elements.forEach(function(subEl) {
            setTransform(subEl, progress);
        });
        slides.forEach(function(slideEl, slideIndex) {
            var slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll("".concat(elementsSelector, ", [data-swiper-parallax-rotate]")).forEach(function(subEl) {
                setTransform(subEl, slideProgress);
            });
        });
    };
    var setTransition = function setTransition(duration) {
        var _elements;
        if (duration === void 0) duration = swiper.params.speed;
        var el = swiper.el, hostEl = swiper.hostEl;
        var elements = (0, $1961f7bca441a4c6$export$71511d61b312f219)(el.querySelectorAll(elementsSelector));
        if (swiper.isElement) (_elements = elements).push.apply(_elements, (0, $1961f7bca441a4c6$export$71511d61b312f219)(hostEl.querySelectorAll(elementsSelector)));
        elements.forEach(function(parallaxEl) {
            var parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = "".concat(parallaxDuration, "ms");
        });
    };
    on('beforeInit', function() {
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', function(_swiper, duration) {
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}






function $321ce32b9a072609$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var window = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    var currentScale = 1;
    var isScaling = false;
    var fakeGestureTouched;
    var fakeGestureMoved;
    var evCache = [];
    var gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    var image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    var velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    var scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get: function() {
            return scale;
        },
        set: function(value) {
            if (scale !== value) {
                var imageEl = gesture.imageEl;
                var slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        var x1 = evCache[0].pageX;
        var y1 = evCache[0].pageY;
        var x2 = evCache[1].pageX;
        var y2 = evCache[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    }
    function getMaxRatio() {
        var params = swiper.params.zoom;
        var maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            var imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        var box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? "swiper-slide" : ".".concat(swiper.params.slideClass);
    }
    function eventWithinSlide(e) {
        var slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter(function(slideEl) {
            return slideEl.contains(e.target);
        }).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        var selector = ".".concat(swiper.params.zoom.containerClass);
        if (e.target.matches(selector)) return true;
        if ((0, $1961f7bca441a4c6$export$71511d61b312f219)(swiper.hostEl.querySelectorAll(selector)).filter(function(containerEl) {
            return containerEl.contains(e.target);
        }).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        var params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $1d888d7d8ce4491f$export$407448d2b89b1813)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            var _getScaleOrigin = (0, $d98b89efad01a571$export$71511d61b312f219)(getScaleOrigin(), 2), originX = _getScaleOrigin[0], originY = _getScaleOrigin[1];
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = "".concat(swiper.params.speed, "ms");
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add("".concat(params.zoomedSlideClass));
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove("".concat(params.zoomedSlideClass));
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    var allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(function() {
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        var device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        var event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        var zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $1d888d7d8ce4491f$export$35e795649ee09318)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $1d888d7d8ce4491f$export$35e795649ee09318)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        var touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        var scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        var originX = gesture.originX, originY = gesture.originY;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = "translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)");
    }
    function onTouchEnd() {
        var zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = "".concat(momentumDuration, "ms");
        gesture.imageWrapEl.style.transform = "translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)");
    }
    function onTransitionEnd() {
        var zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove("".concat(swiper.params.zoom.zoomedSlideClass));
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function zoomIn(e) {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $1d888d7d8ce4491f$export$f1e1789686576879)(swiper.slidesEl, ".".concat(swiper.params.slideActiveClass))[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $1d888d7d8ce4491f$export$407448d2b89b1813)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add("".concat(params.zoomedSlideClass));
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        var forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        var maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $1d888d7d8ce4491f$export$8b22cf2602fb60ce)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $1d888d7d8ce4491f$export$8b22cf2602fb60ce)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = "translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)");
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
    }
    function zoomOut() {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $1d888d7d8ce4491f$export$f1e1789686576879)(swiper.slidesEl, ".".concat(swiper.params.slideActiveClass))[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $1d888d7d8ce4491f$export$407448d2b89b1813)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove("".concat(params.zoomedSlideClass));
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    }
    // Toggle Zoom
    function zoomToggle(e) {
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        var passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach(function(eventName) {
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach(function(eventName) {
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', function() {
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', function() {
        disable();
    });
    on('touchStart', function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', function(_s, e) {
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}




/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $a9daaaacacb57c1e$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        var binarySearch = function search() {
            var maxIndex;
            var minIndex;
            var guess;
            return function(array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        var Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(var i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        var Swiper = swiper.constructor;
        var controlled = swiper.controller.control;
        var i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $1d888d7d8ce4491f$export$7ccc53e8f1e7dfc5)(function() {
                    c.updateAutoHeight();
                });
                (0, $1d888d7d8ce4491f$export$342063e11d6c3cad)(c.wrapperEl, function() {
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', function() {
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            var controlElements = typeof swiper.params.controller.control === 'string' ? (0, $1961f7bca441a4c6$export$71511d61b312f219)(document.querySelectorAll(swiper.params.controller.control)) : [
                swiper.params.controller.control
            ];
            controlElements.forEach(function(controlElement) {
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    var eventName = "".concat(swiper.params.eventsPrefix, "init");
                    var onControllerSwiper = function(e) {
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', function() {
        removeSpline();
    });
    on('resize', function() {
        removeSpline();
    });
    on('observerUpdate', function() {
        removeSpline();
    });
    on('setTranslate', function(_s, translate, byController) {
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', function(_s, duration, byController) {
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $53193df9596c935f$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    var liveRegion = null;
    var preventFocusHandler;
    var focusTargetSlideEl;
    var visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        var notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = '';
        notification.innerHTML = message;
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        var randomChar = function() {
            return Math.round(16 * Math.random()).toString(16);
        };
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-controls', controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-disabled', false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        var params = swiper.params.a11y;
        var targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $9adfcaa468ba5790$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            var prevEls = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(swiper.navigation.prevEl);
            var nextEls = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $9adfcaa468ba5790$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        var params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach(function(bulletEl) {
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $1d888d7d8ce4491f$export$dda1d9f60106f0e9)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $9adfcaa468ba5790$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    var initNavEl = function(el, wrapperId, message) {
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    var handlePointerDown = function(e) {
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    var handlePointerUp = function() {
        preventFocusHandler = false;
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    var onVisibilityChange = function(e) {
        visibilityChangedTimestamp = new Date().getTime();
    };
    var handleFocus = function(e) {
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        var slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        var isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        var isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(function() {
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(parseInt(slideEl.getAttribute('data-swiper-slide-index')), 0);
            else swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
            preventFocusHandler = false;
        });
    };
    var initSlides = function() {
        var params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        var slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach(function(slideEl, index) {
            var slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    var init = function() {
        var params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        var containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        var wrapperEl = swiper.wrapperEl;
        var wrapperId = params.id || wrapperEl.getAttribute('id') || "swiper-wrapper-".concat(getRandomNumber(16));
        var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        var _$_ref = swiper.navigation ? swiper.navigation : {}, nextEl = _$_ref.nextEl, prevEl = _$_ref.prevEl;
        nextEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach(function(el) {
            return initNavEl(el, wrapperId, params.nextSlideMessage);
        });
        if (prevEl) prevEl.forEach(function(el) {
            return initNavEl(el, wrapperId, params.prevSlideMessage);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach(function(el) {
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        var document = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        var _$_ref = swiper.navigation ? swiper.navigation : {}, nextEl = _$_ref.nextEl, prevEl = _$_ref.prevEl;
        nextEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach(function(el) {
            return el.removeEventListener('keydown', onEnterOrSpaceKey);
        });
        if (prevEl) prevEl.forEach(function(el) {
            return el.removeEventListener('keydown', onEnterOrSpaceKey);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = (0, $1d888d7d8ce4491f$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach(function(el) {
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        var document = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', function() {
        liveRegion = (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', function() {
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', function() {
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', function() {
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', function() {
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', function() {
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $b75fa4ca81b585d5$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    var initialized = false;
    var paths = {};
    var slugify = function(text) {
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    var getPathValues = function(urlOverride) {
        var window = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
        var location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        var pathArray = location.pathname.slice(1).split('/').filter(function(part) {
            return part !== '';
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    var setHistory = function(key, index) {
        var window = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        var location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        var slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(index, '"]')) : swiper.slides[index];
        var value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            var root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = "".concat(root, "/").concat(key ? "".concat(key, "/") : '').concat(value);
        } else if (!location.pathname.includes(key)) value = "".concat(key ? "".concat(key, "/") : '').concat(value);
        if (swiper.params.history.keepQuery) value += location.search;
        var currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    var scrollToSlide = function(speed, value, runCallbacks) {
        if (value) for(var i = 0, length = swiper.slides.length; i < length; i += 1){
            var slide = swiper.slides[i];
            var slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                var index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    var setHistoryPopState = function() {
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    var init = function() {
        var window = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    var destroy = function() {
        var window = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', function() {
        if (swiper.params.history.enabled) init();
    });
    on('destroy', function() {
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', function() {
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', function() {
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $0517fcc9137a18fd$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, emit = _ref.emit, on = _ref.on;
    var initialized = false;
    var document = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
    var window = (0, $1cc2be8866fc9c93$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex: function(_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    var slideWithHash = swiper.slides.filter(function(slideEl) {
                        return slideEl.getAttribute('data-hash') === hash;
                    })[0];
                    if (!slideWithHash) return 0;
                    var index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $1d888d7d8ce4491f$export$f1e1789686576879)(swiper.slidesEl, ".".concat(swiper.params.slideClass, '[data-hash="').concat(hash, '"], swiper-slide[data-hash="').concat(hash, '"]'))[0]);
            }
        }
    });
    var onHashChange = function() {
        emit('hashChange');
        var newHash = document.location.hash.replace('#', '');
        var activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(swiper.activeIndex, '"]')) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            var newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    var setHash = function() {
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        var activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(swiper.activeIndex, '"]')) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, "#".concat(activeSlideHash) || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    var init = function() {
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        var hash = document.location.hash.replace('#', '');
        if (hash) {
            var speed = 0;
            var index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    var destroy = function() {
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', function() {
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', function() {
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', function() {
        if (initialized) setHash();
    });
    on('slideChange', function() {
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $bae6d393e6487915$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit, params = _ref.params;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    var timeout;
    var raf;
    var autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    var autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    var autoplayTimeLeft;
    var autoplayStartTime = new Date().getTime();
    var wasPaused;
    var isTouched;
    var pausedByTouch;
    var touchStartTimeout;
    var slideChanged;
    var pausedByInteraction;
    var pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    var calcTimeLeft = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        var timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(function() {
            calcTimeLeft();
        });
    };
    var getSlideDelay = function() {
        var activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter(function(slideEl) {
            return slideEl.classList.contains('swiper-slide-active');
        })[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        var currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    var run = function(delayForce) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        var delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        var currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        var speed = swiper.params.speed;
        var proceed = function() {
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(function() {
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                proceed();
            }, delay);
        } else requestAnimationFrame(function() {
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    var start = function() {
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    var stop = function() {
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    var pause = function(internal, reset) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        var proceed = function() {
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        var delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    var resume = function() {
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    var onVisibilityChange = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        var document = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    var onPointerEnter = function(e) {
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    var onPointerLeave = function(e) {
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    var attachMouseEvents = function() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    var detachMouseEvents = function() {
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    var attachDocumentEvents = function() {
        var document = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    var detachDocumentEvents = function() {
        var document = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', function() {
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', function() {
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', function() {
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', function() {
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', function(_s, speed, internal) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(function() {
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', function() {
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $45dbb82d5bd5356d$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    var initialized = false;
    var swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        var _swiper_params = swiper.params, thumbsParams = _swiper_params.thumbs;
        if (initialized) return false;
        initialized = true;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $1d888d7d8ce4491f$export$882b5998b3b9117c)(thumbsParams.swiper)) {
            var thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach(function(slideEl) {
            return slideEl.classList.remove(thumbActiveClass);
        });
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(var i = 0; i < thumbsToActivate; i += 1)(0, $1d888d7d8ce4491f$export$f1e1789686576879)(thumbsSwiper.slidesEl, '[data-swiper-slide-index="'.concat(swiper.realIndex + i, '"]')).forEach(function(slideEl) {
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(var i1 = 0; i1 < thumbsToActivate; i1 += 1)if (thumbsSwiper.slides[swiper.realIndex + i1]) thumbsSwiper.slides[swiper.realIndex + i1].classList.add(thumbActiveClass);
        }
        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            var direction;
            if (thumbsSwiper.params.loop) {
                var newThumbsSlide = thumbsSwiper.slides.filter(function(slideEl) {
                    return slideEl.getAttribute('data-swiper-slide-index') === "".concat(swiper.realIndex);
                })[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', function() {
        var thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            var document = (0, $1cc2be8866fc9c93$export$39b482c5e57630a8)();
            var getThumbsElementAndInit = function() {
                var thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    var eventName = "".concat(swiper.params.eventsPrefix, "init");
                    var onThumbsSwiper = function(e) {
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            var watchForThumbsToAppear = function() {
                if (swiper.destroyed) return;
                var thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', function() {
        update();
    });
    on('setTransition', function(_s, duration) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', function() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $3075b203b0dfa96c$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, emit = _ref.emit, once = _ref.once;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        var translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        var data = swiper.touchEventsData, touches = swiper.touches;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)()
        });
    }
    function onTouchEnd(_ref2) {
        var currentPos = _ref2.currentPos;
        if (swiper.params.cssMode) return;
        var params = swiper.params, wrapperEl = swiper.wrapperEl, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid, data = swiper.touchEventsData;
        // Time diff
        var touchEndTime = (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)();
        var timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                var lastMoveEvent = data.velocities.pop();
                var velocityEvent = data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $1d888d7d8ce4491f$export$4368d992c4eafac0)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeMode.momentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', function() {
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $1d888d7d8ce4491f$export$342063e11d6c3cad)(wrapperEl, function() {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        (0, $1d888d7d8ce4491f$export$342063e11d6c3cad)(wrapperEl, function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $1d888d7d8ce4491f$export$342063e11d6c3cad)(wrapperEl, function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}



function $f413819ccc5fa7c2$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    var slidesNumberEvenToRows;
    var slidesPerRow;
    var numFullColumns;
    var wasMultiRow;
    var getSpaceBetween = function() {
        var spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    var initSlides = function(slides) {
        var slidesPerView = swiper.params.slidesPerView;
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    var unsetSlides = function() {
        if (swiper.slides) swiper.slides.forEach(function(slide) {
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    var updateSlide = function(i, slide, slides) {
        var slidesPerGroup = swiper.params.slidesPerGroup;
        var spaceBetween = getSpaceBetween();
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        var newSlideOrderIndex;
        var column;
        var row;
        if (fill === 'row' && slidesPerGroup > 1) {
            var groupIndex = Math.floor(i / (slidesPerGroup * rows));
            var slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            var columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = "calc((100% - ".concat((rows - 1) * spaceBetween, "px) / ").concat(rows, ")");
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && "".concat(spaceBetween, "px") : '';
        slide.swiperSlideGridSet = true;
    };
    var updateWrapperSize = function(slideSize, snapGrid) {
        var _swiper_params = swiper.params, centeredSlides = _swiper_params.centeredSlides, roundLengths = _swiper_params.roundLengths;
        var spaceBetween = getSpaceBetween();
        var rows = swiper.params.grid.rows;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = "".concat(swiper.virtualSize + spaceBetween, "px");
        if (centeredSlides) {
            var _snapGrid;
            var newSlidesGrid = [];
            for(var i = 0; i < snapGrid.length; i += 1){
                var slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            (_snapGrid = snapGrid).push.apply(_snapGrid, (0, $1961f7bca441a4c6$export$71511d61b312f219)(newSlidesGrid));
        }
    };
    var onInit = function() {
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    var onUpdate = function() {
        var params = swiper.params, el = swiper.el;
        var isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove("".concat(params.containerModifierClass, "grid"), "".concat(params.containerModifierClass, "grid-column"));
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add("".concat(params.containerModifierClass, "grid"));
            if (params.grid.fill === 'column') el.classList.add("".concat(params.containerModifierClass, "grid-column"));
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



function $c8d8b8cbfbe0a800$var$appendSlide(slides) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var appendElement = function(slideEl) {
        if (typeof slideEl === 'string') {
            var tempDOM = document.createElement('div');
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = '';
        } else slidesEl.append(slideEl);
    };
    if ((typeof slides === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(slides)) === 'object' && 'length' in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $c8d8b8cbfbe0a800$var$prependSlide(slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    var prependElement = function(slideEl) {
        if (typeof slideEl === 'string') {
            var tempDOM = document.createElement('div');
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = '';
        } else slidesEl.prepend(slideEl);
    };
    if ((typeof slides === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(slides)) === 'object' && 'length' in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $c8d8b8cbfbe0a800$var$addSlide(index, slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if ((typeof slides === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(slides)) === 'object' && 'length' in slides) {
        for(var i1 = 0; i1 < slides.length; i1 += 1)if (slides[i1]) slidesEl.append(slides[i1]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(var i2 = 0; i2 < slidesBuffer.length; i2 += 1)slidesEl.append(slidesBuffer[i2]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $c8d8b8cbfbe0a800$var$removeSlide(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if ((typeof slidesIndexes === "undefined" ? "undefined" : (0, $17c6da0aa640e82f$export$71511d61b312f219)(slidesIndexes)) === 'object' && 'length' in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $c8d8b8cbfbe0a800$var$removeAllSlides() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $c8d8b8cbfbe0a800$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper;
    Object.assign(swiper, {
        appendSlide: $c8d8b8cbfbe0a800$var$appendSlide.bind(swiper),
        prependSlide: $c8d8b8cbfbe0a800$var$prependSlide.bind(swiper),
        addSlide: $c8d8b8cbfbe0a800$var$addSlide.bind(swiper),
        removeSlide: $c8d8b8cbfbe0a800$var$removeSlide.bind(swiper),
        removeAllSlides: $c8d8b8cbfbe0a800$var$removeAllSlides.bind(swiper)
    });
}


function $d55ccd1ca0e73ccf$export$f1e1789686576879(params) {
    var effect = params.effect, swiper = params.swiper, on = params.on, setTranslate = params.setTranslate, setTransition = params.setTransition, overwriteParams = params.overwriteParams, perspective = params.perspective, recreateShadows = params.recreateShadows, getEffectParams = params.getEffectParams;
    on('beforeInit', function() {
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass).concat(effect));
        if (perspective && perspective()) swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
        var overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', function() {
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', function(_s, duration) {
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', function() {
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach(function(slideEl) {
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(shadowEl) {
                    return shadowEl.remove();
                });
            });
            // create new one
            recreateShadows();
        }
    });
    var requireUpdateOnVirtual;
    on('virtualUpdate', function() {
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(function() {
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $6404e031166b2a04$export$f1e1789686576879(effectParams, slideEl) {
    var transformEl = (0, $1d888d7d8ce4491f$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $a9ed2860732791a2$export$f1e1789686576879(_ref) {
    var swiper = _ref.swiper, duration = _ref.duration, transformElements = _ref.transformElements, allSlides = _ref.allSlides;
    var activeIndex = swiper.activeIndex;
    var getSlide = function(el) {
        if (!el.parentElement) {
            // assume shadow root
            var slide = swiper.slides.filter(function(slideEl) {
                return slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode;
            })[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        var transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter(function(transformEl) {
            var el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach(function(el) {
            (0, $1d888d7d8ce4491f$export$342063e11d6c3cad)(el, function() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                var evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $3110d5dfe0c9481e$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides;
        var params = swiper.params.fadeEffect;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = swiper.slides[i];
            var offset = slideEl.swiperSlideOffset;
            var tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            var targetEl = (0, $6404e031166b2a04$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)");
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $1d888d7d8ce4491f$export$39b482c5e57630a8)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
        });
        (0, $a9ed2860732791a2$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $d55ccd1ca0e73ccf$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}




function $d1e19a06bf39baad$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    var createSlideShadows = function(slideEl, progress, isHorizontal) {
        var shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        var shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('div', "swiper-slide-shadow-cube swiper-slide-shadow-".concat(isHorizontal ? 'left' : 'top').split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('div', "swiper-slide-shadow-cube swiper-slide-shadow-".concat(isHorizontal ? 'right' : 'bottom').split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    var recreateShadows = function() {
        // create new ones
        var isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach(function(slideEl) {
            var progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    var setTranslate = function() {
        var el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size, browser = swiper.browser;
        var r = (0, $1d888d7d8ce4491f$export$ae1af26003f05816)(swiper);
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = "".concat(swiperWidth, "px");
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var progress = Math.max(Math.min(slideEl.progress, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var transform = "rotateX(".concat(r(isHorizontal ? 0 : -slideAngle), "deg) rotateY(").concat(r(isHorizontal ? slideAngle : 0), "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = "50% 50% -".concat(swiperSize / 2, "px");
        wrapperEl.style['-webkit-transform-origin'] = "50% 50% -".concat(swiperSize / 2, "px");
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = "translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(89.99deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")");
            else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var offset = params.shadowOffset;
                cubeShadowEl.style.transform = "scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + offset, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-89.99deg)");
            }
        }
        var zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = "translate3d(0px,0,".concat(zFactor, "px) rotateX(").concat(r(swiper.isHorizontal() ? 0 : wrapperRotate), "deg) rotateY(").concat(r(swiper.isHorizontal() ? -wrapperRotate : 0), "deg)");
        wrapperEl.style.setProperty('--swiper-cube-translate-z', "".concat(zFactor, "px"));
    };
    var setTransition = function(duration) {
        var el = swiper.el, slides = swiper.slides;
        slides.forEach(function(slideEl) {
            slideEl.style.transitionDuration = "".concat(duration, "ms");
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(subEl) {
                subEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            var shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = "".concat(duration, "ms");
        }
    };
    (0, $d55ccd1ca0e73ccf$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.cubeEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
        }
    });
}



function $48a6b4980d63606d$export$db3b6bfb95261072(suffix, slideEl, side) {
    var shadowClass = "swiper-slide-shadow".concat(side ? "-".concat(side) : '').concat(suffix ? " swiper-slide-shadow-".concat(suffix) : '');
    var shadowContainer = (0, $1d888d7d8ce4491f$export$39b482c5e57630a8)(slideEl);
    var shadowEl = shadowContainer.querySelector(".".concat(shadowClass.split(' ').join('.')));
    if (!shadowEl) {
        shadowEl = (0, $1d888d7d8ce4491f$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $8596601240c38036$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    var createSlideShadows = function(slideEl, progress) {
        var shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        var shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $48a6b4980d63606d$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $48a6b4980d63606d$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    var recreateShadows = function() {
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach(function(slideEl) {
            var progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    var setTranslate = function() {
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        var params = swiper.params.flipEffect;
        var rotateFix = (0, $1d888d7d8ce4491f$export$ae1af26003f05816)(swiper);
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            var offset = slideEl.swiperSlideOffset;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            var transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateFix(rotateX), "deg) rotateY(").concat(rotateFix(rotateY), "deg)");
            var targetEl = (0, $6404e031166b2a04$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $1d888d7d8ce4491f$export$39b482c5e57630a8)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $a9ed2860732791a2$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $d55ccd1ca0e73ccf$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.flipEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}






function $8008c5fb57aa4fda$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    var setTranslate = function() {
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth;
        var r = (0, $1d888d7d8ce4491f$export$ae1af26003f05816)(swiper);
        // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var slideEl = slides[i];
            var slideSize = slidesSizesGrid[i];
            var slideOffset = slideEl.swiperSlideOffset;
            var centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            var offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(r(rotateX), "deg) rotateY(").concat(r(rotateY), "deg) scale(").concat(scale, ")");
            var targetEl = (0, $6404e031166b2a04$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                var shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                var shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $48a6b4980d63606d$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $48a6b4980d63606d$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $1d888d7d8ce4491f$export$39b482c5e57630a8)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
    };
    (0, $d55ccd1ca0e73ccf$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true
            };
        }
    });
}







function $26f5f6ae61850f9a$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    var getTranslateValue = function(value) {
        if (typeof value === 'string') return value;
        return "".concat(value, "px");
    };
    var setTranslate = function() {
        var _loop = function(i) {
            var slideEl = slides[i];
            var slideProgress = slideEl.progress;
            var progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            var originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            var offset = slideEl.swiperSlideOffset;
            var t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            var r = [
                0,
                0,
                0
            ];
            var custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            var data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach(function(value, index) {
                t[index] = "calc(".concat(value, "px + (").concat(getTranslateValue(data.translate[index]), " * ").concat(Math.abs(progress * multiplier), "))");
            });
            // set rotates
            r.forEach(function(value, index) {
                var val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var translateString = t.join(', ');
            var rotateString = "rotateX(".concat(rotateFix(r[0]), "deg) rotateY(").concat(rotateFix(r[1]), "deg) rotateZ(").concat(rotateFix(r[2]), "deg)");
            var scaleString = originalProgress < 0 ? "scale(".concat(1 + (1 - data.scale) * originalProgress * multiplier, ")") : "scale(".concat(1 - (1 - data.scale) * originalProgress * multiplier, ")");
            var opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            var transform = "translate3d(".concat(translateString, ") ").concat(rotateString, " ").concat(scaleString);
            // Set shadows
            if (custom && data.shadow || !custom) {
                var shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $48a6b4980d63606d$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    var shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            var targetEl = (0, $6404e031166b2a04$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        };
        var slides = swiper.slides, wrapperEl = swiper.wrapperEl, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.creativeEffect;
        var multiplier = params.progressMultiplier;
        var isCenteredSlides = swiper.params.centeredSlides;
        var rotateFix = (0, $1d888d7d8ce4491f$export$ae1af26003f05816)(swiper);
        if (isCenteredSlides) {
            var margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = "translateX(calc(50% - ".concat(margin, "px))");
        }
        for(var i = 0; i < slides.length; i += 1)_loop(i);
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $1d888d7d8ce4491f$export$39b482c5e57630a8)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll('.swiper-slide-shadow').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $a9ed2860732791a2$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $d55ccd1ca0e73ccf$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return swiper.params.creativeEffect.perspective;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}







function $ddd72ce05a6c0ec3$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate;
        var params = swiper.params.cardsEffect;
        var _swiper_touchEventsData = swiper.touchEventsData, startTranslate = _swiper_touchEventsData.startTranslate, isTouched = _swiper_touchEventsData.isTouched;
        var currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var slideProgress = slideEl.progress;
            var progress = Math.min(Math.max(slideProgress, -4), 4);
            var offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = "translateX(".concat(swiper.minTranslate(), "px)");
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            var tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var tY = 0;
            var tZ = -100 * Math.abs(progress);
            var scale = 1;
            var rotate = -params.perSlideRotate * progress;
            var tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            var slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            var isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            var isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                var subProgress = Math.pow(1 - Math.abs((Math.abs(progress) - 0.5) / 0.5), 0.5);
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = "".concat(-25 * subProgress * Math.abs(progress), "%");
            }
            if (progress < 0) // next
            tX = "calc(".concat(tX, "px ").concat(rtl ? '-' : '+', " (").concat(tXAdd * Math.abs(progress), "%))");
            else if (progress > 0) // prev
            tX = "calc(".concat(tX, "px ").concat(rtl ? '-' : '+', " (-").concat(tXAdd * Math.abs(progress), "%))");
            else tX = "".concat(tX, "px");
            if (!swiper.isHorizontal()) {
                var prevY = tY;
                tY = tX;
                tX = prevY;
            }
            var scaleString = progress < 0 ? "".concat(1 + (1 - scale) * progress) : "".concat(1 - (1 - scale) * progress);
            /* eslint-disable */ var transform = "\n        translate3d(".concat(tX, ", ").concat(tY, ", ").concat(tZ, "px)\n        rotateZ(").concat(params.rotate ? rtl ? -rotate : rotate : 0, "deg)\n        scale(").concat(scaleString, ")\n      ");
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                var shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $48a6b4980d63606d$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var targetEl = (0, $6404e031166b2a04$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $1d888d7d8ce4491f$export$39b482c5e57630a8)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll('.swiper-slide-shadow').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $a9ed2860732791a2$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $d55ccd1ca0e73ccf$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}




// import { Navigation, Pagination, Keyboard, Autoplay, EffectFade } from 'swiper/modules';
var $a8348e27270c5541$var$swiper = new (0, $b91af9c6f5c98917$export$25ce5a424b770e84)("#event-swiper", {
    modules: [
        (0, $22f35a00b59f007d$export$2e2bcd8739ae039),
        (0, $3156b0fb5cd1dd61$export$2e2bcd8739ae039),
        (0, $dadd4256e0b8da45$export$2e2bcd8739ae039)
    ],
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
        nextEl: "#event-swiper .swiper-button-next",
        prevEl: "#event-swiper .swiper-button-prev"
    },
    loop: true,
    pagination: {
        el: "#event-swiper .swiper-pagination"
    },
    keyboard: {
        enabled: true,
        onlyInViewport: false
    },
    autoplay: false
});


/*
###################################################################################### 
######################################################################################
 
########   #######        ## ########  ######  ########     ######  ##      ## ##     ## #### ########  ######## ########  
##     ## ##     ##       ## ##       ##    ##    ##       ##    ## ##  ##  ## ##     ##  ##  ##     ## ##       ##     ## 
##     ## ##     ##       ## ##       ##          ##       ##       ##  ##  ## ##     ##  ##  ##     ## ##       ##     ## 
########  ##     ##       ## ######   ##          ##        ######  ##  ##  ## ##     ##  ##  ########  ######   ########  
##        ##     ## ##    ## ##       ##          ##             ## ##  ##  ## ##     ##  ##  ##        ##       ##   ##   
##        ##     ## ##    ## ##       ##    ##    ##       ##    ## ##  ##  ## ##     ##  ##  ##        ##       ##    ##  
##         #######   ######  ########  ######     ##        ######   ###  ###   #######  #### ##        ######## ##     ## 

###################################################################################### 
######################################################################################
*/ 

// Initialisiere Swiper
var $30816cfa7e725712$var$swiper = new (0, $b91af9c6f5c98917$export$25ce5a424b770e84)(".projectSwiper", {
    modules: [
        (0, $22f35a00b59f007d$export$2e2bcd8739ae039),
        (0, $3156b0fb5cd1dd61$export$2e2bcd8739ae039),
        (0, $dadd4256e0b8da45$export$2e2bcd8739ae039)
    ],
    loop: true,
    pagination: {
        el: "#projectSwiper .swiper-pagination",
        type: "fraction"
    },
    navigation: {
        nextEl: "#projectSwiper .swiper-button-next",
        prevEl: "#projectSwiper .swiper-button-prev"
    },
    keyboard: {
        enabled: true,
        onlyInViewport: false
    }
});


// Passwort sichtbar machen
//
// Ergänzt Passwortfelder um eine Schaltfläche mit Auge-Symbol, die zwischen
// verdeckter und sichtbarer Eingabe umschaltet. Aktiviert wird das über das
// Attribut data-password-toggle am Eingabefeld. Ohne JavaScript bleibt das Feld
// ein normales Passwortfeld – die Schaltfläche wird erst hier erzeugt.
var $13099e4e3efa9b2f$var$LABEL_SHOW = 'Passwort anzeigen';
var $13099e4e3efa9b2f$var$LABEL_HIDE = 'Passwort verbergen';
function $13099e4e3efa9b2f$var$eyeIcon(crossedOut) {
    var slash = crossedOut ? '<path d="M4 20 20 4"/>' : '';
    return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2 12s3.6-6.5 10-6.5 10 6.5 10 6.5-3.6 6.5-10 6.5S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>' + slash + '</svg>';
}
function $13099e4e3efa9b2f$var$enablePasswordToggle(input) {
    var wrapper = input.closest('.form-floating') || input.parentElement;
    if (!wrapper || wrapper.querySelector('.uo-password-toggle')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'uo-password-toggle';
    button.innerHTML = $13099e4e3efa9b2f$var$eyeIcon(false);
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', $13099e4e3efa9b2f$var$LABEL_SHOW);
    button.setAttribute('title', $13099e4e3efa9b2f$var$LABEL_SHOW);
    if (input.id) button.setAttribute('aria-controls', input.id);
    button.addEventListener('click', function() {
        var sichtbarMachen = input.type === 'password';
        var position = input.selectionStart;
        input.type = sichtbarMachen ? 'text' : 'password';
        button.innerHTML = $13099e4e3efa9b2f$var$eyeIcon(sichtbarMachen);
        button.setAttribute('aria-pressed', sichtbarMachen ? 'true' : 'false');
        button.setAttribute('aria-label', sichtbarMachen ? $13099e4e3efa9b2f$var$LABEL_HIDE : $13099e4e3efa9b2f$var$LABEL_SHOW);
        button.setAttribute('title', sichtbarMachen ? $13099e4e3efa9b2f$var$LABEL_HIDE : $13099e4e3efa9b2f$var$LABEL_SHOW);
        // Fokus und Schreibposition erhalten, damit die Eingabe nicht abreißt
        input.focus();
        if (position !== null && typeof position !== 'undefined') try {
            input.setSelectionRange(position, position);
        } catch (e) {
        // Einzelne Browser erlauben setSelectionRange bei type="password" nicht
        }
    });
    wrapper.appendChild(button);
    // Erst mit vorhandener Schaltfläche wird Platz im Feld freigehalten
    wrapper.classList.add('has-password-toggle');
}
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('input[type="password"][data-password-toggle]').forEach($13099e4e3efa9b2f$var$enablePasswordToggle);
});



})();
//# sourceMappingURL=modules.js.map
